/* eslint-disable */
// @ts-nocheck
/* c8 ignore start */
import type { GraphQLResolveInfo } from 'graphql';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import type {
  FieldPolicy,
  FieldReadFunction,
  TypePolicies,
  TypePolicy,
} from '@apollo/client/cache';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
  [_ in K]?: never;
};
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type RequireFields<T, K extends keyof T> = Omit<T, K> & { [P in K]-?: NonNullable<T[P]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
};

export type ApolloToken = {
  __typename?: 'ApolloToken';
  expiry: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export type ApplicationAttachments = {
  __typename?: 'ApplicationAttachments';
  attachments?: Maybe<Array<ChatAttachment>>;
  cv?: Maybe<ChatAttachment>;
};

export type ApplicationInput = {
  adID: Scalars['String']['input'];
  attachments?: InputMaybe<Array<AttachmentInput>>;
  cv?: InputMaybe<AttachmentInput>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
  sendMessageOnBackend?: InputMaybe<Scalars['Boolean']['input']>;
  withProfile: Scalars['Boolean']['input'];
};

export enum ApplicationRate {
  NOT_OK = 'NOT_OK',
  OK = 'OK',
  UNDEFINED = 'UNDEFINED',
  UNSURE = 'UNSURE',
}

export enum ApplicationRead {
  ONLYREAD = 'onlyRead',
  ONLYUNREAD = 'onlyUnread',
  WITHUNREADMESSAGES = 'withUnreadMessages',
}

export enum ApplicationStatus {
  MEETING_SCHEDULED = 'MEETING_SCHEDULED',
  NEW = 'NEW',
  REJECTED = 'REJECTED',
  SELECTED_FOR_CONTACT = 'SELECTED_FOR_CONTACT',
}

export type ApplicationUpdateInput = {
  attachments?: InputMaybe<Array<AttachmentInput>>;
  cv?: InputMaybe<AttachmentInput>;
  sendMessageOnBackend?: InputMaybe<Scalars['Boolean']['input']>;
  withProfile: Scalars['Boolean']['input'];
};

export type ApplicationsOrderByInput = {
  createdAt?: InputMaybe<Sort>;
};

export enum ApplicationsSortBy {
  BY_BEST_MATCH = 'BY_BEST_MATCH',
  BY_LAST_ACTIVITY = 'BY_LAST_ACTIVITY',
  BY_POSTED_AT = 'BY_POSTED_AT',
}

export type ApplyQuestion = {
  __typename?: 'ApplyQuestion';
  ID: Scalars['ID']['output'];
  answers: Array<ApplyQuestionAnswer>;
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  placeholder?: Maybe<Scalars['String']['output']>;
  tag?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  variant: ApplyQuestionVariant;
};

export type ApplyQuestionAnswer = {
  __typename?: 'ApplyQuestionAnswer';
  isFavorite?: Maybe<Scalars['Boolean']['output']>;
  label: Scalars['String']['output'];
  placeholder?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ApplyQuestionUserAnswerInput = {
  questionID: Scalars['String']['input'];
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum ApplyQuestionVariant {
  CUSTOM = 'custom',
  DEFAULT = 'default',
  PREDEFINED = 'predefined',
}

export type AtlasUser = {
  __typename?: 'AtlasUser';
  created: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type Attachment = {
  __typename?: 'Attachment';
  /**
   * ID - Apollo file ID, use in AttachmentInput
   * Ex. abcd123-JOBSPL
   */
  ID: Scalars['String']['output'];
  /** Download token - pass as Authorization header, works only with downloadURL */
  downloadToken: Scalars['String']['output'];
  /** Download URL - works only with downloadToken */
  downloadURL: Scalars['String']['output'];
  /**
   * Name - file name with extension, use in AttachmentInput
   * Ex. my_cv.pdf
   */
  name: Scalars['String']['output'];
  /**
   * Download URL - works only with token
   * @deprecated please use downloadURL instead
   */
  simpleURL: Scalars['String']['output'];
  /**
   * Download token - pass as Authorization header, works only with simpleURL
   * @deprecated please use downloadToken instead
   */
  token: Scalars['String']['output'];
  /**
   * URL - Apollo file URL, original file URL returned by Apollo, use in AttachmentInput, DO NOT USE FOR DOWNLOAD
   * New Apollo Secure Storage doesn't provide this URL.
   * Ex. https://ireland.apollo.olxcdn.com/v1/files/abcd123-JOBSPL/document"
   * Ex. https://ireland.apollo.olxcdn.com/v1/files/abcd123-JOBSPL/image"
   */
  url?: Maybe<Scalars['String']['output']>;
};

export type AttachmentInput = {
  /** Apollo file ID */
  ID: Scalars['String']['input'];
  /** File name with extension */
  name: Scalars['String']['input'];
  /** Stamp - Apollo Secure encoded metadata for file, required for new files */
  stamp?: InputMaybe<Scalars['String']['input']>;
  /**
   * Apollo file URL - original file URL returned by Apollo.
   * New Apollo Secure Storage doesn't provide this URL.
   * Ex. https://ireland.apollo.olxcdn.com/v1/files/abcd123-JOBSPL/document"
   */
  url?: InputMaybe<Scalars['String']['input']>;
};

export enum AutocompleteType {
  CITY = 'CITY',
  POSTAL_CODE = 'POSTAL_CODE',
  REGION = 'REGION',
  STREET = 'STREET',
}

export enum BenefitType {
  ADDITIONAL_SOCIAL_BENEFITS = 'ADDITIONAL_SOCIAL_BENEFITS',
  CHILDCARE_SUPPORT = 'CHILDCARE_SUPPORT',
  COMPANY_CAR = 'COMPANY_CAR',
  COMPANY_PHONE = 'COMPANY_PHONE',
  DENTAL_CARE = 'DENTAL_CARE',
  DISCOUNTS_FROM_EXTERNAL_PARTNERS = 'DISCOUNTS_FROM_EXTERNAL_PARTNERS',
  DRINKS_AT_THE_OFFICE = 'DRINKS_AT_THE_OFFICE',
  EDUCATION_BUDGET = 'EDUCATION_BUDGET',
  EMPLOYEE_DISCOUNTS = 'EMPLOYEE_DISCOUNTS',
  EMPLOYEE_REFERRAL_PROGRAM = 'EMPLOYEE_REFERRAL_PROGRAM',
  EXTRA_DAYS_OFF = 'EXTRA_DAYS_OFF',
  FLEXIBLE_WORKING_HOURS = 'FLEXIBLE_WORKING_HOURS',
  FREE_MEALS = 'FREE_MEALS',
  FRUITS_AT_THE_OFFICE = 'FRUITS_AT_THE_OFFICE',
  IT_EQUIPMENT_OF_CHOICE = 'IT_EQUIPMENT_OF_CHOICE',
  LANGUAGE_COURSES = 'LANGUAGE_COURSES',
  LIFE_INSURANCE = 'LIFE_INSURANCE',
  PARTIES_AND_EVENTS = 'PARTIES_AND_EVENTS',
  PRIVATE_MEDICAL_INSURANCE = 'PRIVATE_MEDICAL_INSURANCE',
  RELOCATION_ASSISTANCE = 'RELOCATION_ASSISTANCE',
  REMOTE_WORK = 'REMOTE_WORK',
  SUBSIDIED_MEALS = 'SUBSIDIED_MEALS',
  SUBSIDIED_SPORTS = 'SUBSIDIED_SPORTS',
  SUBSIDIED_VACATIONS = 'SUBSIDIED_VACATIONS',
}

export type BusinessCardAbout = {
  __typename?: 'BusinessCardAbout';
  companyName?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  tagline?: Maybe<Scalars['String']['output']>;
};

export type BusinessCardAboutInput = {
  companyName: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  tagline?: InputMaybe<Scalars['String']['input']>;
};

export type BusinessCardAdditionalInfo = {
  __typename?: 'BusinessCardAdditionalInfo';
  companySize?: Maybe<Scalars['String']['output']>;
  companyUrl?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  facebookUrl?: Maybe<Scalars['String']['output']>;
  headquarters?: Maybe<BusinessCardLocation>;
  industry?: Maybe<BusinessCardIndustry>;
  instagramUrl?: Maybe<Scalars['String']['output']>;
  linkedinUrl?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  twitterUrl?: Maybe<Scalars['String']['output']>;
  youtubeUrl?: Maybe<Scalars['String']['output']>;
};

export type BusinessCardAdditionalInformationInput = {
  companySize: Scalars['String']['input'];
  companyUrl?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  facebookUrl?: InputMaybe<Scalars['String']['input']>;
  headquarters: BusinessCardLocationInput;
  industry: BusinessCardIndustry;
  instagramUrl?: InputMaybe<Scalars['String']['input']>;
  linkedinUrl?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  twitterUrl?: InputMaybe<Scalars['String']['input']>;
  youtubeUrl?: InputMaybe<Scalars['String']['input']>;
};

export enum BusinessCardAssetType {
  BANNER = 'BANNER',
  LOGO = 'LOGO',
}

export enum BusinessCardAutocompleteType {
  CITY = 'CITY',
  POSTAL_CODE = 'POSTAL_CODE',
  REGION = 'REGION',
  STREET = 'STREET',
}

export type BusinessCardBaseProfile = {
  about?: Maybe<BusinessCardAbout>;
  additionalInfo?: Maybe<BusinessCardAdditionalInfo>;
  contact?: Maybe<BusinessCardContact>;
  header?: Maybe<BusinessCardHeader>;
  id: Scalars['ID']['output'];
  lifeAt?: Maybe<BusinessCardLifeAt>;
  publishedAt?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  userUuid: Scalars['String']['output'];
};

export type BusinessCardConfirmAssetsInput = {
  assetType: BusinessCardAssetType;
  fileId: Scalars['String']['input'];
  unsplashId?: InputMaybe<Scalars['String']['input']>;
};

export type BusinessCardContact = {
  __typename?: 'BusinessCardContact';
  companyName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  headquarters?: Maybe<BusinessCardLocation>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type BusinessCardContactInput = {
  companyName: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  headquarters: BusinessCardLocationInput;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type BusinessCardHeader = {
  __typename?: 'BusinessCardHeader';
  bannerUrl?: Maybe<Scalars['String']['output']>;
};

export enum BusinessCardIndustry {
  AGRICULTURE_FORESTRY_AND_FISHING = 'AGRICULTURE_FORESTRY_AND_FISHING',
  ARTS_MEDIA_AND_ENTERTAINMENT = 'ARTS_MEDIA_AND_ENTERTAINMENT',
  AUTOMOTIVE = 'AUTOMOTIVE',
  CARE = 'CARE',
  CONSTRUCTION = 'CONSTRUCTION',
  EDUCATION = 'EDUCATION',
  ENERGY_MINING_AND_UTILITIES = 'ENERGY_MINING_AND_UTILITIES',
  ENVIRONMENTAL_PROTECTION = 'ENVIRONMENTAL_PROTECTION',
  FINANCIAL_SERVICES = 'FINANCIAL_SERVICES',
  GOVERNMENT_AND_PUBLIC_ADMINISTRATION = 'GOVERNMENT_AND_PUBLIC_ADMINISTRATION',
  HEALTHCARE = 'HEALTHCARE',
  HEALTH_AND_BEAUTY = 'HEALTH_AND_BEAUTY',
  HUMANRESOURCES_AND_RECRUITMENT = 'HUMANRESOURCES_AND_RECRUITMENT',
  INFORMATION_TECHNOLOGY = 'INFORMATION_TECHNOLOGY',
  INSURANCE = 'INSURANCE',
  LEGAL_SERVICES = 'LEGAL_SERVICES',
  MAINTENANCE_SERVICES = 'MAINTENANCE_SERVICES',
  MANAGEMENT_AND_CONSULTING = 'MANAGEMENT_AND_CONSULTING',
  MANUFACTURING = 'MANUFACTURING',
  MARKETING = 'MARKETING',
  NONPROFIT_AND_NGOS = 'NONPROFIT_AND_NGOS',
  PHARMACEUTICAL_AND_BIOTECHNOLOGY = 'PHARMACEUTICAL_AND_BIOTECHNOLOGY',
  REAL_ESTATE = 'REAL_ESTATE',
  RESTAURANTS_AND_FOOD_SERVICE = 'RESTAURANTS_AND_FOOD_SERVICE',
  RETAIL_AND_WHOLESALE = 'RETAIL_AND_WHOLESALE',
  SECURITY = 'SECURITY',
  TELECOMMUNICATIONS = 'TELECOMMUNICATIONS',
  TOURISM = 'TOURISM',
  TRANSPORTATION_AND_LOGISTICS = 'TRANSPORTATION_AND_LOGISTICS',
}

export type BusinessCardLifeAt = {
  __typename?: 'BusinessCardLifeAt';
  description?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<BusinessCardLifeAtItem>>;
};

export type BusinessCardLifeAtInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<Array<BusinessCardLifeAtItemInput>>;
};

/**
 * IMPORTANT!!!
 * Adding new union type requires handling it in the BusinessCardLifeAtItem resolvers!!!
 * i.e. if (obj.type === BusinessCardLifeAtItemType.Image) return "BusinessCardLifeAtItemImage";
 * see business-card-resolvers.ts
 */
export type BusinessCardLifeAtItem =
  | BusinessCardLifeAtItemExternalVideo
  | BusinessCardLifeAtItemImage;

export type BusinessCardLifeAtItemExternalVideo = {
  __typename?: 'BusinessCardLifeAtItemExternalVideo';
  id: Scalars['ID']['output'];
  type: BusinessCardLifeAtItemType;
  url: Scalars['String']['output'];
};

export type BusinessCardLifeAtItemImage = {
  __typename?: 'BusinessCardLifeAtItemImage';
  fileId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  type: BusinessCardLifeAtItemType;
  url: Scalars['String']['output'];
};

export type BusinessCardLifeAtItemInput = {
  fileId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  type: BusinessCardLifeAtItemType;
  url?: InputMaybe<Scalars['String']['input']>;
};

export enum BusinessCardLifeAtItemType {
  EXTERNAL_VIDEO = 'EXTERNAL_VIDEO',
  IMAGE = 'IMAGE',
}

export type BusinessCardLocation = {
  __typename?: 'BusinessCardLocation';
  city: Scalars['String']['output'];
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
  region?: Maybe<Scalars['String']['output']>;
  streetName?: Maybe<Scalars['String']['output']>;
  streetNumber?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type BusinessCardLocationInput = {
  city: Scalars['String']['input'];
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
  region?: InputMaybe<Scalars['String']['input']>;
  streetName?: InputMaybe<Scalars['String']['input']>;
  streetNumber?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export enum BusinessCardLocationProvider {
  AWS = 'AWS',
  GOOGLE = 'GOOGLE',
}

export type BusinessCardLocationSuggestion = {
  __typename?: 'BusinessCardLocationSuggestion';
  city: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
  region: Scalars['String']['output'];
  streetName: Scalars['String']['output'];
  streetNumber: Scalars['String']['output'];
  zipCode: Scalars['String']['output'];
};

export type BusinessCardMutation = {
  __typename?: 'BusinessCardMutation';
  confirmAssets: BusinessCardPrivateProfile;
  deleteAssets: BusinessCardPrivateProfile;
  deleteData: Scalars['Boolean']['output'];
  publishProfile: BusinessCardPrivateProfile;
  saveAbout: BusinessCardPrivateProfile;
  saveAdditionalInformation: BusinessCardPrivateProfile;
  saveContact: BusinessCardPrivateProfile;
  saveLifeAt: BusinessCardPrivateProfile;
  unpublishProfile: BusinessCardPrivateProfile;
};

export type BusinessCardMutationConfirmAssetsArgs = {
  input: Array<BusinessCardConfirmAssetsInput>;
};

export type BusinessCardMutationDeleteAssetsArgs = {
  input: Array<BusinessCardAssetType>;
};

export type BusinessCardMutationSaveAboutArgs = {
  input: BusinessCardAboutInput;
};

export type BusinessCardMutationSaveAdditionalInformationArgs = {
  input: BusinessCardAdditionalInformationInput;
};

export type BusinessCardMutationSaveContactArgs = {
  input: BusinessCardContactInput;
};

export type BusinessCardMutationSaveLifeAtArgs = {
  input: BusinessCardLifeAtInput;
};

export type BusinessCardPrivateProfile = BusinessCardBaseProfile & {
  __typename?: 'BusinessCardPrivateProfile';
  about?: Maybe<BusinessCardAbout>;
  additionalInfo?: Maybe<BusinessCardAdditionalInfo>;
  contact?: Maybe<BusinessCardContact>;
  header?: Maybe<BusinessCardHeader>;
  id: Scalars['ID']['output'];
  lifeAt?: Maybe<BusinessCardLifeAt>;
  publishedAt?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  userUuid: Scalars['String']['output'];
};

export type BusinessCardPublicProfile = BusinessCardBaseProfile & {
  __typename?: 'BusinessCardPublicProfile';
  about?: Maybe<BusinessCardAbout>;
  additionalInfo?: Maybe<BusinessCardAdditionalInfo>;
  contact?: Maybe<BusinessCardContact>;
  header?: Maybe<BusinessCardHeader>;
  id: Scalars['ID']['output'];
  lifeAt?: Maybe<BusinessCardLifeAt>;
  publishedAt?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  userUuid: Scalars['String']['output'];
};

export type BusinessCardPublicProfileInput = {
  slug?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type BusinessCardQuery = {
  __typename?: 'BusinessCardQuery';
  locationSuggestions: Array<BusinessCardLocationSuggestion>;
  privateProfile?: Maybe<BusinessCardPrivateProfile>;
  publicProfileBySlug?: Maybe<BusinessCardPublicProfile>;
  publicProfileByUuid?: Maybe<BusinessCardPublicProfile>;
  uploadRequestData: BusinessCardUploadRequestDataPayload;
};

export type BusinessCardQueryLocationSuggestionsArgs = {
  phrase: Scalars['String']['input'];
  provider?: InputMaybe<BusinessCardLocationProvider>;
  type?: InputMaybe<BusinessCardAutocompleteType>;
};

export type BusinessCardQueryPublicProfileBySlugArgs = {
  slug: Scalars['String']['input'];
};

export type BusinessCardQueryPublicProfileByUuidArgs = {
  uuid: Scalars['String']['input'];
};

export type BusinessCardUploadRequestDataPayload = {
  __typename?: 'BusinessCardUploadRequestDataPayload';
  token: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type CvGeneratorInput = {
  applicationID?: InputMaybe<Scalars['String']['input']>;
  includeSections?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  template?: InputMaybe<Scalars['String']['input']>;
};

export type CvGeneratorOutput = {
  __typename?: 'CVGeneratorOutput';
  token: Scalars['String']['output'];
};

export type CvParsingResult = {
  __typename?: 'CVParsingResult';
  profile?: Maybe<CandidateProfileProfile>;
  status: Scalars['String']['output'];
};

export enum CacheControlScope {
  PRIVATE = 'PRIVATE',
  PUBLIC = 'PUBLIC',
}

export type Candidate = {
  __typename?: 'Candidate';
  cacheId: Scalars['String']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isRemoved: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type CandidateProfile = {
  __typename?: 'CandidateProfile';
  candidateId: Scalars['String']['output'];
  candidateProfile?: Maybe<CandidateProfileData>;
};

export type CandidateProfileAd = {
  __typename?: 'CandidateProfileAd';
  categoryID: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isBusiness: Scalars['Boolean']['output'];
  ownerID: Scalars['String']['output'];
  ownerUUID?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type CandidateProfileApplication = {
  __typename?: 'CandidateProfileApplication';
  ID: Scalars['ID']['output'];
  ad?: Maybe<CandidateProfileAd>;
  /** User's answers to Apply questions */
  answers?: Maybe<Array<CandidateProfileApplicationAnswer>>;
  attachments?: Maybe<Array<Attachment>>;
  cancelledAt?: Maybe<Scalars['String']['output']>;
  candidateID: Scalars['String']['output'];
  candidateUUID?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  cv?: Maybe<Attachment>;
  /** @deprecated field removed */
  cvFileID?: Maybe<Scalars['String']['output']>;
  /** @deprecated field removed */
  cvFileName?: Maybe<Scalars['String']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  employerID: Scalars['String']['output'];
  employerMeetingDate?: Maybe<Scalars['String']['output']>;
  /**
   * In the future we can add more statuses.
   * Possible values at the moment are:
   * empty
   * MEETING_SCHEDULED - meeting scheduled, see also employerMeetingDate field
   */
  employerStatus?: Maybe<Scalars['String']['output']>;
  employerStatusChangedAt?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  fromInvitation?: Maybe<Scalars['Boolean']['output']>;
  hasBeenReadByEmployer: Scalars['Boolean']['output'];
  isCancelled: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
  phoneNumber: Scalars['String']['output'];
  withProfile: Scalars['Boolean']['output'];
};

export type CandidateProfileApplicationAnswer = {
  __typename?: 'CandidateProfileApplicationAnswer';
  question?: Maybe<ApplyQuestion>;
  values?: Maybe<Array<Scalars['String']['output']>>;
};

export type CandidateProfileApplicationsList = {
  __typename?: 'CandidateProfileApplicationsList';
  applications?: Maybe<Array<Maybe<CandidateProfileApplication>>>;
  cursor?: Maybe<Array<Maybe<CandidateProfileCursorKey>>>;
};

export type CandidateProfileApplyValidation = {
  __typename?: 'CandidateProfileApplyValidation';
  result: Scalars['Boolean']['output'];
};

export type CandidateProfileBasicInfo = {
  __typename?: 'CandidateProfileBasicInfo';
  emailAddress?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  location?: Maybe<CandidateProfileLocation>;
  locationRange?: Maybe<Scalars['Int']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  yearOfBirth?: Maybe<Scalars['Int']['output']>;
};

export type CandidateProfileBasicInfoInput = {
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  yearOfBirth?: InputMaybe<Scalars['Int']['input']>;
};

export type CandidateProfileCv = {
  __typename?: 'CandidateProfileCV';
  /**
   * ID - Apollo ID, use in AttachmentInput
   * Ex. abc7pynrqwog1-JOBSPL
   */
  ID: Scalars['ID']['output'];
  createdAt: Scalars['String']['output'];
  /** Download token - pass as Authorization header, works only with downloadURL */
  downloadToken: Scalars['String']['output'];
  /** Download URL - works only with downloadToken */
  downloadURL: Scalars['String']['output'];
  /**
   * Name - file name with extension, use in AttachmentInput
   * Ex. my_cv.pdf
   */
  name: Scalars['String']['output'];
  /**
   * Download URL - works only with token
   * @deprecated please use downloadURL instead
   */
  simpleURL: Scalars['String']['output'];
  /**
   * Download token - pass as Authorization header, works only with simpleURL
   * @deprecated please use downloadToken instead
   */
  token: Scalars['String']['output'];
  /**
   * URL - Apollo file URL, original file URL returned by Apollo, use in AttachmentInput, DO NOT USE FOR DOWNLOAD
   * New Apollo Secure Storage doesn't provide this URL.
   * Ex. https://ireland.apollo.olxcdn.com/v1/files/abcd123-JOBSPL/document"
   * Ex. https://ireland.apollo.olxcdn.com/v1/files/abcd123-JOBSPL/image"
   */
  url?: Maybe<Scalars['String']['output']>;
};

export type CandidateProfileCvCopy = {
  __typename?: 'CandidateProfileCVCopy';
  /**
   * ID - Apollo ID, use in AttachmentInput
   * Ex. abc7pynrqwog1-JOBSPL
   */
  ID: Scalars['String']['output'];
  /**
   * Name - file name with extension, use in AttachmentInput
   * Ex. my_cv.pdf
   */
  name: Scalars['String']['output'];
  /**
   * URL - Apollo file URL, original file URL returned by Apollo, use in AttachmentInput, DO NOT USE FOR DOWNLOAD
   * New Apollo Secure Storage doesn't provide this URL.
   * Ex. https://ireland.apollo.olxcdn.com/v1/files/abcd123-JOBSPL/document"
   * Ex. https://ireland.apollo.olxcdn.com/v1/files/abcd123-JOBSPL/image"
   */
  url?: Maybe<Scalars['String']['output']>;
};

export type CandidateProfileCvCopyV2 = {
  __typename?: 'CandidateProfileCVCopyV2';
  /**
   * ID - Apollo ID, use in AttachmentInput
   * Ex. abc7pynrqwog1-JOBSPL
   */
  ID: Scalars['String']['output'];
  /**
   * Name - file name with extension, use in AttachmentInput
   * Ex. my_cv.pdf
   */
  name: Scalars['String']['output'];
  /** Stamp - Apollo Secure encoded metadata for file, required for new files, use in AttachmentInput */
  stamp?: Maybe<Scalars['String']['output']>;
};

export type CandidateProfileCvGeneratorToken = {
  __typename?: 'CandidateProfileCVGeneratorToken';
  token: Scalars['String']['output'];
};

export type CandidateProfileCountryOptions = {
  __typename?: 'CandidateProfileCountryOptions';
  contracts: Array<ProfileCountryOption>;
  drivingLicenses: Array<ProfileCountryOption>;
  salaryCurrency: Array<ProfileCountryOption>;
  salaryPeriod: Array<CandidateProfileSalaryPeriod>;
  salaryType: Array<CandidateProfileSalaryType>;
  workingHours: Array<ProfileCountryOption>;
};

export type CandidateProfileCursorKey = {
  __typename?: 'CandidateProfileCursorKey';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type CandidateProfileCursorKeyInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type CandidateProfileData = {
  __typename?: 'CandidateProfileData';
  basicInfo?: Maybe<CandidateProfileBasicInfo>;
  completeness: Scalars['Int']['output'];
  drivingLicense?: Maybe<Array<CandidateProfileDrivingLicenseCategory>>;
  education?: Maybe<Array<CandidateProfileSchool>>;
  experience?: Maybe<Array<CandidateProfileExperience>>;
  hobby?: Maybe<Scalars['String']['output']>;
  languages?: Maybe<Array<CandidateProfileLanguageSkill>>;
  skills?: Maybe<Array<Scalars['String']['output']>>;
};

export enum CandidateProfileDrivingLicenseCategory {
  A = 'A',
  A1 = 'A1',
  B = 'B',
  B1 = 'B1',
  BPLUSE = 'BPLUSE',
  C = 'C',
  C1 = 'C1',
  C1PLUSE = 'C1PLUSE',
  CPLUSE = 'CPLUSE',
  D = 'D',
  D1 = 'D1',
  D1PLUSE = 'D1PLUSE',
  DPLUSE = 'DPLUSE',
  T = 'T',
}

export type CandidateProfileExperience = {
  __typename?: 'CandidateProfileExperience';
  description?: Maybe<Scalars['String']['output']>;
  employerName?: Maybe<Scalars['String']['output']>;
  endMonth?: Maybe<Scalars['Int']['output']>;
  endYear?: Maybe<Scalars['Int']['output']>;
  jobTitle: Scalars['String']['output'];
  ongoing: Scalars['Boolean']['output'];
  startMonth: Scalars['Int']['output'];
  startYear: Scalars['Int']['output'];
};

export type CandidateProfileExperienceInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  employerName?: InputMaybe<Scalars['String']['input']>;
  endMonth?: InputMaybe<Scalars['Int']['input']>;
  endYear?: InputMaybe<Scalars['Int']['input']>;
  jobTitle: Scalars['String']['input'];
  ongoing: Scalars['Boolean']['input'];
  startMonth: Scalars['Int']['input'];
  startYear: Scalars['Int']['input'];
};

export enum CandidateProfileLanguage {
  AF = 'AF',
  AR = 'AR',
  BE = 'BE',
  BG = 'BG',
  CA = 'CA',
  CS = 'CS',
  DA = 'DA',
  DE = 'DE',
  EL = 'EL',
  EN = 'EN',
  ES = 'ES',
  ET = 'ET',
  FA = 'FA',
  FI = 'FI',
  FR = 'FR',
  HE = 'HE',
  HI = 'HI',
  HR = 'HR',
  HU = 'HU',
  HY = 'HY',
  ID = 'ID',
  IS = 'IS',
  IT = 'IT',
  JA = 'JA',
  KA = 'KA',
  KK = 'KK',
  KO = 'KO',
  LT = 'LT',
  LV = 'LV',
  MK = 'MK',
  MN = 'MN',
  MS = 'MS',
  NL = 'NL',
  NOR = 'NOR',
  PL = 'PL',
  PT = 'PT',
  RO = 'RO',
  RU = 'RU',
  SK = 'SK',
  SL = 'SL',
  SQ = 'SQ',
  SR = 'SR',
  SV = 'SV',
  SW = 'SW',
  TH = 'TH',
  TR = 'TR',
  TT = 'TT',
  UK = 'UK',
  UZ = 'UZ',
  VI = 'VI',
  VLS = 'VLS',
  ZH = 'ZH',
}

export type CandidateProfileLanguageSkill = {
  __typename?: 'CandidateProfileLanguageSkill';
  language: CandidateProfileLanguage;
  proficiency: CandidateProfileProficiency;
};

export type CandidateProfileLanguageSkillInput = {
  language: CandidateProfileLanguage;
  proficiency: CandidateProfileProficiency;
};

export type CandidateProfileLatestApplication = {
  __typename?: 'CandidateProfileLatestApplication';
  ID: Scalars['ID']['output'];
  attachments?: Maybe<Array<Attachment>>;
  cancelledAt?: Maybe<Scalars['String']['output']>;
  candidateID: Scalars['String']['output'];
  candidateUUID?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  cv?: Maybe<Attachment>;
  /** @deprecated field removed */
  cvFileID?: Maybe<Scalars['String']['output']>;
  /** @deprecated field removed */
  cvFileName?: Maybe<Scalars['String']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  employerID: Scalars['String']['output'];
  employerStatus?: Maybe<Scalars['String']['output']>;
  employerStatusChangedAt?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  hasBeenReadByEmployer: Scalars['Boolean']['output'];
  isCancelled: Scalars['Boolean']['output'];
  isOnlyApplication?: Maybe<Scalars['Boolean']['output']>;
  lastName: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
  phoneNumber: Scalars['String']['output'];
  withProfile: Scalars['Boolean']['output'];
};

export type CandidateProfileLocation = {
  __typename?: 'CandidateProfileLocation';
  cityId: Scalars['Int']['output'];
  districtId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type CandidateProfileLocationInput = {
  cityId: Scalars['Int']['input'];
  districtId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type CandidateProfileMutation = {
  __typename?: 'CandidateProfileMutation';
  ApplyNew: Scalars['String']['output'];
  BasicInfo: CandidateProfileProfile;
  CV?: Maybe<CandidateProfileCv>;
  CVParsingSubmit?: Maybe<Scalars['String']['output']>;
  CancelApplication?: Maybe<CandidateProfileApplication>;
  CandidatesDatabaseConsentSetting: CandidateProfileSettings;
  CopyCV?: Maybe<CandidateProfileCvCopy>;
  CopyCVV2?: Maybe<CandidateProfileCvCopyV2>;
  DashboardEnabledSettings: CandidateProfileSettings;
  DeleteCV?: Maybe<Scalars['String']['output']>;
  DeletePreferences: CandidateProfilePreferences;
  DeleteProfile: CandidateProfileProfile;
  Dislike?: Maybe<Scalars['String']['output']>;
  DrivingLicense: CandidateProfileProfile;
  Education: CandidateProfileProfile;
  Experience: CandidateProfileProfile;
  Hobby: CandidateProfileProfile;
  IncrementApplicationCounter?: Maybe<Scalars['String']['output']>;
  Languages: CandidateProfileProfile;
  Like?: Maybe<Scalars['String']['output']>;
  PreferredGeneric: CandidateProfilePreferences;
  PreferredLocation: CandidateProfilePreferences;
  PreferredRoles: CandidateProfilePreferences;
  PreferredSalary: CandidateProfilePreferences;
  SaveApplyQuestionsUserAnswers?: Maybe<Scalars['String']['output']>;
  Skills: CandidateProfileProfile;
  Undislike?: Maybe<Scalars['String']['output']>;
  Unlike?: Maybe<Scalars['String']['output']>;
  UpdateApplication?: Maybe<CandidateProfileApplication>;
  VisibilitySettings: CandidateProfileSettings;
};

export type CandidateProfileMutationApplyNewArgs = {
  input: ApplicationInput;
};

export type CandidateProfileMutationBasicInfoArgs = {
  input: CandidateProfileBasicInfoInput;
};

export type CandidateProfileMutationCvArgs = {
  input: AttachmentInput;
};

export type CandidateProfileMutationCancelApplicationArgs = {
  ID: Scalars['ID']['input'];
  sendMessageOnBackend?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CandidateProfileMutationCandidatesDatabaseConsentSettingArgs = {
  input: Scalars['Boolean']['input'];
};

export type CandidateProfileMutationDashboardEnabledSettingsArgs = {
  input: Scalars['Boolean']['input'];
};

export type CandidateProfileMutationDislikeArgs = {
  adId: Scalars['String']['input'];
};

export type CandidateProfileMutationDrivingLicenseArgs = {
  input?: InputMaybe<Array<CandidateProfileDrivingLicenseCategory>>;
};

export type CandidateProfileMutationEducationArgs = {
  input: Array<CandidateProfileSchoolInput>;
};

export type CandidateProfileMutationExperienceArgs = {
  input?: InputMaybe<Array<CandidateProfileExperienceInput>>;
};

export type CandidateProfileMutationHobbyArgs = {
  input?: InputMaybe<Scalars['String']['input']>;
};

export type CandidateProfileMutationIncrementApplicationCounterArgs = {
  adID: Scalars['String']['input'];
};

export type CandidateProfileMutationLanguagesArgs = {
  input?: InputMaybe<Array<CandidateProfileLanguageSkillInput>>;
};

export type CandidateProfileMutationLikeArgs = {
  adId: Scalars['String']['input'];
};

export type CandidateProfileMutationPreferredGenericArgs = {
  input: Array<Scalars['String']['input']>;
  inputType: CandidateProfilePreferenceType;
};

export type CandidateProfileMutationPreferredLocationArgs = {
  input: CandidateProfilePreferredLocationInput;
};

export type CandidateProfileMutationPreferredRolesArgs = {
  input: Array<Scalars['String']['input']>;
};

export type CandidateProfileMutationPreferredSalaryArgs = {
  input: CandidateProfilePreferredSalaryInput;
};

export type CandidateProfileMutationSaveApplyQuestionsUserAnswersArgs = {
  answers: Array<ApplyQuestionUserAnswerInput>;
  applicationID: Scalars['ID']['input'];
};

export type CandidateProfileMutationSkillsArgs = {
  input?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CandidateProfileMutationUndislikeArgs = {
  adId: Scalars['String']['input'];
};

export type CandidateProfileMutationUnlikeArgs = {
  adId: Scalars['String']['input'];
};

export type CandidateProfileMutationUpdateApplicationArgs = {
  ID: Scalars['ID']['input'];
  input: ApplicationUpdateInput;
};

export type CandidateProfileMutationVisibilitySettingsArgs = {
  input: CandidateProfileVisibility;
};

export type CandidateProfileNoAuthMutation = {
  __typename?: 'CandidateProfileNoAuthMutation';
  /** @deprecated use CandidateProfileMutation */
  IncrementCounter?: Maybe<Scalars['String']['output']>;
};

export type CandidateProfileNoAuthMutationIncrementCounterArgs = {
  adID: Scalars['String']['input'];
};

export enum CandidateProfileNotificationFrequency {
  EVERYDAY = 'everyday',
  NEVER = 'never',
  ONCEAWEEK = 'onceAWeek',
  TWICEAWEEK = 'twiceAWeek',
}

export type CandidateProfileNotificationsSettings = {
  __typename?: 'CandidateProfileNotificationsSettings';
  email?: Maybe<CandidateProfileNotificationFrequency>;
  push?: Maybe<CandidateProfileNotificationFrequency>;
};

export enum CandidateProfilePreferenceType {
  CONTRACTS = 'contracts',
  WORKINGHOURS = 'workingHours',
}

export type CandidateProfilePreferences = {
  __typename?: 'CandidateProfilePreferences';
  location: CandidateProfileLocation;
  locationRange: Scalars['Int']['output'];
  /** @deprecated field removed */
  preferredContracts: Array<Scalars['String']['output']>;
  preferredContractsV2: Array<Scalars['String']['output']>;
  preferredRoles: Array<Scalars['String']['output']>;
  preferredSalary: CandidateProfilePreferredSalary;
  /** @deprecated field removed */
  preferredWorkingHours: Array<Scalars['String']['output']>;
  preferredWorkingHoursV2: Array<Scalars['String']['output']>;
};

export type CandidateProfilePreferredLocationInput = {
  location: CandidateProfileLocationInput;
  locationRange: Scalars['Int']['input'];
};

export type CandidateProfilePreferredSalary = {
  __typename?: 'CandidateProfilePreferredSalary';
  amount: Scalars['Float']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  period: CandidateProfileSalaryPeriod;
  type: CandidateProfileSalaryType;
};

export type CandidateProfilePreferredSalaryInput = {
  amount: Scalars['Float']['input'];
  currency?: InputMaybe<Scalars['String']['input']>;
  period: CandidateProfileSalaryPeriod;
  type: CandidateProfileSalaryType;
};

export enum CandidateProfileProficiency {
  ADVANCED = 'ADVANCED',
  BEGINNER = 'BEGINNER',
  FLUENT = 'FLUENT',
  INTERMEDIATE = 'INTERMEDIATE',
}

export type CandidateProfileProfile = {
  __typename?: 'CandidateProfileProfile';
  basicInfo?: Maybe<CandidateProfileBasicInfo>;
  completeness: Scalars['Int']['output'];
  drivingLicense?: Maybe<Array<CandidateProfileDrivingLicenseCategory>>;
  education: Array<CandidateProfileSchool>;
  experience?: Maybe<Array<CandidateProfileExperience>>;
  hobby?: Maybe<Scalars['String']['output']>;
  languages?: Maybe<Array<CandidateProfileLanguageSkill>>;
  skills?: Maybe<Array<Scalars['String']['output']>>;
};

export type CandidateProfileQuery = {
  __typename?: 'CandidateProfileQuery';
  Application?: Maybe<CandidateProfileApplication>;
  ApplicationProfile: CandidateProfileProfile;
  ApplicationsCount?: Maybe<Scalars['Int']['output']>;
  ApplicationsList: CandidateProfileApplicationsList;
  ApplyQuestions?: Maybe<Array<ApplyQuestion>>;
  ApplyValidation?: Maybe<CandidateProfileApplyValidation>;
  AutoSuggest?: Maybe<Array<Maybe<CandidateProfileSuggestion>>>;
  CV?: Maybe<CandidateProfileCv>;
  CVGeneratorTokenProvider?: Maybe<CandidateProfileCvGeneratorToken>;
  CVParsingResult: CvParsingResult;
  Experiment?: Maybe<Scalars['String']['output']>;
  IsJobSeeker?: Maybe<Scalars['Boolean']['output']>;
  LatestApplication?: Maybe<CandidateProfileLatestApplication>;
  Preferences: CandidateProfilePreferences;
  Profile: CandidateProfileProfile;
  ProfileCountryOptions: CandidateProfileCountryOptions;
  ProposedSkills: Array<Maybe<Scalars['String']['output']>>;
  /** @deprecated use RecommendationsV2 query */
  Recommendations: Array<CandidateProfileRecommendation>;
  RecommendationsV2: Array<CandidateProfileRecommendationJobOffer>;
  Settings: CandidateProfileSettings;
  UploadData: CandidateProfileUploadData;
  UploadToken: Scalars['String']['output'];
};

export type CandidateProfileQueryApplicationArgs = {
  applicationID: Scalars['String']['input'];
};

export type CandidateProfileQueryApplicationProfileArgs = {
  applicationId: Scalars['String']['input'];
};

export type CandidateProfileQueryApplicationsListArgs = {
  cursor?: InputMaybe<Array<InputMaybe<CandidateProfileCursorKeyInput>>>;
  limit: Scalars['Int']['input'];
  orderBy?: InputMaybe<ApplicationsOrderByInput>;
};

export type CandidateProfileQueryApplyQuestionsArgs = {
  adID: Scalars['String']['input'];
};

export type CandidateProfileQueryApplyValidationArgs = {
  adID: Scalars['String']['input'];
};

export type CandidateProfileQueryAutoSuggestArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  phrase: Scalars['String']['input'];
  type: SuggestionType;
};

export type CandidateProfileQueryCvGeneratorTokenProviderArgs = {
  input?: InputMaybe<CvGeneratorInput>;
};

export type CandidateProfileQueryExperimentArgs = {
  alias: Scalars['String']['input'];
};

export type CandidateProfileQueryLatestApplicationArgs = {
  adId: Scalars['String']['input'];
};

export type CandidateProfileQueryRecommendationsArgs = {
  param?: InputMaybe<Scalars['String']['input']>;
};

export type CandidateProfileQueryRecommendationsV2Args = {
  param?: InputMaybe<Scalars['String']['input']>;
};

export type CandidateProfileRecommendation = {
  __typename?: 'CandidateProfileRecommendation';
  adId: Scalars['String']['output'];
  addedAt: Scalars['String']['output'];
  categoryId: Scalars['Int']['output'];
  cityName?: Maybe<Scalars['String']['output']>;
  contractType?: Maybe<Scalars['String']['output']>;
  districtName?: Maybe<Scalars['String']['output']>;
  rawParams: Array<CandidateProfileRecommendationRawParam>;
  salaryCurrency?: Maybe<Scalars['String']['output']>;
  salaryMax?: Maybe<Scalars['Float']['output']>;
  salaryMin?: Maybe<Scalars['Float']['output']>;
  salaryPeriod?: Maybe<CandidateProfileSalaryPeriod>;
  source: Scalars['String']['output'];
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
  workingHours?: Maybe<Scalars['String']['output']>;
};

export type CandidateProfileRecommendationJobOffer = {
  __typename?: 'CandidateProfileRecommendationJobOffer';
  ad?: Maybe<JobOfferOffer>;
  adId: Scalars['String']['output'];
  source: Scalars['String']['output'];
};

export type CandidateProfileRecommendationRawParam = {
  __typename?: 'CandidateProfileRecommendationRawParam';
  code: Scalars['String']['output'];
  value?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export enum CandidateProfileSalaryPeriod {
  HOURLY = 'hourly',
  MONTHLY = 'monthly',
}

export enum CandidateProfileSalaryType {
  GROSS = 'gross',
  NET = 'net',
}

export type CandidateProfileSchool = {
  __typename?: 'CandidateProfileSchool';
  endYear?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  ongoing: Scalars['Boolean']['output'];
  specialty?: Maybe<Scalars['String']['output']>;
  startYear: Scalars['Int']['output'];
};

export type CandidateProfileSchoolInput = {
  endYear?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  ongoing: Scalars['Boolean']['input'];
  specialty?: InputMaybe<Scalars['String']['input']>;
  startYear: Scalars['Int']['input'];
};

export type CandidateProfileSettings = {
  __typename?: 'CandidateProfileSettings';
  candidatesDatabaseConsent?: Maybe<Scalars['Boolean']['output']>;
  dashboardEnabled: Scalars['Boolean']['output'];
  notifications: CandidateProfileNotificationsSettings;
  visibility?: Maybe<CandidateProfileVisibility>;
};

export type CandidateProfileSuggestion = {
  __typename?: 'CandidateProfileSuggestion';
  name?: Maybe<Scalars['String']['output']>;
};

export type CandidateProfileUploadData = {
  __typename?: 'CandidateProfileUploadData';
  token: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export enum CandidateProfileVisibility {
  FOREMPLOYERSTOWHOMAPPLIED = 'forEmployersToWhomApplied',
  HIDDEN = 'hidden',
}

export type ChangeMultiAppStatusInput = {
  applicationId: Scalars['String']['input'];
  status: ApplicationStatus;
};

export type ChatAttachment = {
  __typename?: 'ChatAttachment';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  secureUrl: SecureUrl;
  url: Scalars['String']['output'];
};

export type ChatConversation = {
  __typename?: 'ChatConversation';
  archived: Scalars['Boolean']['output'];
  blocked: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  messages: Array<ChatMessage>;
};

export type ChatMessage = {
  __typename?: 'ChatMessage';
  attachments?: Maybe<Array<ChatAttachment>>;
  author: MessageAuthor;
  conversationId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  message: Scalars['String']['output'];
  seen: Scalars['Boolean']['output'];
};

export type CompanyProfileAbout = {
  __typename?: 'CompanyProfileAbout';
  companyName?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  tagline?: Maybe<Scalars['String']['output']>;
};

export type CompanyProfileAboutInput = {
  companyName: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  tagline?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyProfileAdditionalInfo = {
  __typename?: 'CompanyProfileAdditionalInfo';
  companySize?: Maybe<Scalars['String']['output']>;
  companyUrl?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  facebookUrl?: Maybe<Scalars['String']['output']>;
  headquarters?: Maybe<CompanyProfileLocation>;
  industry?: Maybe<CompanyProfileIndustry>;
  instagramUrl?: Maybe<Scalars['String']['output']>;
  linkedinUrl?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  twitterUrl?: Maybe<Scalars['String']['output']>;
  youtubeUrl?: Maybe<Scalars['String']['output']>;
};

export type CompanyProfileAdditionalInformationInput = {
  companySize: Scalars['String']['input'];
  companyUrl?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  facebookUrl?: InputMaybe<Scalars['String']['input']>;
  headquarters: CompanyProfileLocationInput;
  industry: CompanyProfileIndustry;
  instagramUrl?: InputMaybe<Scalars['String']['input']>;
  linkedinUrl?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  twitterUrl?: InputMaybe<Scalars['String']['input']>;
  youtubeUrl?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyProfileAds = {
  __typename?: 'CompanyProfileAds';
  ads: Array<JobOfferOffer>;
  aggregations: CompanyProfileAdsAggregations;
  total: Scalars['Int']['output'];
};

export type CompanyProfileAdsAggregation = {
  __typename?: 'CompanyProfileAdsAggregation';
  type: CompanyProfileAdsAggregationType;
  values: Array<CompanyProfileAdsAggregationValue>;
};

export enum CompanyProfileAdsAggregationType {
  CATEGORIES = 'CATEGORIES',
  CITIES = 'CITIES',
}

export type CompanyProfileAdsAggregationValue = {
  __typename?: 'CompanyProfileAdsAggregationValue';
  count: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type CompanyProfileAdsAggregations = {
  __typename?: 'CompanyProfileAdsAggregations';
  categories: CompanyProfileAdsAggregation;
  cities: CompanyProfileAdsAggregation;
};

export type CompanyProfileAdsInput = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  cityId?: InputMaybe<Scalars['Int']['input']>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  userUuid: Scalars['String']['input'];
};

export enum CompanyProfileAssetType {
  BANNER = 'BANNER',
  BANNER_MOBILE = 'BANNER_MOBILE',
  LOGO = 'LOGO',
}

export type CompanyProfileBaseProfile = {
  about?: Maybe<CompanyProfileAbout>;
  additionalInfo?: Maybe<CompanyProfileAdditionalInfo>;
  benefits?: Maybe<CompanyProfileBenefits>;
  contact?: Maybe<CompanyProfileContact>;
  header?: Maybe<CompanyProfileHeader>;
  id: Scalars['ID']['output'];
  lifeAt?: Maybe<CompanyProfileLifeAt>;
  publishedAt?: Maybe<Scalars['String']['output']>;
  recruitment?: Maybe<CompanyProfileRecruitment>;
  slug?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  userUuid: Scalars['String']['output'];
};

export enum CompanyProfileBenefit {
  ADDITIONAL_SOCIAL_BENEFITS = 'ADDITIONAL_SOCIAL_BENEFITS',
  CHILDCARE_SUPPORT = 'CHILDCARE_SUPPORT',
  COMPANY_CAR = 'COMPANY_CAR',
  COMPANY_PHONE = 'COMPANY_PHONE',
  DENTAL_CARE = 'DENTAL_CARE',
  DISCOUNTS_FROM_EXTERNAL_PARTNERS = 'DISCOUNTS_FROM_EXTERNAL_PARTNERS',
  DRINKS_AT_THE_OFFICE = 'DRINKS_AT_THE_OFFICE',
  EDUCATION_BUDGET = 'EDUCATION_BUDGET',
  EMPLOYEE_DISCOUNTS = 'EMPLOYEE_DISCOUNTS',
  EMPLOYEE_REFERRAL_PROGRAM = 'EMPLOYEE_REFERRAL_PROGRAM',
  EXTRA_DAYS_OFF = 'EXTRA_DAYS_OFF',
  FLEXIBLE_WORKING_HOURS = 'FLEXIBLE_WORKING_HOURS',
  FREE_MEALS = 'FREE_MEALS',
  FRUITS_AT_THE_OFFICE = 'FRUITS_AT_THE_OFFICE',
  IT_EQUIPMENT_OF_CHOICE = 'IT_EQUIPMENT_OF_CHOICE',
  LANGUAGE_COURSES = 'LANGUAGE_COURSES',
  LIFE_INSURANCE = 'LIFE_INSURANCE',
  PARTIES_AND_EVENTS = 'PARTIES_AND_EVENTS',
  PRIVATE_MEDICAL_INSURANCE = 'PRIVATE_MEDICAL_INSURANCE',
  RELOCATION_ASSISTANCE = 'RELOCATION_ASSISTANCE',
  REMOTE_WORK = 'REMOTE_WORK',
  SUBSIDIED_MEALS = 'SUBSIDIED_MEALS',
  SUBSIDIED_SPORTS = 'SUBSIDIED_SPORTS',
  SUBSIDIED_VACATIONS = 'SUBSIDIED_VACATIONS',
}

export type CompanyProfileBenefits = {
  __typename?: 'CompanyProfileBenefits';
  items?: Maybe<Array<CompanyProfileBenefit>>;
};

export type CompanyProfileBenefitsInput = {
  items?: InputMaybe<Array<CompanyProfileBenefit>>;
};

export type CompanyProfileConfig = {
  __typename?: 'CompanyProfileConfig';
  id: Scalars['ID']['output'];
  relations: CompanyProfileConfigRelations;
};

export type CompanyProfileConfigFeatureBanner = CompanyProfileConfigFeatureBase & {
  __typename?: 'CompanyProfileConfigFeatureBanner';
  enabled: Scalars['Boolean']['output'];
};

export type CompanyProfileConfigFeatureBase = {
  enabled: Scalars['Boolean']['output'];
};

export type CompanyProfileConfigFeatureBenefits = CompanyProfileConfigFeatureBase & {
  __typename?: 'CompanyProfileConfigFeatureBenefits';
  enabled: Scalars['Boolean']['output'];
};

export type CompanyProfileConfigFeatureCompanyUrl = CompanyProfileConfigFeatureBase & {
  __typename?: 'CompanyProfileConfigFeatureCompanyUrl';
  enabled: Scalars['Boolean']['output'];
};

export type CompanyProfileConfigFeatureFollowButton = CompanyProfileConfigFeatureBase & {
  __typename?: 'CompanyProfileConfigFeatureFollowButton';
  enabled: Scalars['Boolean']['output'];
};

export type CompanyProfileConfigFeatureGallery = CompanyProfileConfigFeatureBase & {
  __typename?: 'CompanyProfileConfigFeatureGallery';
  enabled: Scalars['Boolean']['output'];
  maxPhotos: Scalars['Int']['output'];
};

export type CompanyProfileConfigFeatureLogo = CompanyProfileConfigFeatureBase & {
  __typename?: 'CompanyProfileConfigFeatureLogo';
  enabled: Scalars['Boolean']['output'];
};

export type CompanyProfileConfigFeatureMultiprofile = CompanyProfileConfigFeatureBase & {
  __typename?: 'CompanyProfileConfigFeatureMultiprofile';
  enabled: Scalars['Boolean']['output'];
};

export type CompanyProfileConfigFeaturePromotedOnListing = CompanyProfileConfigFeatureBase & {
  __typename?: 'CompanyProfileConfigFeaturePromotedOnListing';
  enabled: Scalars['Boolean']['output'];
};

export type CompanyProfileConfigFeatureRecruitment = CompanyProfileConfigFeatureBase & {
  __typename?: 'CompanyProfileConfigFeatureRecruitment';
  enabled: Scalars['Boolean']['output'];
};

export type CompanyProfileConfigFeatureSocialLinks = CompanyProfileConfigFeatureBase & {
  __typename?: 'CompanyProfileConfigFeatureSocialLinks';
  enabled: Scalars['Boolean']['output'];
};

export type CompanyProfileConfigFeatures = {
  __typename?: 'CompanyProfileConfigFeatures';
  banner?: Maybe<CompanyProfileConfigFeatureBanner>;
  benefits?: Maybe<CompanyProfileConfigFeatureBenefits>;
  companyUrl?: Maybe<CompanyProfileConfigFeatureCompanyUrl>;
  followButton?: Maybe<CompanyProfileConfigFeatureFollowButton>;
  gallery?: Maybe<CompanyProfileConfigFeatureGallery>;
  logo?: Maybe<CompanyProfileConfigFeatureLogo>;
  multiprofile?: Maybe<CompanyProfileConfigFeatureMultiprofile>;
  promotedOnListing?: Maybe<CompanyProfileConfigFeaturePromotedOnListing>;
  recruitment?: Maybe<CompanyProfileConfigFeatureRecruitment>;
  socialLinks?: Maybe<CompanyProfileConfigFeatureSocialLinks>;
};

export type CompanyProfileConfigRelations = {
  __typename?: 'CompanyProfileConfigRelations';
  isMainProfile: Scalars['Boolean']['output'];
  subProfiles?: Maybe<Array<CompanyProfileConfigSubProfile>>;
};

export type CompanyProfileConfigSubProfile = {
  __typename?: 'CompanyProfileConfigSubProfile';
  id: Scalars['ID']['output'];
  userId: Scalars['String']['output'];
};

export type CompanyProfileConfirmAssetsInput = {
  assetType: CompanyProfileAssetType;
  fileId: Scalars['String']['input'];
  unsplashId?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyProfileContact = {
  __typename?: 'CompanyProfileContact';
  companyName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  headquarters?: Maybe<CompanyProfileLocation>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type CompanyProfileContactInput = {
  companyName: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  headquarters: CompanyProfileLocationInput;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyProfileHeader = {
  __typename?: 'CompanyProfileHeader';
  bannerUrl?: Maybe<Scalars['String']['output']>;
};

export enum CompanyProfileIndustry {
  AGRICULTURE_FORESTRY_AND_FISHING = 'AGRICULTURE_FORESTRY_AND_FISHING',
  ARTS_MEDIA_AND_ENTERTAINMENT = 'ARTS_MEDIA_AND_ENTERTAINMENT',
  AUTOMOTIVE = 'AUTOMOTIVE',
  CARE = 'CARE',
  CONSTRUCTION = 'CONSTRUCTION',
  EDUCATION = 'EDUCATION',
  ENERGY_MINING_AND_UTILITIES = 'ENERGY_MINING_AND_UTILITIES',
  ENVIRONMENTAL_PROTECTION = 'ENVIRONMENTAL_PROTECTION',
  FINANCIAL_SERVICES = 'FINANCIAL_SERVICES',
  GOVERNMENT_AND_PUBLIC_ADMINISTRATION = 'GOVERNMENT_AND_PUBLIC_ADMINISTRATION',
  HEALTHCARE = 'HEALTHCARE',
  HEALTH_AND_BEAUTY = 'HEALTH_AND_BEAUTY',
  HUMANRESOURCES_AND_RECRUITMENT = 'HUMANRESOURCES_AND_RECRUITMENT',
  INFORMATION_TECHNOLOGY = 'INFORMATION_TECHNOLOGY',
  INSURANCE = 'INSURANCE',
  LEGAL_SERVICES = 'LEGAL_SERVICES',
  MAINTENANCE_SERVICES = 'MAINTENANCE_SERVICES',
  MANAGEMENT_AND_CONSULTING = 'MANAGEMENT_AND_CONSULTING',
  MANUFACTURING = 'MANUFACTURING',
  MARKETING = 'MARKETING',
  NONPROFIT_AND_NGOS = 'NONPROFIT_AND_NGOS',
  PHARMACEUTICAL_AND_BIOTECHNOLOGY = 'PHARMACEUTICAL_AND_BIOTECHNOLOGY',
  REAL_ESTATE = 'REAL_ESTATE',
  RESTAURANTS_AND_FOOD_SERVICE = 'RESTAURANTS_AND_FOOD_SERVICE',
  RETAIL_AND_WHOLESALE = 'RETAIL_AND_WHOLESALE',
  SECURITY = 'SECURITY',
  TELECOMMUNICATIONS = 'TELECOMMUNICATIONS',
  TOURISM = 'TOURISM',
  TRANSPORTATION_AND_LOGISTICS = 'TRANSPORTATION_AND_LOGISTICS',
}

export type CompanyProfileLifeAt = {
  __typename?: 'CompanyProfileLifeAt';
  description?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<CompanyProfileLifeAtItem>>;
};

export type CompanyProfileLifeAtInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<Array<CompanyProfileLifeAtItemInput>>;
};

/**
 * IMPORTANT!!!
 * Adding new union type requires handling it in the CompanyProfileLifeAtItem resolvers!!!
 * i.e. if (obj.type === CompanyProfileLifeAtItemType.Image) return "CompanyProfileLifeAtItemImage";
 * see company-profile-resolvers.ts
 */
export type CompanyProfileLifeAtItem =
  | CompanyProfileLifeAtItemExternalVideo
  | CompanyProfileLifeAtItemImage;

export type CompanyProfileLifeAtItemExternalVideo = {
  __typename?: 'CompanyProfileLifeAtItemExternalVideo';
  id: Scalars['ID']['output'];
  type: CompanyProfileLifeAtItemType;
  url: Scalars['String']['output'];
};

export type CompanyProfileLifeAtItemImage = {
  __typename?: 'CompanyProfileLifeAtItemImage';
  fileId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  type: CompanyProfileLifeAtItemType;
  url: Scalars['String']['output'];
};

export type CompanyProfileLifeAtItemInput = {
  fileId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  type: CompanyProfileLifeAtItemType;
  url?: InputMaybe<Scalars['String']['input']>;
};

export enum CompanyProfileLifeAtItemType {
  EXTERNAL_VIDEO = 'EXTERNAL_VIDEO',
  IMAGE = 'IMAGE',
}

export type CompanyProfileLocation = {
  __typename?: 'CompanyProfileLocation';
  city: Scalars['String']['output'];
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
  region?: Maybe<Scalars['String']['output']>;
  streetName?: Maybe<Scalars['String']['output']>;
  streetNumber?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type CompanyProfileLocationInput = {
  city: Scalars['String']['input'];
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
  region?: InputMaybe<Scalars['String']['input']>;
  streetName?: InputMaybe<Scalars['String']['input']>;
  streetNumber?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyProfileMutation = {
  __typename?: 'CompanyProfileMutation';
  confirmAssets: CompanyProfilePrivateProfile;
  deleteAssets: CompanyProfilePrivateProfile;
  deleteData: Scalars['Boolean']['output'];
  publishProfile: CompanyProfilePrivateProfile;
  saveAbout: CompanyProfilePrivateProfile;
  saveAdditionalInformation: CompanyProfilePrivateProfile;
  saveBenefits: CompanyProfilePrivateProfile;
  saveContact: CompanyProfilePrivateProfile;
  saveLifeAt: CompanyProfilePrivateProfile;
  saveMetadata: Metadata;
  saveRecruitment: CompanyProfilePrivateProfile;
  unpublishProfile: CompanyProfilePrivateProfile;
};

export type CompanyProfileMutationConfirmAssetsArgs = {
  input: Array<CompanyProfileConfirmAssetsInput>;
};

export type CompanyProfileMutationDeleteAssetsArgs = {
  input: Array<CompanyProfileAssetType>;
};

export type CompanyProfileMutationSaveAboutArgs = {
  input: CompanyProfileAboutInput;
};

export type CompanyProfileMutationSaveAdditionalInformationArgs = {
  input: CompanyProfileAdditionalInformationInput;
};

export type CompanyProfileMutationSaveBenefitsArgs = {
  input: CompanyProfileBenefitsInput;
};

export type CompanyProfileMutationSaveContactArgs = {
  input: CompanyProfileContactInput;
};

export type CompanyProfileMutationSaveLifeAtArgs = {
  input: CompanyProfileLifeAtInput;
};

export type CompanyProfileMutationSaveMetadataArgs = {
  input: MetadataInput;
};

export type CompanyProfileMutationSaveRecruitmentArgs = {
  input: CompanyProfileRecruitmentInput;
};

export type CompanyProfilePrivateConfig = {
  __typename?: 'CompanyProfilePrivateConfig';
  features: CompanyProfileConfigFeatures;
  id: Scalars['ID']['output'];
  relations: CompanyProfilePrivateConfigRelations;
  tier: CompanyProfilePrivateConfigTier;
};

export type CompanyProfilePrivateConfigRelations = {
  __typename?: 'CompanyProfilePrivateConfigRelations';
  isMainProfile: Scalars['Boolean']['output'];
  subProfiles?: Maybe<Array<CompanyProfilePrivateConfigSubProfile>>;
};

export type CompanyProfilePrivateConfigSubProfile = {
  __typename?: 'CompanyProfilePrivateConfigSubProfile';
  id: Scalars['ID']['output'];
  userId: Scalars['String']['output'];
};

export type CompanyProfilePrivateConfigTier = {
  __typename?: 'CompanyProfilePrivateConfigTier';
  expireAt?: Maybe<Scalars['String']['output']>;
  type: CompanyProfileTierType;
};

export type CompanyProfilePrivateProfile = CompanyProfileBaseProfile & {
  __typename?: 'CompanyProfilePrivateProfile';
  about?: Maybe<CompanyProfileAbout>;
  additionalInfo?: Maybe<CompanyProfileAdditionalInfo>;
  benefits?: Maybe<CompanyProfileBenefits>;
  contact?: Maybe<CompanyProfileContact>;
  header?: Maybe<CompanyProfileHeader>;
  id: Scalars['ID']['output'];
  lifeAt?: Maybe<CompanyProfileLifeAt>;
  publishedAt?: Maybe<Scalars['String']['output']>;
  recruitment?: Maybe<CompanyProfileRecruitment>;
  slug?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  userUuid: Scalars['String']['output'];
};

export type CompanyProfileProfileCounters = {
  __typename?: 'CompanyProfileProfileCounters';
  ads: Scalars['Int']['output'];
  cities: Scalars['Int']['output'];
};

export type CompanyProfileProfilesCarousel = {
  __typename?: 'CompanyProfileProfilesCarousel';
  profiles: Array<CompanyProfileProfilesCarouselProfile>;
};

export type CompanyProfileProfilesCarouselInput = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  cityId?: InputMaybe<Scalars['Int']['input']>;
  isPromoted?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type CompanyProfileProfilesCarouselProfile = {
  __typename?: 'CompanyProfileProfilesCarouselProfile';
  bannerUrl?: Maybe<Scalars['String']['output']>;
  companyName: Scalars['String']['output'];
  counters: CompanyProfileProfileCounters;
  headquarters: CompanyProfileLocation;
  id: Scalars['ID']['output'];
  industry: CompanyProfileIndustry;
  logoUrl?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type CompanyProfileProfilesListing = {
  __typename?: 'CompanyProfileProfilesListing';
  profiles: Array<CompanyProfileProfilesListingProfile>;
  total: Scalars['Int']['output'];
};

export type CompanyProfileProfilesListingInput = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  cityId?: InputMaybe<Scalars['Int']['input']>;
  isPromoted?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyProfileProfilesListingProfile = {
  __typename?: 'CompanyProfileProfilesListingProfile';
  bannerUrl?: Maybe<Scalars['String']['output']>;
  companyName: Scalars['String']['output'];
  counters: CompanyProfileProfileCounters;
  headquarters: CompanyProfileLocation;
  id: Scalars['ID']['output'];
  industry: CompanyProfileIndustry;
  logoUrl?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type CompanyProfilePublicConfig = {
  __typename?: 'CompanyProfilePublicConfig';
  features: CompanyProfileConfigFeatures;
  tier: CompanyProfileTierType;
};

export type CompanyProfilePublicProfile = CompanyProfileBaseProfile & {
  __typename?: 'CompanyProfilePublicProfile';
  about?: Maybe<CompanyProfileAbout>;
  additionalInfo?: Maybe<CompanyProfileAdditionalInfo>;
  benefits?: Maybe<CompanyProfileBenefits>;
  config: CompanyProfilePublicConfig;
  contact?: Maybe<CompanyProfileContact>;
  header?: Maybe<CompanyProfileHeader>;
  id: Scalars['ID']['output'];
  lifeAt?: Maybe<CompanyProfileLifeAt>;
  publishedAt?: Maybe<Scalars['String']['output']>;
  recruitment?: Maybe<CompanyProfileRecruitment>;
  slug?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  userUuid: Scalars['String']['output'];
};

export type CompanyProfilePublicProfileInput = {
  slug?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyProfilePublicProfilesInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type CompanyProfileQuery = {
  __typename?: 'CompanyProfileQuery';
  ads: CompanyProfileAds;
  employerSegment: EmployerSegmentResponse;
  locationSuggestions: Array<LocationSuggestion>;
  metadata: Metadata;
  previewProfile?: Maybe<CompanyProfilePublicProfile>;
  privateConfig: CompanyProfilePrivateConfig;
  privateProfile?: Maybe<CompanyProfilePrivateProfile>;
  /** @deprecated use publicProfile or privateProfile instead */
  profile?: Maybe<EmployerProfile>;
  /** @deprecated use privateConfig instead */
  profileConfig: CompanyProfileConfig;
  /** @deprecated use publicProfile or privateProfile instead */
  profileV2?: Maybe<EmployerProfile>;
  /** @deprecated use profilesListing or profilesCarousel */
  profiles: Array<EmployerProfile>;
  profilesCarousel: CompanyProfileProfilesCarousel;
  profilesListing: CompanyProfileProfilesListing;
  publicProfileBySlug?: Maybe<CompanyProfilePublicProfile>;
  publicProfileByUuid?: Maybe<CompanyProfilePublicProfile>;
  /** @deprecated use profilesListing or profilesCarousel */
  publicProfiles: Array<CompanyProfilePublicProfile>;
  uploadRequestData: UploadRequestDataPayload;
};

export type CompanyProfileQueryAdsArgs = {
  input: CompanyProfileAdsInput;
};

export type CompanyProfileQueryEmployerSegmentArgs = {
  atlasUserId: Scalars['String']['input'];
};

export type CompanyProfileQueryLocationSuggestionsArgs = {
  phrase: Scalars['String']['input'];
  provider?: InputMaybe<LocationProvider>;
  type?: InputMaybe<AutocompleteType>;
};

export type CompanyProfileQueryProfileArgs = {
  fromMinisite?: InputMaybe<Scalars['Boolean']['input']>;
  uuid: Scalars['String']['input'];
};

export type CompanyProfileQueryProfileV2Args = {
  input: ProfileInput;
};

export type CompanyProfileQueryProfilesArgs = {
  input: ProfilesInput;
};

export type CompanyProfileQueryProfilesCarouselArgs = {
  input: CompanyProfileProfilesCarouselInput;
};

export type CompanyProfileQueryProfilesListingArgs = {
  input: CompanyProfileProfilesListingInput;
};

export type CompanyProfileQueryPublicProfileBySlugArgs = {
  slug: Scalars['String']['input'];
};

export type CompanyProfileQueryPublicProfileByUuidArgs = {
  uuid: Scalars['String']['input'];
};

export type CompanyProfileQueryPublicProfilesArgs = {
  input: CompanyProfilePublicProfilesInput;
};

export type CompanyProfileRecruitment = {
  __typename?: 'CompanyProfileRecruitment';
  items?: Maybe<Array<CompanyProfileRecruitmentProcess>>;
};

export type CompanyProfileRecruitmentInput = {
  items: Array<CompanyProfileRecruitmentProcessInput>;
};

export type CompanyProfileRecruitmentProcess = {
  __typename?: 'CompanyProfileRecruitmentProcess';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  steps: Array<CompanyProfileRecruitmentProcessStep>;
};

export type CompanyProfileRecruitmentProcessInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  steps: Array<CompanyProfileRecruitmentProcessStepInput>;
};

export type CompanyProfileRecruitmentProcessStep = {
  __typename?: 'CompanyProfileRecruitmentProcessStep';
  description: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type CompanyProfileRecruitmentProcessStepInput = {
  description: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export enum CompanyProfileTierType {
  FREE = 'FREE',
  PRO = 'PRO',
}

export type DeleteMultiAppWithChatInput = {
  applicationId: Scalars['String']['input'];
  conversationId?: InputMaybe<Scalars['String']['input']>;
};

export type EditMultiAppNoteInput = {
  applicationId: Scalars['String']['input'];
  content?: InputMaybe<Scalars['String']['input']>;
  updatedAt: Scalars['String']['input'];
};

export type EmployerLead = {
  __typename?: 'EmployerLead';
  closed: Scalars['Boolean']['output'];
  exists: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
};

export type EmployerPanelAdvancedApplyQuestionInput = {
  answers: Array<EmployerPanelApplyQuestionAnswerInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  label: Scalars['String']['input'];
  order: Scalars['Int']['input'];
  tag?: InputMaybe<Scalars['String']['input']>;
  variant: ApplyQuestionVariant;
};

export type EmployerPanelApplyQuestionAnswerInput = {
  isFavorite?: InputMaybe<Scalars['Boolean']['input']>;
  label: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type EmployerPanelApplyQuestionsByAdIdInput = {
  adId: Scalars['String']['input'];
  isPaid: Scalars['Boolean']['input'];
};

export type EmployerPanelMutation = {
  __typename?: 'EmployerPanelMutation';
  blockUser: Scalars['Boolean']['output'];
  changeMultiAppStatus: MultiApplication;
  closeEmployerLead: EmployerLead;
  deleteMultiAppWithChat: Scalars['Boolean']['output'];
  editMultiAppNote: MultiApplication;
  markMultiAppAsRead: MultiApplication;
  offerDelete?: Maybe<Scalars['Boolean']['output']>;
  removeApplyQuestionFromAd: Array<Maybe<ApplyQuestion>>;
  saveAdvancedQuestionsToAd: Array<Maybe<ApplyQuestion>>;
  saveApplyQuestionToAd: Array<Maybe<ApplyQuestion>>;
  saveMultiAppMeetingDate: MultiApplication;
  saveQuestionsToAd: Array<Maybe<ApplyQuestion>>;
  sendMessage: ChatMessage;
  setMultiAppRate: MultiApplication;
  unblockUser: Scalars['Boolean']['output'];
};

export type EmployerPanelMutationBlockUserArgs = {
  candidateId: Scalars['String']['input'];
};

export type EmployerPanelMutationChangeMultiAppStatusArgs = {
  input: ChangeMultiAppStatusInput;
};

export type EmployerPanelMutationCloseEmployerLeadArgs = {
  type: Scalars['String']['input'];
};

export type EmployerPanelMutationDeleteMultiAppWithChatArgs = {
  input: DeleteMultiAppWithChatInput;
};

export type EmployerPanelMutationEditMultiAppNoteArgs = {
  input: EditMultiAppNoteInput;
};

export type EmployerPanelMutationMarkMultiAppAsReadArgs = {
  applicationId: Scalars['String']['input'];
  conversationId?: InputMaybe<Scalars['String']['input']>;
};

export type EmployerPanelMutationOfferDeleteArgs = {
  id: Scalars['String']['input'];
};

export type EmployerPanelMutationRemoveApplyQuestionFromAdArgs = {
  input: RemoveApplyQuestionFromAdInput;
};

export type EmployerPanelMutationSaveAdvancedQuestionsToAdArgs = {
  input: EmployerPanelSaveAdvancedQuestionsToAdInput;
};

export type EmployerPanelMutationSaveApplyQuestionToAdArgs = {
  input: SaveApplyQuestionToAdInput;
};

export type EmployerPanelMutationSaveMultiAppMeetingDateArgs = {
  input: SaveMultiAppMeetingDateInput;
};

export type EmployerPanelMutationSaveQuestionsToAdArgs = {
  input?: InputMaybe<SaveApplyQuestionsToAdInput>;
};

export type EmployerPanelMutationSendMessageArgs = {
  input: SendMessageInput;
};

export type EmployerPanelMutationSetMultiAppRateArgs = {
  input: SetMultiAppRateInput;
};

export type EmployerPanelMutationUnblockUserArgs = {
  candidateId: Scalars['String']['input'];
};

export type EmployerPanelQuery = {
  __typename?: 'EmployerPanelQuery';
  applyQuestionsByAdId: Array<ApplyQuestion>;
  getAllPredefinedAQ: Array<Maybe<ApplyQuestion>>;
  getApolloToken: ApolloToken;
  getApplicationAttachments?: Maybe<ApplicationAttachments>;
  /** @deprecated use getProfileData instead */
  getCandidateProfile: CandidateProfile;
  getChatConversation: ChatConversation;
  getCvGeneratorToken: CvGeneratorOutput;
  getEmployerLead: EmployerLead;
  getEmployerSegment: EmployerSegmentResponse;
  getProfileData: CandidateProfile;
  multiAppByAppIds: Array<MultiApplication>;
  multiAppIds: Array<Scalars['String']['output']>;
  offerById: JobAd;
  offerDelete?: Maybe<Scalars['Boolean']['output']>;
  offerIds: Array<Scalars['String']['output']>;
  offersByIds: Array<JobAd>;
  stafflyGetTestResult?: Maybe<StafflyTestResult>;
};

export type EmployerPanelQueryApplyQuestionsByAdIdArgs = {
  input: EmployerPanelApplyQuestionsByAdIdInput;
};

export type EmployerPanelQueryGetAllPredefinedAqArgs = {
  excludeDefault?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EmployerPanelQueryGetApplicationAttachmentsArgs = {
  applicationId: Scalars['String']['input'];
};

export type EmployerPanelQueryGetCandidateProfileArgs = {
  applicationId: Scalars['String']['input'];
};

export type EmployerPanelQueryGetChatConversationArgs = {
  applicationId: Scalars['String']['input'];
};

export type EmployerPanelQueryGetEmployerLeadArgs = {
  type: Scalars['String']['input'];
};

export type EmployerPanelQueryGetProfileDataArgs = {
  applicationId: Scalars['String']['input'];
};

export type EmployerPanelQueryMultiAppByAppIdsArgs = {
  applicationIds: Array<Scalars['String']['input']>;
};

export type EmployerPanelQueryMultiAppIdsArgs = {
  input: MultiAppIdsInput;
};

export type EmployerPanelQueryOfferByIdArgs = {
  id: Scalars['String']['input'];
  withMultiApps?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EmployerPanelQueryOfferDeleteArgs = {
  id: Scalars['String']['input'];
};

export type EmployerPanelQueryOfferIdsArgs = {
  input?: InputMaybe<OfferIdsInput>;
};

export type EmployerPanelQueryOffersByIdsArgs = {
  adIds: Array<Scalars['String']['input']>;
  withMultiApps?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EmployerPanelQueryStafflyGetTestResultArgs = {
  applicationId: Scalars['String']['input'];
};

export type EmployerPanelSaveAdvancedQuestionsToAdInput = {
  adId: Scalars['String']['input'];
  isPaid: Scalars['Boolean']['input'];
  questions: Array<EmployerPanelAdvancedApplyQuestionInput>;
};

export type EmployerProfile = {
  __typename?: 'EmployerProfile';
  atlasUserId?: Maybe<Scalars['String']['output']>;
  bannerUrl?: Maybe<Scalars['String']['output']>;
  benefits?: Maybe<Array<BenefitType>>;
  companyName?: Maybe<Scalars['String']['output']>;
  companySize?: Maybe<Scalars['String']['output']>;
  companyUrl?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  facebookUrl?: Maybe<Scalars['String']['output']>;
  gdpr?: Maybe<Scalars['String']['output']>;
  headquarters?: Maybe<LocationPayload>;
  id: Scalars['ID']['output'];
  industry?: Maybe<Industry>;
  instagramUrl?: Maybe<Scalars['String']['output']>;
  lifeAt?: Maybe<LifeAt>;
  linkedinUrl?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  mobileBannerUrl?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['String']['output']>;
  recruitment?: Maybe<Array<RecruitmentProcess>>;
  slug?: Maybe<Scalars['String']['output']>;
  tagline?: Maybe<Scalars['String']['output']>;
  twitterUrl?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  youtubeUrl?: Maybe<Scalars['String']['output']>;
};

export enum EmployerSegment {
  INACTIVE = 'inactive',
  LARGE = 'large',
  MEDIUM = 'medium',
  SMALL = 'small',
}

export type EmployerSegmentResponse = {
  __typename?: 'EmployerSegmentResponse';
  employerSegment: EmployerSegment;
  id: Scalars['ID']['output'];
  type: EmployerSegment;
};

export type HomepageArticle = {
  __typename?: 'HomepageArticle';
  URL: Scalars['String']['output'];
  description: Scalars['String']['output'];
  imageThumbnail?: Maybe<ImageThumbnail>;
  imageURL: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type HomepageFeaturedCategory = {
  __typename?: 'HomepageFeaturedCategory';
  ID: Scalars['Int']['output'];
};

export type HomepageFeaturedEmployer = {
  __typename?: 'HomepageFeaturedEmployer';
  ID: Scalars['Float']['output'];
  UUID: Scalars['String']['output'];
  bannerURL: Scalars['String']['output'];
  locationCounter: Scalars['Int']['output'];
  logoURL: Scalars['String']['output'];
  name: Scalars['String']['output'];
  openPositionCounter: Scalars['Int']['output'];
};

export type HomepageQuery = {
  __typename?: 'HomepageQuery';
  FeaturedCategories?: Maybe<Array<Maybe<HomepageFeaturedCategory>>>;
  FeaturedEmployers?: Maybe<Array<Maybe<HomepageFeaturedEmployer>>>;
  LatestArticles?: Maybe<Array<Maybe<HomepageArticle>>>;
};

export type HomepageQueryLatestArticlesArgs = {
  amount: Scalars['Int']['input'];
};

export type ImageThumbnail = {
  __typename?: 'ImageThumbnail';
  s?: Maybe<Scalars['String']['output']>;
  xs?: Maybe<Scalars['String']['output']>;
};

export enum Industry {
  AGRICULTURE_FORESTRY_AND_FISHING = 'AGRICULTURE_FORESTRY_AND_FISHING',
  ARTS_MEDIA_AND_ENTERTAINMENT = 'ARTS_MEDIA_AND_ENTERTAINMENT',
  AUTOMOTIVE = 'AUTOMOTIVE',
  CARE = 'CARE',
  CONSTRUCTION = 'CONSTRUCTION',
  EDUCATION = 'EDUCATION',
  ENERGY_MINING_AND_UTILITIES = 'ENERGY_MINING_AND_UTILITIES',
  ENVIRONMENTAL_PROTECTION = 'ENVIRONMENTAL_PROTECTION',
  FINANCIAL_SERVICES = 'FINANCIAL_SERVICES',
  GOVERNMENT_AND_PUBLIC_ADMINISTRATION = 'GOVERNMENT_AND_PUBLIC_ADMINISTRATION',
  HEALTHCARE = 'HEALTHCARE',
  HEALTH_AND_BEAUTY = 'HEALTH_AND_BEAUTY',
  HUMANRESOURCES_AND_RECRUITMENT = 'HUMANRESOURCES_AND_RECRUITMENT',
  INFORMATION_TECHNOLOGY = 'INFORMATION_TECHNOLOGY',
  INSURANCE = 'INSURANCE',
  LEGAL_SERVICES = 'LEGAL_SERVICES',
  MAINTENANCE_SERVICES = 'MAINTENANCE_SERVICES',
  MANAGEMENT_AND_CONSULTING = 'MANAGEMENT_AND_CONSULTING',
  MANUFACTURING = 'MANUFACTURING',
  MARKETING = 'MARKETING',
  NONPROFIT_AND_NGOS = 'NONPROFIT_AND_NGOS',
  PHARMACEUTICAL_AND_BIOTECHNOLOGY = 'PHARMACEUTICAL_AND_BIOTECHNOLOGY',
  REAL_ESTATE = 'REAL_ESTATE',
  RESTAURANTS_AND_FOOD_SERVICE = 'RESTAURANTS_AND_FOOD_SERVICE',
  RETAIL_AND_WHOLESALE = 'RETAIL_AND_WHOLESALE',
  SECURITY = 'SECURITY',
  TELECOMMUNICATIONS = 'TELECOMMUNICATIONS',
  TOURISM = 'TOURISM',
  TRANSPORTATION_AND_LOGISTICS = 'TRANSPORTATION_AND_LOGISTICS',
}

export type JobAd = {
  __typename?: 'JobAd';
  addedAt: Scalars['String']['output'];
  cdbCounter: Scalars['Int']['output'];
  cityName: Scalars['String']['output'];
  counters: JobAdCounters;
  description: Scalars['String']['output'];
  districtName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  salaryValue?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  title: Scalars['String']['output'];
  trackingParameters: JobAdTrackingParameters;
  url: Scalars['String']['output'];
  validTo?: Maybe<Scalars['String']['output']>;
};

export type JobAdCounters = {
  __typename?: 'JobAdCounters';
  id: Scalars['String']['output'];
  newApplications: Scalars['Int']['output'];
  rejected: Scalars['Int']['output'];
  selectedForContact: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  unread: Scalars['Int']['output'];
};

export type JobAdTrackingParameters = {
  __typename?: 'JobAdTrackingParameters';
  cat_l1_id: Scalars['Int']['output'];
  cat_l1_name?: Maybe<Scalars['String']['output']>;
  cat_l2_id: Scalars['Int']['output'];
  cat_l2_name: Scalars['String']['output'];
  cat_l3_id?: Maybe<Scalars['Int']['output']>;
  cat_l3_name?: Maybe<Scalars['String']['output']>;
  cat_l4_id?: Maybe<Scalars['Int']['output']>;
  cat_l4_name?: Maybe<Scalars['String']['output']>;
  category_id: Scalars['Int']['output'];
  city_id?: Maybe<Scalars['Int']['output']>;
  city_name?: Maybe<Scalars['String']['output']>;
  province_id?: Maybe<Scalars['Int']['output']>;
  region_name?: Maybe<Scalars['String']['output']>;
};

export type JobAdUnreadCounters = {
  __typename?: 'JobAdUnreadCounters';
  newApplications: Scalars['Int']['output'];
  rejected: Scalars['Int']['output'];
  selectedForContact: Scalars['Int']['output'];
};

export type JobOfferCity = {
  __typename?: 'JobOfferCity';
  ID: Scalars['ID']['output'];
  map: JobOfferMap;
  name: Scalars['String']['output'];
  normalized: Scalars['String']['output'];
  regionID: Scalars['Int']['output'];
};

export type JobOfferDistrict = {
  __typename?: 'JobOfferDistrict';
  ID: Scalars['ID']['output'];
  cityID: Scalars['Int']['output'];
  map: JobOfferMap;
  name: Scalars['String']['output'];
};

export type JobOfferEmployer = {
  __typename?: 'JobOfferEmployer';
  bannerUrl?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  hasProfile: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isVerified: Scalars['Boolean']['output'];
  logoThumbnails?: Maybe<JobOfferEmployerLogoThumbnails>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  /** @deprecated use bannerUrl field */
  mobileBannerUrl?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

export type JobOfferEmployerLogoThumbnails = {
  __typename?: 'JobOfferEmployerLogoThumbnails';
  M: Scalars['String']['output'];
  S: Scalars['String']['output'];
};

export type JobOfferFloatValue = {
  __typename?: 'JobOfferFloatValue';
  label: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type JobOfferIntValue = {
  __typename?: 'JobOfferIntValue';
  label: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export type JobOfferLocation = {
  __typename?: 'JobOfferLocation';
  city?: Maybe<JobOfferCity>;
  district?: Maybe<JobOfferDistrict>;
  map: JobOfferMap;
  region?: Maybe<JobOfferRegion>;
};

export type JobOfferMap = {
  __typename?: 'JobOfferMap';
  lat: Scalars['Float']['output'];
  lon: Scalars['Float']['output'];
  radius: Scalars['Float']['output'];
  zoom: Scalars['Int']['output'];
};

export type JobOfferOffer = {
  __typename?: 'JobOfferOffer';
  ID: Scalars['ID']['output'];
  addedAt: Scalars['String']['output'];
  applyUrl?: Maybe<Scalars['String']['output']>;
  categoryID: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  employer: JobOfferEmployer;
  isBusiness: Scalars['Boolean']['output'];
  isSeek: Scalars['Boolean']['output'];
  location: JobOfferLocation;
  parameters: Array<JobOfferParameter>;
  postingComponent: JobOfferPostingComponent;
  salary?: Maybe<JobOfferSalary>;
  status: Scalars['String']['output'];
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
  userID?: Maybe<Scalars['Float']['output']>;
  userUUID?: Maybe<Scalars['String']['output']>;
  validTo?: Maybe<Scalars['String']['output']>;
};

export type JobOfferParameter = {
  __typename?: 'JobOfferParameter';
  code: Scalars['String']['output'];
  html: Scalars['String']['output'];
  label: Scalars['String']['output'];
  values: Array<Maybe<JobOfferStringValue>>;
};

export type JobOfferPostingComponent = {
  __typename?: 'JobOfferPostingComponent';
  companyName?: Maybe<Scalars['String']['output']>;
  gdprClause?: Maybe<Scalars['String']['output']>;
  locationBuildingNumber?: Maybe<Scalars['String']['output']>;
  locationPostalCode?: Maybe<Scalars['String']['output']>;
  locationStreet?: Maybe<Scalars['String']['output']>;
};

export type JobOfferQuery = {
  __typename?: 'JobOfferQuery';
  Employer?: Maybe<JobOfferEmployer>;
  Employers?: Maybe<Array<Maybe<JobOfferEmployer>>>;
  JobOffer?: Maybe<JobOfferOffer>;
  JobOffers?: Maybe<Array<JobOfferOffer>>;
};

export type JobOfferQueryEmployerArgs = {
  UUID: Scalars['ID']['input'];
};

export type JobOfferQueryEmployersArgs = {
  UUIDs: Array<Scalars['ID']['input']>;
};

export type JobOfferQueryJobOfferArgs = {
  ID: Scalars['ID']['input'];
};

export type JobOfferQueryJobOffersArgs = {
  IDs: Array<Scalars['ID']['input']>;
};

export type JobOfferRegion = {
  __typename?: 'JobOfferRegion';
  ID: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  normalized: Scalars['String']['output'];
};

export type JobOfferSalary = {
  __typename?: 'JobOfferSalary';
  amount?: Maybe<JobOfferFloatValue>;
  arranged?: Maybe<JobOfferIntValue>;
  currency: Scalars['String']['output'];
  currencySymbol: Scalars['String']['output'];
  from?: Maybe<JobOfferFloatValue>;
  label: Scalars['String']['output'];
  to?: Maybe<JobOfferFloatValue>;
  type?: Maybe<JobOfferSalaryType>;
};

export type JobOfferSalaryType = {
  __typename?: 'JobOfferSalaryType';
  label: Scalars['String']['output'];
  value: JobOfferStringValue;
};

export type JobOfferStringValue = {
  __typename?: 'JobOfferStringValue';
  code: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type LifeAt = {
  __typename?: 'LifeAt';
  description?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<LifeAtItem>>;
};

/**
 * IMPORTANT!!!
 * Adding new union type requires handling it in the LifeAtItem resolvers!!!
 * i.e. if (obj.type === LifeAtItemType.Image) return "LifeAtItemImage";
 * see company-profile-resolvers.ts
 */
export type LifeAtItem = LifeAtItemExternalVideo | LifeAtItemImage;

export type LifeAtItemExternalVideo = {
  __typename?: 'LifeAtItemExternalVideo';
  id: Scalars['ID']['output'];
  type: LifeAtItemType;
  url: Scalars['String']['output'];
};

export type LifeAtItemImage = {
  __typename?: 'LifeAtItemImage';
  fileId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  type: LifeAtItemType;
  url: Scalars['String']['output'];
};

export enum LifeAtItemType {
  EXTERNAL_VIDEO = 'EXTERNAL_VIDEO',
  IMAGE = 'IMAGE',
}

export type LocationPayload = {
  __typename?: 'LocationPayload';
  city: Scalars['String']['output'];
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
  region?: Maybe<Scalars['String']['output']>;
  streetName?: Maybe<Scalars['String']['output']>;
  streetNumber?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export enum LocationProvider {
  AWS = 'AWS',
  GOOGLE = 'GOOGLE',
}

export type LocationSuggestion = {
  __typename?: 'LocationSuggestion';
  city: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
  region: Scalars['String']['output'];
  streetName: Scalars['String']['output'];
  streetNumber: Scalars['String']['output'];
  zipCode: Scalars['String']['output'];
};

export type MarkAsReadInput = {
  applicationId: Scalars['String']['input'];
  conversationId: Scalars['String']['input'];
  offerId?: InputMaybe<Scalars['String']['input']>;
};

export enum MessageAuthor {
  CANDIDATE = 'candidate',
  EMPLOYER = 'employer',
}

export type Metadata = {
  __typename?: 'Metadata';
  benefitsFeedback?: Maybe<Scalars['String']['output']>;
  onboardingSteps?: Maybe<Array<OnboardingStep>>;
  startDate?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type MetadataInput = {
  benefitsFeedback?: InputMaybe<Scalars['String']['input']>;
  onboardingSteps?: InputMaybe<Array<OnboardingStep>>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type MultiAppIdsInput = {
  bestMatch?: InputMaybe<Scalars['Boolean']['input']>;
  hasAttachments?: InputMaybe<Scalars['Boolean']['input']>;
  jobAdId: Scalars['String']['input'];
  phrase?: InputMaybe<Scalars['String']['input']>;
  rate?: InputMaybe<ApplicationRate>;
  read?: InputMaybe<ApplicationRead>;
  sort?: InputMaybe<SortInput>;
  statuses?: InputMaybe<Array<ApplicationStatus>>;
  withNotes?: InputMaybe<Scalars['Boolean']['input']>;
  withPreviousMeetings?: InputMaybe<Scalars['Boolean']['input']>;
  withUpcomingMeetings?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MultiApplication = {
  __typename?: 'MultiApplication';
  /** @deprecated use jobAdID instead */
  adId?: Maybe<Scalars['String']['output']>;
  /** allAttachments contains all attachments from non canceled applications */
  allAttachments?: Maybe<Array<ChatAttachment>>;
  /** allCVs contains all CVs from non canceled applications */
  allCVs?: Maybe<Array<ChatAttachment>>;
  attachments?: Maybe<Array<ChatAttachment>>;
  candidate: Candidate;
  cv?: Maybe<ChatAttachment>;
  employerId: Scalars['String']['output'];
  fromInvitation?: Maybe<Scalars['Boolean']['output']>;
  hasAttachments: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  isApplyForm: Scalars['Boolean']['output'];
  isCancelled: Scalars['Boolean']['output'];
  isInitialMessageRead: Scalars['Boolean']['output'];
  isReApplication: Scalars['Boolean']['output'];
  jobAdId: Scalars['String']['output'];
  meetingDate?: Maybe<Scalars['String']['output']>;
  note: Note;
  postedAt: Scalars['String']['output'];
  rankingScore: Scalars['Int']['output'];
  rate: ApplicationRate;
  read: Scalars['Boolean']['output'];
  relatedAppsIds?: Maybe<Array<Scalars['String']['output']>>;
  scoreExplanation?: Maybe<Scalars['String']['output']>;
  sortDate: Scalars['String']['output'];
  status: ApplicationStatus;
  unreadMessagesCount: Scalars['Int']['output'];
  userAnswers: Array<Maybe<UserAnswer>>;
  withProfile: Scalars['Boolean']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  BusinessCard: BusinessCardMutation;
  CandidateProfile?: Maybe<CandidateProfileMutation>;
  CandidateProfileNoAuth?: Maybe<CandidateProfileNoAuthMutation>;
  CompanyProfile: CompanyProfileMutation;
  EmployerPanel: EmployerPanelMutation;
};

export type Note = {
  __typename?: 'Note';
  content?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type OfferIdsInput = {
  order?: InputMaybe<Order>;
  phrase?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<OfferIdsStatus>;
};

export enum OfferIdsStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

export enum OnboardingStep {
  PROFILE_COPY_LINK_BUTTON = 'PROFILE_COPY_LINK_BUTTON',
  PROFILE_PUBLISH_BUTTON = 'PROFILE_PUBLISH_BUTTON',
  PROFILE_SECTION_ABOUT = 'PROFILE_SECTION_ABOUT',
  PROFILE_SECTION_ADDITIONAL_INFO = 'PROFILE_SECTION_ADDITIONAL_INFO',
  PROFILE_SECTION_BENEFITS = 'PROFILE_SECTION_BENEFITS',
  PROFILE_SECTION_HEADER = 'PROFILE_SECTION_HEADER',
  PROFILE_SECTION_POSITIONS = 'PROFILE_SECTION_POSITIONS',
  PROFILE_SECTION_RECRUITMENT = 'PROFILE_SECTION_RECRUITMENT',
}

export enum Order {
  ASC = 'asc',
  DESC = 'desc',
}

export type ProfileCountryOption = {
  __typename?: 'ProfileCountryOption';
  label?: Maybe<Scalars['String']['output']>;
  normalizedValue: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ProfileInput = {
  fromMinisite?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type ProfilesInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Query = {
  __typename?: 'Query';
  BusinessCard: BusinessCardQuery;
  CandidateProfile?: Maybe<CandidateProfileQuery>;
  CompanyProfile: CompanyProfileQuery;
  EmployerPanel: EmployerPanelQuery;
  /** @deprecated Homepage is not supported anymore */
  Homepage?: Maybe<HomepageQuery>;
  JobOffer?: Maybe<JobOfferQuery>;
  atlasUser?: Maybe<AtlasUser>;
};

export type QueryAtlasUserArgs = {
  id: Scalars['String']['input'];
};

export type RecruitmentProcess = {
  __typename?: 'RecruitmentProcess';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  steps: Array<RecruitmentProcessStepPayload>;
};

export type RecruitmentProcessStepPayload = {
  __typename?: 'RecruitmentProcessStepPayload';
  description: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type RemoveApplyQuestionFromAdInput = {
  adId: Scalars['String']['input'];
  questionId: Scalars['String']['input'];
};

export type SaveApplyQuestionToAdInput = {
  adId: Scalars['String']['input'];
  label: Scalars['String']['input'];
};

export type SaveApplyQuestionsToAdInput = {
  adId: Scalars['String']['input'];
  questionIds: Array<Scalars['String']['input']>;
};

export type SaveMultiAppMeetingDateInput = {
  applicationId: Scalars['String']['input'];
  meetingDate?: InputMaybe<Scalars['String']['input']>;
};

export type SavePredefinedApplyQuestionToAdInput = {
  adId: Scalars['String']['input'];
  questionId: Scalars['String']['input'];
};

export type SecureUrl = {
  __typename?: 'SecureUrl';
  token: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type SendMessageInput = {
  attachments?: InputMaybe<Array<UploadedFile>>;
  conversationId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  message: Scalars['String']['input'];
};

export type SetMultiAppRateInput = {
  applicationId: Scalars['String']['input'];
  rate: ApplicationRate;
};

export enum Sort {
  ASC = 'asc',
  DESC = 'desc',
}

export type SortInput = {
  order?: InputMaybe<Order>;
  type?: InputMaybe<ApplicationsSortBy>;
};

export type StafflyReport = {
  __typename?: 'StafflyReport';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  secureUrl: StafflyReportSecureUrl;
  url: Scalars['String']['output'];
};

export type StafflyReportSecureUrl = {
  __typename?: 'StafflyReportSecureUrl';
  token: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type StafflyTestResult = {
  __typename?: 'StafflyTestResult';
  adID: Scalars['String']['output'];
  candidateUUID: Scalars['String']['output'];
  report: StafflyReport;
  testID: Scalars['String']['output'];
};

export type UploadRequestDataPayload = {
  __typename?: 'UploadRequestDataPayload';
  token: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type UploadedFile = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type UserAnswer = {
  __typename?: 'UserAnswer';
  questionId: Scalars['String']['output'];
  questionLabel: Scalars['String']['output'];
  values: Array<Maybe<Scalars['String']['output']>>;
};

export enum SuggestionType {
  OCCUPATION = 'occupation',
  SKILL = 'skill',
}

export type CompanyProfileHeaderFragment = {
  __typename?: 'CompanyProfileHeader';
  bannerUrl?: string | null;
};

export type CompanyProfileAboutFragment = {
  __typename?: 'CompanyProfileAbout';
  companyName?: string | null;
  tagline?: string | null;
  logoUrl?: string | null;
  description?: string | null;
};

export type CompanyProfileAdditionalInfoFragment = {
  __typename?: 'CompanyProfileAdditionalInfo';
  industry?: CompanyProfileIndustry | null;
  companySize?: string | null;
  email?: string | null;
  phone?: string | null;
  companyUrl?: string | null;
  facebookUrl?: string | null;
  twitterUrl?: string | null;
  linkedinUrl?: string | null;
  instagramUrl?: string | null;
  youtubeUrl?: string | null;
  headquarters?: {
    __typename?: 'CompanyProfileLocation';
    streetName?: string | null;
    streetNumber?: string | null;
    region?: string | null;
    zipCode?: string | null;
    city: string;
    lat: number;
    lng: number;
  } | null;
};

export type CompanyProfileContactFragment = {
  __typename?: 'CompanyProfileContact';
  companyName?: string | null;
  phone?: string | null;
  email?: string | null;
  headquarters?: {
    __typename?: 'CompanyProfileLocation';
    streetName?: string | null;
    streetNumber?: string | null;
    region?: string | null;
    zipCode?: string | null;
    city: string;
    lat: number;
    lng: number;
  } | null;
};

export type CompanyProfileBenefitsFragment = {
  __typename?: 'CompanyProfileBenefits';
  items?: Array<CompanyProfileBenefit> | null;
};

export type CompanyProfileRecruitmentFragment = {
  __typename?: 'CompanyProfileRecruitment';
  items?: Array<{
    __typename?: 'CompanyProfileRecruitmentProcess';
    id: string;
    name: string;
    steps: Array<{
      __typename?: 'CompanyProfileRecruitmentProcessStep';
      title: string;
      description: string;
    }>;
  }> | null;
};

export type CompanyProfileLifeAtFragment = {
  __typename?: 'CompanyProfileLifeAt';
  description?: string | null;
  items?: Array<
    | {
        __typename: 'CompanyProfileLifeAtItemExternalVideo';
        id: string;
        type: CompanyProfileLifeAtItemType;
        url: string;
      }
    | {
        __typename: 'CompanyProfileLifeAtItemImage';
        id: string;
        type: CompanyProfileLifeAtItemType;
        url: string;
        fileId: string;
      }
  > | null;
};

export type CompanyProfilePrivateProfileFragment = {
  __typename?: 'CompanyProfilePrivateProfile';
  id: string;
  userId?: string | null;
  publishedAt?: string | null;
  slug?: string | null;
  header?: { __typename?: 'CompanyProfileHeader'; bannerUrl?: string | null } | null;
  about?: {
    __typename?: 'CompanyProfileAbout';
    companyName?: string | null;
    tagline?: string | null;
    logoUrl?: string | null;
    description?: string | null;
  } | null;
  additionalInfo?: {
    __typename?: 'CompanyProfileAdditionalInfo';
    industry?: CompanyProfileIndustry | null;
    companySize?: string | null;
    email?: string | null;
    phone?: string | null;
    companyUrl?: string | null;
    facebookUrl?: string | null;
    twitterUrl?: string | null;
    linkedinUrl?: string | null;
    instagramUrl?: string | null;
    youtubeUrl?: string | null;
    headquarters?: {
      __typename?: 'CompanyProfileLocation';
      streetName?: string | null;
      streetNumber?: string | null;
      region?: string | null;
      zipCode?: string | null;
      city: string;
      lat: number;
      lng: number;
    } | null;
  } | null;
  benefits?: {
    __typename?: 'CompanyProfileBenefits';
    items?: Array<CompanyProfileBenefit> | null;
  } | null;
  recruitment?: {
    __typename?: 'CompanyProfileRecruitment';
    items?: Array<{
      __typename?: 'CompanyProfileRecruitmentProcess';
      id: string;
      name: string;
      steps: Array<{
        __typename?: 'CompanyProfileRecruitmentProcessStep';
        title: string;
        description: string;
      }>;
    }> | null;
  } | null;
  lifeAt?: {
    __typename?: 'CompanyProfileLifeAt';
    description?: string | null;
    items?: Array<
      | {
          __typename: 'CompanyProfileLifeAtItemExternalVideo';
          id: string;
          type: CompanyProfileLifeAtItemType;
          url: string;
        }
      | {
          __typename: 'CompanyProfileLifeAtItemImage';
          id: string;
          type: CompanyProfileLifeAtItemType;
          url: string;
          fileId: string;
        }
    > | null;
  } | null;
  contact?: {
    __typename?: 'CompanyProfileContact';
    companyName?: string | null;
    phone?: string | null;
    email?: string | null;
    headquarters?: {
      __typename?: 'CompanyProfileLocation';
      streetName?: string | null;
      streetNumber?: string | null;
      region?: string | null;
      zipCode?: string | null;
      city: string;
      lat: number;
      lng: number;
    } | null;
  } | null;
};

export type CompanyProfilePublicProfileFragment = {
  __typename: 'CompanyProfilePublicProfile';
  id: string;
  userId?: string | null;
  publishedAt?: string | null;
  slug?: string | null;
  header?: { __typename: 'CompanyProfileHeader'; bannerUrl?: string | null } | null;
  about?: {
    __typename: 'CompanyProfileAbout';
    companyName?: string | null;
    tagline?: string | null;
    logoUrl?: string | null;
    description?: string | null;
  } | null;
  additionalInfo?: {
    __typename: 'CompanyProfileAdditionalInfo';
    industry?: CompanyProfileIndustry | null;
    companySize?: string | null;
    email?: string | null;
    phone?: string | null;
    companyUrl?: string | null;
    facebookUrl?: string | null;
    twitterUrl?: string | null;
    linkedinUrl?: string | null;
    instagramUrl?: string | null;
    youtubeUrl?: string | null;
    headquarters?: {
      __typename?: 'CompanyProfileLocation';
      streetName?: string | null;
      streetNumber?: string | null;
      region?: string | null;
      zipCode?: string | null;
      city: string;
      lat: number;
      lng: number;
    } | null;
  } | null;
  benefits?: {
    __typename: 'CompanyProfileBenefits';
    items?: Array<CompanyProfileBenefit> | null;
  } | null;
  recruitment?: {
    __typename: 'CompanyProfileRecruitment';
    items?: Array<{
      __typename?: 'CompanyProfileRecruitmentProcess';
      id: string;
      name: string;
      steps: Array<{
        __typename?: 'CompanyProfileRecruitmentProcessStep';
        title: string;
        description: string;
      }>;
    }> | null;
  } | null;
  lifeAt?: {
    __typename: 'CompanyProfileLifeAt';
    description?: string | null;
    items?: Array<
      | {
          __typename: 'CompanyProfileLifeAtItemExternalVideo';
          id: string;
          type: CompanyProfileLifeAtItemType;
          url: string;
        }
      | {
          __typename: 'CompanyProfileLifeAtItemImage';
          id: string;
          type: CompanyProfileLifeAtItemType;
          url: string;
          fileId: string;
        }
    > | null;
  } | null;
  contact?: {
    __typename: 'CompanyProfileContact';
    companyName?: string | null;
    phone?: string | null;
    email?: string | null;
    headquarters?: {
      __typename?: 'CompanyProfileLocation';
      streetName?: string | null;
      streetNumber?: string | null;
      region?: string | null;
      zipCode?: string | null;
      city: string;
      lat: number;
      lng: number;
    } | null;
  } | null;
};

export type CompanyProfilePublicProfileWithConfigFragment = {
  __typename: 'CompanyProfilePublicProfile';
  id: string;
  userId?: string | null;
  publishedAt?: string | null;
  slug?: string | null;
  config: {
    __typename: 'CompanyProfilePublicConfig';
    tier: CompanyProfileTierType;
    features: {
      __typename?: 'CompanyProfileConfigFeatures';
      followButton?: {
        __typename?: 'CompanyProfileConfigFeatureFollowButton';
        enabled: boolean;
      } | null;
    };
  };
  header?: { __typename: 'CompanyProfileHeader'; bannerUrl?: string | null } | null;
  about?: {
    __typename: 'CompanyProfileAbout';
    companyName?: string | null;
    tagline?: string | null;
    logoUrl?: string | null;
    description?: string | null;
  } | null;
  additionalInfo?: {
    __typename: 'CompanyProfileAdditionalInfo';
    industry?: CompanyProfileIndustry | null;
    companySize?: string | null;
    email?: string | null;
    phone?: string | null;
    companyUrl?: string | null;
    facebookUrl?: string | null;
    twitterUrl?: string | null;
    linkedinUrl?: string | null;
    instagramUrl?: string | null;
    youtubeUrl?: string | null;
    headquarters?: {
      __typename?: 'CompanyProfileLocation';
      streetName?: string | null;
      streetNumber?: string | null;
      region?: string | null;
      zipCode?: string | null;
      city: string;
      lat: number;
      lng: number;
    } | null;
  } | null;
  benefits?: {
    __typename: 'CompanyProfileBenefits';
    items?: Array<CompanyProfileBenefit> | null;
  } | null;
  recruitment?: {
    __typename: 'CompanyProfileRecruitment';
    items?: Array<{
      __typename?: 'CompanyProfileRecruitmentProcess';
      id: string;
      name: string;
      steps: Array<{
        __typename?: 'CompanyProfileRecruitmentProcessStep';
        title: string;
        description: string;
      }>;
    }> | null;
  } | null;
  lifeAt?: {
    __typename: 'CompanyProfileLifeAt';
    description?: string | null;
    items?: Array<
      | {
          __typename: 'CompanyProfileLifeAtItemExternalVideo';
          id: string;
          type: CompanyProfileLifeAtItemType;
          url: string;
        }
      | {
          __typename: 'CompanyProfileLifeAtItemImage';
          id: string;
          type: CompanyProfileLifeAtItemType;
          url: string;
          fileId: string;
        }
    > | null;
  } | null;
  contact?: {
    __typename: 'CompanyProfileContact';
    companyName?: string | null;
    phone?: string | null;
    email?: string | null;
    headquarters?: {
      __typename?: 'CompanyProfileLocation';
      streetName?: string | null;
      streetNumber?: string | null;
      region?: string | null;
      zipCode?: string | null;
      city: string;
      lat: number;
      lng: number;
    } | null;
  } | null;
};

export type CompanyProfilePreviewProfileFragment = {
  __typename: 'CompanyProfilePublicProfile';
  id: string;
  userId?: string | null;
  publishedAt?: string | null;
  slug?: string | null;
  header?: { __typename?: 'CompanyProfileHeader'; bannerUrl?: string | null } | null;
  about?: {
    __typename?: 'CompanyProfileAbout';
    companyName?: string | null;
    tagline?: string | null;
    logoUrl?: string | null;
    description?: string | null;
  } | null;
  additionalInfo?: {
    __typename?: 'CompanyProfileAdditionalInfo';
    industry?: CompanyProfileIndustry | null;
    companySize?: string | null;
    email?: string | null;
    phone?: string | null;
    companyUrl?: string | null;
    facebookUrl?: string | null;
    twitterUrl?: string | null;
    linkedinUrl?: string | null;
    instagramUrl?: string | null;
    youtubeUrl?: string | null;
    headquarters?: {
      __typename?: 'CompanyProfileLocation';
      streetName?: string | null;
      streetNumber?: string | null;
      region?: string | null;
      zipCode?: string | null;
      city: string;
      lat: number;
      lng: number;
    } | null;
  } | null;
  benefits?: {
    __typename?: 'CompanyProfileBenefits';
    items?: Array<CompanyProfileBenefit> | null;
  } | null;
  recruitment?: {
    __typename?: 'CompanyProfileRecruitment';
    items?: Array<{
      __typename?: 'CompanyProfileRecruitmentProcess';
      id: string;
      name: string;
      steps: Array<{
        __typename?: 'CompanyProfileRecruitmentProcessStep';
        title: string;
        description: string;
      }>;
    }> | null;
  } | null;
  lifeAt?: {
    __typename?: 'CompanyProfileLifeAt';
    description?: string | null;
    items?: Array<
      | {
          __typename: 'CompanyProfileLifeAtItemExternalVideo';
          id: string;
          type: CompanyProfileLifeAtItemType;
          url: string;
        }
      | {
          __typename: 'CompanyProfileLifeAtItemImage';
          id: string;
          type: CompanyProfileLifeAtItemType;
          url: string;
          fileId: string;
        }
    > | null;
  } | null;
  contact?: {
    __typename?: 'CompanyProfileContact';
    companyName?: string | null;
    phone?: string | null;
    email?: string | null;
    headquarters?: {
      __typename?: 'CompanyProfileLocation';
      streetName?: string | null;
      streetNumber?: string | null;
      region?: string | null;
      zipCode?: string | null;
      city: string;
      lat: number;
      lng: number;
    } | null;
  } | null;
};

export type CompanyProfilePreviewProfileWithConfigFragment = {
  __typename: 'CompanyProfilePublicProfile';
  id: string;
  userId?: string | null;
  publishedAt?: string | null;
  slug?: string | null;
  config: {
    __typename?: 'CompanyProfilePublicConfig';
    tier: CompanyProfileTierType;
    features: {
      __typename?: 'CompanyProfileConfigFeatures';
      followButton?: {
        __typename?: 'CompanyProfileConfigFeatureFollowButton';
        enabled: boolean;
      } | null;
    };
  };
  header?: { __typename?: 'CompanyProfileHeader'; bannerUrl?: string | null } | null;
  about?: {
    __typename?: 'CompanyProfileAbout';
    companyName?: string | null;
    tagline?: string | null;
    logoUrl?: string | null;
    description?: string | null;
  } | null;
  additionalInfo?: {
    __typename?: 'CompanyProfileAdditionalInfo';
    industry?: CompanyProfileIndustry | null;
    companySize?: string | null;
    email?: string | null;
    phone?: string | null;
    companyUrl?: string | null;
    facebookUrl?: string | null;
    twitterUrl?: string | null;
    linkedinUrl?: string | null;
    instagramUrl?: string | null;
    youtubeUrl?: string | null;
    headquarters?: {
      __typename?: 'CompanyProfileLocation';
      streetName?: string | null;
      streetNumber?: string | null;
      region?: string | null;
      zipCode?: string | null;
      city: string;
      lat: number;
      lng: number;
    } | null;
  } | null;
  benefits?: {
    __typename?: 'CompanyProfileBenefits';
    items?: Array<CompanyProfileBenefit> | null;
  } | null;
  recruitment?: {
    __typename?: 'CompanyProfileRecruitment';
    items?: Array<{
      __typename?: 'CompanyProfileRecruitmentProcess';
      id: string;
      name: string;
      steps: Array<{
        __typename?: 'CompanyProfileRecruitmentProcessStep';
        title: string;
        description: string;
      }>;
    }> | null;
  } | null;
  lifeAt?: {
    __typename?: 'CompanyProfileLifeAt';
    description?: string | null;
    items?: Array<
      | {
          __typename: 'CompanyProfileLifeAtItemExternalVideo';
          id: string;
          type: CompanyProfileLifeAtItemType;
          url: string;
        }
      | {
          __typename: 'CompanyProfileLifeAtItemImage';
          id: string;
          type: CompanyProfileLifeAtItemType;
          url: string;
          fileId: string;
        }
    > | null;
  } | null;
  contact?: {
    __typename?: 'CompanyProfileContact';
    companyName?: string | null;
    phone?: string | null;
    email?: string | null;
    headquarters?: {
      __typename?: 'CompanyProfileLocation';
      streetName?: string | null;
      streetNumber?: string | null;
      region?: string | null;
      zipCode?: string | null;
      city: string;
      lat: number;
      lng: number;
    } | null;
  } | null;
};

export type CompanyProfileJobAdProfileFragment = {
  __typename: 'CompanyProfilePublicProfile';
  id: string;
  slug?: string | null;
  userId?: string | null;
  publishedAt?: string | null;
  about?: {
    __typename: 'CompanyProfileAbout';
    companyName?: string | null;
    tagline?: string | null;
    logoUrl?: string | null;
    description?: string | null;
  } | null;
  additionalInfo?: {
    __typename: 'CompanyProfileAdditionalInfo';
    industry?: CompanyProfileIndustry | null;
    companySize?: string | null;
    email?: string | null;
    phone?: string | null;
    companyUrl?: string | null;
    facebookUrl?: string | null;
    twitterUrl?: string | null;
    linkedinUrl?: string | null;
    instagramUrl?: string | null;
    youtubeUrl?: string | null;
    headquarters?: {
      __typename?: 'CompanyProfileLocation';
      streetName?: string | null;
      streetNumber?: string | null;
      region?: string | null;
      zipCode?: string | null;
      city: string;
      lat: number;
      lng: number;
    } | null;
  } | null;
  benefits?: {
    __typename: 'CompanyProfileBenefits';
    items?: Array<CompanyProfileBenefit> | null;
  } | null;
  recruitment?: {
    __typename: 'CompanyProfileRecruitment';
    items?: Array<{
      __typename?: 'CompanyProfileRecruitmentProcess';
      id: string;
      name: string;
      steps: Array<{
        __typename?: 'CompanyProfileRecruitmentProcessStep';
        title: string;
        description: string;
      }>;
    }> | null;
  } | null;
};

export type CompanyProfileTrialProfileFragment = {
  __typename?: 'CompanyProfilePrivateProfile';
  id: string;
  userId?: string | null;
};

export type CompanyProfileMetadataFragment = {
  __typename?: 'Metadata';
  startDate?: string | null;
  updatedAt?: string | null;
  benefitsFeedback?: string | null;
};

export type CompanyProfilePostingDetailsFragment = {
  __typename?: 'CompanyProfilePrivateProfile';
  id: string;
  publishedAt?: string | null;
  about?: { __typename?: 'CompanyProfileAbout'; companyName?: string | null } | null;
};

export type LegacyCompanyProfileCarouselProfileFragment = {
  __typename: 'CompanyProfilePublicProfile';
  id: string;
  slug?: string | null;
  header?: { __typename: 'CompanyProfileHeader'; bannerUrl?: string | null } | null;
  about?: {
    __typename: 'CompanyProfileAbout';
    companyName?: string | null;
    logoUrl?: string | null;
  } | null;
  additionalInfo?: {
    __typename: 'CompanyProfileAdditionalInfo';
    industry?: CompanyProfileIndustry | null;
  } | null;
};

export type CompanyProfileCarouselProfileFragment = {
  __typename: 'CompanyProfileProfilesCarouselProfile';
  id: string;
  slug: string;
  bannerUrl?: string | null;
  logoUrl?: string | null;
  companyName: string;
  industry: CompanyProfileIndustry;
  counters: { __typename?: 'CompanyProfileProfileCounters'; ads: number; cities: number };
};

export type CompanyProfileJobOfferSalaryFragment = {
  __typename?: 'JobOfferSalary';
  currency: string;
  from?: { __typename?: 'JobOfferFloatValue'; value: number } | null;
  to?: { __typename?: 'JobOfferFloatValue'; value: number } | null;
  type?: {
    __typename?: 'JobOfferSalaryType';
    value: { __typename?: 'JobOfferStringValue'; code: string };
  } | null;
};

export type CompanyProfileJobOfferLocationFragment = {
  __typename?: 'JobOfferLocation';
  city?: { __typename?: 'JobOfferCity'; ID: string; name: string } | null;
  district?: { __typename?: 'JobOfferDistrict'; ID: string; name: string } | null;
};

export type CompanyProfileJobOfferParameterFragment = {
  __typename?: 'JobOfferParameter';
  code: string;
  label: string;
  values: Array<{ __typename?: 'JobOfferStringValue'; code: string; label: string } | null>;
};

export type CompanyProfileJobOfferFragment = {
  __typename?: 'JobOfferOffer';
  ID: string;
  url: string;
  title: string;
  addedAt: string;
  salary?: {
    __typename?: 'JobOfferSalary';
    currency: string;
    from?: { __typename?: 'JobOfferFloatValue'; value: number } | null;
    to?: { __typename?: 'JobOfferFloatValue'; value: number } | null;
    type?: {
      __typename?: 'JobOfferSalaryType';
      value: { __typename?: 'JobOfferStringValue'; code: string };
    } | null;
  } | null;
  location: {
    __typename?: 'JobOfferLocation';
    city?: { __typename?: 'JobOfferCity'; ID: string; name: string } | null;
    district?: { __typename?: 'JobOfferDistrict'; ID: string; name: string } | null;
  };
  parameters: Array<{
    __typename?: 'JobOfferParameter';
    code: string;
    label: string;
    values: Array<{ __typename?: 'JobOfferStringValue'; code: string; label: string } | null>;
  }>;
};

export type CompanyProfileJobOfferAggregationFragment = {
  __typename?: 'CompanyProfileAdsAggregation';
  type: CompanyProfileAdsAggregationType;
  values: Array<{
    __typename?: 'CompanyProfileAdsAggregationValue';
    count: number;
    label: string;
    value: string;
  }>;
};

export type CompanyProfileListingFragment = {
  __typename?: 'CompanyProfileProfilesListing';
  total: number;
  profiles: Array<{
    __typename: 'CompanyProfileProfilesListingProfile';
    id: string;
    userId: string;
    companyName: string;
    industry: CompanyProfileIndustry;
    logoUrl?: string | null;
    bannerUrl?: string | null;
    slug: string;
    counters: { __typename?: 'CompanyProfileProfileCounters'; ads: number; cities: number };
  }>;
};

export type CompanyProfileListingProfileFragment = {
  __typename: 'CompanyProfileProfilesListingProfile';
  id: string;
  userId: string;
  companyName: string;
  industry: CompanyProfileIndustry;
  logoUrl?: string | null;
  bannerUrl?: string | null;
  slug: string;
  counters: { __typename?: 'CompanyProfileProfileCounters'; ads: number; cities: number };
};

export type CompanyProfilePrivateConfigFragment = {
  __typename?: 'CompanyProfilePrivateConfig';
  id: string;
  relations: {
    __typename?: 'CompanyProfilePrivateConfigRelations';
    isMainProfile: boolean;
    subProfiles?: Array<{
      __typename?: 'CompanyProfilePrivateConfigSubProfile';
      id: string;
      userId: string;
    }> | null;
  };
  tier: { __typename?: 'CompanyProfilePrivateConfigTier'; type: CompanyProfileTierType };
  features: {
    __typename?: 'CompanyProfileConfigFeatures';
    logo?: { __typename?: 'CompanyProfileConfigFeatureLogo'; enabled: boolean } | null;
    banner?: { __typename?: 'CompanyProfileConfigFeatureBanner'; enabled: boolean } | null;
    companyUrl?: { __typename?: 'CompanyProfileConfigFeatureCompanyUrl'; enabled: boolean } | null;
    socialLinks?: {
      __typename?: 'CompanyProfileConfigFeatureSocialLinks';
      enabled: boolean;
    } | null;
    gallery?: { __typename?: 'CompanyProfileConfigFeatureGallery'; enabled: boolean } | null;
    benefits?: { __typename?: 'CompanyProfileConfigFeatureBenefits'; enabled: boolean } | null;
    recruitment?: {
      __typename?: 'CompanyProfileConfigFeatureRecruitment';
      enabled: boolean;
    } | null;
    followButton?: {
      __typename?: 'CompanyProfileConfigFeatureFollowButton';
      enabled: boolean;
    } | null;
  };
};

export type CompanyProfilePrivateConfigRelationsFragment = {
  __typename?: 'CompanyProfilePrivateConfigRelations';
  isMainProfile: boolean;
  subProfiles?: Array<{
    __typename?: 'CompanyProfilePrivateConfigSubProfile';
    id: string;
    userId: string;
  }> | null;
};

export type CompanyProfilePrivateConfigTierFragment = {
  __typename?: 'CompanyProfilePrivateConfigTier';
  type: CompanyProfileTierType;
};

export type CompanyProfileConfigFeaturesFragment = {
  __typename?: 'CompanyProfileConfigFeatures';
  logo?: { __typename?: 'CompanyProfileConfigFeatureLogo'; enabled: boolean } | null;
  banner?: { __typename?: 'CompanyProfileConfigFeatureBanner'; enabled: boolean } | null;
  companyUrl?: { __typename?: 'CompanyProfileConfigFeatureCompanyUrl'; enabled: boolean } | null;
  socialLinks?: { __typename?: 'CompanyProfileConfigFeatureSocialLinks'; enabled: boolean } | null;
  gallery?: { __typename?: 'CompanyProfileConfigFeatureGallery'; enabled: boolean } | null;
  benefits?: { __typename?: 'CompanyProfileConfigFeatureBenefits'; enabled: boolean } | null;
  recruitment?: { __typename?: 'CompanyProfileConfigFeatureRecruitment'; enabled: boolean } | null;
  followButton?: {
    __typename?: 'CompanyProfileConfigFeatureFollowButton';
    enabled: boolean;
  } | null;
};

export type CompanyProfilePublicConfigFragment = {
  __typename?: 'CompanyProfilePublicConfig';
  tier: CompanyProfileTierType;
  features: {
    __typename?: 'CompanyProfileConfigFeatures';
    followButton?: {
      __typename?: 'CompanyProfileConfigFeatureFollowButton';
      enabled: boolean;
    } | null;
  };
};

export type CompanyProfileSaveAboutMutationVariables = Exact<{
  input: CompanyProfileAboutInput;
}>;

export type CompanyProfileSaveAboutMutation = {
  __typename?: 'Mutation';
  CompanyProfile: {
    __typename?: 'CompanyProfileMutation';
    saveAbout: {
      __typename?: 'CompanyProfilePrivateProfile';
      id: string;
      userId?: string | null;
      slug?: string | null;
      about?: {
        __typename?: 'CompanyProfileAbout';
        companyName?: string | null;
        tagline?: string | null;
        logoUrl?: string | null;
        description?: string | null;
      } | null;
    };
  };
};

export type CompanyProfileSaveAdditionalInfoMutationVariables = Exact<{
  input: CompanyProfileAdditionalInformationInput;
}>;

export type CompanyProfileSaveAdditionalInfoMutation = {
  __typename?: 'Mutation';
  CompanyProfile: {
    __typename?: 'CompanyProfileMutation';
    saveAdditionalInformation: {
      __typename?: 'CompanyProfilePrivateProfile';
      id: string;
      userId?: string | null;
      additionalInfo?: {
        __typename?: 'CompanyProfileAdditionalInfo';
        industry?: CompanyProfileIndustry | null;
        companySize?: string | null;
        email?: string | null;
        phone?: string | null;
        companyUrl?: string | null;
        facebookUrl?: string | null;
        twitterUrl?: string | null;
        linkedinUrl?: string | null;
        instagramUrl?: string | null;
        youtubeUrl?: string | null;
        headquarters?: {
          __typename?: 'CompanyProfileLocation';
          streetName?: string | null;
          streetNumber?: string | null;
          region?: string | null;
          zipCode?: string | null;
          city: string;
          lat: number;
          lng: number;
        } | null;
      } | null;
    };
  };
};

export type CompanyProfileSaveContactMutationVariables = Exact<{
  input: CompanyProfileContactInput;
}>;

export type CompanyProfileSaveContactMutation = {
  __typename?: 'Mutation';
  CompanyProfile: {
    __typename?: 'CompanyProfileMutation';
    saveContact: {
      __typename?: 'CompanyProfilePrivateProfile';
      id: string;
      slug?: string | null;
      userId?: string | null;
      contact?: {
        __typename?: 'CompanyProfileContact';
        companyName?: string | null;
        phone?: string | null;
        email?: string | null;
        headquarters?: {
          __typename?: 'CompanyProfileLocation';
          streetName?: string | null;
          streetNumber?: string | null;
          region?: string | null;
          zipCode?: string | null;
          city: string;
          lat: number;
          lng: number;
        } | null;
      } | null;
    };
  };
};

export type CompanyProfileSaveBenefitsMutationVariables = Exact<{
  input: CompanyProfileBenefitsInput;
}>;

export type CompanyProfileSaveBenefitsMutation = {
  __typename?: 'Mutation';
  CompanyProfile: {
    __typename?: 'CompanyProfileMutation';
    saveBenefits: {
      __typename?: 'CompanyProfilePrivateProfile';
      id: string;
      userId?: string | null;
      benefits?: {
        __typename?: 'CompanyProfileBenefits';
        items?: Array<CompanyProfileBenefit> | null;
      } | null;
    };
  };
};

export type CompanyProfileSaveRecruitmentMutationVariables = Exact<{
  input: CompanyProfileRecruitmentInput;
}>;

export type CompanyProfileSaveRecruitmentMutation = {
  __typename?: 'Mutation';
  CompanyProfile: {
    __typename?: 'CompanyProfileMutation';
    saveRecruitment: {
      __typename?: 'CompanyProfilePrivateProfile';
      id: string;
      userId?: string | null;
      recruitment?: {
        __typename?: 'CompanyProfileRecruitment';
        items?: Array<{
          __typename?: 'CompanyProfileRecruitmentProcess';
          id: string;
          name: string;
          steps: Array<{
            __typename?: 'CompanyProfileRecruitmentProcessStep';
            title: string;
            description: string;
          }>;
        }> | null;
      } | null;
    };
  };
};

export type CompanyProfileSaveLifeAtMutationVariables = Exact<{
  input: CompanyProfileLifeAtInput;
}>;

export type CompanyProfileSaveLifeAtMutation = {
  __typename?: 'Mutation';
  CompanyProfile: {
    __typename?: 'CompanyProfileMutation';
    saveLifeAt: {
      __typename?: 'CompanyProfilePrivateProfile';
      id: string;
      userId?: string | null;
      lifeAt?: {
        __typename?: 'CompanyProfileLifeAt';
        description?: string | null;
        items?: Array<
          | {
              __typename: 'CompanyProfileLifeAtItemExternalVideo';
              id: string;
              type: CompanyProfileLifeAtItemType;
              url: string;
            }
          | {
              __typename: 'CompanyProfileLifeAtItemImage';
              id: string;
              type: CompanyProfileLifeAtItemType;
              url: string;
              fileId: string;
            }
        > | null;
      } | null;
    };
  };
};

export type CompanyProfileSaveMetadataMutationVariables = Exact<{
  input: MetadataInput;
}>;

export type CompanyProfileSaveMetadataMutation = {
  __typename?: 'Mutation';
  CompanyProfile: {
    __typename?: 'CompanyProfileMutation';
    saveMetadata: {
      __typename?: 'Metadata';
      startDate?: string | null;
      updatedAt?: string | null;
      benefitsFeedback?: string | null;
    };
  };
};

export type CompanyProfileConfirmAssetsMutationVariables = Exact<{
  input: Array<CompanyProfileConfirmAssetsInput> | CompanyProfileConfirmAssetsInput;
}>;

export type CompanyProfileConfirmAssetsMutation = {
  __typename?: 'Mutation';
  CompanyProfile: {
    __typename?: 'CompanyProfileMutation';
    confirmAssets: {
      __typename?: 'CompanyProfilePrivateProfile';
      id: string;
      about?: { __typename?: 'CompanyProfileAbout'; logoUrl?: string | null } | null;
      header?: { __typename?: 'CompanyProfileHeader'; bannerUrl?: string | null } | null;
    };
  };
};

export type CompanyProfileDeleteDataMutationVariables = Exact<{ [key: string]: never }>;

export type CompanyProfileDeleteDataMutation = {
  __typename?: 'Mutation';
  CompanyProfile: { __typename?: 'CompanyProfileMutation'; deleteData: boolean };
};

export type CompanyProfileDeleteAssetsMutationVariables = Exact<{
  input: Array<CompanyProfileAssetType> | CompanyProfileAssetType;
}>;

export type CompanyProfileDeleteAssetsMutation = {
  __typename?: 'Mutation';
  CompanyProfile: {
    __typename?: 'CompanyProfileMutation';
    deleteAssets: {
      __typename?: 'CompanyProfilePrivateProfile';
      id: string;
      about?: { __typename?: 'CompanyProfileAbout'; logoUrl?: string | null } | null;
      header?: { __typename?: 'CompanyProfileHeader'; bannerUrl?: string | null } | null;
    };
  };
};

export type CompanyProfilePublishProfileMutationVariables = Exact<{ [key: string]: never }>;

export type CompanyProfilePublishProfileMutation = {
  __typename?: 'Mutation';
  CompanyProfile: {
    __typename?: 'CompanyProfileMutation';
    publishProfile: {
      __typename?: 'CompanyProfilePrivateProfile';
      id: string;
      publishedAt?: string | null;
    };
  };
};

export type CompanyProfilePrivateQueryVariables = Exact<{ [key: string]: never }>;

export type CompanyProfilePrivateQuery = {
  __typename?: 'Query';
  CompanyProfile: {
    __typename?: 'CompanyProfileQuery';
    privateProfile?: {
      __typename?: 'CompanyProfilePrivateProfile';
      id: string;
      userId?: string | null;
      publishedAt?: string | null;
      slug?: string | null;
      header?: { __typename?: 'CompanyProfileHeader'; bannerUrl?: string | null } | null;
      about?: {
        __typename?: 'CompanyProfileAbout';
        companyName?: string | null;
        tagline?: string | null;
        logoUrl?: string | null;
        description?: string | null;
      } | null;
      additionalInfo?: {
        __typename?: 'CompanyProfileAdditionalInfo';
        industry?: CompanyProfileIndustry | null;
        companySize?: string | null;
        email?: string | null;
        phone?: string | null;
        companyUrl?: string | null;
        facebookUrl?: string | null;
        twitterUrl?: string | null;
        linkedinUrl?: string | null;
        instagramUrl?: string | null;
        youtubeUrl?: string | null;
        headquarters?: {
          __typename?: 'CompanyProfileLocation';
          streetName?: string | null;
          streetNumber?: string | null;
          region?: string | null;
          zipCode?: string | null;
          city: string;
          lat: number;
          lng: number;
        } | null;
      } | null;
      benefits?: {
        __typename?: 'CompanyProfileBenefits';
        items?: Array<CompanyProfileBenefit> | null;
      } | null;
      recruitment?: {
        __typename?: 'CompanyProfileRecruitment';
        items?: Array<{
          __typename?: 'CompanyProfileRecruitmentProcess';
          id: string;
          name: string;
          steps: Array<{
            __typename?: 'CompanyProfileRecruitmentProcessStep';
            title: string;
            description: string;
          }>;
        }> | null;
      } | null;
      lifeAt?: {
        __typename?: 'CompanyProfileLifeAt';
        description?: string | null;
        items?: Array<
          | {
              __typename: 'CompanyProfileLifeAtItemExternalVideo';
              id: string;
              type: CompanyProfileLifeAtItemType;
              url: string;
            }
          | {
              __typename: 'CompanyProfileLifeAtItemImage';
              id: string;
              type: CompanyProfileLifeAtItemType;
              url: string;
              fileId: string;
            }
        > | null;
      } | null;
      contact?: {
        __typename?: 'CompanyProfileContact';
        companyName?: string | null;
        phone?: string | null;
        email?: string | null;
        headquarters?: {
          __typename?: 'CompanyProfileLocation';
          streetName?: string | null;
          streetNumber?: string | null;
          region?: string | null;
          zipCode?: string | null;
          city: string;
          lat: number;
          lng: number;
        } | null;
      } | null;
    } | null;
  };
};

export type CompanyProfilePublicQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;

export type CompanyProfilePublicQuery = {
  __typename?: 'Query';
  CompanyProfile: {
    __typename?: 'CompanyProfileQuery';
    publicProfileBySlug?: {
      __typename: 'CompanyProfilePublicProfile';
      id: string;
      userId?: string | null;
      publishedAt?: string | null;
      slug?: string | null;
      config: {
        __typename: 'CompanyProfilePublicConfig';
        tier: CompanyProfileTierType;
        features: {
          __typename?: 'CompanyProfileConfigFeatures';
          followButton?: {
            __typename?: 'CompanyProfileConfigFeatureFollowButton';
            enabled: boolean;
          } | null;
        };
      };
      header?: { __typename: 'CompanyProfileHeader'; bannerUrl?: string | null } | null;
      about?: {
        __typename: 'CompanyProfileAbout';
        companyName?: string | null;
        tagline?: string | null;
        logoUrl?: string | null;
        description?: string | null;
      } | null;
      additionalInfo?: {
        __typename: 'CompanyProfileAdditionalInfo';
        industry?: CompanyProfileIndustry | null;
        companySize?: string | null;
        email?: string | null;
        phone?: string | null;
        companyUrl?: string | null;
        facebookUrl?: string | null;
        twitterUrl?: string | null;
        linkedinUrl?: string | null;
        instagramUrl?: string | null;
        youtubeUrl?: string | null;
        headquarters?: {
          __typename?: 'CompanyProfileLocation';
          streetName?: string | null;
          streetNumber?: string | null;
          region?: string | null;
          zipCode?: string | null;
          city: string;
          lat: number;
          lng: number;
        } | null;
      } | null;
      benefits?: {
        __typename: 'CompanyProfileBenefits';
        items?: Array<CompanyProfileBenefit> | null;
      } | null;
      recruitment?: {
        __typename: 'CompanyProfileRecruitment';
        items?: Array<{
          __typename?: 'CompanyProfileRecruitmentProcess';
          id: string;
          name: string;
          steps: Array<{
            __typename?: 'CompanyProfileRecruitmentProcessStep';
            title: string;
            description: string;
          }>;
        }> | null;
      } | null;
      lifeAt?: {
        __typename: 'CompanyProfileLifeAt';
        description?: string | null;
        items?: Array<
          | {
              __typename: 'CompanyProfileLifeAtItemExternalVideo';
              id: string;
              type: CompanyProfileLifeAtItemType;
              url: string;
            }
          | {
              __typename: 'CompanyProfileLifeAtItemImage';
              id: string;
              type: CompanyProfileLifeAtItemType;
              url: string;
              fileId: string;
            }
        > | null;
      } | null;
      contact?: {
        __typename: 'CompanyProfileContact';
        companyName?: string | null;
        phone?: string | null;
        email?: string | null;
        headquarters?: {
          __typename?: 'CompanyProfileLocation';
          streetName?: string | null;
          streetNumber?: string | null;
          region?: string | null;
          zipCode?: string | null;
          city: string;
          lat: number;
          lng: number;
        } | null;
      } | null;
    } | null;
  };
};

export type CompanyProfilePreviewQueryVariables = Exact<{ [key: string]: never }>;

export type CompanyProfilePreviewQuery = {
  __typename?: 'Query';
  CompanyProfile: {
    __typename?: 'CompanyProfileQuery';
    previewProfile?: {
      __typename: 'CompanyProfilePublicProfile';
      id: string;
      userId?: string | null;
      publishedAt?: string | null;
      slug?: string | null;
      config: {
        __typename?: 'CompanyProfilePublicConfig';
        tier: CompanyProfileTierType;
        features: {
          __typename?: 'CompanyProfileConfigFeatures';
          followButton?: {
            __typename?: 'CompanyProfileConfigFeatureFollowButton';
            enabled: boolean;
          } | null;
        };
      };
      header?: { __typename?: 'CompanyProfileHeader'; bannerUrl?: string | null } | null;
      about?: {
        __typename?: 'CompanyProfileAbout';
        companyName?: string | null;
        tagline?: string | null;
        logoUrl?: string | null;
        description?: string | null;
      } | null;
      additionalInfo?: {
        __typename?: 'CompanyProfileAdditionalInfo';
        industry?: CompanyProfileIndustry | null;
        companySize?: string | null;
        email?: string | null;
        phone?: string | null;
        companyUrl?: string | null;
        facebookUrl?: string | null;
        twitterUrl?: string | null;
        linkedinUrl?: string | null;
        instagramUrl?: string | null;
        youtubeUrl?: string | null;
        headquarters?: {
          __typename?: 'CompanyProfileLocation';
          streetName?: string | null;
          streetNumber?: string | null;
          region?: string | null;
          zipCode?: string | null;
          city: string;
          lat: number;
          lng: number;
        } | null;
      } | null;
      benefits?: {
        __typename?: 'CompanyProfileBenefits';
        items?: Array<CompanyProfileBenefit> | null;
      } | null;
      recruitment?: {
        __typename?: 'CompanyProfileRecruitment';
        items?: Array<{
          __typename?: 'CompanyProfileRecruitmentProcess';
          id: string;
          name: string;
          steps: Array<{
            __typename?: 'CompanyProfileRecruitmentProcessStep';
            title: string;
            description: string;
          }>;
        }> | null;
      } | null;
      lifeAt?: {
        __typename?: 'CompanyProfileLifeAt';
        description?: string | null;
        items?: Array<
          | {
              __typename: 'CompanyProfileLifeAtItemExternalVideo';
              id: string;
              type: CompanyProfileLifeAtItemType;
              url: string;
            }
          | {
              __typename: 'CompanyProfileLifeAtItemImage';
              id: string;
              type: CompanyProfileLifeAtItemType;
              url: string;
              fileId: string;
            }
        > | null;
      } | null;
      contact?: {
        __typename?: 'CompanyProfileContact';
        companyName?: string | null;
        phone?: string | null;
        email?: string | null;
        headquarters?: {
          __typename?: 'CompanyProfileLocation';
          streetName?: string | null;
          streetNumber?: string | null;
          region?: string | null;
          zipCode?: string | null;
          city: string;
          lat: number;
          lng: number;
        } | null;
      } | null;
    } | null;
  };
};

export type CompanyProfilePublicSlugQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;

export type CompanyProfilePublicSlugQuery = {
  __typename?: 'Query';
  CompanyProfile: {
    __typename?: 'CompanyProfileQuery';
    publicProfileByUuid?: {
      __typename?: 'CompanyProfilePublicProfile';
      id: string;
      slug?: string | null;
    } | null;
  };
};

export type LegacyCompanyProfileJobListingCarouselProfilesQueryVariables = Exact<{
  input: CompanyProfilePublicProfilesInput;
}>;

export type LegacyCompanyProfileJobListingCarouselProfilesQuery = {
  __typename?: 'Query';
  CompanyProfile: {
    __typename?: 'CompanyProfileQuery';
    publicProfiles: Array<{
      __typename: 'CompanyProfilePublicProfile';
      id: string;
      slug?: string | null;
      header?: { __typename: 'CompanyProfileHeader'; bannerUrl?: string | null } | null;
      about?: {
        __typename: 'CompanyProfileAbout';
        companyName?: string | null;
        logoUrl?: string | null;
      } | null;
      additionalInfo?: {
        __typename: 'CompanyProfileAdditionalInfo';
        industry?: CompanyProfileIndustry | null;
      } | null;
    }>;
  };
};

export type CompanyProfileCarouselQueryVariables = Exact<{
  input: CompanyProfileProfilesCarouselInput;
}>;

export type CompanyProfileCarouselQuery = {
  __typename?: 'Query';
  CompanyProfile: {
    __typename?: 'CompanyProfileQuery';
    profilesCarousel: {
      __typename?: 'CompanyProfileProfilesCarousel';
      profiles: Array<{
        __typename: 'CompanyProfileProfilesCarouselProfile';
        id: string;
        slug: string;
        bannerUrl?: string | null;
        logoUrl?: string | null;
        companyName: string;
        industry: CompanyProfileIndustry;
        counters: { __typename?: 'CompanyProfileProfileCounters'; ads: number; cities: number };
      }>;
    };
  };
};

export type CompanyProfileListingQueryVariables = Exact<{
  input: CompanyProfileProfilesListingInput;
}>;

export type CompanyProfileListingQuery = {
  __typename?: 'Query';
  CompanyProfile: {
    __typename?: 'CompanyProfileQuery';
    profilesListing: {
      __typename?: 'CompanyProfileProfilesListing';
      total: number;
      profiles: Array<{
        __typename: 'CompanyProfileProfilesListingProfile';
        id: string;
        userId: string;
        companyName: string;
        industry: CompanyProfileIndustry;
        logoUrl?: string | null;
        bannerUrl?: string | null;
        slug: string;
        counters: { __typename?: 'CompanyProfileProfileCounters'; ads: number; cities: number };
      }>;
    };
  };
};

export type CompanyProfileTrialQueryVariables = Exact<{ [key: string]: never }>;

export type CompanyProfileTrialQuery = {
  __typename?: 'Query';
  CompanyProfile: {
    __typename?: 'CompanyProfileQuery';
    privateProfile?: {
      __typename?: 'CompanyProfilePrivateProfile';
      id: string;
      userId?: string | null;
    } | null;
  };
};

export type CompanyProfileJobAdQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;

export type CompanyProfileJobAdQuery = {
  __typename?: 'Query';
  CompanyProfile: {
    __typename?: 'CompanyProfileQuery';
    publicProfileByUuid?: {
      __typename: 'CompanyProfilePublicProfile';
      id: string;
      slug?: string | null;
      userId?: string | null;
      publishedAt?: string | null;
      about?: {
        __typename: 'CompanyProfileAbout';
        companyName?: string | null;
        tagline?: string | null;
        logoUrl?: string | null;
        description?: string | null;
      } | null;
      additionalInfo?: {
        __typename: 'CompanyProfileAdditionalInfo';
        industry?: CompanyProfileIndustry | null;
        companySize?: string | null;
        email?: string | null;
        phone?: string | null;
        companyUrl?: string | null;
        facebookUrl?: string | null;
        twitterUrl?: string | null;
        linkedinUrl?: string | null;
        instagramUrl?: string | null;
        youtubeUrl?: string | null;
        headquarters?: {
          __typename?: 'CompanyProfileLocation';
          streetName?: string | null;
          streetNumber?: string | null;
          region?: string | null;
          zipCode?: string | null;
          city: string;
          lat: number;
          lng: number;
        } | null;
      } | null;
      benefits?: {
        __typename: 'CompanyProfileBenefits';
        items?: Array<CompanyProfileBenefit> | null;
      } | null;
      recruitment?: {
        __typename: 'CompanyProfileRecruitment';
        items?: Array<{
          __typename?: 'CompanyProfileRecruitmentProcess';
          id: string;
          name: string;
          steps: Array<{
            __typename?: 'CompanyProfileRecruitmentProcessStep';
            title: string;
            description: string;
          }>;
        }> | null;
      } | null;
    } | null;
  };
};

export type CompanyProfilePostingDetailsQueryVariables = Exact<{ [key: string]: never }>;

export type CompanyProfilePostingDetailsQuery = {
  __typename?: 'Query';
  CompanyProfile: {
    __typename?: 'CompanyProfileQuery';
    privateProfile?: {
      __typename?: 'CompanyProfilePrivateProfile';
      id: string;
      publishedAt?: string | null;
      about?: { __typename?: 'CompanyProfileAbout'; companyName?: string | null } | null;
    } | null;
  };
};

export type CompanyProfileMetadataQueryVariables = Exact<{ [key: string]: never }>;

export type CompanyProfileMetadataQuery = {
  __typename?: 'Query';
  CompanyProfile: {
    __typename?: 'CompanyProfileQuery';
    metadata: {
      __typename?: 'Metadata';
      startDate?: string | null;
      updatedAt?: string | null;
      benefitsFeedback?: string | null;
    };
  };
};

export type CompanyProfileUploadRequestDataQueryVariables = Exact<{ [key: string]: never }>;

export type CompanyProfileUploadRequestDataQuery = {
  __typename?: 'Query';
  CompanyProfile: {
    __typename?: 'CompanyProfileQuery';
    uploadRequestData: { __typename?: 'UploadRequestDataPayload'; url: string; token: string };
  };
};

export type CompanyProfileLocationSuggestionsQueryVariables = Exact<{
  phrase: Scalars['String']['input'];
  provider?: InputMaybe<LocationProvider>;
}>;

export type CompanyProfileLocationSuggestionsQuery = {
  __typename?: 'Query';
  CompanyProfile: {
    __typename?: 'CompanyProfileQuery';
    locationSuggestions: Array<{
      __typename?: 'LocationSuggestion';
      id: string;
      city: string;
      label: string;
      lat: number;
      lng: number;
      region: string;
      streetName: string;
      streetNumber: string;
      zipCode: string;
    }>;
  };
};

export type CompanyProfileEmployerSegmentQueryVariables = Exact<{
  atlasUserId: Scalars['String']['input'];
}>;

export type CompanyProfileEmployerSegmentQuery = {
  __typename?: 'Query';
  CompanyProfile: {
    __typename?: 'CompanyProfileQuery';
    employerSegment: { __typename: 'EmployerSegmentResponse'; id: string; type: EmployerSegment };
  };
};

export type CompanyProfileJobOffersQueryVariables = Exact<{
  input: CompanyProfileAdsInput;
}>;

export type CompanyProfileJobOffersQuery = {
  __typename?: 'Query';
  CompanyProfile: {
    __typename?: 'CompanyProfileQuery';
    ads: {
      __typename?: 'CompanyProfileAds';
      total: number;
      ads: Array<{
        __typename?: 'JobOfferOffer';
        ID: string;
        url: string;
        title: string;
        addedAt: string;
        salary?: {
          __typename?: 'JobOfferSalary';
          currency: string;
          from?: { __typename?: 'JobOfferFloatValue'; value: number } | null;
          to?: { __typename?: 'JobOfferFloatValue'; value: number } | null;
          type?: {
            __typename?: 'JobOfferSalaryType';
            value: { __typename?: 'JobOfferStringValue'; code: string };
          } | null;
        } | null;
        location: {
          __typename?: 'JobOfferLocation';
          city?: { __typename?: 'JobOfferCity'; ID: string; name: string } | null;
          district?: { __typename?: 'JobOfferDistrict'; ID: string; name: string } | null;
        };
        parameters: Array<{
          __typename?: 'JobOfferParameter';
          code: string;
          label: string;
          values: Array<{ __typename?: 'JobOfferStringValue'; code: string; label: string } | null>;
        }>;
      }>;
      aggregations: {
        __typename?: 'CompanyProfileAdsAggregations';
        categories: {
          __typename?: 'CompanyProfileAdsAggregation';
          type: CompanyProfileAdsAggregationType;
          values: Array<{
            __typename?: 'CompanyProfileAdsAggregationValue';
            count: number;
            label: string;
            value: string;
          }>;
        };
        cities: {
          __typename?: 'CompanyProfileAdsAggregation';
          type: CompanyProfileAdsAggregationType;
          values: Array<{
            __typename?: 'CompanyProfileAdsAggregationValue';
            count: number;
            label: string;
            value: string;
          }>;
        };
      };
    };
  };
};

export type CompanyProfileExternalImageAdsCategoriesQueryVariables = Exact<{
  input: CompanyProfileAdsInput;
}>;

export type CompanyProfileExternalImageAdsCategoriesQuery = {
  __typename?: 'Query';
  CompanyProfile: {
    __typename?: 'CompanyProfileQuery';
    ads: {
      __typename?: 'CompanyProfileAds';
      aggregations: {
        __typename?: 'CompanyProfileAdsAggregations';
        categories: {
          __typename?: 'CompanyProfileAdsAggregation';
          type: CompanyProfileAdsAggregationType;
          values: Array<{
            __typename?: 'CompanyProfileAdsAggregationValue';
            count: number;
            label: string;
            value: string;
          }>;
        };
      };
    };
  };
};

export type AtlasUserQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type AtlasUserQuery = {
  __typename?: 'Query';
  atlasUser?: { __typename?: 'AtlasUser'; id: string; created: string } | null;
};

export type CompanyProfileMainFallbackProfileQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;

export type CompanyProfileMainFallbackProfileQuery = {
  __typename?: 'Query';
  CompanyProfile: {
    __typename?: 'CompanyProfileQuery';
    publicProfileByUuid?: {
      __typename: 'CompanyProfilePublicProfile';
      id: string;
      userId?: string | null;
      publishedAt?: string | null;
      slug?: string | null;
      header?: { __typename: 'CompanyProfileHeader'; bannerUrl?: string | null } | null;
      about?: {
        __typename: 'CompanyProfileAbout';
        companyName?: string | null;
        tagline?: string | null;
        logoUrl?: string | null;
        description?: string | null;
      } | null;
      additionalInfo?: {
        __typename: 'CompanyProfileAdditionalInfo';
        industry?: CompanyProfileIndustry | null;
        companySize?: string | null;
        email?: string | null;
        phone?: string | null;
        companyUrl?: string | null;
        facebookUrl?: string | null;
        twitterUrl?: string | null;
        linkedinUrl?: string | null;
        instagramUrl?: string | null;
        youtubeUrl?: string | null;
        headquarters?: {
          __typename?: 'CompanyProfileLocation';
          streetName?: string | null;
          streetNumber?: string | null;
          region?: string | null;
          zipCode?: string | null;
          city: string;
          lat: number;
          lng: number;
        } | null;
      } | null;
      benefits?: {
        __typename: 'CompanyProfileBenefits';
        items?: Array<CompanyProfileBenefit> | null;
      } | null;
      recruitment?: {
        __typename: 'CompanyProfileRecruitment';
        items?: Array<{
          __typename?: 'CompanyProfileRecruitmentProcess';
          id: string;
          name: string;
          steps: Array<{
            __typename?: 'CompanyProfileRecruitmentProcessStep';
            title: string;
            description: string;
          }>;
        }> | null;
      } | null;
      lifeAt?: {
        __typename: 'CompanyProfileLifeAt';
        description?: string | null;
        items?: Array<
          | {
              __typename: 'CompanyProfileLifeAtItemExternalVideo';
              id: string;
              type: CompanyProfileLifeAtItemType;
              url: string;
            }
          | {
              __typename: 'CompanyProfileLifeAtItemImage';
              id: string;
              type: CompanyProfileLifeAtItemType;
              url: string;
              fileId: string;
            }
        > | null;
      } | null;
      contact?: {
        __typename: 'CompanyProfileContact';
        companyName?: string | null;
        phone?: string | null;
        email?: string | null;
        headquarters?: {
          __typename?: 'CompanyProfileLocation';
          streetName?: string | null;
          streetNumber?: string | null;
          region?: string | null;
          zipCode?: string | null;
          city: string;
          lat: number;
          lng: number;
        } | null;
      } | null;
    } | null;
  };
};

export type CompanyProfilePrivateConfigQueryVariables = Exact<{ [key: string]: never }>;

export type CompanyProfilePrivateConfigQuery = {
  __typename?: 'Query';
  CompanyProfile: {
    __typename?: 'CompanyProfileQuery';
    privateConfig: {
      __typename?: 'CompanyProfilePrivateConfig';
      id: string;
      relations: {
        __typename?: 'CompanyProfilePrivateConfigRelations';
        isMainProfile: boolean;
        subProfiles?: Array<{
          __typename?: 'CompanyProfilePrivateConfigSubProfile';
          id: string;
          userId: string;
        }> | null;
      };
      tier: { __typename?: 'CompanyProfilePrivateConfigTier'; type: CompanyProfileTierType };
      features: {
        __typename?: 'CompanyProfileConfigFeatures';
        logo?: { __typename?: 'CompanyProfileConfigFeatureLogo'; enabled: boolean } | null;
        banner?: { __typename?: 'CompanyProfileConfigFeatureBanner'; enabled: boolean } | null;
        companyUrl?: {
          __typename?: 'CompanyProfileConfigFeatureCompanyUrl';
          enabled: boolean;
        } | null;
        socialLinks?: {
          __typename?: 'CompanyProfileConfigFeatureSocialLinks';
          enabled: boolean;
        } | null;
        gallery?: { __typename?: 'CompanyProfileConfigFeatureGallery'; enabled: boolean } | null;
        benefits?: { __typename?: 'CompanyProfileConfigFeatureBenefits'; enabled: boolean } | null;
        recruitment?: {
          __typename?: 'CompanyProfileConfigFeatureRecruitment';
          enabled: boolean;
        } | null;
        followButton?: {
          __typename?: 'CompanyProfileConfigFeatureFollowButton';
          enabled: boolean;
        } | null;
      };
    };
  };
};

export const CompanyProfileHeaderFragmentDoc = gql`
  fragment CompanyProfileHeader on CompanyProfileHeader {
    bannerUrl
  }
`;
export const CompanyProfileAboutFragmentDoc = gql`
  fragment CompanyProfileAbout on CompanyProfileAbout {
    companyName
    tagline
    logoUrl
    description
  }
`;
export const CompanyProfileAdditionalInfoFragmentDoc = gql`
  fragment CompanyProfileAdditionalInfo on CompanyProfileAdditionalInfo {
    industry
    companySize
    headquarters {
      streetName
      streetNumber
      region
      zipCode
      city
      lat
      lng
    }
    email
    phone
    companyUrl
    facebookUrl
    twitterUrl
    linkedinUrl
    instagramUrl
    youtubeUrl
  }
`;
export const CompanyProfileBenefitsFragmentDoc = gql`
  fragment CompanyProfileBenefits on CompanyProfileBenefits {
    items
  }
`;
export const CompanyProfileRecruitmentFragmentDoc = gql`
  fragment CompanyProfileRecruitment on CompanyProfileRecruitment {
    items {
      id
      name
      steps {
        title
        description
      }
    }
  }
`;
export const CompanyProfileLifeAtFragmentDoc = gql`
  fragment CompanyProfileLifeAt on CompanyProfileLifeAt {
    description
    items {
      ... on CompanyProfileLifeAtItemImage {
        __typename
        id
        type
        url
        fileId
      }
      ... on CompanyProfileLifeAtItemExternalVideo {
        __typename
        id
        type
        url
      }
    }
  }
`;
export const CompanyProfileContactFragmentDoc = gql`
  fragment CompanyProfileContact on CompanyProfileContact {
    companyName
    headquarters {
      streetName
      streetNumber
      region
      zipCode
      city
      lat
      lng
    }
    phone
    email
  }
`;
export const CompanyProfilePrivateProfileFragmentDoc = gql`
  fragment CompanyProfilePrivateProfile on CompanyProfilePrivateProfile {
    id
    userId
    publishedAt
    slug
    header {
      ...CompanyProfileHeader
    }
    about {
      ...CompanyProfileAbout
    }
    additionalInfo {
      ...CompanyProfileAdditionalInfo
    }
    benefits {
      ...CompanyProfileBenefits
    }
    recruitment {
      ...CompanyProfileRecruitment
    }
    lifeAt {
      ...CompanyProfileLifeAt
    }
    contact {
      ...CompanyProfileContact
    }
  }
  ${CompanyProfileHeaderFragmentDoc}
  ${CompanyProfileAboutFragmentDoc}
  ${CompanyProfileAdditionalInfoFragmentDoc}
  ${CompanyProfileBenefitsFragmentDoc}
  ${CompanyProfileRecruitmentFragmentDoc}
  ${CompanyProfileLifeAtFragmentDoc}
  ${CompanyProfileContactFragmentDoc}
`;
export const CompanyProfilePublicProfileFragmentDoc = gql`
  fragment CompanyProfilePublicProfile on CompanyProfilePublicProfile {
    __typename
    id
    userId
    publishedAt
    slug
    header {
      __typename
      ...CompanyProfileHeader
    }
    about {
      __typename
      ...CompanyProfileAbout
    }
    additionalInfo {
      __typename
      ...CompanyProfileAdditionalInfo
    }
    benefits {
      __typename
      ...CompanyProfileBenefits
    }
    recruitment {
      __typename
      ...CompanyProfileRecruitment
    }
    lifeAt {
      __typename
      ...CompanyProfileLifeAt
    }
    contact {
      __typename
      ...CompanyProfileContact
    }
  }
  ${CompanyProfileHeaderFragmentDoc}
  ${CompanyProfileAboutFragmentDoc}
  ${CompanyProfileAdditionalInfoFragmentDoc}
  ${CompanyProfileBenefitsFragmentDoc}
  ${CompanyProfileRecruitmentFragmentDoc}
  ${CompanyProfileLifeAtFragmentDoc}
  ${CompanyProfileContactFragmentDoc}
`;
export const CompanyProfilePublicConfigFragmentDoc = gql`
  fragment CompanyProfilePublicConfig on CompanyProfilePublicConfig {
    tier
    features {
      followButton {
        enabled
      }
    }
  }
`;
export const CompanyProfilePublicProfileWithConfigFragmentDoc = gql`
  fragment CompanyProfilePublicProfileWithConfig on CompanyProfilePublicProfile {
    ...CompanyProfilePublicProfile
    config {
      __typename
      ...CompanyProfilePublicConfig
    }
  }
  ${CompanyProfilePublicProfileFragmentDoc}
  ${CompanyProfilePublicConfigFragmentDoc}
`;
export const CompanyProfilePreviewProfileFragmentDoc = gql`
  fragment CompanyProfilePreviewProfile on CompanyProfilePublicProfile {
    __typename
    id
    userId
    publishedAt
    slug
    header {
      ...CompanyProfileHeader
    }
    about {
      ...CompanyProfileAbout
    }
    additionalInfo {
      ...CompanyProfileAdditionalInfo
    }
    benefits {
      ...CompanyProfileBenefits
    }
    recruitment {
      ...CompanyProfileRecruitment
    }
    lifeAt {
      ...CompanyProfileLifeAt
    }
    contact {
      ...CompanyProfileContact
    }
  }
  ${CompanyProfileHeaderFragmentDoc}
  ${CompanyProfileAboutFragmentDoc}
  ${CompanyProfileAdditionalInfoFragmentDoc}
  ${CompanyProfileBenefitsFragmentDoc}
  ${CompanyProfileRecruitmentFragmentDoc}
  ${CompanyProfileLifeAtFragmentDoc}
  ${CompanyProfileContactFragmentDoc}
`;
export const CompanyProfilePreviewProfileWithConfigFragmentDoc = gql`
  fragment CompanyProfilePreviewProfileWithConfig on CompanyProfilePublicProfile {
    ...CompanyProfilePreviewProfile
    config {
      ...CompanyProfilePublicConfig
    }
  }
  ${CompanyProfilePreviewProfileFragmentDoc}
  ${CompanyProfilePublicConfigFragmentDoc}
`;
export const CompanyProfileJobAdProfileFragmentDoc = gql`
  fragment CompanyProfileJobAdProfile on CompanyProfilePublicProfile {
    __typename
    id
    slug
    userId
    publishedAt
    about {
      __typename
      ...CompanyProfileAbout
    }
    additionalInfo {
      __typename
      ...CompanyProfileAdditionalInfo
    }
    benefits {
      __typename
      ...CompanyProfileBenefits
    }
    recruitment {
      __typename
      ...CompanyProfileRecruitment
    }
  }
  ${CompanyProfileAboutFragmentDoc}
  ${CompanyProfileAdditionalInfoFragmentDoc}
  ${CompanyProfileBenefitsFragmentDoc}
  ${CompanyProfileRecruitmentFragmentDoc}
`;
export const CompanyProfileTrialProfileFragmentDoc = gql`
  fragment CompanyProfileTrialProfile on CompanyProfilePrivateProfile {
    id
    userId
  }
`;
export const CompanyProfileMetadataFragmentDoc = gql`
  fragment CompanyProfileMetadata on Metadata {
    startDate
    updatedAt
    benefitsFeedback
  }
`;
export const CompanyProfilePostingDetailsFragmentDoc = gql`
  fragment CompanyProfilePostingDetails on CompanyProfilePrivateProfile {
    id
    publishedAt
    about {
      companyName
    }
  }
`;
export const LegacyCompanyProfileCarouselProfileFragmentDoc = gql`
  fragment LegacyCompanyProfileCarouselProfile on CompanyProfilePublicProfile {
    __typename
    id
    slug
    header {
      __typename
      bannerUrl
    }
    about {
      __typename
      companyName
      logoUrl
    }
    additionalInfo {
      __typename
      industry
    }
  }
`;
export const CompanyProfileCarouselProfileFragmentDoc = gql`
  fragment CompanyProfileCarouselProfile on CompanyProfileProfilesCarouselProfile {
    __typename
    id
    slug
    bannerUrl
    logoUrl
    companyName
    industry
    counters {
      ads
      cities
    }
  }
`;
export const CompanyProfileJobOfferSalaryFragmentDoc = gql`
  fragment CompanyProfileJobOfferSalary on JobOfferSalary {
    from {
      value
    }
    to {
      value
    }
    currency
    type {
      value {
        code
      }
    }
  }
`;
export const CompanyProfileJobOfferLocationFragmentDoc = gql`
  fragment CompanyProfileJobOfferLocation on JobOfferLocation {
    city {
      ID
      name
    }
    district {
      ID
      name
    }
  }
`;
export const CompanyProfileJobOfferParameterFragmentDoc = gql`
  fragment CompanyProfileJobOfferParameter on JobOfferParameter {
    code
    label
    values {
      code
      label
    }
  }
`;
export const CompanyProfileJobOfferFragmentDoc = gql`
  fragment CompanyProfileJobOffer on JobOfferOffer {
    ID
    url
    title
    addedAt
    salary {
      ...CompanyProfileJobOfferSalary
    }
    location {
      ...CompanyProfileJobOfferLocation
    }
    parameters {
      ...CompanyProfileJobOfferParameter
    }
  }
  ${CompanyProfileJobOfferSalaryFragmentDoc}
  ${CompanyProfileJobOfferLocationFragmentDoc}
  ${CompanyProfileJobOfferParameterFragmentDoc}
`;
export const CompanyProfileJobOfferAggregationFragmentDoc = gql`
  fragment CompanyProfileJobOfferAggregation on CompanyProfileAdsAggregation {
    type
    values {
      count
      label
      value
    }
  }
`;
export const CompanyProfileListingProfileFragmentDoc = gql`
  fragment CompanyProfileListingProfile on CompanyProfileProfilesListingProfile {
    __typename
    id
    userId
    companyName
    industry
    logoUrl
    bannerUrl
    counters {
      ads
      cities
    }
    slug
  }
`;
export const CompanyProfileListingFragmentDoc = gql`
  fragment CompanyProfileListing on CompanyProfileProfilesListing {
    profiles {
      ...CompanyProfileListingProfile
    }
    total
  }
  ${CompanyProfileListingProfileFragmentDoc}
`;
export const CompanyProfilePrivateConfigRelationsFragmentDoc = gql`
  fragment CompanyProfilePrivateConfigRelations on CompanyProfilePrivateConfigRelations {
    isMainProfile
    subProfiles {
      id
      userId
    }
  }
`;
export const CompanyProfilePrivateConfigTierFragmentDoc = gql`
  fragment CompanyProfilePrivateConfigTier on CompanyProfilePrivateConfigTier {
    type
  }
`;
export const CompanyProfileConfigFeaturesFragmentDoc = gql`
  fragment CompanyProfileConfigFeatures on CompanyProfileConfigFeatures {
    logo {
      enabled
    }
    banner {
      enabled
    }
    companyUrl {
      enabled
    }
    socialLinks {
      enabled
    }
    gallery {
      enabled
    }
    benefits {
      enabled
    }
    recruitment {
      enabled
    }
    followButton {
      enabled
    }
  }
`;
export const CompanyProfilePrivateConfigFragmentDoc = gql`
  fragment CompanyProfilePrivateConfig on CompanyProfilePrivateConfig {
    id
    relations {
      ...CompanyProfilePrivateConfigRelations
    }
    tier {
      ...CompanyProfilePrivateConfigTier
    }
    features {
      ...CompanyProfileConfigFeatures
    }
  }
  ${CompanyProfilePrivateConfigRelationsFragmentDoc}
  ${CompanyProfilePrivateConfigTierFragmentDoc}
  ${CompanyProfileConfigFeaturesFragmentDoc}
`;
export const CompanyProfileSaveAboutDocument = gql`
  mutation CompanyProfileSaveAbout($input: CompanyProfileAboutInput!) {
    CompanyProfile {
      saveAbout(input: $input) {
        id
        userId
        slug
        about {
          ...CompanyProfileAbout
        }
      }
    }
  }
  ${CompanyProfileAboutFragmentDoc}
`;
export type CompanyProfileSaveAboutMutationFn = Apollo.MutationFunction<
  CompanyProfileSaveAboutMutation,
  CompanyProfileSaveAboutMutationVariables
>;

/**
 * __useCompanyProfileSaveAboutMutation__
 *
 * To run a mutation, you first call `useCompanyProfileSaveAboutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompanyProfileSaveAboutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [companyProfileSaveAboutMutation, { data, loading, error }] = useCompanyProfileSaveAboutMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompanyProfileSaveAboutMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CompanyProfileSaveAboutMutation,
    CompanyProfileSaveAboutMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CompanyProfileSaveAboutMutation,
    CompanyProfileSaveAboutMutationVariables
  >(CompanyProfileSaveAboutDocument, options);
}
export type CompanyProfileSaveAboutMutationHookResult = ReturnType<
  typeof useCompanyProfileSaveAboutMutation
>;
export type CompanyProfileSaveAboutMutationResult =
  Apollo.MutationResult<CompanyProfileSaveAboutMutation>;
export type CompanyProfileSaveAboutMutationOptions = Apollo.BaseMutationOptions<
  CompanyProfileSaveAboutMutation,
  CompanyProfileSaveAboutMutationVariables
>;
export const CompanyProfileSaveAdditionalInfoDocument = gql`
  mutation CompanyProfileSaveAdditionalInfo($input: CompanyProfileAdditionalInformationInput!) {
    CompanyProfile {
      saveAdditionalInformation(input: $input) {
        id
        userId
        additionalInfo {
          ...CompanyProfileAdditionalInfo
        }
      }
    }
  }
  ${CompanyProfileAdditionalInfoFragmentDoc}
`;
export type CompanyProfileSaveAdditionalInfoMutationFn = Apollo.MutationFunction<
  CompanyProfileSaveAdditionalInfoMutation,
  CompanyProfileSaveAdditionalInfoMutationVariables
>;

/**
 * __useCompanyProfileSaveAdditionalInfoMutation__
 *
 * To run a mutation, you first call `useCompanyProfileSaveAdditionalInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompanyProfileSaveAdditionalInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [companyProfileSaveAdditionalInfoMutation, { data, loading, error }] = useCompanyProfileSaveAdditionalInfoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompanyProfileSaveAdditionalInfoMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CompanyProfileSaveAdditionalInfoMutation,
    CompanyProfileSaveAdditionalInfoMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CompanyProfileSaveAdditionalInfoMutation,
    CompanyProfileSaveAdditionalInfoMutationVariables
  >(CompanyProfileSaveAdditionalInfoDocument, options);
}
export type CompanyProfileSaveAdditionalInfoMutationHookResult = ReturnType<
  typeof useCompanyProfileSaveAdditionalInfoMutation
>;
export type CompanyProfileSaveAdditionalInfoMutationResult =
  Apollo.MutationResult<CompanyProfileSaveAdditionalInfoMutation>;
export type CompanyProfileSaveAdditionalInfoMutationOptions = Apollo.BaseMutationOptions<
  CompanyProfileSaveAdditionalInfoMutation,
  CompanyProfileSaveAdditionalInfoMutationVariables
>;
export const CompanyProfileSaveContactDocument = gql`
  mutation CompanyProfileSaveContact($input: CompanyProfileContactInput!) {
    CompanyProfile {
      saveContact(input: $input) {
        id
        slug
        userId
        contact {
          ...CompanyProfileContact
        }
      }
    }
  }
  ${CompanyProfileContactFragmentDoc}
`;
export type CompanyProfileSaveContactMutationFn = Apollo.MutationFunction<
  CompanyProfileSaveContactMutation,
  CompanyProfileSaveContactMutationVariables
>;

/**
 * __useCompanyProfileSaveContactMutation__
 *
 * To run a mutation, you first call `useCompanyProfileSaveContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompanyProfileSaveContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [companyProfileSaveContactMutation, { data, loading, error }] = useCompanyProfileSaveContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompanyProfileSaveContactMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CompanyProfileSaveContactMutation,
    CompanyProfileSaveContactMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CompanyProfileSaveContactMutation,
    CompanyProfileSaveContactMutationVariables
  >(CompanyProfileSaveContactDocument, options);
}
export type CompanyProfileSaveContactMutationHookResult = ReturnType<
  typeof useCompanyProfileSaveContactMutation
>;
export type CompanyProfileSaveContactMutationResult =
  Apollo.MutationResult<CompanyProfileSaveContactMutation>;
export type CompanyProfileSaveContactMutationOptions = Apollo.BaseMutationOptions<
  CompanyProfileSaveContactMutation,
  CompanyProfileSaveContactMutationVariables
>;
export const CompanyProfileSaveBenefitsDocument = gql`
  mutation CompanyProfileSaveBenefits($input: CompanyProfileBenefitsInput!) {
    CompanyProfile {
      saveBenefits(input: $input) {
        id
        userId
        benefits {
          ...CompanyProfileBenefits
        }
      }
    }
  }
  ${CompanyProfileBenefitsFragmentDoc}
`;
export type CompanyProfileSaveBenefitsMutationFn = Apollo.MutationFunction<
  CompanyProfileSaveBenefitsMutation,
  CompanyProfileSaveBenefitsMutationVariables
>;

/**
 * __useCompanyProfileSaveBenefitsMutation__
 *
 * To run a mutation, you first call `useCompanyProfileSaveBenefitsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompanyProfileSaveBenefitsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [companyProfileSaveBenefitsMutation, { data, loading, error }] = useCompanyProfileSaveBenefitsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompanyProfileSaveBenefitsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CompanyProfileSaveBenefitsMutation,
    CompanyProfileSaveBenefitsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CompanyProfileSaveBenefitsMutation,
    CompanyProfileSaveBenefitsMutationVariables
  >(CompanyProfileSaveBenefitsDocument, options);
}
export type CompanyProfileSaveBenefitsMutationHookResult = ReturnType<
  typeof useCompanyProfileSaveBenefitsMutation
>;
export type CompanyProfileSaveBenefitsMutationResult =
  Apollo.MutationResult<CompanyProfileSaveBenefitsMutation>;
export type CompanyProfileSaveBenefitsMutationOptions = Apollo.BaseMutationOptions<
  CompanyProfileSaveBenefitsMutation,
  CompanyProfileSaveBenefitsMutationVariables
>;
export const CompanyProfileSaveRecruitmentDocument = gql`
  mutation CompanyProfileSaveRecruitment($input: CompanyProfileRecruitmentInput!) {
    CompanyProfile {
      saveRecruitment(input: $input) {
        id
        userId
        recruitment {
          ...CompanyProfileRecruitment
        }
      }
    }
  }
  ${CompanyProfileRecruitmentFragmentDoc}
`;
export type CompanyProfileSaveRecruitmentMutationFn = Apollo.MutationFunction<
  CompanyProfileSaveRecruitmentMutation,
  CompanyProfileSaveRecruitmentMutationVariables
>;

/**
 * __useCompanyProfileSaveRecruitmentMutation__
 *
 * To run a mutation, you first call `useCompanyProfileSaveRecruitmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompanyProfileSaveRecruitmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [companyProfileSaveRecruitmentMutation, { data, loading, error }] = useCompanyProfileSaveRecruitmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompanyProfileSaveRecruitmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CompanyProfileSaveRecruitmentMutation,
    CompanyProfileSaveRecruitmentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CompanyProfileSaveRecruitmentMutation,
    CompanyProfileSaveRecruitmentMutationVariables
  >(CompanyProfileSaveRecruitmentDocument, options);
}
export type CompanyProfileSaveRecruitmentMutationHookResult = ReturnType<
  typeof useCompanyProfileSaveRecruitmentMutation
>;
export type CompanyProfileSaveRecruitmentMutationResult =
  Apollo.MutationResult<CompanyProfileSaveRecruitmentMutation>;
export type CompanyProfileSaveRecruitmentMutationOptions = Apollo.BaseMutationOptions<
  CompanyProfileSaveRecruitmentMutation,
  CompanyProfileSaveRecruitmentMutationVariables
>;
export const CompanyProfileSaveLifeAtDocument = gql`
  mutation CompanyProfileSaveLifeAt($input: CompanyProfileLifeAtInput!) {
    CompanyProfile {
      saveLifeAt(input: $input) {
        id
        userId
        lifeAt {
          ...CompanyProfileLifeAt
        }
      }
    }
  }
  ${CompanyProfileLifeAtFragmentDoc}
`;
export type CompanyProfileSaveLifeAtMutationFn = Apollo.MutationFunction<
  CompanyProfileSaveLifeAtMutation,
  CompanyProfileSaveLifeAtMutationVariables
>;

/**
 * __useCompanyProfileSaveLifeAtMutation__
 *
 * To run a mutation, you first call `useCompanyProfileSaveLifeAtMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompanyProfileSaveLifeAtMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [companyProfileSaveLifeAtMutation, { data, loading, error }] = useCompanyProfileSaveLifeAtMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompanyProfileSaveLifeAtMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CompanyProfileSaveLifeAtMutation,
    CompanyProfileSaveLifeAtMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CompanyProfileSaveLifeAtMutation,
    CompanyProfileSaveLifeAtMutationVariables
  >(CompanyProfileSaveLifeAtDocument, options);
}
export type CompanyProfileSaveLifeAtMutationHookResult = ReturnType<
  typeof useCompanyProfileSaveLifeAtMutation
>;
export type CompanyProfileSaveLifeAtMutationResult =
  Apollo.MutationResult<CompanyProfileSaveLifeAtMutation>;
export type CompanyProfileSaveLifeAtMutationOptions = Apollo.BaseMutationOptions<
  CompanyProfileSaveLifeAtMutation,
  CompanyProfileSaveLifeAtMutationVariables
>;
export const CompanyProfileSaveMetadataDocument = gql`
  mutation CompanyProfileSaveMetadata($input: MetadataInput!) {
    CompanyProfile {
      saveMetadata(input: $input) {
        ...CompanyProfileMetadata
      }
    }
  }
  ${CompanyProfileMetadataFragmentDoc}
`;
export type CompanyProfileSaveMetadataMutationFn = Apollo.MutationFunction<
  CompanyProfileSaveMetadataMutation,
  CompanyProfileSaveMetadataMutationVariables
>;

/**
 * __useCompanyProfileSaveMetadataMutation__
 *
 * To run a mutation, you first call `useCompanyProfileSaveMetadataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompanyProfileSaveMetadataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [companyProfileSaveMetadataMutation, { data, loading, error }] = useCompanyProfileSaveMetadataMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompanyProfileSaveMetadataMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CompanyProfileSaveMetadataMutation,
    CompanyProfileSaveMetadataMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CompanyProfileSaveMetadataMutation,
    CompanyProfileSaveMetadataMutationVariables
  >(CompanyProfileSaveMetadataDocument, options);
}
export type CompanyProfileSaveMetadataMutationHookResult = ReturnType<
  typeof useCompanyProfileSaveMetadataMutation
>;
export type CompanyProfileSaveMetadataMutationResult =
  Apollo.MutationResult<CompanyProfileSaveMetadataMutation>;
export type CompanyProfileSaveMetadataMutationOptions = Apollo.BaseMutationOptions<
  CompanyProfileSaveMetadataMutation,
  CompanyProfileSaveMetadataMutationVariables
>;
export const CompanyProfileConfirmAssetsDocument = gql`
  mutation CompanyProfileConfirmAssets($input: [CompanyProfileConfirmAssetsInput!]!) {
    CompanyProfile {
      confirmAssets(input: $input) {
        id
        about {
          logoUrl
        }
        header {
          bannerUrl
        }
      }
    }
  }
`;
export type CompanyProfileConfirmAssetsMutationFn = Apollo.MutationFunction<
  CompanyProfileConfirmAssetsMutation,
  CompanyProfileConfirmAssetsMutationVariables
>;

/**
 * __useCompanyProfileConfirmAssetsMutation__
 *
 * To run a mutation, you first call `useCompanyProfileConfirmAssetsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompanyProfileConfirmAssetsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [companyProfileConfirmAssetsMutation, { data, loading, error }] = useCompanyProfileConfirmAssetsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompanyProfileConfirmAssetsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CompanyProfileConfirmAssetsMutation,
    CompanyProfileConfirmAssetsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CompanyProfileConfirmAssetsMutation,
    CompanyProfileConfirmAssetsMutationVariables
  >(CompanyProfileConfirmAssetsDocument, options);
}
export type CompanyProfileConfirmAssetsMutationHookResult = ReturnType<
  typeof useCompanyProfileConfirmAssetsMutation
>;
export type CompanyProfileConfirmAssetsMutationResult =
  Apollo.MutationResult<CompanyProfileConfirmAssetsMutation>;
export type CompanyProfileConfirmAssetsMutationOptions = Apollo.BaseMutationOptions<
  CompanyProfileConfirmAssetsMutation,
  CompanyProfileConfirmAssetsMutationVariables
>;
export const CompanyProfileDeleteDataDocument = gql`
  mutation CompanyProfileDeleteData {
    CompanyProfile {
      deleteData
    }
  }
`;
export type CompanyProfileDeleteDataMutationFn = Apollo.MutationFunction<
  CompanyProfileDeleteDataMutation,
  CompanyProfileDeleteDataMutationVariables
>;

/**
 * __useCompanyProfileDeleteDataMutation__
 *
 * To run a mutation, you first call `useCompanyProfileDeleteDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompanyProfileDeleteDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [companyProfileDeleteDataMutation, { data, loading, error }] = useCompanyProfileDeleteDataMutation({
 *   variables: {
 *   },
 * });
 */
export function useCompanyProfileDeleteDataMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CompanyProfileDeleteDataMutation,
    CompanyProfileDeleteDataMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CompanyProfileDeleteDataMutation,
    CompanyProfileDeleteDataMutationVariables
  >(CompanyProfileDeleteDataDocument, options);
}
export type CompanyProfileDeleteDataMutationHookResult = ReturnType<
  typeof useCompanyProfileDeleteDataMutation
>;
export type CompanyProfileDeleteDataMutationResult =
  Apollo.MutationResult<CompanyProfileDeleteDataMutation>;
export type CompanyProfileDeleteDataMutationOptions = Apollo.BaseMutationOptions<
  CompanyProfileDeleteDataMutation,
  CompanyProfileDeleteDataMutationVariables
>;
export const CompanyProfileDeleteAssetsDocument = gql`
  mutation CompanyProfileDeleteAssets($input: [CompanyProfileAssetType!]!) {
    CompanyProfile {
      deleteAssets(input: $input) {
        id
        about {
          logoUrl
        }
        header {
          bannerUrl
        }
      }
    }
  }
`;
export type CompanyProfileDeleteAssetsMutationFn = Apollo.MutationFunction<
  CompanyProfileDeleteAssetsMutation,
  CompanyProfileDeleteAssetsMutationVariables
>;

/**
 * __useCompanyProfileDeleteAssetsMutation__
 *
 * To run a mutation, you first call `useCompanyProfileDeleteAssetsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompanyProfileDeleteAssetsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [companyProfileDeleteAssetsMutation, { data, loading, error }] = useCompanyProfileDeleteAssetsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompanyProfileDeleteAssetsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CompanyProfileDeleteAssetsMutation,
    CompanyProfileDeleteAssetsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CompanyProfileDeleteAssetsMutation,
    CompanyProfileDeleteAssetsMutationVariables
  >(CompanyProfileDeleteAssetsDocument, options);
}
export type CompanyProfileDeleteAssetsMutationHookResult = ReturnType<
  typeof useCompanyProfileDeleteAssetsMutation
>;
export type CompanyProfileDeleteAssetsMutationResult =
  Apollo.MutationResult<CompanyProfileDeleteAssetsMutation>;
export type CompanyProfileDeleteAssetsMutationOptions = Apollo.BaseMutationOptions<
  CompanyProfileDeleteAssetsMutation,
  CompanyProfileDeleteAssetsMutationVariables
>;
export const CompanyProfilePublishProfileDocument = gql`
  mutation CompanyProfilePublishProfile {
    CompanyProfile {
      publishProfile {
        id
        publishedAt
      }
    }
  }
`;
export type CompanyProfilePublishProfileMutationFn = Apollo.MutationFunction<
  CompanyProfilePublishProfileMutation,
  CompanyProfilePublishProfileMutationVariables
>;

/**
 * __useCompanyProfilePublishProfileMutation__
 *
 * To run a mutation, you first call `useCompanyProfilePublishProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompanyProfilePublishProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [companyProfilePublishProfileMutation, { data, loading, error }] = useCompanyProfilePublishProfileMutation({
 *   variables: {
 *   },
 * });
 */
export function useCompanyProfilePublishProfileMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CompanyProfilePublishProfileMutation,
    CompanyProfilePublishProfileMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CompanyProfilePublishProfileMutation,
    CompanyProfilePublishProfileMutationVariables
  >(CompanyProfilePublishProfileDocument, options);
}
export type CompanyProfilePublishProfileMutationHookResult = ReturnType<
  typeof useCompanyProfilePublishProfileMutation
>;
export type CompanyProfilePublishProfileMutationResult =
  Apollo.MutationResult<CompanyProfilePublishProfileMutation>;
export type CompanyProfilePublishProfileMutationOptions = Apollo.BaseMutationOptions<
  CompanyProfilePublishProfileMutation,
  CompanyProfilePublishProfileMutationVariables
>;
export const CompanyProfilePrivateDocument = gql`
  query CompanyProfilePrivate {
    CompanyProfile {
      privateProfile {
        ...CompanyProfilePrivateProfile
      }
    }
  }
  ${CompanyProfilePrivateProfileFragmentDoc}
`;

/**
 * __useCompanyProfilePrivateQuery__
 *
 * To run a query within a React component, call `useCompanyProfilePrivateQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyProfilePrivateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyProfilePrivateQuery({
 *   variables: {
 *   },
 * });
 */
export function useCompanyProfilePrivateQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CompanyProfilePrivateQuery,
    CompanyProfilePrivateQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CompanyProfilePrivateQuery, CompanyProfilePrivateQueryVariables>(
    CompanyProfilePrivateDocument,
    options,
  );
}
export function useCompanyProfilePrivateLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CompanyProfilePrivateQuery,
    CompanyProfilePrivateQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CompanyProfilePrivateQuery, CompanyProfilePrivateQueryVariables>(
    CompanyProfilePrivateDocument,
    options,
  );
}
export function useCompanyProfilePrivateSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CompanyProfilePrivateQuery,
    CompanyProfilePrivateQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<CompanyProfilePrivateQuery, CompanyProfilePrivateQueryVariables>(
    CompanyProfilePrivateDocument,
    options,
  );
}
export type CompanyProfilePrivateQueryHookResult = ReturnType<typeof useCompanyProfilePrivateQuery>;
export type CompanyProfilePrivateLazyQueryHookResult = ReturnType<
  typeof useCompanyProfilePrivateLazyQuery
>;
export type CompanyProfilePrivateSuspenseQueryHookResult = ReturnType<
  typeof useCompanyProfilePrivateSuspenseQuery
>;
export type CompanyProfilePrivateQueryResult = Apollo.QueryResult<
  CompanyProfilePrivateQuery,
  CompanyProfilePrivateQueryVariables
>;
export const CompanyProfilePublicDocument = gql`
  query CompanyProfilePublic($slug: String!) {
    CompanyProfile {
      publicProfileBySlug(slug: $slug) {
        ...CompanyProfilePublicProfileWithConfig
      }
    }
  }
  ${CompanyProfilePublicProfileWithConfigFragmentDoc}
`;

/**
 * __useCompanyProfilePublicQuery__
 *
 * To run a query within a React component, call `useCompanyProfilePublicQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyProfilePublicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyProfilePublicQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useCompanyProfilePublicQuery(
  baseOptions: Apollo.QueryHookOptions<
    CompanyProfilePublicQuery,
    CompanyProfilePublicQueryVariables
  > &
    ({ variables: CompanyProfilePublicQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CompanyProfilePublicQuery, CompanyProfilePublicQueryVariables>(
    CompanyProfilePublicDocument,
    options,
  );
}
export function useCompanyProfilePublicLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CompanyProfilePublicQuery,
    CompanyProfilePublicQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CompanyProfilePublicQuery, CompanyProfilePublicQueryVariables>(
    CompanyProfilePublicDocument,
    options,
  );
}
export function useCompanyProfilePublicSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CompanyProfilePublicQuery,
    CompanyProfilePublicQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<CompanyProfilePublicQuery, CompanyProfilePublicQueryVariables>(
    CompanyProfilePublicDocument,
    options,
  );
}
export type CompanyProfilePublicQueryHookResult = ReturnType<typeof useCompanyProfilePublicQuery>;
export type CompanyProfilePublicLazyQueryHookResult = ReturnType<
  typeof useCompanyProfilePublicLazyQuery
>;
export type CompanyProfilePublicSuspenseQueryHookResult = ReturnType<
  typeof useCompanyProfilePublicSuspenseQuery
>;
export type CompanyProfilePublicQueryResult = Apollo.QueryResult<
  CompanyProfilePublicQuery,
  CompanyProfilePublicQueryVariables
>;
export const CompanyProfilePreviewDocument = gql`
  query CompanyProfilePreview {
    CompanyProfile {
      previewProfile {
        ...CompanyProfilePreviewProfileWithConfig
      }
    }
  }
  ${CompanyProfilePreviewProfileWithConfigFragmentDoc}
`;

/**
 * __useCompanyProfilePreviewQuery__
 *
 * To run a query within a React component, call `useCompanyProfilePreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyProfilePreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyProfilePreviewQuery({
 *   variables: {
 *   },
 * });
 */
export function useCompanyProfilePreviewQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CompanyProfilePreviewQuery,
    CompanyProfilePreviewQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CompanyProfilePreviewQuery, CompanyProfilePreviewQueryVariables>(
    CompanyProfilePreviewDocument,
    options,
  );
}
export function useCompanyProfilePreviewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CompanyProfilePreviewQuery,
    CompanyProfilePreviewQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CompanyProfilePreviewQuery, CompanyProfilePreviewQueryVariables>(
    CompanyProfilePreviewDocument,
    options,
  );
}
export function useCompanyProfilePreviewSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CompanyProfilePreviewQuery,
    CompanyProfilePreviewQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<CompanyProfilePreviewQuery, CompanyProfilePreviewQueryVariables>(
    CompanyProfilePreviewDocument,
    options,
  );
}
export type CompanyProfilePreviewQueryHookResult = ReturnType<typeof useCompanyProfilePreviewQuery>;
export type CompanyProfilePreviewLazyQueryHookResult = ReturnType<
  typeof useCompanyProfilePreviewLazyQuery
>;
export type CompanyProfilePreviewSuspenseQueryHookResult = ReturnType<
  typeof useCompanyProfilePreviewSuspenseQuery
>;
export type CompanyProfilePreviewQueryResult = Apollo.QueryResult<
  CompanyProfilePreviewQuery,
  CompanyProfilePreviewQueryVariables
>;
export const CompanyProfilePublicSlugDocument = gql`
  query CompanyProfilePublicSlug($uuid: String!) {
    CompanyProfile {
      publicProfileByUuid(uuid: $uuid) {
        id
        slug
      }
    }
  }
`;

/**
 * __useCompanyProfilePublicSlugQuery__
 *
 * To run a query within a React component, call `useCompanyProfilePublicSlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyProfilePublicSlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyProfilePublicSlugQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useCompanyProfilePublicSlugQuery(
  baseOptions: Apollo.QueryHookOptions<
    CompanyProfilePublicSlugQuery,
    CompanyProfilePublicSlugQueryVariables
  > &
    ({ variables: CompanyProfilePublicSlugQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CompanyProfilePublicSlugQuery, CompanyProfilePublicSlugQueryVariables>(
    CompanyProfilePublicSlugDocument,
    options,
  );
}
export function useCompanyProfilePublicSlugLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CompanyProfilePublicSlugQuery,
    CompanyProfilePublicSlugQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CompanyProfilePublicSlugQuery, CompanyProfilePublicSlugQueryVariables>(
    CompanyProfilePublicSlugDocument,
    options,
  );
}
export function useCompanyProfilePublicSlugSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CompanyProfilePublicSlugQuery,
    CompanyProfilePublicSlugQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CompanyProfilePublicSlugQuery,
    CompanyProfilePublicSlugQueryVariables
  >(CompanyProfilePublicSlugDocument, options);
}
export type CompanyProfilePublicSlugQueryHookResult = ReturnType<
  typeof useCompanyProfilePublicSlugQuery
>;
export type CompanyProfilePublicSlugLazyQueryHookResult = ReturnType<
  typeof useCompanyProfilePublicSlugLazyQuery
>;
export type CompanyProfilePublicSlugSuspenseQueryHookResult = ReturnType<
  typeof useCompanyProfilePublicSlugSuspenseQuery
>;
export type CompanyProfilePublicSlugQueryResult = Apollo.QueryResult<
  CompanyProfilePublicSlugQuery,
  CompanyProfilePublicSlugQueryVariables
>;
export const LegacyCompanyProfileJobListingCarouselProfilesDocument = gql`
  query LegacyCompanyProfileJobListingCarouselProfiles($input: CompanyProfilePublicProfilesInput!) {
    CompanyProfile {
      publicProfiles(input: $input) {
        ...LegacyCompanyProfileCarouselProfile
      }
    }
  }
  ${LegacyCompanyProfileCarouselProfileFragmentDoc}
`;

/**
 * __useLegacyCompanyProfileJobListingCarouselProfilesQuery__
 *
 * To run a query within a React component, call `useLegacyCompanyProfileJobListingCarouselProfilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLegacyCompanyProfileJobListingCarouselProfilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLegacyCompanyProfileJobListingCarouselProfilesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLegacyCompanyProfileJobListingCarouselProfilesQuery(
  baseOptions: Apollo.QueryHookOptions<
    LegacyCompanyProfileJobListingCarouselProfilesQuery,
    LegacyCompanyProfileJobListingCarouselProfilesQueryVariables
  > &
    (
      | { variables: LegacyCompanyProfileJobListingCarouselProfilesQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    LegacyCompanyProfileJobListingCarouselProfilesQuery,
    LegacyCompanyProfileJobListingCarouselProfilesQueryVariables
  >(LegacyCompanyProfileJobListingCarouselProfilesDocument, options);
}
export function useLegacyCompanyProfileJobListingCarouselProfilesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LegacyCompanyProfileJobListingCarouselProfilesQuery,
    LegacyCompanyProfileJobListingCarouselProfilesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    LegacyCompanyProfileJobListingCarouselProfilesQuery,
    LegacyCompanyProfileJobListingCarouselProfilesQueryVariables
  >(LegacyCompanyProfileJobListingCarouselProfilesDocument, options);
}
export function useLegacyCompanyProfileJobListingCarouselProfilesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    LegacyCompanyProfileJobListingCarouselProfilesQuery,
    LegacyCompanyProfileJobListingCarouselProfilesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    LegacyCompanyProfileJobListingCarouselProfilesQuery,
    LegacyCompanyProfileJobListingCarouselProfilesQueryVariables
  >(LegacyCompanyProfileJobListingCarouselProfilesDocument, options);
}
export type LegacyCompanyProfileJobListingCarouselProfilesQueryHookResult = ReturnType<
  typeof useLegacyCompanyProfileJobListingCarouselProfilesQuery
>;
export type LegacyCompanyProfileJobListingCarouselProfilesLazyQueryHookResult = ReturnType<
  typeof useLegacyCompanyProfileJobListingCarouselProfilesLazyQuery
>;
export type LegacyCompanyProfileJobListingCarouselProfilesSuspenseQueryHookResult = ReturnType<
  typeof useLegacyCompanyProfileJobListingCarouselProfilesSuspenseQuery
>;
export type LegacyCompanyProfileJobListingCarouselProfilesQueryResult = Apollo.QueryResult<
  LegacyCompanyProfileJobListingCarouselProfilesQuery,
  LegacyCompanyProfileJobListingCarouselProfilesQueryVariables
>;
export const CompanyProfileCarouselDocument = gql`
  query CompanyProfileCarousel($input: CompanyProfileProfilesCarouselInput!) {
    CompanyProfile {
      profilesCarousel(input: $input) {
        profiles {
          ...CompanyProfileCarouselProfile
        }
      }
    }
  }
  ${CompanyProfileCarouselProfileFragmentDoc}
`;

/**
 * __useCompanyProfileCarouselQuery__
 *
 * To run a query within a React component, call `useCompanyProfileCarouselQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyProfileCarouselQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyProfileCarouselQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompanyProfileCarouselQuery(
  baseOptions: Apollo.QueryHookOptions<
    CompanyProfileCarouselQuery,
    CompanyProfileCarouselQueryVariables
  > &
    ({ variables: CompanyProfileCarouselQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CompanyProfileCarouselQuery, CompanyProfileCarouselQueryVariables>(
    CompanyProfileCarouselDocument,
    options,
  );
}
export function useCompanyProfileCarouselLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CompanyProfileCarouselQuery,
    CompanyProfileCarouselQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CompanyProfileCarouselQuery, CompanyProfileCarouselQueryVariables>(
    CompanyProfileCarouselDocument,
    options,
  );
}
export function useCompanyProfileCarouselSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CompanyProfileCarouselQuery,
    CompanyProfileCarouselQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<CompanyProfileCarouselQuery, CompanyProfileCarouselQueryVariables>(
    CompanyProfileCarouselDocument,
    options,
  );
}
export type CompanyProfileCarouselQueryHookResult = ReturnType<
  typeof useCompanyProfileCarouselQuery
>;
export type CompanyProfileCarouselLazyQueryHookResult = ReturnType<
  typeof useCompanyProfileCarouselLazyQuery
>;
export type CompanyProfileCarouselSuspenseQueryHookResult = ReturnType<
  typeof useCompanyProfileCarouselSuspenseQuery
>;
export type CompanyProfileCarouselQueryResult = Apollo.QueryResult<
  CompanyProfileCarouselQuery,
  CompanyProfileCarouselQueryVariables
>;
export const CompanyProfileListingDocument = gql`
  query CompanyProfileListing($input: CompanyProfileProfilesListingInput!) {
    CompanyProfile {
      profilesListing(input: $input) {
        ...CompanyProfileListing
      }
    }
  }
  ${CompanyProfileListingFragmentDoc}
`;

/**
 * __useCompanyProfileListingQuery__
 *
 * To run a query within a React component, call `useCompanyProfileListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyProfileListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyProfileListingQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompanyProfileListingQuery(
  baseOptions: Apollo.QueryHookOptions<
    CompanyProfileListingQuery,
    CompanyProfileListingQueryVariables
  > &
    ({ variables: CompanyProfileListingQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CompanyProfileListingQuery, CompanyProfileListingQueryVariables>(
    CompanyProfileListingDocument,
    options,
  );
}
export function useCompanyProfileListingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CompanyProfileListingQuery,
    CompanyProfileListingQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CompanyProfileListingQuery, CompanyProfileListingQueryVariables>(
    CompanyProfileListingDocument,
    options,
  );
}
export function useCompanyProfileListingSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CompanyProfileListingQuery,
    CompanyProfileListingQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<CompanyProfileListingQuery, CompanyProfileListingQueryVariables>(
    CompanyProfileListingDocument,
    options,
  );
}
export type CompanyProfileListingQueryHookResult = ReturnType<typeof useCompanyProfileListingQuery>;
export type CompanyProfileListingLazyQueryHookResult = ReturnType<
  typeof useCompanyProfileListingLazyQuery
>;
export type CompanyProfileListingSuspenseQueryHookResult = ReturnType<
  typeof useCompanyProfileListingSuspenseQuery
>;
export type CompanyProfileListingQueryResult = Apollo.QueryResult<
  CompanyProfileListingQuery,
  CompanyProfileListingQueryVariables
>;
export const CompanyProfileTrialDocument = gql`
  query CompanyProfileTrial {
    CompanyProfile {
      privateProfile {
        ...CompanyProfileTrialProfile
      }
    }
  }
  ${CompanyProfileTrialProfileFragmentDoc}
`;

/**
 * __useCompanyProfileTrialQuery__
 *
 * To run a query within a React component, call `useCompanyProfileTrialQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyProfileTrialQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyProfileTrialQuery({
 *   variables: {
 *   },
 * });
 */
export function useCompanyProfileTrialQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CompanyProfileTrialQuery,
    CompanyProfileTrialQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CompanyProfileTrialQuery, CompanyProfileTrialQueryVariables>(
    CompanyProfileTrialDocument,
    options,
  );
}
export function useCompanyProfileTrialLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CompanyProfileTrialQuery,
    CompanyProfileTrialQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CompanyProfileTrialQuery, CompanyProfileTrialQueryVariables>(
    CompanyProfileTrialDocument,
    options,
  );
}
export function useCompanyProfileTrialSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CompanyProfileTrialQuery,
    CompanyProfileTrialQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<CompanyProfileTrialQuery, CompanyProfileTrialQueryVariables>(
    CompanyProfileTrialDocument,
    options,
  );
}
export type CompanyProfileTrialQueryHookResult = ReturnType<typeof useCompanyProfileTrialQuery>;
export type CompanyProfileTrialLazyQueryHookResult = ReturnType<
  typeof useCompanyProfileTrialLazyQuery
>;
export type CompanyProfileTrialSuspenseQueryHookResult = ReturnType<
  typeof useCompanyProfileTrialSuspenseQuery
>;
export type CompanyProfileTrialQueryResult = Apollo.QueryResult<
  CompanyProfileTrialQuery,
  CompanyProfileTrialQueryVariables
>;
export const CompanyProfileJobAdDocument = gql`
  query CompanyProfileJobAd($uuid: String!) {
    CompanyProfile {
      publicProfileByUuid(uuid: $uuid) {
        ...CompanyProfileJobAdProfile
      }
    }
  }
  ${CompanyProfileJobAdProfileFragmentDoc}
`;

/**
 * __useCompanyProfileJobAdQuery__
 *
 * To run a query within a React component, call `useCompanyProfileJobAdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyProfileJobAdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyProfileJobAdQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useCompanyProfileJobAdQuery(
  baseOptions: Apollo.QueryHookOptions<
    CompanyProfileJobAdQuery,
    CompanyProfileJobAdQueryVariables
  > &
    ({ variables: CompanyProfileJobAdQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CompanyProfileJobAdQuery, CompanyProfileJobAdQueryVariables>(
    CompanyProfileJobAdDocument,
    options,
  );
}
export function useCompanyProfileJobAdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CompanyProfileJobAdQuery,
    CompanyProfileJobAdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CompanyProfileJobAdQuery, CompanyProfileJobAdQueryVariables>(
    CompanyProfileJobAdDocument,
    options,
  );
}
export function useCompanyProfileJobAdSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CompanyProfileJobAdQuery,
    CompanyProfileJobAdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<CompanyProfileJobAdQuery, CompanyProfileJobAdQueryVariables>(
    CompanyProfileJobAdDocument,
    options,
  );
}
export type CompanyProfileJobAdQueryHookResult = ReturnType<typeof useCompanyProfileJobAdQuery>;
export type CompanyProfileJobAdLazyQueryHookResult = ReturnType<
  typeof useCompanyProfileJobAdLazyQuery
>;
export type CompanyProfileJobAdSuspenseQueryHookResult = ReturnType<
  typeof useCompanyProfileJobAdSuspenseQuery
>;
export type CompanyProfileJobAdQueryResult = Apollo.QueryResult<
  CompanyProfileJobAdQuery,
  CompanyProfileJobAdQueryVariables
>;
export const CompanyProfilePostingDetailsDocument = gql`
  query CompanyProfilePostingDetails {
    CompanyProfile {
      privateProfile {
        ...CompanyProfilePostingDetails
      }
    }
  }
  ${CompanyProfilePostingDetailsFragmentDoc}
`;

/**
 * __useCompanyProfilePostingDetailsQuery__
 *
 * To run a query within a React component, call `useCompanyProfilePostingDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyProfilePostingDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyProfilePostingDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCompanyProfilePostingDetailsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CompanyProfilePostingDetailsQuery,
    CompanyProfilePostingDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CompanyProfilePostingDetailsQuery,
    CompanyProfilePostingDetailsQueryVariables
  >(CompanyProfilePostingDetailsDocument, options);
}
export function useCompanyProfilePostingDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CompanyProfilePostingDetailsQuery,
    CompanyProfilePostingDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CompanyProfilePostingDetailsQuery,
    CompanyProfilePostingDetailsQueryVariables
  >(CompanyProfilePostingDetailsDocument, options);
}
export function useCompanyProfilePostingDetailsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CompanyProfilePostingDetailsQuery,
    CompanyProfilePostingDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CompanyProfilePostingDetailsQuery,
    CompanyProfilePostingDetailsQueryVariables
  >(CompanyProfilePostingDetailsDocument, options);
}
export type CompanyProfilePostingDetailsQueryHookResult = ReturnType<
  typeof useCompanyProfilePostingDetailsQuery
>;
export type CompanyProfilePostingDetailsLazyQueryHookResult = ReturnType<
  typeof useCompanyProfilePostingDetailsLazyQuery
>;
export type CompanyProfilePostingDetailsSuspenseQueryHookResult = ReturnType<
  typeof useCompanyProfilePostingDetailsSuspenseQuery
>;
export type CompanyProfilePostingDetailsQueryResult = Apollo.QueryResult<
  CompanyProfilePostingDetailsQuery,
  CompanyProfilePostingDetailsQueryVariables
>;
export const CompanyProfileMetadataDocument = gql`
  query CompanyProfileMetadata {
    CompanyProfile {
      metadata {
        ...CompanyProfileMetadata
      }
    }
  }
  ${CompanyProfileMetadataFragmentDoc}
`;

/**
 * __useCompanyProfileMetadataQuery__
 *
 * To run a query within a React component, call `useCompanyProfileMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyProfileMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyProfileMetadataQuery({
 *   variables: {
 *   },
 * });
 */
export function useCompanyProfileMetadataQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CompanyProfileMetadataQuery,
    CompanyProfileMetadataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CompanyProfileMetadataQuery, CompanyProfileMetadataQueryVariables>(
    CompanyProfileMetadataDocument,
    options,
  );
}
export function useCompanyProfileMetadataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CompanyProfileMetadataQuery,
    CompanyProfileMetadataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CompanyProfileMetadataQuery, CompanyProfileMetadataQueryVariables>(
    CompanyProfileMetadataDocument,
    options,
  );
}
export function useCompanyProfileMetadataSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CompanyProfileMetadataQuery,
    CompanyProfileMetadataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<CompanyProfileMetadataQuery, CompanyProfileMetadataQueryVariables>(
    CompanyProfileMetadataDocument,
    options,
  );
}
export type CompanyProfileMetadataQueryHookResult = ReturnType<
  typeof useCompanyProfileMetadataQuery
>;
export type CompanyProfileMetadataLazyQueryHookResult = ReturnType<
  typeof useCompanyProfileMetadataLazyQuery
>;
export type CompanyProfileMetadataSuspenseQueryHookResult = ReturnType<
  typeof useCompanyProfileMetadataSuspenseQuery
>;
export type CompanyProfileMetadataQueryResult = Apollo.QueryResult<
  CompanyProfileMetadataQuery,
  CompanyProfileMetadataQueryVariables
>;
export const CompanyProfileUploadRequestDataDocument = gql`
  query CompanyProfileUploadRequestData {
    CompanyProfile {
      uploadRequestData {
        url
        token
      }
    }
  }
`;

/**
 * __useCompanyProfileUploadRequestDataQuery__
 *
 * To run a query within a React component, call `useCompanyProfileUploadRequestDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyProfileUploadRequestDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyProfileUploadRequestDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useCompanyProfileUploadRequestDataQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CompanyProfileUploadRequestDataQuery,
    CompanyProfileUploadRequestDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CompanyProfileUploadRequestDataQuery,
    CompanyProfileUploadRequestDataQueryVariables
  >(CompanyProfileUploadRequestDataDocument, options);
}
export function useCompanyProfileUploadRequestDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CompanyProfileUploadRequestDataQuery,
    CompanyProfileUploadRequestDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CompanyProfileUploadRequestDataQuery,
    CompanyProfileUploadRequestDataQueryVariables
  >(CompanyProfileUploadRequestDataDocument, options);
}
export function useCompanyProfileUploadRequestDataSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CompanyProfileUploadRequestDataQuery,
    CompanyProfileUploadRequestDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CompanyProfileUploadRequestDataQuery,
    CompanyProfileUploadRequestDataQueryVariables
  >(CompanyProfileUploadRequestDataDocument, options);
}
export type CompanyProfileUploadRequestDataQueryHookResult = ReturnType<
  typeof useCompanyProfileUploadRequestDataQuery
>;
export type CompanyProfileUploadRequestDataLazyQueryHookResult = ReturnType<
  typeof useCompanyProfileUploadRequestDataLazyQuery
>;
export type CompanyProfileUploadRequestDataSuspenseQueryHookResult = ReturnType<
  typeof useCompanyProfileUploadRequestDataSuspenseQuery
>;
export type CompanyProfileUploadRequestDataQueryResult = Apollo.QueryResult<
  CompanyProfileUploadRequestDataQuery,
  CompanyProfileUploadRequestDataQueryVariables
>;
export const CompanyProfileLocationSuggestionsDocument = gql`
  query CompanyProfileLocationSuggestions($phrase: String!, $provider: LocationProvider) {
    CompanyProfile {
      locationSuggestions(phrase: $phrase, provider: $provider) {
        id
        city
        label
        lat
        lng
        region
        streetName
        streetNumber
        zipCode
      }
    }
  }
`;

/**
 * __useCompanyProfileLocationSuggestionsQuery__
 *
 * To run a query within a React component, call `useCompanyProfileLocationSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyProfileLocationSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyProfileLocationSuggestionsQuery({
 *   variables: {
 *      phrase: // value for 'phrase'
 *      provider: // value for 'provider'
 *   },
 * });
 */
export function useCompanyProfileLocationSuggestionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    CompanyProfileLocationSuggestionsQuery,
    CompanyProfileLocationSuggestionsQueryVariables
  > &
    (
      | { variables: CompanyProfileLocationSuggestionsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CompanyProfileLocationSuggestionsQuery,
    CompanyProfileLocationSuggestionsQueryVariables
  >(CompanyProfileLocationSuggestionsDocument, options);
}
export function useCompanyProfileLocationSuggestionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CompanyProfileLocationSuggestionsQuery,
    CompanyProfileLocationSuggestionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CompanyProfileLocationSuggestionsQuery,
    CompanyProfileLocationSuggestionsQueryVariables
  >(CompanyProfileLocationSuggestionsDocument, options);
}
export function useCompanyProfileLocationSuggestionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CompanyProfileLocationSuggestionsQuery,
    CompanyProfileLocationSuggestionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CompanyProfileLocationSuggestionsQuery,
    CompanyProfileLocationSuggestionsQueryVariables
  >(CompanyProfileLocationSuggestionsDocument, options);
}
export type CompanyProfileLocationSuggestionsQueryHookResult = ReturnType<
  typeof useCompanyProfileLocationSuggestionsQuery
>;
export type CompanyProfileLocationSuggestionsLazyQueryHookResult = ReturnType<
  typeof useCompanyProfileLocationSuggestionsLazyQuery
>;
export type CompanyProfileLocationSuggestionsSuspenseQueryHookResult = ReturnType<
  typeof useCompanyProfileLocationSuggestionsSuspenseQuery
>;
export type CompanyProfileLocationSuggestionsQueryResult = Apollo.QueryResult<
  CompanyProfileLocationSuggestionsQuery,
  CompanyProfileLocationSuggestionsQueryVariables
>;
export const CompanyProfileEmployerSegmentDocument = gql`
  query CompanyProfileEmployerSegment($atlasUserId: String!) {
    CompanyProfile {
      employerSegment(atlasUserId: $atlasUserId) {
        __typename
        id
        type
      }
    }
  }
`;

/**
 * __useCompanyProfileEmployerSegmentQuery__
 *
 * To run a query within a React component, call `useCompanyProfileEmployerSegmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyProfileEmployerSegmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyProfileEmployerSegmentQuery({
 *   variables: {
 *      atlasUserId: // value for 'atlasUserId'
 *   },
 * });
 */
export function useCompanyProfileEmployerSegmentQuery(
  baseOptions: Apollo.QueryHookOptions<
    CompanyProfileEmployerSegmentQuery,
    CompanyProfileEmployerSegmentQueryVariables
  > &
    (
      | { variables: CompanyProfileEmployerSegmentQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CompanyProfileEmployerSegmentQuery,
    CompanyProfileEmployerSegmentQueryVariables
  >(CompanyProfileEmployerSegmentDocument, options);
}
export function useCompanyProfileEmployerSegmentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CompanyProfileEmployerSegmentQuery,
    CompanyProfileEmployerSegmentQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CompanyProfileEmployerSegmentQuery,
    CompanyProfileEmployerSegmentQueryVariables
  >(CompanyProfileEmployerSegmentDocument, options);
}
export function useCompanyProfileEmployerSegmentSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CompanyProfileEmployerSegmentQuery,
    CompanyProfileEmployerSegmentQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CompanyProfileEmployerSegmentQuery,
    CompanyProfileEmployerSegmentQueryVariables
  >(CompanyProfileEmployerSegmentDocument, options);
}
export type CompanyProfileEmployerSegmentQueryHookResult = ReturnType<
  typeof useCompanyProfileEmployerSegmentQuery
>;
export type CompanyProfileEmployerSegmentLazyQueryHookResult = ReturnType<
  typeof useCompanyProfileEmployerSegmentLazyQuery
>;
export type CompanyProfileEmployerSegmentSuspenseQueryHookResult = ReturnType<
  typeof useCompanyProfileEmployerSegmentSuspenseQuery
>;
export type CompanyProfileEmployerSegmentQueryResult = Apollo.QueryResult<
  CompanyProfileEmployerSegmentQuery,
  CompanyProfileEmployerSegmentQueryVariables
>;
export const CompanyProfileJobOffersDocument = gql`
  query CompanyProfileJobOffers($input: CompanyProfileAdsInput!) {
    CompanyProfile {
      ads(input: $input) {
        ads {
          ...CompanyProfileJobOffer
        }
        aggregations {
          categories {
            ...CompanyProfileJobOfferAggregation
          }
          cities {
            ...CompanyProfileJobOfferAggregation
          }
        }
        total
      }
    }
  }
  ${CompanyProfileJobOfferFragmentDoc}
  ${CompanyProfileJobOfferAggregationFragmentDoc}
`;

/**
 * __useCompanyProfileJobOffersQuery__
 *
 * To run a query within a React component, call `useCompanyProfileJobOffersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyProfileJobOffersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyProfileJobOffersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompanyProfileJobOffersQuery(
  baseOptions: Apollo.QueryHookOptions<
    CompanyProfileJobOffersQuery,
    CompanyProfileJobOffersQueryVariables
  > &
    ({ variables: CompanyProfileJobOffersQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CompanyProfileJobOffersQuery, CompanyProfileJobOffersQueryVariables>(
    CompanyProfileJobOffersDocument,
    options,
  );
}
export function useCompanyProfileJobOffersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CompanyProfileJobOffersQuery,
    CompanyProfileJobOffersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CompanyProfileJobOffersQuery, CompanyProfileJobOffersQueryVariables>(
    CompanyProfileJobOffersDocument,
    options,
  );
}
export function useCompanyProfileJobOffersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CompanyProfileJobOffersQuery,
    CompanyProfileJobOffersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CompanyProfileJobOffersQuery,
    CompanyProfileJobOffersQueryVariables
  >(CompanyProfileJobOffersDocument, options);
}
export type CompanyProfileJobOffersQueryHookResult = ReturnType<
  typeof useCompanyProfileJobOffersQuery
>;
export type CompanyProfileJobOffersLazyQueryHookResult = ReturnType<
  typeof useCompanyProfileJobOffersLazyQuery
>;
export type CompanyProfileJobOffersSuspenseQueryHookResult = ReturnType<
  typeof useCompanyProfileJobOffersSuspenseQuery
>;
export type CompanyProfileJobOffersQueryResult = Apollo.QueryResult<
  CompanyProfileJobOffersQuery,
  CompanyProfileJobOffersQueryVariables
>;
export const CompanyProfileExternalImageAdsCategoriesDocument = gql`
  query CompanyProfileExternalImageAdsCategories($input: CompanyProfileAdsInput!) {
    CompanyProfile {
      ads(input: $input) {
        aggregations {
          categories {
            ...CompanyProfileJobOfferAggregation
          }
        }
      }
    }
  }
  ${CompanyProfileJobOfferAggregationFragmentDoc}
`;

/**
 * __useCompanyProfileExternalImageAdsCategoriesQuery__
 *
 * To run a query within a React component, call `useCompanyProfileExternalImageAdsCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyProfileExternalImageAdsCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyProfileExternalImageAdsCategoriesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompanyProfileExternalImageAdsCategoriesQuery(
  baseOptions: Apollo.QueryHookOptions<
    CompanyProfileExternalImageAdsCategoriesQuery,
    CompanyProfileExternalImageAdsCategoriesQueryVariables
  > &
    (
      | { variables: CompanyProfileExternalImageAdsCategoriesQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CompanyProfileExternalImageAdsCategoriesQuery,
    CompanyProfileExternalImageAdsCategoriesQueryVariables
  >(CompanyProfileExternalImageAdsCategoriesDocument, options);
}
export function useCompanyProfileExternalImageAdsCategoriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CompanyProfileExternalImageAdsCategoriesQuery,
    CompanyProfileExternalImageAdsCategoriesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CompanyProfileExternalImageAdsCategoriesQuery,
    CompanyProfileExternalImageAdsCategoriesQueryVariables
  >(CompanyProfileExternalImageAdsCategoriesDocument, options);
}
export function useCompanyProfileExternalImageAdsCategoriesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CompanyProfileExternalImageAdsCategoriesQuery,
    CompanyProfileExternalImageAdsCategoriesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CompanyProfileExternalImageAdsCategoriesQuery,
    CompanyProfileExternalImageAdsCategoriesQueryVariables
  >(CompanyProfileExternalImageAdsCategoriesDocument, options);
}
export type CompanyProfileExternalImageAdsCategoriesQueryHookResult = ReturnType<
  typeof useCompanyProfileExternalImageAdsCategoriesQuery
>;
export type CompanyProfileExternalImageAdsCategoriesLazyQueryHookResult = ReturnType<
  typeof useCompanyProfileExternalImageAdsCategoriesLazyQuery
>;
export type CompanyProfileExternalImageAdsCategoriesSuspenseQueryHookResult = ReturnType<
  typeof useCompanyProfileExternalImageAdsCategoriesSuspenseQuery
>;
export type CompanyProfileExternalImageAdsCategoriesQueryResult = Apollo.QueryResult<
  CompanyProfileExternalImageAdsCategoriesQuery,
  CompanyProfileExternalImageAdsCategoriesQueryVariables
>;
export const AtlasUserDocument = gql`
  query AtlasUser($id: String!) {
    atlasUser(id: $id) @rest(path: "/users/{args.id}", endpoint: "v1", type: "AtlasUser") {
      id
      created
    }
  }
`;

/**
 * __useAtlasUserQuery__
 *
 * To run a query within a React component, call `useAtlasUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useAtlasUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAtlasUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAtlasUserQuery(
  baseOptions: Apollo.QueryHookOptions<AtlasUserQuery, AtlasUserQueryVariables> &
    ({ variables: AtlasUserQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AtlasUserQuery, AtlasUserQueryVariables>(AtlasUserDocument, options);
}
export function useAtlasUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<AtlasUserQuery, AtlasUserQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AtlasUserQuery, AtlasUserQueryVariables>(AtlasUserDocument, options);
}
export function useAtlasUserSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<AtlasUserQuery, AtlasUserQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AtlasUserQuery, AtlasUserQueryVariables>(
    AtlasUserDocument,
    options,
  );
}
export type AtlasUserQueryHookResult = ReturnType<typeof useAtlasUserQuery>;
export type AtlasUserLazyQueryHookResult = ReturnType<typeof useAtlasUserLazyQuery>;
export type AtlasUserSuspenseQueryHookResult = ReturnType<typeof useAtlasUserSuspenseQuery>;
export type AtlasUserQueryResult = Apollo.QueryResult<AtlasUserQuery, AtlasUserQueryVariables>;
export const CompanyProfileMainFallbackProfileDocument = gql`
  query CompanyProfileMainFallbackProfile($uuid: String!) {
    CompanyProfile {
      publicProfileByUuid(uuid: $uuid) {
        ...CompanyProfilePublicProfile
      }
    }
  }
  ${CompanyProfilePublicProfileFragmentDoc}
`;

/**
 * __useCompanyProfileMainFallbackProfileQuery__
 *
 * To run a query within a React component, call `useCompanyProfileMainFallbackProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyProfileMainFallbackProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyProfileMainFallbackProfileQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useCompanyProfileMainFallbackProfileQuery(
  baseOptions: Apollo.QueryHookOptions<
    CompanyProfileMainFallbackProfileQuery,
    CompanyProfileMainFallbackProfileQueryVariables
  > &
    (
      | { variables: CompanyProfileMainFallbackProfileQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CompanyProfileMainFallbackProfileQuery,
    CompanyProfileMainFallbackProfileQueryVariables
  >(CompanyProfileMainFallbackProfileDocument, options);
}
export function useCompanyProfileMainFallbackProfileLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CompanyProfileMainFallbackProfileQuery,
    CompanyProfileMainFallbackProfileQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CompanyProfileMainFallbackProfileQuery,
    CompanyProfileMainFallbackProfileQueryVariables
  >(CompanyProfileMainFallbackProfileDocument, options);
}
export function useCompanyProfileMainFallbackProfileSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CompanyProfileMainFallbackProfileQuery,
    CompanyProfileMainFallbackProfileQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CompanyProfileMainFallbackProfileQuery,
    CompanyProfileMainFallbackProfileQueryVariables
  >(CompanyProfileMainFallbackProfileDocument, options);
}
export type CompanyProfileMainFallbackProfileQueryHookResult = ReturnType<
  typeof useCompanyProfileMainFallbackProfileQuery
>;
export type CompanyProfileMainFallbackProfileLazyQueryHookResult = ReturnType<
  typeof useCompanyProfileMainFallbackProfileLazyQuery
>;
export type CompanyProfileMainFallbackProfileSuspenseQueryHookResult = ReturnType<
  typeof useCompanyProfileMainFallbackProfileSuspenseQuery
>;
export type CompanyProfileMainFallbackProfileQueryResult = Apollo.QueryResult<
  CompanyProfileMainFallbackProfileQuery,
  CompanyProfileMainFallbackProfileQueryVariables
>;
export const CompanyProfilePrivateConfigDocument = gql`
  query CompanyProfilePrivateConfig {
    CompanyProfile {
      privateConfig {
        ...CompanyProfilePrivateConfig
      }
    }
  }
  ${CompanyProfilePrivateConfigFragmentDoc}
`;

/**
 * __useCompanyProfilePrivateConfigQuery__
 *
 * To run a query within a React component, call `useCompanyProfilePrivateConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyProfilePrivateConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyProfilePrivateConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useCompanyProfilePrivateConfigQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CompanyProfilePrivateConfigQuery,
    CompanyProfilePrivateConfigQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CompanyProfilePrivateConfigQuery,
    CompanyProfilePrivateConfigQueryVariables
  >(CompanyProfilePrivateConfigDocument, options);
}
export function useCompanyProfilePrivateConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CompanyProfilePrivateConfigQuery,
    CompanyProfilePrivateConfigQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CompanyProfilePrivateConfigQuery,
    CompanyProfilePrivateConfigQueryVariables
  >(CompanyProfilePrivateConfigDocument, options);
}
export function useCompanyProfilePrivateConfigSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CompanyProfilePrivateConfigQuery,
    CompanyProfilePrivateConfigQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CompanyProfilePrivateConfigQuery,
    CompanyProfilePrivateConfigQueryVariables
  >(CompanyProfilePrivateConfigDocument, options);
}
export type CompanyProfilePrivateConfigQueryHookResult = ReturnType<
  typeof useCompanyProfilePrivateConfigQuery
>;
export type CompanyProfilePrivateConfigLazyQueryHookResult = ReturnType<
  typeof useCompanyProfilePrivateConfigLazyQuery
>;
export type CompanyProfilePrivateConfigSuspenseQueryHookResult = ReturnType<
  typeof useCompanyProfilePrivateConfigSuspenseQuery
>;
export type CompanyProfilePrivateConfigQueryResult = Apollo.QueryResult<
  CompanyProfilePrivateConfigQuery,
  CompanyProfilePrivateConfigQueryVariables
>;
export type WithIndex<TObject> = TObject & Record<string, any>;
export type ResolversObject<TObject> = WithIndex<TObject>;

export type ResolverTypeWrapper<T> = Promise<T> | T;

export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> =
  | ResolverFn<TResult, TParent, TContext, TArgs>
  | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo,
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo,
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo,
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<
  TResult,
  TKey extends string,
  TParent,
  TContext,
  TArgs,
> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<
  TResult,
  TKey extends string,
  TParent = {},
  TContext = {},
  TArgs = {},
> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo,
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (
  obj: T,
  context: TContext,
  info: GraphQLResolveInfo,
) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = {}, TParent = {}, TContext = {}, TArgs = {}> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo,
) => TResult | Promise<TResult>;

/** Mapping of union types */
export type ResolversUnionTypes<_RefType extends Record<string, unknown>> = ResolversObject<{
  BusinessCardLifeAtItem: BusinessCardLifeAtItemExternalVideo | BusinessCardLifeAtItemImage;
  CompanyProfileLifeAtItem: CompanyProfileLifeAtItemExternalVideo | CompanyProfileLifeAtItemImage;
  LifeAtItem: LifeAtItemExternalVideo | LifeAtItemImage;
}>;

/** Mapping of interface types */
export type ResolversInterfaceTypes<_RefType extends Record<string, unknown>> = ResolversObject<{
  BusinessCardBaseProfile:
    | (Omit<BusinessCardPrivateProfile, 'about' | 'lifeAt'> & {
        about?: Maybe<_RefType['BusinessCardAbout']>;
        lifeAt?: Maybe<_RefType['BusinessCardLifeAt']>;
      })
    | (Omit<BusinessCardPublicProfile, 'about' | 'lifeAt'> & {
        about?: Maybe<_RefType['BusinessCardAbout']>;
        lifeAt?: Maybe<_RefType['BusinessCardLifeAt']>;
      });
  CompanyProfileBaseProfile:
    | (Omit<CompanyProfilePrivateProfile, 'about' | 'lifeAt'> & {
        about?: Maybe<_RefType['CompanyProfileAbout']>;
        lifeAt?: Maybe<_RefType['CompanyProfileLifeAt']>;
      })
    | (Omit<CompanyProfilePublicProfile, 'about' | 'lifeAt'> & {
        about?: Maybe<_RefType['CompanyProfileAbout']>;
        lifeAt?: Maybe<_RefType['CompanyProfileLifeAt']>;
      });
  CompanyProfileConfigFeatureBase:
    | CompanyProfileConfigFeatureBanner
    | CompanyProfileConfigFeatureBenefits
    | CompanyProfileConfigFeatureCompanyUrl
    | CompanyProfileConfigFeatureFollowButton
    | CompanyProfileConfigFeatureGallery
    | CompanyProfileConfigFeatureLogo
    | CompanyProfileConfigFeatureMultiprofile
    | CompanyProfileConfigFeaturePromotedOnListing
    | CompanyProfileConfigFeatureRecruitment
    | CompanyProfileConfigFeatureSocialLinks;
}>;

/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = ResolversObject<{
  ApolloToken: ResolverTypeWrapper<ApolloToken>;
  ApplicationAttachments: ResolverTypeWrapper<ApplicationAttachments>;
  ApplicationInput: ApplicationInput;
  ApplicationRate: ApplicationRate;
  ApplicationRead: ApplicationRead;
  ApplicationStatus: ApplicationStatus;
  ApplicationUpdateInput: ApplicationUpdateInput;
  ApplicationsOrderByInput: ApplicationsOrderByInput;
  ApplicationsSortBy: ApplicationsSortBy;
  ApplyQuestion: ResolverTypeWrapper<ApplyQuestion>;
  ApplyQuestionAnswer: ResolverTypeWrapper<ApplyQuestionAnswer>;
  ApplyQuestionUserAnswerInput: ApplyQuestionUserAnswerInput;
  ApplyQuestionVariant: ApplyQuestionVariant;
  AtlasUser: ResolverTypeWrapper<AtlasUser>;
  Attachment: ResolverTypeWrapper<Attachment>;
  AttachmentInput: AttachmentInput;
  AutocompleteType: AutocompleteType;
  BenefitType: BenefitType;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']['output']>;
  BusinessCardAbout: ResolverTypeWrapper<BusinessCardAbout>;
  BusinessCardAboutInput: BusinessCardAboutInput;
  BusinessCardAdditionalInfo: ResolverTypeWrapper<BusinessCardAdditionalInfo>;
  BusinessCardAdditionalInformationInput: BusinessCardAdditionalInformationInput;
  BusinessCardAssetType: BusinessCardAssetType;
  BusinessCardAutocompleteType: BusinessCardAutocompleteType;
  BusinessCardBaseProfile: ResolverTypeWrapper<
    ResolversInterfaceTypes<ResolversTypes>['BusinessCardBaseProfile']
  >;
  BusinessCardConfirmAssetsInput: BusinessCardConfirmAssetsInput;
  BusinessCardContact: ResolverTypeWrapper<BusinessCardContact>;
  BusinessCardContactInput: BusinessCardContactInput;
  BusinessCardHeader: ResolverTypeWrapper<BusinessCardHeader>;
  BusinessCardIndustry: BusinessCardIndustry;
  BusinessCardLifeAt: ResolverTypeWrapper<
    Omit<BusinessCardLifeAt, 'items'> & {
      items?: Maybe<Array<ResolversTypes['BusinessCardLifeAtItem']>>;
    }
  >;
  BusinessCardLifeAtInput: BusinessCardLifeAtInput;
  BusinessCardLifeAtItem: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>['BusinessCardLifeAtItem']
  >;
  BusinessCardLifeAtItemExternalVideo: ResolverTypeWrapper<BusinessCardLifeAtItemExternalVideo>;
  BusinessCardLifeAtItemImage: ResolverTypeWrapper<BusinessCardLifeAtItemImage>;
  BusinessCardLifeAtItemInput: BusinessCardLifeAtItemInput;
  BusinessCardLifeAtItemType: BusinessCardLifeAtItemType;
  BusinessCardLocation: ResolverTypeWrapper<BusinessCardLocation>;
  BusinessCardLocationInput: BusinessCardLocationInput;
  BusinessCardLocationProvider: BusinessCardLocationProvider;
  BusinessCardLocationSuggestion: ResolverTypeWrapper<BusinessCardLocationSuggestion>;
  BusinessCardMutation: ResolverTypeWrapper<
    Omit<
      BusinessCardMutation,
      | 'confirmAssets'
      | 'deleteAssets'
      | 'publishProfile'
      | 'saveAbout'
      | 'saveAdditionalInformation'
      | 'saveContact'
      | 'saveLifeAt'
      | 'unpublishProfile'
    > & {
      confirmAssets: ResolversTypes['BusinessCardPrivateProfile'];
      deleteAssets: ResolversTypes['BusinessCardPrivateProfile'];
      publishProfile: ResolversTypes['BusinessCardPrivateProfile'];
      saveAbout: ResolversTypes['BusinessCardPrivateProfile'];
      saveAdditionalInformation: ResolversTypes['BusinessCardPrivateProfile'];
      saveContact: ResolversTypes['BusinessCardPrivateProfile'];
      saveLifeAt: ResolversTypes['BusinessCardPrivateProfile'];
      unpublishProfile: ResolversTypes['BusinessCardPrivateProfile'];
    }
  >;
  BusinessCardPrivateProfile: ResolverTypeWrapper<
    Omit<BusinessCardPrivateProfile, 'about' | 'lifeAt'> & {
      about?: Maybe<ResolversTypes['BusinessCardAbout']>;
      lifeAt?: Maybe<ResolversTypes['BusinessCardLifeAt']>;
    }
  >;
  BusinessCardPublicProfile: ResolverTypeWrapper<
    Omit<BusinessCardPublicProfile, 'about' | 'lifeAt'> & {
      about?: Maybe<ResolversTypes['BusinessCardAbout']>;
      lifeAt?: Maybe<ResolversTypes['BusinessCardLifeAt']>;
    }
  >;
  BusinessCardPublicProfileInput: BusinessCardPublicProfileInput;
  BusinessCardQuery: ResolverTypeWrapper<
    Omit<BusinessCardQuery, 'privateProfile' | 'publicProfileBySlug' | 'publicProfileByUuid'> & {
      privateProfile?: Maybe<ResolversTypes['BusinessCardPrivateProfile']>;
      publicProfileBySlug?: Maybe<ResolversTypes['BusinessCardPublicProfile']>;
      publicProfileByUuid?: Maybe<ResolversTypes['BusinessCardPublicProfile']>;
    }
  >;
  BusinessCardUploadRequestDataPayload: ResolverTypeWrapper<BusinessCardUploadRequestDataPayload>;
  CVGeneratorInput: CvGeneratorInput;
  CVGeneratorOutput: ResolverTypeWrapper<CvGeneratorOutput>;
  CVParsingResult: ResolverTypeWrapper<CvParsingResult>;
  CacheControlScope: CacheControlScope;
  Candidate: ResolverTypeWrapper<Candidate>;
  CandidateProfile: ResolverTypeWrapper<CandidateProfile>;
  CandidateProfileAd: ResolverTypeWrapper<CandidateProfileAd>;
  CandidateProfileApplication: ResolverTypeWrapper<CandidateProfileApplication>;
  CandidateProfileApplicationAnswer: ResolverTypeWrapper<CandidateProfileApplicationAnswer>;
  CandidateProfileApplicationsList: ResolverTypeWrapper<CandidateProfileApplicationsList>;
  CandidateProfileApplyValidation: ResolverTypeWrapper<CandidateProfileApplyValidation>;
  CandidateProfileBasicInfo: ResolverTypeWrapper<CandidateProfileBasicInfo>;
  CandidateProfileBasicInfoInput: CandidateProfileBasicInfoInput;
  CandidateProfileCV: ResolverTypeWrapper<CandidateProfileCv>;
  CandidateProfileCVCopy: ResolverTypeWrapper<CandidateProfileCvCopy>;
  CandidateProfileCVCopyV2: ResolverTypeWrapper<CandidateProfileCvCopyV2>;
  CandidateProfileCVGeneratorToken: ResolverTypeWrapper<CandidateProfileCvGeneratorToken>;
  CandidateProfileCountryOptions: ResolverTypeWrapper<CandidateProfileCountryOptions>;
  CandidateProfileCursorKey: ResolverTypeWrapper<CandidateProfileCursorKey>;
  CandidateProfileCursorKeyInput: CandidateProfileCursorKeyInput;
  CandidateProfileData: ResolverTypeWrapper<CandidateProfileData>;
  CandidateProfileDrivingLicenseCategory: CandidateProfileDrivingLicenseCategory;
  CandidateProfileExperience: ResolverTypeWrapper<CandidateProfileExperience>;
  CandidateProfileExperienceInput: CandidateProfileExperienceInput;
  CandidateProfileLanguage: CandidateProfileLanguage;
  CandidateProfileLanguageSkill: ResolverTypeWrapper<CandidateProfileLanguageSkill>;
  CandidateProfileLanguageSkillInput: CandidateProfileLanguageSkillInput;
  CandidateProfileLatestApplication: ResolverTypeWrapper<CandidateProfileLatestApplication>;
  CandidateProfileLocation: ResolverTypeWrapper<CandidateProfileLocation>;
  CandidateProfileLocationInput: CandidateProfileLocationInput;
  CandidateProfileMutation: ResolverTypeWrapper<CandidateProfileMutation>;
  CandidateProfileNoAuthMutation: ResolverTypeWrapper<CandidateProfileNoAuthMutation>;
  CandidateProfileNotificationFrequency: CandidateProfileNotificationFrequency;
  CandidateProfileNotificationsSettings: ResolverTypeWrapper<CandidateProfileNotificationsSettings>;
  CandidateProfilePreferenceType: CandidateProfilePreferenceType;
  CandidateProfilePreferences: ResolverTypeWrapper<CandidateProfilePreferences>;
  CandidateProfilePreferredLocationInput: CandidateProfilePreferredLocationInput;
  CandidateProfilePreferredSalary: ResolverTypeWrapper<CandidateProfilePreferredSalary>;
  CandidateProfilePreferredSalaryInput: CandidateProfilePreferredSalaryInput;
  CandidateProfileProficiency: CandidateProfileProficiency;
  CandidateProfileProfile: ResolverTypeWrapper<CandidateProfileProfile>;
  CandidateProfileQuery: ResolverTypeWrapper<CandidateProfileQuery>;
  CandidateProfileRecommendation: ResolverTypeWrapper<CandidateProfileRecommendation>;
  CandidateProfileRecommendationJobOffer: ResolverTypeWrapper<CandidateProfileRecommendationJobOffer>;
  CandidateProfileRecommendationRawParam: ResolverTypeWrapper<CandidateProfileRecommendationRawParam>;
  CandidateProfileSalaryPeriod: CandidateProfileSalaryPeriod;
  CandidateProfileSalaryType: CandidateProfileSalaryType;
  CandidateProfileSchool: ResolverTypeWrapper<CandidateProfileSchool>;
  CandidateProfileSchoolInput: CandidateProfileSchoolInput;
  CandidateProfileSettings: ResolverTypeWrapper<CandidateProfileSettings>;
  CandidateProfileSuggestion: ResolverTypeWrapper<CandidateProfileSuggestion>;
  CandidateProfileUploadData: ResolverTypeWrapper<CandidateProfileUploadData>;
  CandidateProfileVisibility: CandidateProfileVisibility;
  ChangeMultiAppStatusInput: ChangeMultiAppStatusInput;
  ChatAttachment: ResolverTypeWrapper<ChatAttachment>;
  ChatConversation: ResolverTypeWrapper<ChatConversation>;
  ChatMessage: ResolverTypeWrapper<ChatMessage>;
  CompanyProfileAbout: ResolverTypeWrapper<CompanyProfileAbout>;
  CompanyProfileAboutInput: CompanyProfileAboutInput;
  CompanyProfileAdditionalInfo: ResolverTypeWrapper<CompanyProfileAdditionalInfo>;
  CompanyProfileAdditionalInformationInput: CompanyProfileAdditionalInformationInput;
  CompanyProfileAds: ResolverTypeWrapper<CompanyProfileAds>;
  CompanyProfileAdsAggregation: ResolverTypeWrapper<CompanyProfileAdsAggregation>;
  CompanyProfileAdsAggregationType: CompanyProfileAdsAggregationType;
  CompanyProfileAdsAggregationValue: ResolverTypeWrapper<CompanyProfileAdsAggregationValue>;
  CompanyProfileAdsAggregations: ResolverTypeWrapper<CompanyProfileAdsAggregations>;
  CompanyProfileAdsInput: CompanyProfileAdsInput;
  CompanyProfileAssetType: CompanyProfileAssetType;
  CompanyProfileBaseProfile: ResolverTypeWrapper<
    ResolversInterfaceTypes<ResolversTypes>['CompanyProfileBaseProfile']
  >;
  CompanyProfileBenefit: CompanyProfileBenefit;
  CompanyProfileBenefits: ResolverTypeWrapper<CompanyProfileBenefits>;
  CompanyProfileBenefitsInput: CompanyProfileBenefitsInput;
  CompanyProfileConfig: ResolverTypeWrapper<CompanyProfileConfig>;
  CompanyProfileConfigFeatureBanner: ResolverTypeWrapper<CompanyProfileConfigFeatureBanner>;
  CompanyProfileConfigFeatureBase: ResolverTypeWrapper<
    ResolversInterfaceTypes<ResolversTypes>['CompanyProfileConfigFeatureBase']
  >;
  CompanyProfileConfigFeatureBenefits: ResolverTypeWrapper<CompanyProfileConfigFeatureBenefits>;
  CompanyProfileConfigFeatureCompanyUrl: ResolverTypeWrapper<CompanyProfileConfigFeatureCompanyUrl>;
  CompanyProfileConfigFeatureFollowButton: ResolverTypeWrapper<CompanyProfileConfigFeatureFollowButton>;
  CompanyProfileConfigFeatureGallery: ResolverTypeWrapper<CompanyProfileConfigFeatureGallery>;
  CompanyProfileConfigFeatureLogo: ResolverTypeWrapper<CompanyProfileConfigFeatureLogo>;
  CompanyProfileConfigFeatureMultiprofile: ResolverTypeWrapper<CompanyProfileConfigFeatureMultiprofile>;
  CompanyProfileConfigFeaturePromotedOnListing: ResolverTypeWrapper<CompanyProfileConfigFeaturePromotedOnListing>;
  CompanyProfileConfigFeatureRecruitment: ResolverTypeWrapper<CompanyProfileConfigFeatureRecruitment>;
  CompanyProfileConfigFeatureSocialLinks: ResolverTypeWrapper<CompanyProfileConfigFeatureSocialLinks>;
  CompanyProfileConfigFeatures: ResolverTypeWrapper<CompanyProfileConfigFeatures>;
  CompanyProfileConfigRelations: ResolverTypeWrapper<CompanyProfileConfigRelations>;
  CompanyProfileConfigSubProfile: ResolverTypeWrapper<CompanyProfileConfigSubProfile>;
  CompanyProfileConfirmAssetsInput: CompanyProfileConfirmAssetsInput;
  CompanyProfileContact: ResolverTypeWrapper<CompanyProfileContact>;
  CompanyProfileContactInput: CompanyProfileContactInput;
  CompanyProfileHeader: ResolverTypeWrapper<CompanyProfileHeader>;
  CompanyProfileIndustry: CompanyProfileIndustry;
  CompanyProfileLifeAt: ResolverTypeWrapper<
    Omit<CompanyProfileLifeAt, 'items'> & {
      items?: Maybe<Array<ResolversTypes['CompanyProfileLifeAtItem']>>;
    }
  >;
  CompanyProfileLifeAtInput: CompanyProfileLifeAtInput;
  CompanyProfileLifeAtItem: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>['CompanyProfileLifeAtItem']
  >;
  CompanyProfileLifeAtItemExternalVideo: ResolverTypeWrapper<CompanyProfileLifeAtItemExternalVideo>;
  CompanyProfileLifeAtItemImage: ResolverTypeWrapper<CompanyProfileLifeAtItemImage>;
  CompanyProfileLifeAtItemInput: CompanyProfileLifeAtItemInput;
  CompanyProfileLifeAtItemType: CompanyProfileLifeAtItemType;
  CompanyProfileLocation: ResolverTypeWrapper<CompanyProfileLocation>;
  CompanyProfileLocationInput: CompanyProfileLocationInput;
  CompanyProfileMutation: ResolverTypeWrapper<
    Omit<
      CompanyProfileMutation,
      | 'confirmAssets'
      | 'deleteAssets'
      | 'publishProfile'
      | 'saveAbout'
      | 'saveAdditionalInformation'
      | 'saveBenefits'
      | 'saveContact'
      | 'saveLifeAt'
      | 'saveRecruitment'
      | 'unpublishProfile'
    > & {
      confirmAssets: ResolversTypes['CompanyProfilePrivateProfile'];
      deleteAssets: ResolversTypes['CompanyProfilePrivateProfile'];
      publishProfile: ResolversTypes['CompanyProfilePrivateProfile'];
      saveAbout: ResolversTypes['CompanyProfilePrivateProfile'];
      saveAdditionalInformation: ResolversTypes['CompanyProfilePrivateProfile'];
      saveBenefits: ResolversTypes['CompanyProfilePrivateProfile'];
      saveContact: ResolversTypes['CompanyProfilePrivateProfile'];
      saveLifeAt: ResolversTypes['CompanyProfilePrivateProfile'];
      saveRecruitment: ResolversTypes['CompanyProfilePrivateProfile'];
      unpublishProfile: ResolversTypes['CompanyProfilePrivateProfile'];
    }
  >;
  CompanyProfilePrivateConfig: ResolverTypeWrapper<CompanyProfilePrivateConfig>;
  CompanyProfilePrivateConfigRelations: ResolverTypeWrapper<CompanyProfilePrivateConfigRelations>;
  CompanyProfilePrivateConfigSubProfile: ResolverTypeWrapper<CompanyProfilePrivateConfigSubProfile>;
  CompanyProfilePrivateConfigTier: ResolverTypeWrapper<CompanyProfilePrivateConfigTier>;
  CompanyProfilePrivateProfile: ResolverTypeWrapper<
    Omit<CompanyProfilePrivateProfile, 'about' | 'lifeAt'> & {
      about?: Maybe<ResolversTypes['CompanyProfileAbout']>;
      lifeAt?: Maybe<ResolversTypes['CompanyProfileLifeAt']>;
    }
  >;
  CompanyProfileProfileCounters: ResolverTypeWrapper<CompanyProfileProfileCounters>;
  CompanyProfileProfilesCarousel: ResolverTypeWrapper<CompanyProfileProfilesCarousel>;
  CompanyProfileProfilesCarouselInput: CompanyProfileProfilesCarouselInput;
  CompanyProfileProfilesCarouselProfile: ResolverTypeWrapper<CompanyProfileProfilesCarouselProfile>;
  CompanyProfileProfilesListing: ResolverTypeWrapper<CompanyProfileProfilesListing>;
  CompanyProfileProfilesListingInput: CompanyProfileProfilesListingInput;
  CompanyProfileProfilesListingProfile: ResolverTypeWrapper<CompanyProfileProfilesListingProfile>;
  CompanyProfilePublicConfig: ResolverTypeWrapper<CompanyProfilePublicConfig>;
  CompanyProfilePublicProfile: ResolverTypeWrapper<
    Omit<CompanyProfilePublicProfile, 'about' | 'lifeAt'> & {
      about?: Maybe<ResolversTypes['CompanyProfileAbout']>;
      lifeAt?: Maybe<ResolversTypes['CompanyProfileLifeAt']>;
    }
  >;
  CompanyProfilePublicProfileInput: CompanyProfilePublicProfileInput;
  CompanyProfilePublicProfilesInput: CompanyProfilePublicProfilesInput;
  CompanyProfileQuery: ResolverTypeWrapper<
    Omit<
      CompanyProfileQuery,
      | 'previewProfile'
      | 'privateProfile'
      | 'profile'
      | 'profileV2'
      | 'profiles'
      | 'publicProfileBySlug'
      | 'publicProfileByUuid'
      | 'publicProfiles'
    > & {
      previewProfile?: Maybe<ResolversTypes['CompanyProfilePublicProfile']>;
      privateProfile?: Maybe<ResolversTypes['CompanyProfilePrivateProfile']>;
      profile?: Maybe<ResolversTypes['EmployerProfile']>;
      profileV2?: Maybe<ResolversTypes['EmployerProfile']>;
      profiles: Array<ResolversTypes['EmployerProfile']>;
      publicProfileBySlug?: Maybe<ResolversTypes['CompanyProfilePublicProfile']>;
      publicProfileByUuid?: Maybe<ResolversTypes['CompanyProfilePublicProfile']>;
      publicProfiles: Array<ResolversTypes['CompanyProfilePublicProfile']>;
    }
  >;
  CompanyProfileRecruitment: ResolverTypeWrapper<CompanyProfileRecruitment>;
  CompanyProfileRecruitmentInput: CompanyProfileRecruitmentInput;
  CompanyProfileRecruitmentProcess: ResolverTypeWrapper<CompanyProfileRecruitmentProcess>;
  CompanyProfileRecruitmentProcessInput: CompanyProfileRecruitmentProcessInput;
  CompanyProfileRecruitmentProcessStep: ResolverTypeWrapper<CompanyProfileRecruitmentProcessStep>;
  CompanyProfileRecruitmentProcessStepInput: CompanyProfileRecruitmentProcessStepInput;
  CompanyProfileTierType: CompanyProfileTierType;
  DeleteMultiAppWithChatInput: DeleteMultiAppWithChatInput;
  EditMultiAppNoteInput: EditMultiAppNoteInput;
  EmployerLead: ResolverTypeWrapper<EmployerLead>;
  EmployerPanelAdvancedApplyQuestionInput: EmployerPanelAdvancedApplyQuestionInput;
  EmployerPanelApplyQuestionAnswerInput: EmployerPanelApplyQuestionAnswerInput;
  EmployerPanelApplyQuestionsByAdIdInput: EmployerPanelApplyQuestionsByAdIdInput;
  EmployerPanelMutation: ResolverTypeWrapper<EmployerPanelMutation>;
  EmployerPanelQuery: ResolverTypeWrapper<EmployerPanelQuery>;
  EmployerPanelSaveAdvancedQuestionsToAdInput: EmployerPanelSaveAdvancedQuestionsToAdInput;
  EmployerProfile: ResolverTypeWrapper<
    Omit<EmployerProfile, 'headquarters' | 'lifeAt'> & {
      headquarters?: Maybe<ResolversTypes['LocationPayload']>;
      lifeAt?: Maybe<ResolversTypes['LifeAt']>;
    }
  >;
  EmployerSegment: EmployerSegment;
  EmployerSegmentResponse: ResolverTypeWrapper<EmployerSegmentResponse>;
  Float: ResolverTypeWrapper<Scalars['Float']['output']>;
  HomepageArticle: ResolverTypeWrapper<HomepageArticle>;
  HomepageFeaturedCategory: ResolverTypeWrapper<HomepageFeaturedCategory>;
  HomepageFeaturedEmployer: ResolverTypeWrapper<HomepageFeaturedEmployer>;
  HomepageQuery: ResolverTypeWrapper<HomepageQuery>;
  ID: ResolverTypeWrapper<Scalars['ID']['output']>;
  ImageThumbnail: ResolverTypeWrapper<ImageThumbnail>;
  Industry: Industry;
  Int: ResolverTypeWrapper<Scalars['Int']['output']>;
  JobAd: ResolverTypeWrapper<JobAd>;
  JobAdCounters: ResolverTypeWrapper<JobAdCounters>;
  JobAdTrackingParameters: ResolverTypeWrapper<JobAdTrackingParameters>;
  JobAdUnreadCounters: ResolverTypeWrapper<JobAdUnreadCounters>;
  JobOfferCity: ResolverTypeWrapper<JobOfferCity>;
  JobOfferDistrict: ResolverTypeWrapper<JobOfferDistrict>;
  JobOfferEmployer: ResolverTypeWrapper<JobOfferEmployer>;
  JobOfferEmployerLogoThumbnails: ResolverTypeWrapper<JobOfferEmployerLogoThumbnails>;
  JobOfferFloatValue: ResolverTypeWrapper<JobOfferFloatValue>;
  JobOfferIntValue: ResolverTypeWrapper<JobOfferIntValue>;
  JobOfferLocation: ResolverTypeWrapper<JobOfferLocation>;
  JobOfferMap: ResolverTypeWrapper<JobOfferMap>;
  JobOfferOffer: ResolverTypeWrapper<JobOfferOffer>;
  JobOfferParameter: ResolverTypeWrapper<JobOfferParameter>;
  JobOfferPostingComponent: ResolverTypeWrapper<JobOfferPostingComponent>;
  JobOfferQuery: ResolverTypeWrapper<JobOfferQuery>;
  JobOfferRegion: ResolverTypeWrapper<JobOfferRegion>;
  JobOfferSalary: ResolverTypeWrapper<JobOfferSalary>;
  JobOfferSalaryType: ResolverTypeWrapper<JobOfferSalaryType>;
  JobOfferStringValue: ResolverTypeWrapper<JobOfferStringValue>;
  LifeAt: ResolverTypeWrapper<
    Omit<LifeAt, 'items'> & { items?: Maybe<Array<ResolversTypes['LifeAtItem']>> }
  >;
  LifeAtItem: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['LifeAtItem']>;
  LifeAtItemExternalVideo: ResolverTypeWrapper<LifeAtItemExternalVideo>;
  LifeAtItemImage: ResolverTypeWrapper<LifeAtItemImage>;
  LifeAtItemType: LifeAtItemType;
  LocationPayload: ResolverTypeWrapper<LocationPayload>;
  LocationProvider: LocationProvider;
  LocationSuggestion: ResolverTypeWrapper<LocationSuggestion>;
  MarkAsReadInput: MarkAsReadInput;
  MessageAuthor: MessageAuthor;
  Metadata: ResolverTypeWrapper<Metadata>;
  MetadataInput: MetadataInput;
  MultiAppIdsInput: MultiAppIdsInput;
  MultiApplication: ResolverTypeWrapper<MultiApplication>;
  Mutation: ResolverTypeWrapper<{}>;
  Note: ResolverTypeWrapper<Note>;
  OfferIdsInput: OfferIdsInput;
  OfferIdsStatus: OfferIdsStatus;
  OnboardingStep: OnboardingStep;
  Order: Order;
  ProfileCountryOption: ResolverTypeWrapper<ProfileCountryOption>;
  ProfileInput: ProfileInput;
  ProfilesInput: ProfilesInput;
  Query: ResolverTypeWrapper<{}>;
  RecruitmentProcess: ResolverTypeWrapper<RecruitmentProcess>;
  RecruitmentProcessStepPayload: ResolverTypeWrapper<RecruitmentProcessStepPayload>;
  RemoveApplyQuestionFromAdInput: RemoveApplyQuestionFromAdInput;
  SaveApplyQuestionToAdInput: SaveApplyQuestionToAdInput;
  SaveApplyQuestionsToAdInput: SaveApplyQuestionsToAdInput;
  SaveMultiAppMeetingDateInput: SaveMultiAppMeetingDateInput;
  SavePredefinedApplyQuestionToAdInput: SavePredefinedApplyQuestionToAdInput;
  SecureUrl: ResolverTypeWrapper<SecureUrl>;
  SendMessageInput: SendMessageInput;
  SetMultiAppRateInput: SetMultiAppRateInput;
  Sort: Sort;
  SortInput: SortInput;
  StafflyReport: ResolverTypeWrapper<StafflyReport>;
  StafflyReportSecureUrl: ResolverTypeWrapper<StafflyReportSecureUrl>;
  StafflyTestResult: ResolverTypeWrapper<StafflyTestResult>;
  String: ResolverTypeWrapper<Scalars['String']['output']>;
  UploadRequestDataPayload: ResolverTypeWrapper<UploadRequestDataPayload>;
  UploadedFile: UploadedFile;
  UserAnswer: ResolverTypeWrapper<UserAnswer>;
  suggestionType: SuggestionType;
}>;

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = ResolversObject<{
  ApolloToken: ApolloToken;
  ApplicationAttachments: ApplicationAttachments;
  ApplicationInput: ApplicationInput;
  ApplicationUpdateInput: ApplicationUpdateInput;
  ApplicationsOrderByInput: ApplicationsOrderByInput;
  ApplyQuestion: ApplyQuestion;
  ApplyQuestionAnswer: ApplyQuestionAnswer;
  ApplyQuestionUserAnswerInput: ApplyQuestionUserAnswerInput;
  AtlasUser: AtlasUser;
  Attachment: Attachment;
  AttachmentInput: AttachmentInput;
  Boolean: Scalars['Boolean']['output'];
  BusinessCardAbout: BusinessCardAbout;
  BusinessCardAboutInput: BusinessCardAboutInput;
  BusinessCardAdditionalInfo: BusinessCardAdditionalInfo;
  BusinessCardAdditionalInformationInput: BusinessCardAdditionalInformationInput;
  BusinessCardBaseProfile: ResolversInterfaceTypes<ResolversParentTypes>['BusinessCardBaseProfile'];
  BusinessCardConfirmAssetsInput: BusinessCardConfirmAssetsInput;
  BusinessCardContact: BusinessCardContact;
  BusinessCardContactInput: BusinessCardContactInput;
  BusinessCardHeader: BusinessCardHeader;
  BusinessCardLifeAt: Omit<BusinessCardLifeAt, 'items'> & {
    items?: Maybe<Array<ResolversParentTypes['BusinessCardLifeAtItem']>>;
  };
  BusinessCardLifeAtInput: BusinessCardLifeAtInput;
  BusinessCardLifeAtItem: ResolversUnionTypes<ResolversParentTypes>['BusinessCardLifeAtItem'];
  BusinessCardLifeAtItemExternalVideo: BusinessCardLifeAtItemExternalVideo;
  BusinessCardLifeAtItemImage: BusinessCardLifeAtItemImage;
  BusinessCardLifeAtItemInput: BusinessCardLifeAtItemInput;
  BusinessCardLocation: BusinessCardLocation;
  BusinessCardLocationInput: BusinessCardLocationInput;
  BusinessCardLocationSuggestion: BusinessCardLocationSuggestion;
  BusinessCardMutation: Omit<
    BusinessCardMutation,
    | 'confirmAssets'
    | 'deleteAssets'
    | 'publishProfile'
    | 'saveAbout'
    | 'saveAdditionalInformation'
    | 'saveContact'
    | 'saveLifeAt'
    | 'unpublishProfile'
  > & {
    confirmAssets: ResolversParentTypes['BusinessCardPrivateProfile'];
    deleteAssets: ResolversParentTypes['BusinessCardPrivateProfile'];
    publishProfile: ResolversParentTypes['BusinessCardPrivateProfile'];
    saveAbout: ResolversParentTypes['BusinessCardPrivateProfile'];
    saveAdditionalInformation: ResolversParentTypes['BusinessCardPrivateProfile'];
    saveContact: ResolversParentTypes['BusinessCardPrivateProfile'];
    saveLifeAt: ResolversParentTypes['BusinessCardPrivateProfile'];
    unpublishProfile: ResolversParentTypes['BusinessCardPrivateProfile'];
  };
  BusinessCardPrivateProfile: Omit<BusinessCardPrivateProfile, 'about' | 'lifeAt'> & {
    about?: Maybe<ResolversParentTypes['BusinessCardAbout']>;
    lifeAt?: Maybe<ResolversParentTypes['BusinessCardLifeAt']>;
  };
  BusinessCardPublicProfile: Omit<BusinessCardPublicProfile, 'about' | 'lifeAt'> & {
    about?: Maybe<ResolversParentTypes['BusinessCardAbout']>;
    lifeAt?: Maybe<ResolversParentTypes['BusinessCardLifeAt']>;
  };
  BusinessCardPublicProfileInput: BusinessCardPublicProfileInput;
  BusinessCardQuery: Omit<
    BusinessCardQuery,
    'privateProfile' | 'publicProfileBySlug' | 'publicProfileByUuid'
  > & {
    privateProfile?: Maybe<ResolversParentTypes['BusinessCardPrivateProfile']>;
    publicProfileBySlug?: Maybe<ResolversParentTypes['BusinessCardPublicProfile']>;
    publicProfileByUuid?: Maybe<ResolversParentTypes['BusinessCardPublicProfile']>;
  };
  BusinessCardUploadRequestDataPayload: BusinessCardUploadRequestDataPayload;
  CVGeneratorInput: CvGeneratorInput;
  CVGeneratorOutput: CvGeneratorOutput;
  CVParsingResult: CvParsingResult;
  Candidate: Candidate;
  CandidateProfile: CandidateProfile;
  CandidateProfileAd: CandidateProfileAd;
  CandidateProfileApplication: CandidateProfileApplication;
  CandidateProfileApplicationAnswer: CandidateProfileApplicationAnswer;
  CandidateProfileApplicationsList: CandidateProfileApplicationsList;
  CandidateProfileApplyValidation: CandidateProfileApplyValidation;
  CandidateProfileBasicInfo: CandidateProfileBasicInfo;
  CandidateProfileBasicInfoInput: CandidateProfileBasicInfoInput;
  CandidateProfileCV: CandidateProfileCv;
  CandidateProfileCVCopy: CandidateProfileCvCopy;
  CandidateProfileCVCopyV2: CandidateProfileCvCopyV2;
  CandidateProfileCVGeneratorToken: CandidateProfileCvGeneratorToken;
  CandidateProfileCountryOptions: CandidateProfileCountryOptions;
  CandidateProfileCursorKey: CandidateProfileCursorKey;
  CandidateProfileCursorKeyInput: CandidateProfileCursorKeyInput;
  CandidateProfileData: CandidateProfileData;
  CandidateProfileExperience: CandidateProfileExperience;
  CandidateProfileExperienceInput: CandidateProfileExperienceInput;
  CandidateProfileLanguageSkill: CandidateProfileLanguageSkill;
  CandidateProfileLanguageSkillInput: CandidateProfileLanguageSkillInput;
  CandidateProfileLatestApplication: CandidateProfileLatestApplication;
  CandidateProfileLocation: CandidateProfileLocation;
  CandidateProfileLocationInput: CandidateProfileLocationInput;
  CandidateProfileMutation: CandidateProfileMutation;
  CandidateProfileNoAuthMutation: CandidateProfileNoAuthMutation;
  CandidateProfileNotificationsSettings: CandidateProfileNotificationsSettings;
  CandidateProfilePreferences: CandidateProfilePreferences;
  CandidateProfilePreferredLocationInput: CandidateProfilePreferredLocationInput;
  CandidateProfilePreferredSalary: CandidateProfilePreferredSalary;
  CandidateProfilePreferredSalaryInput: CandidateProfilePreferredSalaryInput;
  CandidateProfileProfile: CandidateProfileProfile;
  CandidateProfileQuery: CandidateProfileQuery;
  CandidateProfileRecommendation: CandidateProfileRecommendation;
  CandidateProfileRecommendationJobOffer: CandidateProfileRecommendationJobOffer;
  CandidateProfileRecommendationRawParam: CandidateProfileRecommendationRawParam;
  CandidateProfileSchool: CandidateProfileSchool;
  CandidateProfileSchoolInput: CandidateProfileSchoolInput;
  CandidateProfileSettings: CandidateProfileSettings;
  CandidateProfileSuggestion: CandidateProfileSuggestion;
  CandidateProfileUploadData: CandidateProfileUploadData;
  ChangeMultiAppStatusInput: ChangeMultiAppStatusInput;
  ChatAttachment: ChatAttachment;
  ChatConversation: ChatConversation;
  ChatMessage: ChatMessage;
  CompanyProfileAbout: CompanyProfileAbout;
  CompanyProfileAboutInput: CompanyProfileAboutInput;
  CompanyProfileAdditionalInfo: CompanyProfileAdditionalInfo;
  CompanyProfileAdditionalInformationInput: CompanyProfileAdditionalInformationInput;
  CompanyProfileAds: CompanyProfileAds;
  CompanyProfileAdsAggregation: CompanyProfileAdsAggregation;
  CompanyProfileAdsAggregationValue: CompanyProfileAdsAggregationValue;
  CompanyProfileAdsAggregations: CompanyProfileAdsAggregations;
  CompanyProfileAdsInput: CompanyProfileAdsInput;
  CompanyProfileBaseProfile: ResolversInterfaceTypes<ResolversParentTypes>['CompanyProfileBaseProfile'];
  CompanyProfileBenefits: CompanyProfileBenefits;
  CompanyProfileBenefitsInput: CompanyProfileBenefitsInput;
  CompanyProfileConfig: CompanyProfileConfig;
  CompanyProfileConfigFeatureBanner: CompanyProfileConfigFeatureBanner;
  CompanyProfileConfigFeatureBase: ResolversInterfaceTypes<ResolversParentTypes>['CompanyProfileConfigFeatureBase'];
  CompanyProfileConfigFeatureBenefits: CompanyProfileConfigFeatureBenefits;
  CompanyProfileConfigFeatureCompanyUrl: CompanyProfileConfigFeatureCompanyUrl;
  CompanyProfileConfigFeatureFollowButton: CompanyProfileConfigFeatureFollowButton;
  CompanyProfileConfigFeatureGallery: CompanyProfileConfigFeatureGallery;
  CompanyProfileConfigFeatureLogo: CompanyProfileConfigFeatureLogo;
  CompanyProfileConfigFeatureMultiprofile: CompanyProfileConfigFeatureMultiprofile;
  CompanyProfileConfigFeaturePromotedOnListing: CompanyProfileConfigFeaturePromotedOnListing;
  CompanyProfileConfigFeatureRecruitment: CompanyProfileConfigFeatureRecruitment;
  CompanyProfileConfigFeatureSocialLinks: CompanyProfileConfigFeatureSocialLinks;
  CompanyProfileConfigFeatures: CompanyProfileConfigFeatures;
  CompanyProfileConfigRelations: CompanyProfileConfigRelations;
  CompanyProfileConfigSubProfile: CompanyProfileConfigSubProfile;
  CompanyProfileConfirmAssetsInput: CompanyProfileConfirmAssetsInput;
  CompanyProfileContact: CompanyProfileContact;
  CompanyProfileContactInput: CompanyProfileContactInput;
  CompanyProfileHeader: CompanyProfileHeader;
  CompanyProfileLifeAt: Omit<CompanyProfileLifeAt, 'items'> & {
    items?: Maybe<Array<ResolversParentTypes['CompanyProfileLifeAtItem']>>;
  };
  CompanyProfileLifeAtInput: CompanyProfileLifeAtInput;
  CompanyProfileLifeAtItem: ResolversUnionTypes<ResolversParentTypes>['CompanyProfileLifeAtItem'];
  CompanyProfileLifeAtItemExternalVideo: CompanyProfileLifeAtItemExternalVideo;
  CompanyProfileLifeAtItemImage: CompanyProfileLifeAtItemImage;
  CompanyProfileLifeAtItemInput: CompanyProfileLifeAtItemInput;
  CompanyProfileLocation: CompanyProfileLocation;
  CompanyProfileLocationInput: CompanyProfileLocationInput;
  CompanyProfileMutation: Omit<
    CompanyProfileMutation,
    | 'confirmAssets'
    | 'deleteAssets'
    | 'publishProfile'
    | 'saveAbout'
    | 'saveAdditionalInformation'
    | 'saveBenefits'
    | 'saveContact'
    | 'saveLifeAt'
    | 'saveRecruitment'
    | 'unpublishProfile'
  > & {
    confirmAssets: ResolversParentTypes['CompanyProfilePrivateProfile'];
    deleteAssets: ResolversParentTypes['CompanyProfilePrivateProfile'];
    publishProfile: ResolversParentTypes['CompanyProfilePrivateProfile'];
    saveAbout: ResolversParentTypes['CompanyProfilePrivateProfile'];
    saveAdditionalInformation: ResolversParentTypes['CompanyProfilePrivateProfile'];
    saveBenefits: ResolversParentTypes['CompanyProfilePrivateProfile'];
    saveContact: ResolversParentTypes['CompanyProfilePrivateProfile'];
    saveLifeAt: ResolversParentTypes['CompanyProfilePrivateProfile'];
    saveRecruitment: ResolversParentTypes['CompanyProfilePrivateProfile'];
    unpublishProfile: ResolversParentTypes['CompanyProfilePrivateProfile'];
  };
  CompanyProfilePrivateConfig: CompanyProfilePrivateConfig;
  CompanyProfilePrivateConfigRelations: CompanyProfilePrivateConfigRelations;
  CompanyProfilePrivateConfigSubProfile: CompanyProfilePrivateConfigSubProfile;
  CompanyProfilePrivateConfigTier: CompanyProfilePrivateConfigTier;
  CompanyProfilePrivateProfile: Omit<CompanyProfilePrivateProfile, 'about' | 'lifeAt'> & {
    about?: Maybe<ResolversParentTypes['CompanyProfileAbout']>;
    lifeAt?: Maybe<ResolversParentTypes['CompanyProfileLifeAt']>;
  };
  CompanyProfileProfileCounters: CompanyProfileProfileCounters;
  CompanyProfileProfilesCarousel: CompanyProfileProfilesCarousel;
  CompanyProfileProfilesCarouselInput: CompanyProfileProfilesCarouselInput;
  CompanyProfileProfilesCarouselProfile: CompanyProfileProfilesCarouselProfile;
  CompanyProfileProfilesListing: CompanyProfileProfilesListing;
  CompanyProfileProfilesListingInput: CompanyProfileProfilesListingInput;
  CompanyProfileProfilesListingProfile: CompanyProfileProfilesListingProfile;
  CompanyProfilePublicConfig: CompanyProfilePublicConfig;
  CompanyProfilePublicProfile: Omit<CompanyProfilePublicProfile, 'about' | 'lifeAt'> & {
    about?: Maybe<ResolversParentTypes['CompanyProfileAbout']>;
    lifeAt?: Maybe<ResolversParentTypes['CompanyProfileLifeAt']>;
  };
  CompanyProfilePublicProfileInput: CompanyProfilePublicProfileInput;
  CompanyProfilePublicProfilesInput: CompanyProfilePublicProfilesInput;
  CompanyProfileQuery: Omit<
    CompanyProfileQuery,
    | 'previewProfile'
    | 'privateProfile'
    | 'profile'
    | 'profileV2'
    | 'profiles'
    | 'publicProfileBySlug'
    | 'publicProfileByUuid'
    | 'publicProfiles'
  > & {
    previewProfile?: Maybe<ResolversParentTypes['CompanyProfilePublicProfile']>;
    privateProfile?: Maybe<ResolversParentTypes['CompanyProfilePrivateProfile']>;
    profile?: Maybe<ResolversParentTypes['EmployerProfile']>;
    profileV2?: Maybe<ResolversParentTypes['EmployerProfile']>;
    profiles: Array<ResolversParentTypes['EmployerProfile']>;
    publicProfileBySlug?: Maybe<ResolversParentTypes['CompanyProfilePublicProfile']>;
    publicProfileByUuid?: Maybe<ResolversParentTypes['CompanyProfilePublicProfile']>;
    publicProfiles: Array<ResolversParentTypes['CompanyProfilePublicProfile']>;
  };
  CompanyProfileRecruitment: CompanyProfileRecruitment;
  CompanyProfileRecruitmentInput: CompanyProfileRecruitmentInput;
  CompanyProfileRecruitmentProcess: CompanyProfileRecruitmentProcess;
  CompanyProfileRecruitmentProcessInput: CompanyProfileRecruitmentProcessInput;
  CompanyProfileRecruitmentProcessStep: CompanyProfileRecruitmentProcessStep;
  CompanyProfileRecruitmentProcessStepInput: CompanyProfileRecruitmentProcessStepInput;
  DeleteMultiAppWithChatInput: DeleteMultiAppWithChatInput;
  EditMultiAppNoteInput: EditMultiAppNoteInput;
  EmployerLead: EmployerLead;
  EmployerPanelAdvancedApplyQuestionInput: EmployerPanelAdvancedApplyQuestionInput;
  EmployerPanelApplyQuestionAnswerInput: EmployerPanelApplyQuestionAnswerInput;
  EmployerPanelApplyQuestionsByAdIdInput: EmployerPanelApplyQuestionsByAdIdInput;
  EmployerPanelMutation: EmployerPanelMutation;
  EmployerPanelQuery: EmployerPanelQuery;
  EmployerPanelSaveAdvancedQuestionsToAdInput: EmployerPanelSaveAdvancedQuestionsToAdInput;
  EmployerProfile: Omit<EmployerProfile, 'headquarters' | 'lifeAt'> & {
    headquarters?: Maybe<ResolversParentTypes['LocationPayload']>;
    lifeAt?: Maybe<ResolversParentTypes['LifeAt']>;
  };
  EmployerSegmentResponse: EmployerSegmentResponse;
  Float: Scalars['Float']['output'];
  HomepageArticle: HomepageArticle;
  HomepageFeaturedCategory: HomepageFeaturedCategory;
  HomepageFeaturedEmployer: HomepageFeaturedEmployer;
  HomepageQuery: HomepageQuery;
  ID: Scalars['ID']['output'];
  ImageThumbnail: ImageThumbnail;
  Int: Scalars['Int']['output'];
  JobAd: JobAd;
  JobAdCounters: JobAdCounters;
  JobAdTrackingParameters: JobAdTrackingParameters;
  JobAdUnreadCounters: JobAdUnreadCounters;
  JobOfferCity: JobOfferCity;
  JobOfferDistrict: JobOfferDistrict;
  JobOfferEmployer: JobOfferEmployer;
  JobOfferEmployerLogoThumbnails: JobOfferEmployerLogoThumbnails;
  JobOfferFloatValue: JobOfferFloatValue;
  JobOfferIntValue: JobOfferIntValue;
  JobOfferLocation: JobOfferLocation;
  JobOfferMap: JobOfferMap;
  JobOfferOffer: JobOfferOffer;
  JobOfferParameter: JobOfferParameter;
  JobOfferPostingComponent: JobOfferPostingComponent;
  JobOfferQuery: JobOfferQuery;
  JobOfferRegion: JobOfferRegion;
  JobOfferSalary: JobOfferSalary;
  JobOfferSalaryType: JobOfferSalaryType;
  JobOfferStringValue: JobOfferStringValue;
  LifeAt: Omit<LifeAt, 'items'> & { items?: Maybe<Array<ResolversParentTypes['LifeAtItem']>> };
  LifeAtItem: ResolversUnionTypes<ResolversParentTypes>['LifeAtItem'];
  LifeAtItemExternalVideo: LifeAtItemExternalVideo;
  LifeAtItemImage: LifeAtItemImage;
  LocationPayload: LocationPayload;
  LocationSuggestion: LocationSuggestion;
  MarkAsReadInput: MarkAsReadInput;
  Metadata: Metadata;
  MetadataInput: MetadataInput;
  MultiAppIdsInput: MultiAppIdsInput;
  MultiApplication: MultiApplication;
  Mutation: {};
  Note: Note;
  OfferIdsInput: OfferIdsInput;
  ProfileCountryOption: ProfileCountryOption;
  ProfileInput: ProfileInput;
  ProfilesInput: ProfilesInput;
  Query: {};
  RecruitmentProcess: RecruitmentProcess;
  RecruitmentProcessStepPayload: RecruitmentProcessStepPayload;
  RemoveApplyQuestionFromAdInput: RemoveApplyQuestionFromAdInput;
  SaveApplyQuestionToAdInput: SaveApplyQuestionToAdInput;
  SaveApplyQuestionsToAdInput: SaveApplyQuestionsToAdInput;
  SaveMultiAppMeetingDateInput: SaveMultiAppMeetingDateInput;
  SavePredefinedApplyQuestionToAdInput: SavePredefinedApplyQuestionToAdInput;
  SecureUrl: SecureUrl;
  SendMessageInput: SendMessageInput;
  SetMultiAppRateInput: SetMultiAppRateInput;
  SortInput: SortInput;
  StafflyReport: StafflyReport;
  StafflyReportSecureUrl: StafflyReportSecureUrl;
  StafflyTestResult: StafflyTestResult;
  String: Scalars['String']['output'];
  UploadRequestDataPayload: UploadRequestDataPayload;
  UploadedFile: UploadedFile;
  UserAnswer: UserAnswer;
}>;

export type OneOfDirectiveArgs = {};

export type OneOfDirectiveResolver<
  Result,
  Parent,
  ContextType = any,
  Args = OneOfDirectiveArgs,
> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type ApolloTokenResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ApolloToken'] = ResolversParentTypes['ApolloToken'],
> = ResolversObject<{
  expiry?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  token?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ApplicationAttachmentsResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['ApplicationAttachments'] = ResolversParentTypes['ApplicationAttachments'],
> = ResolversObject<{
  attachments?: Resolver<Maybe<Array<ResolversTypes['ChatAttachment']>>, ParentType, ContextType>;
  cv?: Resolver<Maybe<ResolversTypes['ChatAttachment']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ApplyQuestionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ApplyQuestion'] = ResolversParentTypes['ApplyQuestion'],
> = ResolversObject<{
  ID?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  answers?: Resolver<Array<ResolversTypes['ApplyQuestionAnswer']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  order?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  placeholder?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  variant?: Resolver<ResolversTypes['ApplyQuestionVariant'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ApplyQuestionAnswerResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['ApplyQuestionAnswer'] = ResolversParentTypes['ApplyQuestionAnswer'],
> = ResolversObject<{
  isFavorite?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  placeholder?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AtlasUserResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AtlasUser'] = ResolversParentTypes['AtlasUser'],
> = ResolversObject<{
  created?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AttachmentResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Attachment'] = ResolversParentTypes['Attachment'],
> = ResolversObject<{
  ID?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  downloadToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  downloadURL?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  simpleURL?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  token?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BusinessCardAboutResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['BusinessCardAbout'] = ResolversParentTypes['BusinessCardAbout'],
> = ResolversObject<{
  companyName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logoUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tagline?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BusinessCardAdditionalInfoResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['BusinessCardAdditionalInfo'] = ResolversParentTypes['BusinessCardAdditionalInfo'],
> = ResolversObject<{
  companySize?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  companyUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  facebookUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  headquarters?: Resolver<Maybe<ResolversTypes['BusinessCardLocation']>, ParentType, ContextType>;
  industry?: Resolver<Maybe<ResolversTypes['BusinessCardIndustry']>, ParentType, ContextType>;
  instagramUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  linkedinUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  twitterUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  youtubeUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BusinessCardBaseProfileResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['BusinessCardBaseProfile'] = ResolversParentTypes['BusinessCardBaseProfile'],
> = ResolversObject<{
  __resolveType: TypeResolveFn<
    'BusinessCardPrivateProfile' | 'BusinessCardPublicProfile',
    ParentType,
    ContextType
  >;
  about?: Resolver<Maybe<ResolversTypes['BusinessCardAbout']>, ParentType, ContextType>;
  additionalInfo?: Resolver<
    Maybe<ResolversTypes['BusinessCardAdditionalInfo']>,
    ParentType,
    ContextType
  >;
  contact?: Resolver<Maybe<ResolversTypes['BusinessCardContact']>, ParentType, ContextType>;
  header?: Resolver<Maybe<ResolversTypes['BusinessCardHeader']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lifeAt?: Resolver<Maybe<ResolversTypes['BusinessCardLifeAt']>, ParentType, ContextType>;
  publishedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  slug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userUuid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
}>;

export type BusinessCardContactResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['BusinessCardContact'] = ResolversParentTypes['BusinessCardContact'],
> = ResolversObject<{
  companyName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  headquarters?: Resolver<Maybe<ResolversTypes['BusinessCardLocation']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BusinessCardHeaderResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['BusinessCardHeader'] = ResolversParentTypes['BusinessCardHeader'],
> = ResolversObject<{
  bannerUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BusinessCardLifeAtResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['BusinessCardLifeAt'] = ResolversParentTypes['BusinessCardLifeAt'],
> = ResolversObject<{
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  items?: Resolver<Maybe<Array<ResolversTypes['BusinessCardLifeAtItem']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BusinessCardLifeAtItemResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['BusinessCardLifeAtItem'] = ResolversParentTypes['BusinessCardLifeAtItem'],
> = ResolversObject<{
  __resolveType: TypeResolveFn<
    'BusinessCardLifeAtItemExternalVideo' | 'BusinessCardLifeAtItemImage',
    ParentType,
    ContextType
  >;
}>;

export type BusinessCardLifeAtItemExternalVideoResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['BusinessCardLifeAtItemExternalVideo'] = ResolversParentTypes['BusinessCardLifeAtItemExternalVideo'],
> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['BusinessCardLifeAtItemType'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BusinessCardLifeAtItemImageResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['BusinessCardLifeAtItemImage'] = ResolversParentTypes['BusinessCardLifeAtItemImage'],
> = ResolversObject<{
  fileId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['BusinessCardLifeAtItemType'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BusinessCardLocationResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['BusinessCardLocation'] = ResolversParentTypes['BusinessCardLocation'],
> = ResolversObject<{
  city?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lat?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  lng?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  region?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  streetName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  streetNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  zipCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BusinessCardLocationSuggestionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['BusinessCardLocationSuggestion'] = ResolversParentTypes['BusinessCardLocationSuggestion'],
> = ResolversObject<{
  city?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lat?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  lng?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  region?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  streetName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  streetNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  zipCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BusinessCardMutationResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['BusinessCardMutation'] = ResolversParentTypes['BusinessCardMutation'],
> = ResolversObject<{
  confirmAssets?: Resolver<
    ResolversTypes['BusinessCardPrivateProfile'],
    ParentType,
    ContextType,
    RequireFields<BusinessCardMutationConfirmAssetsArgs, 'input'>
  >;
  deleteAssets?: Resolver<
    ResolversTypes['BusinessCardPrivateProfile'],
    ParentType,
    ContextType,
    RequireFields<BusinessCardMutationDeleteAssetsArgs, 'input'>
  >;
  deleteData?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  publishProfile?: Resolver<ResolversTypes['BusinessCardPrivateProfile'], ParentType, ContextType>;
  saveAbout?: Resolver<
    ResolversTypes['BusinessCardPrivateProfile'],
    ParentType,
    ContextType,
    RequireFields<BusinessCardMutationSaveAboutArgs, 'input'>
  >;
  saveAdditionalInformation?: Resolver<
    ResolversTypes['BusinessCardPrivateProfile'],
    ParentType,
    ContextType,
    RequireFields<BusinessCardMutationSaveAdditionalInformationArgs, 'input'>
  >;
  saveContact?: Resolver<
    ResolversTypes['BusinessCardPrivateProfile'],
    ParentType,
    ContextType,
    RequireFields<BusinessCardMutationSaveContactArgs, 'input'>
  >;
  saveLifeAt?: Resolver<
    ResolversTypes['BusinessCardPrivateProfile'],
    ParentType,
    ContextType,
    RequireFields<BusinessCardMutationSaveLifeAtArgs, 'input'>
  >;
  unpublishProfile?: Resolver<
    ResolversTypes['BusinessCardPrivateProfile'],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BusinessCardPrivateProfileResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['BusinessCardPrivateProfile'] = ResolversParentTypes['BusinessCardPrivateProfile'],
> = ResolversObject<{
  about?: Resolver<Maybe<ResolversTypes['BusinessCardAbout']>, ParentType, ContextType>;
  additionalInfo?: Resolver<
    Maybe<ResolversTypes['BusinessCardAdditionalInfo']>,
    ParentType,
    ContextType
  >;
  contact?: Resolver<Maybe<ResolversTypes['BusinessCardContact']>, ParentType, ContextType>;
  header?: Resolver<Maybe<ResolversTypes['BusinessCardHeader']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lifeAt?: Resolver<Maybe<ResolversTypes['BusinessCardLifeAt']>, ParentType, ContextType>;
  publishedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  slug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userUuid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BusinessCardPublicProfileResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['BusinessCardPublicProfile'] = ResolversParentTypes['BusinessCardPublicProfile'],
> = ResolversObject<{
  about?: Resolver<Maybe<ResolversTypes['BusinessCardAbout']>, ParentType, ContextType>;
  additionalInfo?: Resolver<
    Maybe<ResolversTypes['BusinessCardAdditionalInfo']>,
    ParentType,
    ContextType
  >;
  contact?: Resolver<Maybe<ResolversTypes['BusinessCardContact']>, ParentType, ContextType>;
  header?: Resolver<Maybe<ResolversTypes['BusinessCardHeader']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lifeAt?: Resolver<Maybe<ResolversTypes['BusinessCardLifeAt']>, ParentType, ContextType>;
  publishedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  slug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userUuid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BusinessCardQueryResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['BusinessCardQuery'] = ResolversParentTypes['BusinessCardQuery'],
> = ResolversObject<{
  locationSuggestions?: Resolver<
    Array<ResolversTypes['BusinessCardLocationSuggestion']>,
    ParentType,
    ContextType,
    RequireFields<BusinessCardQueryLocationSuggestionsArgs, 'phrase'>
  >;
  privateProfile?: Resolver<
    Maybe<ResolversTypes['BusinessCardPrivateProfile']>,
    ParentType,
    ContextType
  >;
  publicProfileBySlug?: Resolver<
    Maybe<ResolversTypes['BusinessCardPublicProfile']>,
    ParentType,
    ContextType,
    RequireFields<BusinessCardQueryPublicProfileBySlugArgs, 'slug'>
  >;
  publicProfileByUuid?: Resolver<
    Maybe<ResolversTypes['BusinessCardPublicProfile']>,
    ParentType,
    ContextType,
    RequireFields<BusinessCardQueryPublicProfileByUuidArgs, 'uuid'>
  >;
  uploadRequestData?: Resolver<
    ResolversTypes['BusinessCardUploadRequestDataPayload'],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BusinessCardUploadRequestDataPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['BusinessCardUploadRequestDataPayload'] = ResolversParentTypes['BusinessCardUploadRequestDataPayload'],
> = ResolversObject<{
  token?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CvGeneratorOutputResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CVGeneratorOutput'] = ResolversParentTypes['CVGeneratorOutput'],
> = ResolversObject<{
  token?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CvParsingResultResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CVParsingResult'] = ResolversParentTypes['CVParsingResult'],
> = ResolversObject<{
  profile?: Resolver<Maybe<ResolversTypes['CandidateProfileProfile']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CandidateResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Candidate'] = ResolversParentTypes['Candidate'],
> = ResolversObject<{
  cacheId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isRemoved?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CandidateProfileResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CandidateProfile'] = ResolversParentTypes['CandidateProfile'],
> = ResolversObject<{
  candidateId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  candidateProfile?: Resolver<
    Maybe<ResolversTypes['CandidateProfileData']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CandidateProfileAdResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CandidateProfileAd'] = ResolversParentTypes['CandidateProfileAd'],
> = ResolversObject<{
  categoryID?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isBusiness?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  ownerID?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ownerUUID?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CandidateProfileApplicationResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CandidateProfileApplication'] = ResolversParentTypes['CandidateProfileApplication'],
> = ResolversObject<{
  ID?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  ad?: Resolver<Maybe<ResolversTypes['CandidateProfileAd']>, ParentType, ContextType>;
  answers?: Resolver<
    Maybe<Array<ResolversTypes['CandidateProfileApplicationAnswer']>>,
    ParentType,
    ContextType
  >;
  attachments?: Resolver<Maybe<Array<ResolversTypes['Attachment']>>, ParentType, ContextType>;
  cancelledAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  candidateID?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  candidateUUID?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  cv?: Resolver<Maybe<ResolversTypes['Attachment']>, ParentType, ContextType>;
  cvFileID?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cvFileName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  emailAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  employerID?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  employerMeetingDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  employerStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  employerStatusChangedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fromInvitation?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hasBeenReadByEmployer?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isCancelled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  withProfile?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CandidateProfileApplicationAnswerResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CandidateProfileApplicationAnswer'] = ResolversParentTypes['CandidateProfileApplicationAnswer'],
> = ResolversObject<{
  question?: Resolver<Maybe<ResolversTypes['ApplyQuestion']>, ParentType, ContextType>;
  values?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CandidateProfileApplicationsListResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CandidateProfileApplicationsList'] = ResolversParentTypes['CandidateProfileApplicationsList'],
> = ResolversObject<{
  applications?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['CandidateProfileApplication']>>>,
    ParentType,
    ContextType
  >;
  cursor?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['CandidateProfileCursorKey']>>>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CandidateProfileApplyValidationResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CandidateProfileApplyValidation'] = ResolversParentTypes['CandidateProfileApplyValidation'],
> = ResolversObject<{
  result?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CandidateProfileBasicInfoResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CandidateProfileBasicInfo'] = ResolversParentTypes['CandidateProfileBasicInfo'],
> = ResolversObject<{
  emailAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  location?: Resolver<Maybe<ResolversTypes['CandidateProfileLocation']>, ParentType, ContextType>;
  locationRange?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  yearOfBirth?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CandidateProfileCvResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CandidateProfileCV'] = ResolversParentTypes['CandidateProfileCV'],
> = ResolversObject<{
  ID?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  downloadToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  downloadURL?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  simpleURL?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  token?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CandidateProfileCvCopyResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CandidateProfileCVCopy'] = ResolversParentTypes['CandidateProfileCVCopy'],
> = ResolversObject<{
  ID?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CandidateProfileCvCopyV2Resolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CandidateProfileCVCopyV2'] = ResolversParentTypes['CandidateProfileCVCopyV2'],
> = ResolversObject<{
  ID?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  stamp?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CandidateProfileCvGeneratorTokenResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CandidateProfileCVGeneratorToken'] = ResolversParentTypes['CandidateProfileCVGeneratorToken'],
> = ResolversObject<{
  token?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CandidateProfileCountryOptionsResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CandidateProfileCountryOptions'] = ResolversParentTypes['CandidateProfileCountryOptions'],
> = ResolversObject<{
  contracts?: Resolver<Array<ResolversTypes['ProfileCountryOption']>, ParentType, ContextType>;
  drivingLicenses?: Resolver<
    Array<ResolversTypes['ProfileCountryOption']>,
    ParentType,
    ContextType
  >;
  salaryCurrency?: Resolver<Array<ResolversTypes['ProfileCountryOption']>, ParentType, ContextType>;
  salaryPeriod?: Resolver<
    Array<ResolversTypes['CandidateProfileSalaryPeriod']>,
    ParentType,
    ContextType
  >;
  salaryType?: Resolver<
    Array<ResolversTypes['CandidateProfileSalaryType']>,
    ParentType,
    ContextType
  >;
  workingHours?: Resolver<Array<ResolversTypes['ProfileCountryOption']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CandidateProfileCursorKeyResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CandidateProfileCursorKey'] = ResolversParentTypes['CandidateProfileCursorKey'],
> = ResolversObject<{
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CandidateProfileDataResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CandidateProfileData'] = ResolversParentTypes['CandidateProfileData'],
> = ResolversObject<{
  basicInfo?: Resolver<Maybe<ResolversTypes['CandidateProfileBasicInfo']>, ParentType, ContextType>;
  completeness?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  drivingLicense?: Resolver<
    Maybe<Array<ResolversTypes['CandidateProfileDrivingLicenseCategory']>>,
    ParentType,
    ContextType
  >;
  education?: Resolver<
    Maybe<Array<ResolversTypes['CandidateProfileSchool']>>,
    ParentType,
    ContextType
  >;
  experience?: Resolver<
    Maybe<Array<ResolversTypes['CandidateProfileExperience']>>,
    ParentType,
    ContextType
  >;
  hobby?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  languages?: Resolver<
    Maybe<Array<ResolversTypes['CandidateProfileLanguageSkill']>>,
    ParentType,
    ContextType
  >;
  skills?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CandidateProfileExperienceResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CandidateProfileExperience'] = ResolversParentTypes['CandidateProfileExperience'],
> = ResolversObject<{
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  employerName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endMonth?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  endYear?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  jobTitle?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ongoing?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  startMonth?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  startYear?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CandidateProfileLanguageSkillResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CandidateProfileLanguageSkill'] = ResolversParentTypes['CandidateProfileLanguageSkill'],
> = ResolversObject<{
  language?: Resolver<ResolversTypes['CandidateProfileLanguage'], ParentType, ContextType>;
  proficiency?: Resolver<ResolversTypes['CandidateProfileProficiency'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CandidateProfileLatestApplicationResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CandidateProfileLatestApplication'] = ResolversParentTypes['CandidateProfileLatestApplication'],
> = ResolversObject<{
  ID?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  attachments?: Resolver<Maybe<Array<ResolversTypes['Attachment']>>, ParentType, ContextType>;
  cancelledAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  candidateID?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  candidateUUID?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  cv?: Resolver<Maybe<ResolversTypes['Attachment']>, ParentType, ContextType>;
  cvFileID?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cvFileName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  emailAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  employerID?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  employerStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  employerStatusChangedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  hasBeenReadByEmployer?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isCancelled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isOnlyApplication?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  withProfile?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CandidateProfileLocationResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CandidateProfileLocation'] = ResolversParentTypes['CandidateProfileLocation'],
> = ResolversObject<{
  cityId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  districtId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CandidateProfileMutationResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CandidateProfileMutation'] = ResolversParentTypes['CandidateProfileMutation'],
> = ResolversObject<{
  ApplyNew?: Resolver<
    ResolversTypes['String'],
    ParentType,
    ContextType,
    RequireFields<CandidateProfileMutationApplyNewArgs, 'input'>
  >;
  BasicInfo?: Resolver<
    ResolversTypes['CandidateProfileProfile'],
    ParentType,
    ContextType,
    RequireFields<CandidateProfileMutationBasicInfoArgs, 'input'>
  >;
  CV?: Resolver<
    Maybe<ResolversTypes['CandidateProfileCV']>,
    ParentType,
    ContextType,
    RequireFields<CandidateProfileMutationCvArgs, 'input'>
  >;
  CVParsingSubmit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  CancelApplication?: Resolver<
    Maybe<ResolversTypes['CandidateProfileApplication']>,
    ParentType,
    ContextType,
    RequireFields<CandidateProfileMutationCancelApplicationArgs, 'ID'>
  >;
  CandidatesDatabaseConsentSetting?: Resolver<
    ResolversTypes['CandidateProfileSettings'],
    ParentType,
    ContextType,
    RequireFields<CandidateProfileMutationCandidatesDatabaseConsentSettingArgs, 'input'>
  >;
  CopyCV?: Resolver<Maybe<ResolversTypes['CandidateProfileCVCopy']>, ParentType, ContextType>;
  CopyCVV2?: Resolver<Maybe<ResolversTypes['CandidateProfileCVCopyV2']>, ParentType, ContextType>;
  DashboardEnabledSettings?: Resolver<
    ResolversTypes['CandidateProfileSettings'],
    ParentType,
    ContextType,
    RequireFields<CandidateProfileMutationDashboardEnabledSettingsArgs, 'input'>
  >;
  DeleteCV?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  DeletePreferences?: Resolver<
    ResolversTypes['CandidateProfilePreferences'],
    ParentType,
    ContextType
  >;
  DeleteProfile?: Resolver<ResolversTypes['CandidateProfileProfile'], ParentType, ContextType>;
  Dislike?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType,
    RequireFields<CandidateProfileMutationDislikeArgs, 'adId'>
  >;
  DrivingLicense?: Resolver<
    ResolversTypes['CandidateProfileProfile'],
    ParentType,
    ContextType,
    Partial<CandidateProfileMutationDrivingLicenseArgs>
  >;
  Education?: Resolver<
    ResolversTypes['CandidateProfileProfile'],
    ParentType,
    ContextType,
    RequireFields<CandidateProfileMutationEducationArgs, 'input'>
  >;
  Experience?: Resolver<
    ResolversTypes['CandidateProfileProfile'],
    ParentType,
    ContextType,
    Partial<CandidateProfileMutationExperienceArgs>
  >;
  Hobby?: Resolver<
    ResolversTypes['CandidateProfileProfile'],
    ParentType,
    ContextType,
    Partial<CandidateProfileMutationHobbyArgs>
  >;
  IncrementApplicationCounter?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType,
    RequireFields<CandidateProfileMutationIncrementApplicationCounterArgs, 'adID'>
  >;
  Languages?: Resolver<
    ResolversTypes['CandidateProfileProfile'],
    ParentType,
    ContextType,
    Partial<CandidateProfileMutationLanguagesArgs>
  >;
  Like?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType,
    RequireFields<CandidateProfileMutationLikeArgs, 'adId'>
  >;
  PreferredGeneric?: Resolver<
    ResolversTypes['CandidateProfilePreferences'],
    ParentType,
    ContextType,
    RequireFields<CandidateProfileMutationPreferredGenericArgs, 'input' | 'inputType'>
  >;
  PreferredLocation?: Resolver<
    ResolversTypes['CandidateProfilePreferences'],
    ParentType,
    ContextType,
    RequireFields<CandidateProfileMutationPreferredLocationArgs, 'input'>
  >;
  PreferredRoles?: Resolver<
    ResolversTypes['CandidateProfilePreferences'],
    ParentType,
    ContextType,
    RequireFields<CandidateProfileMutationPreferredRolesArgs, 'input'>
  >;
  PreferredSalary?: Resolver<
    ResolversTypes['CandidateProfilePreferences'],
    ParentType,
    ContextType,
    RequireFields<CandidateProfileMutationPreferredSalaryArgs, 'input'>
  >;
  SaveApplyQuestionsUserAnswers?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType,
    RequireFields<
      CandidateProfileMutationSaveApplyQuestionsUserAnswersArgs,
      'answers' | 'applicationID'
    >
  >;
  Skills?: Resolver<
    ResolversTypes['CandidateProfileProfile'],
    ParentType,
    ContextType,
    Partial<CandidateProfileMutationSkillsArgs>
  >;
  Undislike?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType,
    RequireFields<CandidateProfileMutationUndislikeArgs, 'adId'>
  >;
  Unlike?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType,
    RequireFields<CandidateProfileMutationUnlikeArgs, 'adId'>
  >;
  UpdateApplication?: Resolver<
    Maybe<ResolversTypes['CandidateProfileApplication']>,
    ParentType,
    ContextType,
    RequireFields<CandidateProfileMutationUpdateApplicationArgs, 'ID' | 'input'>
  >;
  VisibilitySettings?: Resolver<
    ResolversTypes['CandidateProfileSettings'],
    ParentType,
    ContextType,
    RequireFields<CandidateProfileMutationVisibilitySettingsArgs, 'input'>
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CandidateProfileNoAuthMutationResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CandidateProfileNoAuthMutation'] = ResolversParentTypes['CandidateProfileNoAuthMutation'],
> = ResolversObject<{
  IncrementCounter?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType,
    RequireFields<CandidateProfileNoAuthMutationIncrementCounterArgs, 'adID'>
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CandidateProfileNotificationsSettingsResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CandidateProfileNotificationsSettings'] = ResolversParentTypes['CandidateProfileNotificationsSettings'],
> = ResolversObject<{
  email?: Resolver<
    Maybe<ResolversTypes['CandidateProfileNotificationFrequency']>,
    ParentType,
    ContextType
  >;
  push?: Resolver<
    Maybe<ResolversTypes['CandidateProfileNotificationFrequency']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CandidateProfilePreferencesResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CandidateProfilePreferences'] = ResolversParentTypes['CandidateProfilePreferences'],
> = ResolversObject<{
  location?: Resolver<ResolversTypes['CandidateProfileLocation'], ParentType, ContextType>;
  locationRange?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  preferredContracts?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  preferredContractsV2?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  preferredRoles?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  preferredSalary?: Resolver<
    ResolversTypes['CandidateProfilePreferredSalary'],
    ParentType,
    ContextType
  >;
  preferredWorkingHours?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  preferredWorkingHoursV2?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CandidateProfilePreferredSalaryResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CandidateProfilePreferredSalary'] = ResolversParentTypes['CandidateProfilePreferredSalary'],
> = ResolversObject<{
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  period?: Resolver<ResolversTypes['CandidateProfileSalaryPeriod'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['CandidateProfileSalaryType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CandidateProfileProfileResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CandidateProfileProfile'] = ResolversParentTypes['CandidateProfileProfile'],
> = ResolversObject<{
  basicInfo?: Resolver<Maybe<ResolversTypes['CandidateProfileBasicInfo']>, ParentType, ContextType>;
  completeness?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  drivingLicense?: Resolver<
    Maybe<Array<ResolversTypes['CandidateProfileDrivingLicenseCategory']>>,
    ParentType,
    ContextType
  >;
  education?: Resolver<Array<ResolversTypes['CandidateProfileSchool']>, ParentType, ContextType>;
  experience?: Resolver<
    Maybe<Array<ResolversTypes['CandidateProfileExperience']>>,
    ParentType,
    ContextType
  >;
  hobby?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  languages?: Resolver<
    Maybe<Array<ResolversTypes['CandidateProfileLanguageSkill']>>,
    ParentType,
    ContextType
  >;
  skills?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CandidateProfileQueryResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CandidateProfileQuery'] = ResolversParentTypes['CandidateProfileQuery'],
> = ResolversObject<{
  Application?: Resolver<
    Maybe<ResolversTypes['CandidateProfileApplication']>,
    ParentType,
    ContextType,
    RequireFields<CandidateProfileQueryApplicationArgs, 'applicationID'>
  >;
  ApplicationProfile?: Resolver<
    ResolversTypes['CandidateProfileProfile'],
    ParentType,
    ContextType,
    RequireFields<CandidateProfileQueryApplicationProfileArgs, 'applicationId'>
  >;
  ApplicationsCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  ApplicationsList?: Resolver<
    ResolversTypes['CandidateProfileApplicationsList'],
    ParentType,
    ContextType,
    RequireFields<CandidateProfileQueryApplicationsListArgs, 'limit'>
  >;
  ApplyQuestions?: Resolver<
    Maybe<Array<ResolversTypes['ApplyQuestion']>>,
    ParentType,
    ContextType,
    RequireFields<CandidateProfileQueryApplyQuestionsArgs, 'adID'>
  >;
  ApplyValidation?: Resolver<
    Maybe<ResolversTypes['CandidateProfileApplyValidation']>,
    ParentType,
    ContextType,
    RequireFields<CandidateProfileQueryApplyValidationArgs, 'adID'>
  >;
  AutoSuggest?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['CandidateProfileSuggestion']>>>,
    ParentType,
    ContextType,
    RequireFields<CandidateProfileQueryAutoSuggestArgs, 'phrase' | 'type'>
  >;
  CV?: Resolver<Maybe<ResolversTypes['CandidateProfileCV']>, ParentType, ContextType>;
  CVGeneratorTokenProvider?: Resolver<
    Maybe<ResolversTypes['CandidateProfileCVGeneratorToken']>,
    ParentType,
    ContextType,
    Partial<CandidateProfileQueryCvGeneratorTokenProviderArgs>
  >;
  CVParsingResult?: Resolver<ResolversTypes['CVParsingResult'], ParentType, ContextType>;
  Experiment?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType,
    RequireFields<CandidateProfileQueryExperimentArgs, 'alias'>
  >;
  IsJobSeeker?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  LatestApplication?: Resolver<
    Maybe<ResolversTypes['CandidateProfileLatestApplication']>,
    ParentType,
    ContextType,
    RequireFields<CandidateProfileQueryLatestApplicationArgs, 'adId'>
  >;
  Preferences?: Resolver<ResolversTypes['CandidateProfilePreferences'], ParentType, ContextType>;
  Profile?: Resolver<ResolversTypes['CandidateProfileProfile'], ParentType, ContextType>;
  ProfileCountryOptions?: Resolver<
    ResolversTypes['CandidateProfileCountryOptions'],
    ParentType,
    ContextType
  >;
  ProposedSkills?: Resolver<Array<Maybe<ResolversTypes['String']>>, ParentType, ContextType>;
  Recommendations?: Resolver<
    Array<ResolversTypes['CandidateProfileRecommendation']>,
    ParentType,
    ContextType,
    RequireFields<CandidateProfileQueryRecommendationsArgs, 'param'>
  >;
  RecommendationsV2?: Resolver<
    Array<ResolversTypes['CandidateProfileRecommendationJobOffer']>,
    ParentType,
    ContextType,
    RequireFields<CandidateProfileQueryRecommendationsV2Args, 'param'>
  >;
  Settings?: Resolver<ResolversTypes['CandidateProfileSettings'], ParentType, ContextType>;
  UploadData?: Resolver<ResolversTypes['CandidateProfileUploadData'], ParentType, ContextType>;
  UploadToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CandidateProfileRecommendationResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CandidateProfileRecommendation'] = ResolversParentTypes['CandidateProfileRecommendation'],
> = ResolversObject<{
  adId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  addedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  categoryId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  cityName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contractType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  districtName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rawParams?: Resolver<
    Array<ResolversTypes['CandidateProfileRecommendationRawParam']>,
    ParentType,
    ContextType
  >;
  salaryCurrency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  salaryMax?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  salaryMin?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  salaryPeriod?: Resolver<
    Maybe<ResolversTypes['CandidateProfileSalaryPeriod']>,
    ParentType,
    ContextType
  >;
  source?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  workingHours?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CandidateProfileRecommendationJobOfferResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CandidateProfileRecommendationJobOffer'] = ResolversParentTypes['CandidateProfileRecommendationJobOffer'],
> = ResolversObject<{
  ad?: Resolver<Maybe<ResolversTypes['JobOfferOffer']>, ParentType, ContextType>;
  adId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  source?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CandidateProfileRecommendationRawParamResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CandidateProfileRecommendationRawParam'] = ResolversParentTypes['CandidateProfileRecommendationRawParam'],
> = ResolversObject<{
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CandidateProfileSchoolResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CandidateProfileSchool'] = ResolversParentTypes['CandidateProfileSchool'],
> = ResolversObject<{
  endYear?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ongoing?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  specialty?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  startYear?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CandidateProfileSettingsResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CandidateProfileSettings'] = ResolversParentTypes['CandidateProfileSettings'],
> = ResolversObject<{
  candidatesDatabaseConsent?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  dashboardEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  notifications?: Resolver<
    ResolversTypes['CandidateProfileNotificationsSettings'],
    ParentType,
    ContextType
  >;
  visibility?: Resolver<
    Maybe<ResolversTypes['CandidateProfileVisibility']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CandidateProfileSuggestionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CandidateProfileSuggestion'] = ResolversParentTypes['CandidateProfileSuggestion'],
> = ResolversObject<{
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CandidateProfileUploadDataResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CandidateProfileUploadData'] = ResolversParentTypes['CandidateProfileUploadData'],
> = ResolversObject<{
  token?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ChatAttachmentResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['ChatAttachment'] = ResolversParentTypes['ChatAttachment'],
> = ResolversObject<{
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  secureUrl?: Resolver<ResolversTypes['SecureUrl'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ChatConversationResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['ChatConversation'] = ResolversParentTypes['ChatConversation'],
> = ResolversObject<{
  archived?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  blocked?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  messages?: Resolver<Array<ResolversTypes['ChatMessage']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ChatMessageResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ChatMessage'] = ResolversParentTypes['ChatMessage'],
> = ResolversObject<{
  attachments?: Resolver<Maybe<Array<ResolversTypes['ChatAttachment']>>, ParentType, ContextType>;
  author?: Resolver<ResolversTypes['MessageAuthor'], ParentType, ContextType>;
  conversationId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  seen?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CompanyProfileAboutResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CompanyProfileAbout'] = ResolversParentTypes['CompanyProfileAbout'],
> = ResolversObject<{
  companyName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logoUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tagline?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CompanyProfileAdditionalInfoResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CompanyProfileAdditionalInfo'] = ResolversParentTypes['CompanyProfileAdditionalInfo'],
> = ResolversObject<{
  companySize?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  companyUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  facebookUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  headquarters?: Resolver<Maybe<ResolversTypes['CompanyProfileLocation']>, ParentType, ContextType>;
  industry?: Resolver<Maybe<ResolversTypes['CompanyProfileIndustry']>, ParentType, ContextType>;
  instagramUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  linkedinUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  twitterUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  youtubeUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CompanyProfileAdsResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CompanyProfileAds'] = ResolversParentTypes['CompanyProfileAds'],
> = ResolversObject<{
  ads?: Resolver<Array<ResolversTypes['JobOfferOffer']>, ParentType, ContextType>;
  aggregations?: Resolver<ResolversTypes['CompanyProfileAdsAggregations'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CompanyProfileAdsAggregationResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CompanyProfileAdsAggregation'] = ResolversParentTypes['CompanyProfileAdsAggregation'],
> = ResolversObject<{
  type?: Resolver<ResolversTypes['CompanyProfileAdsAggregationType'], ParentType, ContextType>;
  values?: Resolver<
    Array<ResolversTypes['CompanyProfileAdsAggregationValue']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CompanyProfileAdsAggregationValueResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CompanyProfileAdsAggregationValue'] = ResolversParentTypes['CompanyProfileAdsAggregationValue'],
> = ResolversObject<{
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CompanyProfileAdsAggregationsResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CompanyProfileAdsAggregations'] = ResolversParentTypes['CompanyProfileAdsAggregations'],
> = ResolversObject<{
  categories?: Resolver<ResolversTypes['CompanyProfileAdsAggregation'], ParentType, ContextType>;
  cities?: Resolver<ResolversTypes['CompanyProfileAdsAggregation'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CompanyProfileBaseProfileResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CompanyProfileBaseProfile'] = ResolversParentTypes['CompanyProfileBaseProfile'],
> = ResolversObject<{
  __resolveType: TypeResolveFn<
    'CompanyProfilePrivateProfile' | 'CompanyProfilePublicProfile',
    ParentType,
    ContextType
  >;
  about?: Resolver<Maybe<ResolversTypes['CompanyProfileAbout']>, ParentType, ContextType>;
  additionalInfo?: Resolver<
    Maybe<ResolversTypes['CompanyProfileAdditionalInfo']>,
    ParentType,
    ContextType
  >;
  benefits?: Resolver<Maybe<ResolversTypes['CompanyProfileBenefits']>, ParentType, ContextType>;
  contact?: Resolver<Maybe<ResolversTypes['CompanyProfileContact']>, ParentType, ContextType>;
  header?: Resolver<Maybe<ResolversTypes['CompanyProfileHeader']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lifeAt?: Resolver<Maybe<ResolversTypes['CompanyProfileLifeAt']>, ParentType, ContextType>;
  publishedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  recruitment?: Resolver<
    Maybe<ResolversTypes['CompanyProfileRecruitment']>,
    ParentType,
    ContextType
  >;
  slug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userUuid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
}>;

export type CompanyProfileBenefitsResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CompanyProfileBenefits'] = ResolversParentTypes['CompanyProfileBenefits'],
> = ResolversObject<{
  items?: Resolver<Maybe<Array<ResolversTypes['CompanyProfileBenefit']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CompanyProfileConfigResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CompanyProfileConfig'] = ResolversParentTypes['CompanyProfileConfig'],
> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  relations?: Resolver<ResolversTypes['CompanyProfileConfigRelations'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CompanyProfileConfigFeatureBannerResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CompanyProfileConfigFeatureBanner'] = ResolversParentTypes['CompanyProfileConfigFeatureBanner'],
> = ResolversObject<{
  enabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CompanyProfileConfigFeatureBaseResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CompanyProfileConfigFeatureBase'] = ResolversParentTypes['CompanyProfileConfigFeatureBase'],
> = ResolversObject<{
  __resolveType: TypeResolveFn<
    | 'CompanyProfileConfigFeatureBanner'
    | 'CompanyProfileConfigFeatureBenefits'
    | 'CompanyProfileConfigFeatureCompanyUrl'
    | 'CompanyProfileConfigFeatureFollowButton'
    | 'CompanyProfileConfigFeatureGallery'
    | 'CompanyProfileConfigFeatureLogo'
    | 'CompanyProfileConfigFeatureMultiprofile'
    | 'CompanyProfileConfigFeaturePromotedOnListing'
    | 'CompanyProfileConfigFeatureRecruitment'
    | 'CompanyProfileConfigFeatureSocialLinks',
    ParentType,
    ContextType
  >;
  enabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
}>;

export type CompanyProfileConfigFeatureBenefitsResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CompanyProfileConfigFeatureBenefits'] = ResolversParentTypes['CompanyProfileConfigFeatureBenefits'],
> = ResolversObject<{
  enabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CompanyProfileConfigFeatureCompanyUrlResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CompanyProfileConfigFeatureCompanyUrl'] = ResolversParentTypes['CompanyProfileConfigFeatureCompanyUrl'],
> = ResolversObject<{
  enabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CompanyProfileConfigFeatureFollowButtonResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CompanyProfileConfigFeatureFollowButton'] = ResolversParentTypes['CompanyProfileConfigFeatureFollowButton'],
> = ResolversObject<{
  enabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CompanyProfileConfigFeatureGalleryResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CompanyProfileConfigFeatureGallery'] = ResolversParentTypes['CompanyProfileConfigFeatureGallery'],
> = ResolversObject<{
  enabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  maxPhotos?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CompanyProfileConfigFeatureLogoResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CompanyProfileConfigFeatureLogo'] = ResolversParentTypes['CompanyProfileConfigFeatureLogo'],
> = ResolversObject<{
  enabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CompanyProfileConfigFeatureMultiprofileResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CompanyProfileConfigFeatureMultiprofile'] = ResolversParentTypes['CompanyProfileConfigFeatureMultiprofile'],
> = ResolversObject<{
  enabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CompanyProfileConfigFeaturePromotedOnListingResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CompanyProfileConfigFeaturePromotedOnListing'] = ResolversParentTypes['CompanyProfileConfigFeaturePromotedOnListing'],
> = ResolversObject<{
  enabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CompanyProfileConfigFeatureRecruitmentResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CompanyProfileConfigFeatureRecruitment'] = ResolversParentTypes['CompanyProfileConfigFeatureRecruitment'],
> = ResolversObject<{
  enabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CompanyProfileConfigFeatureSocialLinksResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CompanyProfileConfigFeatureSocialLinks'] = ResolversParentTypes['CompanyProfileConfigFeatureSocialLinks'],
> = ResolversObject<{
  enabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CompanyProfileConfigFeaturesResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CompanyProfileConfigFeatures'] = ResolversParentTypes['CompanyProfileConfigFeatures'],
> = ResolversObject<{
  banner?: Resolver<
    Maybe<ResolversTypes['CompanyProfileConfigFeatureBanner']>,
    ParentType,
    ContextType
  >;
  benefits?: Resolver<
    Maybe<ResolversTypes['CompanyProfileConfigFeatureBenefits']>,
    ParentType,
    ContextType
  >;
  companyUrl?: Resolver<
    Maybe<ResolversTypes['CompanyProfileConfigFeatureCompanyUrl']>,
    ParentType,
    ContextType
  >;
  followButton?: Resolver<
    Maybe<ResolversTypes['CompanyProfileConfigFeatureFollowButton']>,
    ParentType,
    ContextType
  >;
  gallery?: Resolver<
    Maybe<ResolversTypes['CompanyProfileConfigFeatureGallery']>,
    ParentType,
    ContextType
  >;
  logo?: Resolver<
    Maybe<ResolversTypes['CompanyProfileConfigFeatureLogo']>,
    ParentType,
    ContextType
  >;
  multiprofile?: Resolver<
    Maybe<ResolversTypes['CompanyProfileConfigFeatureMultiprofile']>,
    ParentType,
    ContextType
  >;
  promotedOnListing?: Resolver<
    Maybe<ResolversTypes['CompanyProfileConfigFeaturePromotedOnListing']>,
    ParentType,
    ContextType
  >;
  recruitment?: Resolver<
    Maybe<ResolversTypes['CompanyProfileConfigFeatureRecruitment']>,
    ParentType,
    ContextType
  >;
  socialLinks?: Resolver<
    Maybe<ResolversTypes['CompanyProfileConfigFeatureSocialLinks']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CompanyProfileConfigRelationsResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CompanyProfileConfigRelations'] = ResolversParentTypes['CompanyProfileConfigRelations'],
> = ResolversObject<{
  isMainProfile?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  subProfiles?: Resolver<
    Maybe<Array<ResolversTypes['CompanyProfileConfigSubProfile']>>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CompanyProfileConfigSubProfileResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CompanyProfileConfigSubProfile'] = ResolversParentTypes['CompanyProfileConfigSubProfile'],
> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CompanyProfileContactResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CompanyProfileContact'] = ResolversParentTypes['CompanyProfileContact'],
> = ResolversObject<{
  companyName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  headquarters?: Resolver<Maybe<ResolversTypes['CompanyProfileLocation']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CompanyProfileHeaderResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CompanyProfileHeader'] = ResolversParentTypes['CompanyProfileHeader'],
> = ResolversObject<{
  bannerUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CompanyProfileLifeAtResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CompanyProfileLifeAt'] = ResolversParentTypes['CompanyProfileLifeAt'],
> = ResolversObject<{
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  items?: Resolver<
    Maybe<Array<ResolversTypes['CompanyProfileLifeAtItem']>>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CompanyProfileLifeAtItemResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CompanyProfileLifeAtItem'] = ResolversParentTypes['CompanyProfileLifeAtItem'],
> = ResolversObject<{
  __resolveType: TypeResolveFn<
    'CompanyProfileLifeAtItemExternalVideo' | 'CompanyProfileLifeAtItemImage',
    ParentType,
    ContextType
  >;
}>;

export type CompanyProfileLifeAtItemExternalVideoResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CompanyProfileLifeAtItemExternalVideo'] = ResolversParentTypes['CompanyProfileLifeAtItemExternalVideo'],
> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['CompanyProfileLifeAtItemType'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CompanyProfileLifeAtItemImageResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CompanyProfileLifeAtItemImage'] = ResolversParentTypes['CompanyProfileLifeAtItemImage'],
> = ResolversObject<{
  fileId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['CompanyProfileLifeAtItemType'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CompanyProfileLocationResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CompanyProfileLocation'] = ResolversParentTypes['CompanyProfileLocation'],
> = ResolversObject<{
  city?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lat?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  lng?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  region?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  streetName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  streetNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  zipCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CompanyProfileMutationResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CompanyProfileMutation'] = ResolversParentTypes['CompanyProfileMutation'],
> = ResolversObject<{
  confirmAssets?: Resolver<
    ResolversTypes['CompanyProfilePrivateProfile'],
    ParentType,
    ContextType,
    RequireFields<CompanyProfileMutationConfirmAssetsArgs, 'input'>
  >;
  deleteAssets?: Resolver<
    ResolversTypes['CompanyProfilePrivateProfile'],
    ParentType,
    ContextType,
    RequireFields<CompanyProfileMutationDeleteAssetsArgs, 'input'>
  >;
  deleteData?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  publishProfile?: Resolver<
    ResolversTypes['CompanyProfilePrivateProfile'],
    ParentType,
    ContextType
  >;
  saveAbout?: Resolver<
    ResolversTypes['CompanyProfilePrivateProfile'],
    ParentType,
    ContextType,
    RequireFields<CompanyProfileMutationSaveAboutArgs, 'input'>
  >;
  saveAdditionalInformation?: Resolver<
    ResolversTypes['CompanyProfilePrivateProfile'],
    ParentType,
    ContextType,
    RequireFields<CompanyProfileMutationSaveAdditionalInformationArgs, 'input'>
  >;
  saveBenefits?: Resolver<
    ResolversTypes['CompanyProfilePrivateProfile'],
    ParentType,
    ContextType,
    RequireFields<CompanyProfileMutationSaveBenefitsArgs, 'input'>
  >;
  saveContact?: Resolver<
    ResolversTypes['CompanyProfilePrivateProfile'],
    ParentType,
    ContextType,
    RequireFields<CompanyProfileMutationSaveContactArgs, 'input'>
  >;
  saveLifeAt?: Resolver<
    ResolversTypes['CompanyProfilePrivateProfile'],
    ParentType,
    ContextType,
    RequireFields<CompanyProfileMutationSaveLifeAtArgs, 'input'>
  >;
  saveMetadata?: Resolver<
    ResolversTypes['Metadata'],
    ParentType,
    ContextType,
    RequireFields<CompanyProfileMutationSaveMetadataArgs, 'input'>
  >;
  saveRecruitment?: Resolver<
    ResolversTypes['CompanyProfilePrivateProfile'],
    ParentType,
    ContextType,
    RequireFields<CompanyProfileMutationSaveRecruitmentArgs, 'input'>
  >;
  unpublishProfile?: Resolver<
    ResolversTypes['CompanyProfilePrivateProfile'],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CompanyProfilePrivateConfigResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CompanyProfilePrivateConfig'] = ResolversParentTypes['CompanyProfilePrivateConfig'],
> = ResolversObject<{
  features?: Resolver<ResolversTypes['CompanyProfileConfigFeatures'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  relations?: Resolver<
    ResolversTypes['CompanyProfilePrivateConfigRelations'],
    ParentType,
    ContextType
  >;
  tier?: Resolver<ResolversTypes['CompanyProfilePrivateConfigTier'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CompanyProfilePrivateConfigRelationsResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CompanyProfilePrivateConfigRelations'] = ResolversParentTypes['CompanyProfilePrivateConfigRelations'],
> = ResolversObject<{
  isMainProfile?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  subProfiles?: Resolver<
    Maybe<Array<ResolversTypes['CompanyProfilePrivateConfigSubProfile']>>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CompanyProfilePrivateConfigSubProfileResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CompanyProfilePrivateConfigSubProfile'] = ResolversParentTypes['CompanyProfilePrivateConfigSubProfile'],
> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CompanyProfilePrivateConfigTierResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CompanyProfilePrivateConfigTier'] = ResolversParentTypes['CompanyProfilePrivateConfigTier'],
> = ResolversObject<{
  expireAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['CompanyProfileTierType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CompanyProfilePrivateProfileResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CompanyProfilePrivateProfile'] = ResolversParentTypes['CompanyProfilePrivateProfile'],
> = ResolversObject<{
  about?: Resolver<Maybe<ResolversTypes['CompanyProfileAbout']>, ParentType, ContextType>;
  additionalInfo?: Resolver<
    Maybe<ResolversTypes['CompanyProfileAdditionalInfo']>,
    ParentType,
    ContextType
  >;
  benefits?: Resolver<Maybe<ResolversTypes['CompanyProfileBenefits']>, ParentType, ContextType>;
  contact?: Resolver<Maybe<ResolversTypes['CompanyProfileContact']>, ParentType, ContextType>;
  header?: Resolver<Maybe<ResolversTypes['CompanyProfileHeader']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lifeAt?: Resolver<Maybe<ResolversTypes['CompanyProfileLifeAt']>, ParentType, ContextType>;
  publishedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  recruitment?: Resolver<
    Maybe<ResolversTypes['CompanyProfileRecruitment']>,
    ParentType,
    ContextType
  >;
  slug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userUuid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CompanyProfileProfileCountersResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CompanyProfileProfileCounters'] = ResolversParentTypes['CompanyProfileProfileCounters'],
> = ResolversObject<{
  ads?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  cities?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CompanyProfileProfilesCarouselResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CompanyProfileProfilesCarousel'] = ResolversParentTypes['CompanyProfileProfilesCarousel'],
> = ResolversObject<{
  profiles?: Resolver<
    Array<ResolversTypes['CompanyProfileProfilesCarouselProfile']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CompanyProfileProfilesCarouselProfileResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CompanyProfileProfilesCarouselProfile'] = ResolversParentTypes['CompanyProfileProfilesCarouselProfile'],
> = ResolversObject<{
  bannerUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  companyName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  counters?: Resolver<ResolversTypes['CompanyProfileProfileCounters'], ParentType, ContextType>;
  headquarters?: Resolver<ResolversTypes['CompanyProfileLocation'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  industry?: Resolver<ResolversTypes['CompanyProfileIndustry'], ParentType, ContextType>;
  logoUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CompanyProfileProfilesListingResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CompanyProfileProfilesListing'] = ResolversParentTypes['CompanyProfileProfilesListing'],
> = ResolversObject<{
  profiles?: Resolver<
    Array<ResolversTypes['CompanyProfileProfilesListingProfile']>,
    ParentType,
    ContextType
  >;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CompanyProfileProfilesListingProfileResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CompanyProfileProfilesListingProfile'] = ResolversParentTypes['CompanyProfileProfilesListingProfile'],
> = ResolversObject<{
  bannerUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  companyName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  counters?: Resolver<ResolversTypes['CompanyProfileProfileCounters'], ParentType, ContextType>;
  headquarters?: Resolver<ResolversTypes['CompanyProfileLocation'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  industry?: Resolver<ResolversTypes['CompanyProfileIndustry'], ParentType, ContextType>;
  logoUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CompanyProfilePublicConfigResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CompanyProfilePublicConfig'] = ResolversParentTypes['CompanyProfilePublicConfig'],
> = ResolversObject<{
  features?: Resolver<ResolversTypes['CompanyProfileConfigFeatures'], ParentType, ContextType>;
  tier?: Resolver<ResolversTypes['CompanyProfileTierType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CompanyProfilePublicProfileResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CompanyProfilePublicProfile'] = ResolversParentTypes['CompanyProfilePublicProfile'],
> = ResolversObject<{
  about?: Resolver<Maybe<ResolversTypes['CompanyProfileAbout']>, ParentType, ContextType>;
  additionalInfo?: Resolver<
    Maybe<ResolversTypes['CompanyProfileAdditionalInfo']>,
    ParentType,
    ContextType
  >;
  benefits?: Resolver<Maybe<ResolversTypes['CompanyProfileBenefits']>, ParentType, ContextType>;
  config?: Resolver<ResolversTypes['CompanyProfilePublicConfig'], ParentType, ContextType>;
  contact?: Resolver<Maybe<ResolversTypes['CompanyProfileContact']>, ParentType, ContextType>;
  header?: Resolver<Maybe<ResolversTypes['CompanyProfileHeader']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lifeAt?: Resolver<Maybe<ResolversTypes['CompanyProfileLifeAt']>, ParentType, ContextType>;
  publishedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  recruitment?: Resolver<
    Maybe<ResolversTypes['CompanyProfileRecruitment']>,
    ParentType,
    ContextType
  >;
  slug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userUuid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CompanyProfileQueryResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CompanyProfileQuery'] = ResolversParentTypes['CompanyProfileQuery'],
> = ResolversObject<{
  ads?: Resolver<
    ResolversTypes['CompanyProfileAds'],
    ParentType,
    ContextType,
    RequireFields<CompanyProfileQueryAdsArgs, 'input'>
  >;
  employerSegment?: Resolver<
    ResolversTypes['EmployerSegmentResponse'],
    ParentType,
    ContextType,
    RequireFields<CompanyProfileQueryEmployerSegmentArgs, 'atlasUserId'>
  >;
  locationSuggestions?: Resolver<
    Array<ResolversTypes['LocationSuggestion']>,
    ParentType,
    ContextType,
    RequireFields<CompanyProfileQueryLocationSuggestionsArgs, 'phrase'>
  >;
  metadata?: Resolver<ResolversTypes['Metadata'], ParentType, ContextType>;
  previewProfile?: Resolver<
    Maybe<ResolversTypes['CompanyProfilePublicProfile']>,
    ParentType,
    ContextType
  >;
  privateConfig?: Resolver<ResolversTypes['CompanyProfilePrivateConfig'], ParentType, ContextType>;
  privateProfile?: Resolver<
    Maybe<ResolversTypes['CompanyProfilePrivateProfile']>,
    ParentType,
    ContextType
  >;
  profile?: Resolver<
    Maybe<ResolversTypes['EmployerProfile']>,
    ParentType,
    ContextType,
    RequireFields<CompanyProfileQueryProfileArgs, 'uuid'>
  >;
  profileConfig?: Resolver<ResolversTypes['CompanyProfileConfig'], ParentType, ContextType>;
  profileV2?: Resolver<
    Maybe<ResolversTypes['EmployerProfile']>,
    ParentType,
    ContextType,
    RequireFields<CompanyProfileQueryProfileV2Args, 'input'>
  >;
  profiles?: Resolver<
    Array<ResolversTypes['EmployerProfile']>,
    ParentType,
    ContextType,
    RequireFields<CompanyProfileQueryProfilesArgs, 'input'>
  >;
  profilesCarousel?: Resolver<
    ResolversTypes['CompanyProfileProfilesCarousel'],
    ParentType,
    ContextType,
    RequireFields<CompanyProfileQueryProfilesCarouselArgs, 'input'>
  >;
  profilesListing?: Resolver<
    ResolversTypes['CompanyProfileProfilesListing'],
    ParentType,
    ContextType,
    RequireFields<CompanyProfileQueryProfilesListingArgs, 'input'>
  >;
  publicProfileBySlug?: Resolver<
    Maybe<ResolversTypes['CompanyProfilePublicProfile']>,
    ParentType,
    ContextType,
    RequireFields<CompanyProfileQueryPublicProfileBySlugArgs, 'slug'>
  >;
  publicProfileByUuid?: Resolver<
    Maybe<ResolversTypes['CompanyProfilePublicProfile']>,
    ParentType,
    ContextType,
    RequireFields<CompanyProfileQueryPublicProfileByUuidArgs, 'uuid'>
  >;
  publicProfiles?: Resolver<
    Array<ResolversTypes['CompanyProfilePublicProfile']>,
    ParentType,
    ContextType,
    RequireFields<CompanyProfileQueryPublicProfilesArgs, 'input'>
  >;
  uploadRequestData?: Resolver<ResolversTypes['UploadRequestDataPayload'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CompanyProfileRecruitmentResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CompanyProfileRecruitment'] = ResolversParentTypes['CompanyProfileRecruitment'],
> = ResolversObject<{
  items?: Resolver<
    Maybe<Array<ResolversTypes['CompanyProfileRecruitmentProcess']>>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CompanyProfileRecruitmentProcessResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CompanyProfileRecruitmentProcess'] = ResolversParentTypes['CompanyProfileRecruitmentProcess'],
> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  steps?: Resolver<
    Array<ResolversTypes['CompanyProfileRecruitmentProcessStep']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CompanyProfileRecruitmentProcessStepResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CompanyProfileRecruitmentProcessStep'] = ResolversParentTypes['CompanyProfileRecruitmentProcessStep'],
> = ResolversObject<{
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type EmployerLeadResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['EmployerLead'] = ResolversParentTypes['EmployerLead'],
> = ResolversObject<{
  closed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  exists?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type EmployerPanelMutationResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['EmployerPanelMutation'] = ResolversParentTypes['EmployerPanelMutation'],
> = ResolversObject<{
  blockUser?: Resolver<
    ResolversTypes['Boolean'],
    ParentType,
    ContextType,
    RequireFields<EmployerPanelMutationBlockUserArgs, 'candidateId'>
  >;
  changeMultiAppStatus?: Resolver<
    ResolversTypes['MultiApplication'],
    ParentType,
    ContextType,
    RequireFields<EmployerPanelMutationChangeMultiAppStatusArgs, 'input'>
  >;
  closeEmployerLead?: Resolver<
    ResolversTypes['EmployerLead'],
    ParentType,
    ContextType,
    RequireFields<EmployerPanelMutationCloseEmployerLeadArgs, 'type'>
  >;
  deleteMultiAppWithChat?: Resolver<
    ResolversTypes['Boolean'],
    ParentType,
    ContextType,
    RequireFields<EmployerPanelMutationDeleteMultiAppWithChatArgs, 'input'>
  >;
  editMultiAppNote?: Resolver<
    ResolversTypes['MultiApplication'],
    ParentType,
    ContextType,
    RequireFields<EmployerPanelMutationEditMultiAppNoteArgs, 'input'>
  >;
  markMultiAppAsRead?: Resolver<
    ResolversTypes['MultiApplication'],
    ParentType,
    ContextType,
    RequireFields<EmployerPanelMutationMarkMultiAppAsReadArgs, 'applicationId'>
  >;
  offerDelete?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType,
    RequireFields<EmployerPanelMutationOfferDeleteArgs, 'id'>
  >;
  removeApplyQuestionFromAd?: Resolver<
    Array<Maybe<ResolversTypes['ApplyQuestion']>>,
    ParentType,
    ContextType,
    RequireFields<EmployerPanelMutationRemoveApplyQuestionFromAdArgs, 'input'>
  >;
  saveAdvancedQuestionsToAd?: Resolver<
    Array<Maybe<ResolversTypes['ApplyQuestion']>>,
    ParentType,
    ContextType,
    RequireFields<EmployerPanelMutationSaveAdvancedQuestionsToAdArgs, 'input'>
  >;
  saveApplyQuestionToAd?: Resolver<
    Array<Maybe<ResolversTypes['ApplyQuestion']>>,
    ParentType,
    ContextType,
    RequireFields<EmployerPanelMutationSaveApplyQuestionToAdArgs, 'input'>
  >;
  saveMultiAppMeetingDate?: Resolver<
    ResolversTypes['MultiApplication'],
    ParentType,
    ContextType,
    RequireFields<EmployerPanelMutationSaveMultiAppMeetingDateArgs, 'input'>
  >;
  saveQuestionsToAd?: Resolver<
    Array<Maybe<ResolversTypes['ApplyQuestion']>>,
    ParentType,
    ContextType,
    Partial<EmployerPanelMutationSaveQuestionsToAdArgs>
  >;
  sendMessage?: Resolver<
    ResolversTypes['ChatMessage'],
    ParentType,
    ContextType,
    RequireFields<EmployerPanelMutationSendMessageArgs, 'input'>
  >;
  setMultiAppRate?: Resolver<
    ResolversTypes['MultiApplication'],
    ParentType,
    ContextType,
    RequireFields<EmployerPanelMutationSetMultiAppRateArgs, 'input'>
  >;
  unblockUser?: Resolver<
    ResolversTypes['Boolean'],
    ParentType,
    ContextType,
    RequireFields<EmployerPanelMutationUnblockUserArgs, 'candidateId'>
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type EmployerPanelQueryResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['EmployerPanelQuery'] = ResolversParentTypes['EmployerPanelQuery'],
> = ResolversObject<{
  applyQuestionsByAdId?: Resolver<
    Array<ResolversTypes['ApplyQuestion']>,
    ParentType,
    ContextType,
    RequireFields<EmployerPanelQueryApplyQuestionsByAdIdArgs, 'input'>
  >;
  getAllPredefinedAQ?: Resolver<
    Array<Maybe<ResolversTypes['ApplyQuestion']>>,
    ParentType,
    ContextType,
    RequireFields<EmployerPanelQueryGetAllPredefinedAqArgs, 'excludeDefault'>
  >;
  getApolloToken?: Resolver<ResolversTypes['ApolloToken'], ParentType, ContextType>;
  getApplicationAttachments?: Resolver<
    Maybe<ResolversTypes['ApplicationAttachments']>,
    ParentType,
    ContextType,
    RequireFields<EmployerPanelQueryGetApplicationAttachmentsArgs, 'applicationId'>
  >;
  getCandidateProfile?: Resolver<
    ResolversTypes['CandidateProfile'],
    ParentType,
    ContextType,
    RequireFields<EmployerPanelQueryGetCandidateProfileArgs, 'applicationId'>
  >;
  getChatConversation?: Resolver<
    ResolversTypes['ChatConversation'],
    ParentType,
    ContextType,
    RequireFields<EmployerPanelQueryGetChatConversationArgs, 'applicationId'>
  >;
  getCvGeneratorToken?: Resolver<ResolversTypes['CVGeneratorOutput'], ParentType, ContextType>;
  getEmployerLead?: Resolver<
    ResolversTypes['EmployerLead'],
    ParentType,
    ContextType,
    RequireFields<EmployerPanelQueryGetEmployerLeadArgs, 'type'>
  >;
  getEmployerSegment?: Resolver<ResolversTypes['EmployerSegmentResponse'], ParentType, ContextType>;
  getProfileData?: Resolver<
    ResolversTypes['CandidateProfile'],
    ParentType,
    ContextType,
    RequireFields<EmployerPanelQueryGetProfileDataArgs, 'applicationId'>
  >;
  multiAppByAppIds?: Resolver<
    Array<ResolversTypes['MultiApplication']>,
    ParentType,
    ContextType,
    RequireFields<EmployerPanelQueryMultiAppByAppIdsArgs, 'applicationIds'>
  >;
  multiAppIds?: Resolver<
    Array<ResolversTypes['String']>,
    ParentType,
    ContextType,
    RequireFields<EmployerPanelQueryMultiAppIdsArgs, 'input'>
  >;
  offerById?: Resolver<
    ResolversTypes['JobAd'],
    ParentType,
    ContextType,
    RequireFields<EmployerPanelQueryOfferByIdArgs, 'id'>
  >;
  offerDelete?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType,
    RequireFields<EmployerPanelQueryOfferDeleteArgs, 'id'>
  >;
  offerIds?: Resolver<
    Array<ResolversTypes['String']>,
    ParentType,
    ContextType,
    Partial<EmployerPanelQueryOfferIdsArgs>
  >;
  offersByIds?: Resolver<
    Array<ResolversTypes['JobAd']>,
    ParentType,
    ContextType,
    RequireFields<EmployerPanelQueryOffersByIdsArgs, 'adIds'>
  >;
  stafflyGetTestResult?: Resolver<
    Maybe<ResolversTypes['StafflyTestResult']>,
    ParentType,
    ContextType,
    RequireFields<EmployerPanelQueryStafflyGetTestResultArgs, 'applicationId'>
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type EmployerProfileResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['EmployerProfile'] = ResolversParentTypes['EmployerProfile'],
> = ResolversObject<{
  atlasUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bannerUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  benefits?: Resolver<Maybe<Array<ResolversTypes['BenefitType']>>, ParentType, ContextType>;
  companyName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  companySize?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  companyUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  facebookUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  gdpr?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  headquarters?: Resolver<Maybe<ResolversTypes['LocationPayload']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  industry?: Resolver<Maybe<ResolversTypes['Industry']>, ParentType, ContextType>;
  instagramUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lifeAt?: Resolver<Maybe<ResolversTypes['LifeAt']>, ParentType, ContextType>;
  linkedinUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logoUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mobileBannerUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  publishedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  recruitment?: Resolver<
    Maybe<Array<ResolversTypes['RecruitmentProcess']>>,
    ParentType,
    ContextType
  >;
  slug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tagline?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  twitterUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  youtubeUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type EmployerSegmentResponseResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['EmployerSegmentResponse'] = ResolversParentTypes['EmployerSegmentResponse'],
> = ResolversObject<{
  employerSegment?: Resolver<ResolversTypes['EmployerSegment'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['EmployerSegment'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type HomepageArticleResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['HomepageArticle'] = ResolversParentTypes['HomepageArticle'],
> = ResolversObject<{
  URL?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  imageThumbnail?: Resolver<Maybe<ResolversTypes['ImageThumbnail']>, ParentType, ContextType>;
  imageURL?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type HomepageFeaturedCategoryResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['HomepageFeaturedCategory'] = ResolversParentTypes['HomepageFeaturedCategory'],
> = ResolversObject<{
  ID?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type HomepageFeaturedEmployerResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['HomepageFeaturedEmployer'] = ResolversParentTypes['HomepageFeaturedEmployer'],
> = ResolversObject<{
  ID?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  UUID?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  bannerURL?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  locationCounter?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  logoURL?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  openPositionCounter?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type HomepageQueryResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['HomepageQuery'] = ResolversParentTypes['HomepageQuery'],
> = ResolversObject<{
  FeaturedCategories?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['HomepageFeaturedCategory']>>>,
    ParentType,
    ContextType
  >;
  FeaturedEmployers?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['HomepageFeaturedEmployer']>>>,
    ParentType,
    ContextType
  >;
  LatestArticles?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['HomepageArticle']>>>,
    ParentType,
    ContextType,
    RequireFields<HomepageQueryLatestArticlesArgs, 'amount'>
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ImageThumbnailResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['ImageThumbnail'] = ResolversParentTypes['ImageThumbnail'],
> = ResolversObject<{
  s?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  xs?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type JobAdResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['JobAd'] = ResolversParentTypes['JobAd'],
> = ResolversObject<{
  addedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  cdbCounter?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  cityName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  counters?: Resolver<ResolversTypes['JobAdCounters'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  districtName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  salaryValue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  trackingParameters?: Resolver<ResolversTypes['JobAdTrackingParameters'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  validTo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type JobAdCountersResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['JobAdCounters'] = ResolversParentTypes['JobAdCounters'],
> = ResolversObject<{
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  newApplications?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  rejected?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  selectedForContact?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  unread?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type JobAdTrackingParametersResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['JobAdTrackingParameters'] = ResolversParentTypes['JobAdTrackingParameters'],
> = ResolversObject<{
  cat_l1_id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  cat_l1_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cat_l2_id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  cat_l2_name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  cat_l3_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  cat_l3_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cat_l4_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  cat_l4_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  category_id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  city_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  city_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  province_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  region_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type JobAdUnreadCountersResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['JobAdUnreadCounters'] = ResolversParentTypes['JobAdUnreadCounters'],
> = ResolversObject<{
  newApplications?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  rejected?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  selectedForContact?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type JobOfferCityResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['JobOfferCity'] = ResolversParentTypes['JobOfferCity'],
> = ResolversObject<{
  ID?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  map?: Resolver<ResolversTypes['JobOfferMap'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  normalized?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  regionID?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type JobOfferDistrictResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['JobOfferDistrict'] = ResolversParentTypes['JobOfferDistrict'],
> = ResolversObject<{
  ID?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  cityID?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  map?: Resolver<ResolversTypes['JobOfferMap'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type JobOfferEmployerResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['JobOfferEmployer'] = ResolversParentTypes['JobOfferEmployer'],
> = ResolversObject<{
  bannerUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  companyName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasProfile?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isVerified?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  logoThumbnails?: Resolver<
    Maybe<ResolversTypes['JobOfferEmployerLogoThumbnails']>,
    ParentType,
    ContextType
  >;
  logoUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mobileBannerUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  slug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type JobOfferEmployerLogoThumbnailsResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['JobOfferEmployerLogoThumbnails'] = ResolversParentTypes['JobOfferEmployerLogoThumbnails'],
> = ResolversObject<{
  M?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  S?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type JobOfferFloatValueResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['JobOfferFloatValue'] = ResolversParentTypes['JobOfferFloatValue'],
> = ResolversObject<{
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type JobOfferIntValueResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['JobOfferIntValue'] = ResolversParentTypes['JobOfferIntValue'],
> = ResolversObject<{
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type JobOfferLocationResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['JobOfferLocation'] = ResolversParentTypes['JobOfferLocation'],
> = ResolversObject<{
  city?: Resolver<Maybe<ResolversTypes['JobOfferCity']>, ParentType, ContextType>;
  district?: Resolver<Maybe<ResolversTypes['JobOfferDistrict']>, ParentType, ContextType>;
  map?: Resolver<ResolversTypes['JobOfferMap'], ParentType, ContextType>;
  region?: Resolver<Maybe<ResolversTypes['JobOfferRegion']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type JobOfferMapResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['JobOfferMap'] = ResolversParentTypes['JobOfferMap'],
> = ResolversObject<{
  lat?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  lon?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  radius?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  zoom?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type JobOfferOfferResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['JobOfferOffer'] = ResolversParentTypes['JobOfferOffer'],
> = ResolversObject<{
  ID?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  addedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  applyUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  categoryID?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  employer?: Resolver<ResolversTypes['JobOfferEmployer'], ParentType, ContextType>;
  isBusiness?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isSeek?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  location?: Resolver<ResolversTypes['JobOfferLocation'], ParentType, ContextType>;
  parameters?: Resolver<Array<ResolversTypes['JobOfferParameter']>, ParentType, ContextType>;
  postingComponent?: Resolver<ResolversTypes['JobOfferPostingComponent'], ParentType, ContextType>;
  salary?: Resolver<Maybe<ResolversTypes['JobOfferSalary']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userID?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  userUUID?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  validTo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type JobOfferParameterResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['JobOfferParameter'] = ResolversParentTypes['JobOfferParameter'],
> = ResolversObject<{
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  html?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  values?: Resolver<Array<Maybe<ResolversTypes['JobOfferStringValue']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type JobOfferPostingComponentResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['JobOfferPostingComponent'] = ResolversParentTypes['JobOfferPostingComponent'],
> = ResolversObject<{
  companyName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  gdprClause?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  locationBuildingNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  locationPostalCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  locationStreet?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type JobOfferQueryResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['JobOfferQuery'] = ResolversParentTypes['JobOfferQuery'],
> = ResolversObject<{
  Employer?: Resolver<
    Maybe<ResolversTypes['JobOfferEmployer']>,
    ParentType,
    ContextType,
    RequireFields<JobOfferQueryEmployerArgs, 'UUID'>
  >;
  Employers?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['JobOfferEmployer']>>>,
    ParentType,
    ContextType,
    RequireFields<JobOfferQueryEmployersArgs, 'UUIDs'>
  >;
  JobOffer?: Resolver<
    Maybe<ResolversTypes['JobOfferOffer']>,
    ParentType,
    ContextType,
    RequireFields<JobOfferQueryJobOfferArgs, 'ID'>
  >;
  JobOffers?: Resolver<
    Maybe<Array<ResolversTypes['JobOfferOffer']>>,
    ParentType,
    ContextType,
    RequireFields<JobOfferQueryJobOffersArgs, 'IDs'>
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type JobOfferRegionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['JobOfferRegion'] = ResolversParentTypes['JobOfferRegion'],
> = ResolversObject<{
  ID?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  normalized?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type JobOfferSalaryResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['JobOfferSalary'] = ResolversParentTypes['JobOfferSalary'],
> = ResolversObject<{
  amount?: Resolver<Maybe<ResolversTypes['JobOfferFloatValue']>, ParentType, ContextType>;
  arranged?: Resolver<Maybe<ResolversTypes['JobOfferIntValue']>, ParentType, ContextType>;
  currency?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  currencySymbol?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  from?: Resolver<Maybe<ResolversTypes['JobOfferFloatValue']>, ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  to?: Resolver<Maybe<ResolversTypes['JobOfferFloatValue']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['JobOfferSalaryType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type JobOfferSalaryTypeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['JobOfferSalaryType'] = ResolversParentTypes['JobOfferSalaryType'],
> = ResolversObject<{
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['JobOfferStringValue'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type JobOfferStringValueResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['JobOfferStringValue'] = ResolversParentTypes['JobOfferStringValue'],
> = ResolversObject<{
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type LifeAtResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LifeAt'] = ResolversParentTypes['LifeAt'],
> = ResolversObject<{
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  items?: Resolver<Maybe<Array<ResolversTypes['LifeAtItem']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type LifeAtItemResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LifeAtItem'] = ResolversParentTypes['LifeAtItem'],
> = ResolversObject<{
  __resolveType: TypeResolveFn<
    'LifeAtItemExternalVideo' | 'LifeAtItemImage',
    ParentType,
    ContextType
  >;
}>;

export type LifeAtItemExternalVideoResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['LifeAtItemExternalVideo'] = ResolversParentTypes['LifeAtItemExternalVideo'],
> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['LifeAtItemType'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type LifeAtItemImageResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['LifeAtItemImage'] = ResolversParentTypes['LifeAtItemImage'],
> = ResolversObject<{
  fileId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['LifeAtItemType'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type LocationPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['LocationPayload'] = ResolversParentTypes['LocationPayload'],
> = ResolversObject<{
  city?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lat?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  lng?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  region?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  streetName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  streetNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  zipCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type LocationSuggestionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['LocationSuggestion'] = ResolversParentTypes['LocationSuggestion'],
> = ResolversObject<{
  city?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lat?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  lng?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  region?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  streetName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  streetNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  zipCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MetadataResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Metadata'] = ResolversParentTypes['Metadata'],
> = ResolversObject<{
  benefitsFeedback?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  onboardingSteps?: Resolver<
    Maybe<Array<ResolversTypes['OnboardingStep']>>,
    ParentType,
    ContextType
  >;
  startDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MultiApplicationResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['MultiApplication'] = ResolversParentTypes['MultiApplication'],
> = ResolversObject<{
  adId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  allAttachments?: Resolver<
    Maybe<Array<ResolversTypes['ChatAttachment']>>,
    ParentType,
    ContextType
  >;
  allCVs?: Resolver<Maybe<Array<ResolversTypes['ChatAttachment']>>, ParentType, ContextType>;
  attachments?: Resolver<Maybe<Array<ResolversTypes['ChatAttachment']>>, ParentType, ContextType>;
  candidate?: Resolver<ResolversTypes['Candidate'], ParentType, ContextType>;
  cv?: Resolver<Maybe<ResolversTypes['ChatAttachment']>, ParentType, ContextType>;
  employerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fromInvitation?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hasAttachments?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isApplyForm?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isCancelled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isInitialMessageRead?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isReApplication?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  jobAdId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  meetingDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  note?: Resolver<ResolversTypes['Note'], ParentType, ContextType>;
  postedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rankingScore?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  rate?: Resolver<ResolversTypes['ApplicationRate'], ParentType, ContextType>;
  read?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  relatedAppsIds?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  scoreExplanation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sortDate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['ApplicationStatus'], ParentType, ContextType>;
  unreadMessagesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  userAnswers?: Resolver<Array<Maybe<ResolversTypes['UserAnswer']>>, ParentType, ContextType>;
  withProfile?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MutationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Mutation'] = ResolversParentTypes['Mutation'],
> = ResolversObject<{
  BusinessCard?: Resolver<ResolversTypes['BusinessCardMutation'], ParentType, ContextType>;
  CandidateProfile?: Resolver<
    Maybe<ResolversTypes['CandidateProfileMutation']>,
    ParentType,
    ContextType
  >;
  CandidateProfileNoAuth?: Resolver<
    Maybe<ResolversTypes['CandidateProfileNoAuthMutation']>,
    ParentType,
    ContextType
  >;
  CompanyProfile?: Resolver<ResolversTypes['CompanyProfileMutation'], ParentType, ContextType>;
  EmployerPanel?: Resolver<ResolversTypes['EmployerPanelMutation'], ParentType, ContextType>;
}>;

export type NoteResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Note'] = ResolversParentTypes['Note'],
> = ResolversObject<{
  content?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ProfileCountryOptionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['ProfileCountryOption'] = ResolversParentTypes['ProfileCountryOption'],
> = ResolversObject<{
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  normalizedValue?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type QueryResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query'],
> = ResolversObject<{
  BusinessCard?: Resolver<ResolversTypes['BusinessCardQuery'], ParentType, ContextType>;
  CandidateProfile?: Resolver<
    Maybe<ResolversTypes['CandidateProfileQuery']>,
    ParentType,
    ContextType
  >;
  CompanyProfile?: Resolver<ResolversTypes['CompanyProfileQuery'], ParentType, ContextType>;
  EmployerPanel?: Resolver<ResolversTypes['EmployerPanelQuery'], ParentType, ContextType>;
  Homepage?: Resolver<Maybe<ResolversTypes['HomepageQuery']>, ParentType, ContextType>;
  JobOffer?: Resolver<Maybe<ResolversTypes['JobOfferQuery']>, ParentType, ContextType>;
  atlasUser?: Resolver<
    Maybe<ResolversTypes['AtlasUser']>,
    ParentType,
    ContextType,
    RequireFields<QueryAtlasUserArgs, 'id'>
  >;
}>;

export type RecruitmentProcessResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['RecruitmentProcess'] = ResolversParentTypes['RecruitmentProcess'],
> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  steps?: Resolver<Array<ResolversTypes['RecruitmentProcessStepPayload']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RecruitmentProcessStepPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['RecruitmentProcessStepPayload'] = ResolversParentTypes['RecruitmentProcessStepPayload'],
> = ResolversObject<{
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SecureUrlResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SecureUrl'] = ResolversParentTypes['SecureUrl'],
> = ResolversObject<{
  token?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type StafflyReportResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['StafflyReport'] = ResolversParentTypes['StafflyReport'],
> = ResolversObject<{
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  secureUrl?: Resolver<ResolversTypes['StafflyReportSecureUrl'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type StafflyReportSecureUrlResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['StafflyReportSecureUrl'] = ResolversParentTypes['StafflyReportSecureUrl'],
> = ResolversObject<{
  token?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type StafflyTestResultResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['StafflyTestResult'] = ResolversParentTypes['StafflyTestResult'],
> = ResolversObject<{
  adID?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  candidateUUID?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  report?: Resolver<ResolversTypes['StafflyReport'], ParentType, ContextType>;
  testID?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UploadRequestDataPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['UploadRequestDataPayload'] = ResolversParentTypes['UploadRequestDataPayload'],
> = ResolversObject<{
  token?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UserAnswerResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UserAnswer'] = ResolversParentTypes['UserAnswer'],
> = ResolversObject<{
  questionId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  questionLabel?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  values?: Resolver<Array<Maybe<ResolversTypes['String']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type Resolvers<ContextType = any> = ResolversObject<{
  ApolloToken?: ApolloTokenResolvers<ContextType>;
  ApplicationAttachments?: ApplicationAttachmentsResolvers<ContextType>;
  ApplyQuestion?: ApplyQuestionResolvers<ContextType>;
  ApplyQuestionAnswer?: ApplyQuestionAnswerResolvers<ContextType>;
  AtlasUser?: AtlasUserResolvers<ContextType>;
  Attachment?: AttachmentResolvers<ContextType>;
  BusinessCardAbout?: BusinessCardAboutResolvers<ContextType>;
  BusinessCardAdditionalInfo?: BusinessCardAdditionalInfoResolvers<ContextType>;
  BusinessCardBaseProfile?: BusinessCardBaseProfileResolvers<ContextType>;
  BusinessCardContact?: BusinessCardContactResolvers<ContextType>;
  BusinessCardHeader?: BusinessCardHeaderResolvers<ContextType>;
  BusinessCardLifeAt?: BusinessCardLifeAtResolvers<ContextType>;
  BusinessCardLifeAtItem?: BusinessCardLifeAtItemResolvers<ContextType>;
  BusinessCardLifeAtItemExternalVideo?: BusinessCardLifeAtItemExternalVideoResolvers<ContextType>;
  BusinessCardLifeAtItemImage?: BusinessCardLifeAtItemImageResolvers<ContextType>;
  BusinessCardLocation?: BusinessCardLocationResolvers<ContextType>;
  BusinessCardLocationSuggestion?: BusinessCardLocationSuggestionResolvers<ContextType>;
  BusinessCardMutation?: BusinessCardMutationResolvers<ContextType>;
  BusinessCardPrivateProfile?: BusinessCardPrivateProfileResolvers<ContextType>;
  BusinessCardPublicProfile?: BusinessCardPublicProfileResolvers<ContextType>;
  BusinessCardQuery?: BusinessCardQueryResolvers<ContextType>;
  BusinessCardUploadRequestDataPayload?: BusinessCardUploadRequestDataPayloadResolvers<ContextType>;
  CVGeneratorOutput?: CvGeneratorOutputResolvers<ContextType>;
  CVParsingResult?: CvParsingResultResolvers<ContextType>;
  Candidate?: CandidateResolvers<ContextType>;
  CandidateProfile?: CandidateProfileResolvers<ContextType>;
  CandidateProfileAd?: CandidateProfileAdResolvers<ContextType>;
  CandidateProfileApplication?: CandidateProfileApplicationResolvers<ContextType>;
  CandidateProfileApplicationAnswer?: CandidateProfileApplicationAnswerResolvers<ContextType>;
  CandidateProfileApplicationsList?: CandidateProfileApplicationsListResolvers<ContextType>;
  CandidateProfileApplyValidation?: CandidateProfileApplyValidationResolvers<ContextType>;
  CandidateProfileBasicInfo?: CandidateProfileBasicInfoResolvers<ContextType>;
  CandidateProfileCV?: CandidateProfileCvResolvers<ContextType>;
  CandidateProfileCVCopy?: CandidateProfileCvCopyResolvers<ContextType>;
  CandidateProfileCVCopyV2?: CandidateProfileCvCopyV2Resolvers<ContextType>;
  CandidateProfileCVGeneratorToken?: CandidateProfileCvGeneratorTokenResolvers<ContextType>;
  CandidateProfileCountryOptions?: CandidateProfileCountryOptionsResolvers<ContextType>;
  CandidateProfileCursorKey?: CandidateProfileCursorKeyResolvers<ContextType>;
  CandidateProfileData?: CandidateProfileDataResolvers<ContextType>;
  CandidateProfileExperience?: CandidateProfileExperienceResolvers<ContextType>;
  CandidateProfileLanguageSkill?: CandidateProfileLanguageSkillResolvers<ContextType>;
  CandidateProfileLatestApplication?: CandidateProfileLatestApplicationResolvers<ContextType>;
  CandidateProfileLocation?: CandidateProfileLocationResolvers<ContextType>;
  CandidateProfileMutation?: CandidateProfileMutationResolvers<ContextType>;
  CandidateProfileNoAuthMutation?: CandidateProfileNoAuthMutationResolvers<ContextType>;
  CandidateProfileNotificationsSettings?: CandidateProfileNotificationsSettingsResolvers<ContextType>;
  CandidateProfilePreferences?: CandidateProfilePreferencesResolvers<ContextType>;
  CandidateProfilePreferredSalary?: CandidateProfilePreferredSalaryResolvers<ContextType>;
  CandidateProfileProfile?: CandidateProfileProfileResolvers<ContextType>;
  CandidateProfileQuery?: CandidateProfileQueryResolvers<ContextType>;
  CandidateProfileRecommendation?: CandidateProfileRecommendationResolvers<ContextType>;
  CandidateProfileRecommendationJobOffer?: CandidateProfileRecommendationJobOfferResolvers<ContextType>;
  CandidateProfileRecommendationRawParam?: CandidateProfileRecommendationRawParamResolvers<ContextType>;
  CandidateProfileSchool?: CandidateProfileSchoolResolvers<ContextType>;
  CandidateProfileSettings?: CandidateProfileSettingsResolvers<ContextType>;
  CandidateProfileSuggestion?: CandidateProfileSuggestionResolvers<ContextType>;
  CandidateProfileUploadData?: CandidateProfileUploadDataResolvers<ContextType>;
  ChatAttachment?: ChatAttachmentResolvers<ContextType>;
  ChatConversation?: ChatConversationResolvers<ContextType>;
  ChatMessage?: ChatMessageResolvers<ContextType>;
  CompanyProfileAbout?: CompanyProfileAboutResolvers<ContextType>;
  CompanyProfileAdditionalInfo?: CompanyProfileAdditionalInfoResolvers<ContextType>;
  CompanyProfileAds?: CompanyProfileAdsResolvers<ContextType>;
  CompanyProfileAdsAggregation?: CompanyProfileAdsAggregationResolvers<ContextType>;
  CompanyProfileAdsAggregationValue?: CompanyProfileAdsAggregationValueResolvers<ContextType>;
  CompanyProfileAdsAggregations?: CompanyProfileAdsAggregationsResolvers<ContextType>;
  CompanyProfileBaseProfile?: CompanyProfileBaseProfileResolvers<ContextType>;
  CompanyProfileBenefits?: CompanyProfileBenefitsResolvers<ContextType>;
  CompanyProfileConfig?: CompanyProfileConfigResolvers<ContextType>;
  CompanyProfileConfigFeatureBanner?: CompanyProfileConfigFeatureBannerResolvers<ContextType>;
  CompanyProfileConfigFeatureBase?: CompanyProfileConfigFeatureBaseResolvers<ContextType>;
  CompanyProfileConfigFeatureBenefits?: CompanyProfileConfigFeatureBenefitsResolvers<ContextType>;
  CompanyProfileConfigFeatureCompanyUrl?: CompanyProfileConfigFeatureCompanyUrlResolvers<ContextType>;
  CompanyProfileConfigFeatureFollowButton?: CompanyProfileConfigFeatureFollowButtonResolvers<ContextType>;
  CompanyProfileConfigFeatureGallery?: CompanyProfileConfigFeatureGalleryResolvers<ContextType>;
  CompanyProfileConfigFeatureLogo?: CompanyProfileConfigFeatureLogoResolvers<ContextType>;
  CompanyProfileConfigFeatureMultiprofile?: CompanyProfileConfigFeatureMultiprofileResolvers<ContextType>;
  CompanyProfileConfigFeaturePromotedOnListing?: CompanyProfileConfigFeaturePromotedOnListingResolvers<ContextType>;
  CompanyProfileConfigFeatureRecruitment?: CompanyProfileConfigFeatureRecruitmentResolvers<ContextType>;
  CompanyProfileConfigFeatureSocialLinks?: CompanyProfileConfigFeatureSocialLinksResolvers<ContextType>;
  CompanyProfileConfigFeatures?: CompanyProfileConfigFeaturesResolvers<ContextType>;
  CompanyProfileConfigRelations?: CompanyProfileConfigRelationsResolvers<ContextType>;
  CompanyProfileConfigSubProfile?: CompanyProfileConfigSubProfileResolvers<ContextType>;
  CompanyProfileContact?: CompanyProfileContactResolvers<ContextType>;
  CompanyProfileHeader?: CompanyProfileHeaderResolvers<ContextType>;
  CompanyProfileLifeAt?: CompanyProfileLifeAtResolvers<ContextType>;
  CompanyProfileLifeAtItem?: CompanyProfileLifeAtItemResolvers<ContextType>;
  CompanyProfileLifeAtItemExternalVideo?: CompanyProfileLifeAtItemExternalVideoResolvers<ContextType>;
  CompanyProfileLifeAtItemImage?: CompanyProfileLifeAtItemImageResolvers<ContextType>;
  CompanyProfileLocation?: CompanyProfileLocationResolvers<ContextType>;
  CompanyProfileMutation?: CompanyProfileMutationResolvers<ContextType>;
  CompanyProfilePrivateConfig?: CompanyProfilePrivateConfigResolvers<ContextType>;
  CompanyProfilePrivateConfigRelations?: CompanyProfilePrivateConfigRelationsResolvers<ContextType>;
  CompanyProfilePrivateConfigSubProfile?: CompanyProfilePrivateConfigSubProfileResolvers<ContextType>;
  CompanyProfilePrivateConfigTier?: CompanyProfilePrivateConfigTierResolvers<ContextType>;
  CompanyProfilePrivateProfile?: CompanyProfilePrivateProfileResolvers<ContextType>;
  CompanyProfileProfileCounters?: CompanyProfileProfileCountersResolvers<ContextType>;
  CompanyProfileProfilesCarousel?: CompanyProfileProfilesCarouselResolvers<ContextType>;
  CompanyProfileProfilesCarouselProfile?: CompanyProfileProfilesCarouselProfileResolvers<ContextType>;
  CompanyProfileProfilesListing?: CompanyProfileProfilesListingResolvers<ContextType>;
  CompanyProfileProfilesListingProfile?: CompanyProfileProfilesListingProfileResolvers<ContextType>;
  CompanyProfilePublicConfig?: CompanyProfilePublicConfigResolvers<ContextType>;
  CompanyProfilePublicProfile?: CompanyProfilePublicProfileResolvers<ContextType>;
  CompanyProfileQuery?: CompanyProfileQueryResolvers<ContextType>;
  CompanyProfileRecruitment?: CompanyProfileRecruitmentResolvers<ContextType>;
  CompanyProfileRecruitmentProcess?: CompanyProfileRecruitmentProcessResolvers<ContextType>;
  CompanyProfileRecruitmentProcessStep?: CompanyProfileRecruitmentProcessStepResolvers<ContextType>;
  EmployerLead?: EmployerLeadResolvers<ContextType>;
  EmployerPanelMutation?: EmployerPanelMutationResolvers<ContextType>;
  EmployerPanelQuery?: EmployerPanelQueryResolvers<ContextType>;
  EmployerProfile?: EmployerProfileResolvers<ContextType>;
  EmployerSegmentResponse?: EmployerSegmentResponseResolvers<ContextType>;
  HomepageArticle?: HomepageArticleResolvers<ContextType>;
  HomepageFeaturedCategory?: HomepageFeaturedCategoryResolvers<ContextType>;
  HomepageFeaturedEmployer?: HomepageFeaturedEmployerResolvers<ContextType>;
  HomepageQuery?: HomepageQueryResolvers<ContextType>;
  ImageThumbnail?: ImageThumbnailResolvers<ContextType>;
  JobAd?: JobAdResolvers<ContextType>;
  JobAdCounters?: JobAdCountersResolvers<ContextType>;
  JobAdTrackingParameters?: JobAdTrackingParametersResolvers<ContextType>;
  JobAdUnreadCounters?: JobAdUnreadCountersResolvers<ContextType>;
  JobOfferCity?: JobOfferCityResolvers<ContextType>;
  JobOfferDistrict?: JobOfferDistrictResolvers<ContextType>;
  JobOfferEmployer?: JobOfferEmployerResolvers<ContextType>;
  JobOfferEmployerLogoThumbnails?: JobOfferEmployerLogoThumbnailsResolvers<ContextType>;
  JobOfferFloatValue?: JobOfferFloatValueResolvers<ContextType>;
  JobOfferIntValue?: JobOfferIntValueResolvers<ContextType>;
  JobOfferLocation?: JobOfferLocationResolvers<ContextType>;
  JobOfferMap?: JobOfferMapResolvers<ContextType>;
  JobOfferOffer?: JobOfferOfferResolvers<ContextType>;
  JobOfferParameter?: JobOfferParameterResolvers<ContextType>;
  JobOfferPostingComponent?: JobOfferPostingComponentResolvers<ContextType>;
  JobOfferQuery?: JobOfferQueryResolvers<ContextType>;
  JobOfferRegion?: JobOfferRegionResolvers<ContextType>;
  JobOfferSalary?: JobOfferSalaryResolvers<ContextType>;
  JobOfferSalaryType?: JobOfferSalaryTypeResolvers<ContextType>;
  JobOfferStringValue?: JobOfferStringValueResolvers<ContextType>;
  LifeAt?: LifeAtResolvers<ContextType>;
  LifeAtItem?: LifeAtItemResolvers<ContextType>;
  LifeAtItemExternalVideo?: LifeAtItemExternalVideoResolvers<ContextType>;
  LifeAtItemImage?: LifeAtItemImageResolvers<ContextType>;
  LocationPayload?: LocationPayloadResolvers<ContextType>;
  LocationSuggestion?: LocationSuggestionResolvers<ContextType>;
  Metadata?: MetadataResolvers<ContextType>;
  MultiApplication?: MultiApplicationResolvers<ContextType>;
  Mutation?: MutationResolvers<ContextType>;
  Note?: NoteResolvers<ContextType>;
  ProfileCountryOption?: ProfileCountryOptionResolvers<ContextType>;
  Query?: QueryResolvers<ContextType>;
  RecruitmentProcess?: RecruitmentProcessResolvers<ContextType>;
  RecruitmentProcessStepPayload?: RecruitmentProcessStepPayloadResolvers<ContextType>;
  SecureUrl?: SecureUrlResolvers<ContextType>;
  StafflyReport?: StafflyReportResolvers<ContextType>;
  StafflyReportSecureUrl?: StafflyReportSecureUrlResolvers<ContextType>;
  StafflyTestResult?: StafflyTestResultResolvers<ContextType>;
  UploadRequestDataPayload?: UploadRequestDataPayloadResolvers<ContextType>;
  UserAnswer?: UserAnswerResolvers<ContextType>;
}>;

export type DirectiveResolvers<ContextType = any> = ResolversObject<{
  oneOf?: OneOfDirectiveResolver<any, any, ContextType>;
}>;

export type ApolloTokenKeySpecifier = ('expiry' | 'token' | ApolloTokenKeySpecifier)[];
export type ApolloTokenFieldPolicy = {
  expiry?: FieldPolicy<any> | FieldReadFunction<any>;
  token?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ApplicationAttachmentsKeySpecifier = (
  | 'attachments'
  | 'cv'
  | ApplicationAttachmentsKeySpecifier
)[];
export type ApplicationAttachmentsFieldPolicy = {
  attachments?: FieldPolicy<any> | FieldReadFunction<any>;
  cv?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ApplyQuestionKeySpecifier = (
  | 'ID'
  | 'answers'
  | 'createdAt'
  | 'id'
  | 'label'
  | 'order'
  | 'placeholder'
  | 'tag'
  | 'type'
  | 'variant'
  | ApplyQuestionKeySpecifier
)[];
export type ApplyQuestionFieldPolicy = {
  ID?: FieldPolicy<any> | FieldReadFunction<any>;
  answers?: FieldPolicy<any> | FieldReadFunction<any>;
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  order?: FieldPolicy<any> | FieldReadFunction<any>;
  placeholder?: FieldPolicy<any> | FieldReadFunction<any>;
  tag?: FieldPolicy<any> | FieldReadFunction<any>;
  type?: FieldPolicy<any> | FieldReadFunction<any>;
  variant?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ApplyQuestionAnswerKeySpecifier = (
  | 'isFavorite'
  | 'label'
  | 'placeholder'
  | 'type'
  | 'value'
  | ApplyQuestionAnswerKeySpecifier
)[];
export type ApplyQuestionAnswerFieldPolicy = {
  isFavorite?: FieldPolicy<any> | FieldReadFunction<any>;
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  placeholder?: FieldPolicy<any> | FieldReadFunction<any>;
  type?: FieldPolicy<any> | FieldReadFunction<any>;
  value?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AtlasUserKeySpecifier = ('created' | 'id' | AtlasUserKeySpecifier)[];
export type AtlasUserFieldPolicy = {
  created?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AttachmentKeySpecifier = (
  | 'ID'
  | 'downloadToken'
  | 'downloadURL'
  | 'name'
  | 'simpleURL'
  | 'token'
  | 'url'
  | AttachmentKeySpecifier
)[];
export type AttachmentFieldPolicy = {
  ID?: FieldPolicy<any> | FieldReadFunction<any>;
  downloadToken?: FieldPolicy<any> | FieldReadFunction<any>;
  downloadURL?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  simpleURL?: FieldPolicy<any> | FieldReadFunction<any>;
  token?: FieldPolicy<any> | FieldReadFunction<any>;
  url?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type BusinessCardAboutKeySpecifier = (
  | 'companyName'
  | 'description'
  | 'logoUrl'
  | 'tagline'
  | BusinessCardAboutKeySpecifier
)[];
export type BusinessCardAboutFieldPolicy = {
  companyName?: FieldPolicy<any> | FieldReadFunction<any>;
  description?: FieldPolicy<any> | FieldReadFunction<any>;
  logoUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  tagline?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type BusinessCardAdditionalInfoKeySpecifier = (
  | 'companySize'
  | 'companyUrl'
  | 'email'
  | 'facebookUrl'
  | 'headquarters'
  | 'industry'
  | 'instagramUrl'
  | 'linkedinUrl'
  | 'phone'
  | 'twitterUrl'
  | 'youtubeUrl'
  | BusinessCardAdditionalInfoKeySpecifier
)[];
export type BusinessCardAdditionalInfoFieldPolicy = {
  companySize?: FieldPolicy<any> | FieldReadFunction<any>;
  companyUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  email?: FieldPolicy<any> | FieldReadFunction<any>;
  facebookUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  headquarters?: FieldPolicy<any> | FieldReadFunction<any>;
  industry?: FieldPolicy<any> | FieldReadFunction<any>;
  instagramUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  linkedinUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  phone?: FieldPolicy<any> | FieldReadFunction<any>;
  twitterUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  youtubeUrl?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type BusinessCardBaseProfileKeySpecifier = (
  | 'about'
  | 'additionalInfo'
  | 'contact'
  | 'header'
  | 'id'
  | 'lifeAt'
  | 'publishedAt'
  | 'slug'
  | 'userId'
  | 'userUuid'
  | BusinessCardBaseProfileKeySpecifier
)[];
export type BusinessCardBaseProfileFieldPolicy = {
  about?: FieldPolicy<any> | FieldReadFunction<any>;
  additionalInfo?: FieldPolicy<any> | FieldReadFunction<any>;
  contact?: FieldPolicy<any> | FieldReadFunction<any>;
  header?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lifeAt?: FieldPolicy<any> | FieldReadFunction<any>;
  publishedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  slug?: FieldPolicy<any> | FieldReadFunction<any>;
  userId?: FieldPolicy<any> | FieldReadFunction<any>;
  userUuid?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type BusinessCardContactKeySpecifier = (
  | 'companyName'
  | 'email'
  | 'headquarters'
  | 'phone'
  | BusinessCardContactKeySpecifier
)[];
export type BusinessCardContactFieldPolicy = {
  companyName?: FieldPolicy<any> | FieldReadFunction<any>;
  email?: FieldPolicy<any> | FieldReadFunction<any>;
  headquarters?: FieldPolicy<any> | FieldReadFunction<any>;
  phone?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type BusinessCardHeaderKeySpecifier = ('bannerUrl' | BusinessCardHeaderKeySpecifier)[];
export type BusinessCardHeaderFieldPolicy = {
  bannerUrl?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type BusinessCardLifeAtKeySpecifier = (
  | 'description'
  | 'items'
  | BusinessCardLifeAtKeySpecifier
)[];
export type BusinessCardLifeAtFieldPolicy = {
  description?: FieldPolicy<any> | FieldReadFunction<any>;
  items?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type BusinessCardLifeAtItemExternalVideoKeySpecifier = (
  | 'id'
  | 'type'
  | 'url'
  | BusinessCardLifeAtItemExternalVideoKeySpecifier
)[];
export type BusinessCardLifeAtItemExternalVideoFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  type?: FieldPolicy<any> | FieldReadFunction<any>;
  url?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type BusinessCardLifeAtItemImageKeySpecifier = (
  | 'fileId'
  | 'id'
  | 'type'
  | 'url'
  | BusinessCardLifeAtItemImageKeySpecifier
)[];
export type BusinessCardLifeAtItemImageFieldPolicy = {
  fileId?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  type?: FieldPolicy<any> | FieldReadFunction<any>;
  url?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type BusinessCardLocationKeySpecifier = (
  | 'city'
  | 'lat'
  | 'lng'
  | 'region'
  | 'streetName'
  | 'streetNumber'
  | 'zipCode'
  | BusinessCardLocationKeySpecifier
)[];
export type BusinessCardLocationFieldPolicy = {
  city?: FieldPolicy<any> | FieldReadFunction<any>;
  lat?: FieldPolicy<any> | FieldReadFunction<any>;
  lng?: FieldPolicy<any> | FieldReadFunction<any>;
  region?: FieldPolicy<any> | FieldReadFunction<any>;
  streetName?: FieldPolicy<any> | FieldReadFunction<any>;
  streetNumber?: FieldPolicy<any> | FieldReadFunction<any>;
  zipCode?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type BusinessCardLocationSuggestionKeySpecifier = (
  | 'city'
  | 'id'
  | 'label'
  | 'lat'
  | 'lng'
  | 'region'
  | 'streetName'
  | 'streetNumber'
  | 'zipCode'
  | BusinessCardLocationSuggestionKeySpecifier
)[];
export type BusinessCardLocationSuggestionFieldPolicy = {
  city?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  lat?: FieldPolicy<any> | FieldReadFunction<any>;
  lng?: FieldPolicy<any> | FieldReadFunction<any>;
  region?: FieldPolicy<any> | FieldReadFunction<any>;
  streetName?: FieldPolicy<any> | FieldReadFunction<any>;
  streetNumber?: FieldPolicy<any> | FieldReadFunction<any>;
  zipCode?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type BusinessCardMutationKeySpecifier = (
  | 'confirmAssets'
  | 'deleteAssets'
  | 'deleteData'
  | 'publishProfile'
  | 'saveAbout'
  | 'saveAdditionalInformation'
  | 'saveContact'
  | 'saveLifeAt'
  | 'unpublishProfile'
  | BusinessCardMutationKeySpecifier
)[];
export type BusinessCardMutationFieldPolicy = {
  confirmAssets?: FieldPolicy<any> | FieldReadFunction<any>;
  deleteAssets?: FieldPolicy<any> | FieldReadFunction<any>;
  deleteData?: FieldPolicy<any> | FieldReadFunction<any>;
  publishProfile?: FieldPolicy<any> | FieldReadFunction<any>;
  saveAbout?: FieldPolicy<any> | FieldReadFunction<any>;
  saveAdditionalInformation?: FieldPolicy<any> | FieldReadFunction<any>;
  saveContact?: FieldPolicy<any> | FieldReadFunction<any>;
  saveLifeAt?: FieldPolicy<any> | FieldReadFunction<any>;
  unpublishProfile?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type BusinessCardPrivateProfileKeySpecifier = (
  | 'about'
  | 'additionalInfo'
  | 'contact'
  | 'header'
  | 'id'
  | 'lifeAt'
  | 'publishedAt'
  | 'slug'
  | 'userId'
  | 'userUuid'
  | BusinessCardPrivateProfileKeySpecifier
)[];
export type BusinessCardPrivateProfileFieldPolicy = {
  about?: FieldPolicy<any> | FieldReadFunction<any>;
  additionalInfo?: FieldPolicy<any> | FieldReadFunction<any>;
  contact?: FieldPolicy<any> | FieldReadFunction<any>;
  header?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lifeAt?: FieldPolicy<any> | FieldReadFunction<any>;
  publishedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  slug?: FieldPolicy<any> | FieldReadFunction<any>;
  userId?: FieldPolicy<any> | FieldReadFunction<any>;
  userUuid?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type BusinessCardPublicProfileKeySpecifier = (
  | 'about'
  | 'additionalInfo'
  | 'contact'
  | 'header'
  | 'id'
  | 'lifeAt'
  | 'publishedAt'
  | 'slug'
  | 'userId'
  | 'userUuid'
  | BusinessCardPublicProfileKeySpecifier
)[];
export type BusinessCardPublicProfileFieldPolicy = {
  about?: FieldPolicy<any> | FieldReadFunction<any>;
  additionalInfo?: FieldPolicy<any> | FieldReadFunction<any>;
  contact?: FieldPolicy<any> | FieldReadFunction<any>;
  header?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lifeAt?: FieldPolicy<any> | FieldReadFunction<any>;
  publishedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  slug?: FieldPolicy<any> | FieldReadFunction<any>;
  userId?: FieldPolicy<any> | FieldReadFunction<any>;
  userUuid?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type BusinessCardQueryKeySpecifier = (
  | 'locationSuggestions'
  | 'privateProfile'
  | 'publicProfileBySlug'
  | 'publicProfileByUuid'
  | 'uploadRequestData'
  | BusinessCardQueryKeySpecifier
)[];
export type BusinessCardQueryFieldPolicy = {
  locationSuggestions?: FieldPolicy<any> | FieldReadFunction<any>;
  privateProfile?: FieldPolicy<any> | FieldReadFunction<any>;
  publicProfileBySlug?: FieldPolicy<any> | FieldReadFunction<any>;
  publicProfileByUuid?: FieldPolicy<any> | FieldReadFunction<any>;
  uploadRequestData?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type BusinessCardUploadRequestDataPayloadKeySpecifier = (
  | 'token'
  | 'url'
  | BusinessCardUploadRequestDataPayloadKeySpecifier
)[];
export type BusinessCardUploadRequestDataPayloadFieldPolicy = {
  token?: FieldPolicy<any> | FieldReadFunction<any>;
  url?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CVGeneratorOutputKeySpecifier = ('token' | CVGeneratorOutputKeySpecifier)[];
export type CVGeneratorOutputFieldPolicy = {
  token?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CVParsingResultKeySpecifier = ('profile' | 'status' | CVParsingResultKeySpecifier)[];
export type CVParsingResultFieldPolicy = {
  profile?: FieldPolicy<any> | FieldReadFunction<any>;
  status?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CandidateKeySpecifier = (
  | 'cacheId'
  | 'email'
  | 'firstName'
  | 'id'
  | 'isRemoved'
  | 'lastName'
  | 'phoneNumber'
  | CandidateKeySpecifier
)[];
export type CandidateFieldPolicy = {
  cacheId?: FieldPolicy<any> | FieldReadFunction<any>;
  email?: FieldPolicy<any> | FieldReadFunction<any>;
  firstName?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  isRemoved?: FieldPolicy<any> | FieldReadFunction<any>;
  lastName?: FieldPolicy<any> | FieldReadFunction<any>;
  phoneNumber?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CandidateProfileKeySpecifier = (
  | 'candidateId'
  | 'candidateProfile'
  | CandidateProfileKeySpecifier
)[];
export type CandidateProfileFieldPolicy = {
  candidateId?: FieldPolicy<any> | FieldReadFunction<any>;
  candidateProfile?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CandidateProfileAdKeySpecifier = (
  | 'categoryID'
  | 'id'
  | 'isBusiness'
  | 'ownerID'
  | 'ownerUUID'
  | 'title'
  | 'url'
  | CandidateProfileAdKeySpecifier
)[];
export type CandidateProfileAdFieldPolicy = {
  categoryID?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  isBusiness?: FieldPolicy<any> | FieldReadFunction<any>;
  ownerID?: FieldPolicy<any> | FieldReadFunction<any>;
  ownerUUID?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
  url?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CandidateProfileApplicationKeySpecifier = (
  | 'ID'
  | 'ad'
  | 'answers'
  | 'attachments'
  | 'cancelledAt'
  | 'candidateID'
  | 'candidateUUID'
  | 'createdAt'
  | 'cv'
  | 'cvFileID'
  | 'cvFileName'
  | 'emailAddress'
  | 'employerID'
  | 'employerMeetingDate'
  | 'employerStatus'
  | 'employerStatusChangedAt'
  | 'firstName'
  | 'fromInvitation'
  | 'hasBeenReadByEmployer'
  | 'isCancelled'
  | 'lastName'
  | 'message'
  | 'phoneNumber'
  | 'withProfile'
  | CandidateProfileApplicationKeySpecifier
)[];
export type CandidateProfileApplicationFieldPolicy = {
  ID?: FieldPolicy<any> | FieldReadFunction<any>;
  ad?: FieldPolicy<any> | FieldReadFunction<any>;
  answers?: FieldPolicy<any> | FieldReadFunction<any>;
  attachments?: FieldPolicy<any> | FieldReadFunction<any>;
  cancelledAt?: FieldPolicy<any> | FieldReadFunction<any>;
  candidateID?: FieldPolicy<any> | FieldReadFunction<any>;
  candidateUUID?: FieldPolicy<any> | FieldReadFunction<any>;
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  cv?: FieldPolicy<any> | FieldReadFunction<any>;
  cvFileID?: FieldPolicy<any> | FieldReadFunction<any>;
  cvFileName?: FieldPolicy<any> | FieldReadFunction<any>;
  emailAddress?: FieldPolicy<any> | FieldReadFunction<any>;
  employerID?: FieldPolicy<any> | FieldReadFunction<any>;
  employerMeetingDate?: FieldPolicy<any> | FieldReadFunction<any>;
  employerStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  employerStatusChangedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  firstName?: FieldPolicy<any> | FieldReadFunction<any>;
  fromInvitation?: FieldPolicy<any> | FieldReadFunction<any>;
  hasBeenReadByEmployer?: FieldPolicy<any> | FieldReadFunction<any>;
  isCancelled?: FieldPolicy<any> | FieldReadFunction<any>;
  lastName?: FieldPolicy<any> | FieldReadFunction<any>;
  message?: FieldPolicy<any> | FieldReadFunction<any>;
  phoneNumber?: FieldPolicy<any> | FieldReadFunction<any>;
  withProfile?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CandidateProfileApplicationAnswerKeySpecifier = (
  | 'question'
  | 'values'
  | CandidateProfileApplicationAnswerKeySpecifier
)[];
export type CandidateProfileApplicationAnswerFieldPolicy = {
  question?: FieldPolicy<any> | FieldReadFunction<any>;
  values?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CandidateProfileApplicationsListKeySpecifier = (
  | 'applications'
  | 'cursor'
  | CandidateProfileApplicationsListKeySpecifier
)[];
export type CandidateProfileApplicationsListFieldPolicy = {
  applications?: FieldPolicy<any> | FieldReadFunction<any>;
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CandidateProfileApplyValidationKeySpecifier = (
  | 'result'
  | CandidateProfileApplyValidationKeySpecifier
)[];
export type CandidateProfileApplyValidationFieldPolicy = {
  result?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CandidateProfileBasicInfoKeySpecifier = (
  | 'emailAddress'
  | 'firstName'
  | 'lastName'
  | 'location'
  | 'locationRange'
  | 'phoneNumber'
  | 'yearOfBirth'
  | CandidateProfileBasicInfoKeySpecifier
)[];
export type CandidateProfileBasicInfoFieldPolicy = {
  emailAddress?: FieldPolicy<any> | FieldReadFunction<any>;
  firstName?: FieldPolicy<any> | FieldReadFunction<any>;
  lastName?: FieldPolicy<any> | FieldReadFunction<any>;
  location?: FieldPolicy<any> | FieldReadFunction<any>;
  locationRange?: FieldPolicy<any> | FieldReadFunction<any>;
  phoneNumber?: FieldPolicy<any> | FieldReadFunction<any>;
  yearOfBirth?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CandidateProfileCVKeySpecifier = (
  | 'ID'
  | 'createdAt'
  | 'downloadToken'
  | 'downloadURL'
  | 'name'
  | 'simpleURL'
  | 'token'
  | 'url'
  | CandidateProfileCVKeySpecifier
)[];
export type CandidateProfileCVFieldPolicy = {
  ID?: FieldPolicy<any> | FieldReadFunction<any>;
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  downloadToken?: FieldPolicy<any> | FieldReadFunction<any>;
  downloadURL?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  simpleURL?: FieldPolicy<any> | FieldReadFunction<any>;
  token?: FieldPolicy<any> | FieldReadFunction<any>;
  url?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CandidateProfileCVCopyKeySpecifier = (
  | 'ID'
  | 'name'
  | 'url'
  | CandidateProfileCVCopyKeySpecifier
)[];
export type CandidateProfileCVCopyFieldPolicy = {
  ID?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  url?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CandidateProfileCVCopyV2KeySpecifier = (
  | 'ID'
  | 'name'
  | 'stamp'
  | CandidateProfileCVCopyV2KeySpecifier
)[];
export type CandidateProfileCVCopyV2FieldPolicy = {
  ID?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  stamp?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CandidateProfileCVGeneratorTokenKeySpecifier = (
  | 'token'
  | CandidateProfileCVGeneratorTokenKeySpecifier
)[];
export type CandidateProfileCVGeneratorTokenFieldPolicy = {
  token?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CandidateProfileCountryOptionsKeySpecifier = (
  | 'contracts'
  | 'drivingLicenses'
  | 'salaryCurrency'
  | 'salaryPeriod'
  | 'salaryType'
  | 'workingHours'
  | CandidateProfileCountryOptionsKeySpecifier
)[];
export type CandidateProfileCountryOptionsFieldPolicy = {
  contracts?: FieldPolicy<any> | FieldReadFunction<any>;
  drivingLicenses?: FieldPolicy<any> | FieldReadFunction<any>;
  salaryCurrency?: FieldPolicy<any> | FieldReadFunction<any>;
  salaryPeriod?: FieldPolicy<any> | FieldReadFunction<any>;
  salaryType?: FieldPolicy<any> | FieldReadFunction<any>;
  workingHours?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CandidateProfileCursorKeyKeySpecifier = (
  | 'key'
  | 'value'
  | CandidateProfileCursorKeyKeySpecifier
)[];
export type CandidateProfileCursorKeyFieldPolicy = {
  key?: FieldPolicy<any> | FieldReadFunction<any>;
  value?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CandidateProfileDataKeySpecifier = (
  | 'basicInfo'
  | 'completeness'
  | 'drivingLicense'
  | 'education'
  | 'experience'
  | 'hobby'
  | 'languages'
  | 'skills'
  | CandidateProfileDataKeySpecifier
)[];
export type CandidateProfileDataFieldPolicy = {
  basicInfo?: FieldPolicy<any> | FieldReadFunction<any>;
  completeness?: FieldPolicy<any> | FieldReadFunction<any>;
  drivingLicense?: FieldPolicy<any> | FieldReadFunction<any>;
  education?: FieldPolicy<any> | FieldReadFunction<any>;
  experience?: FieldPolicy<any> | FieldReadFunction<any>;
  hobby?: FieldPolicy<any> | FieldReadFunction<any>;
  languages?: FieldPolicy<any> | FieldReadFunction<any>;
  skills?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CandidateProfileExperienceKeySpecifier = (
  | 'description'
  | 'employerName'
  | 'endMonth'
  | 'endYear'
  | 'jobTitle'
  | 'ongoing'
  | 'startMonth'
  | 'startYear'
  | CandidateProfileExperienceKeySpecifier
)[];
export type CandidateProfileExperienceFieldPolicy = {
  description?: FieldPolicy<any> | FieldReadFunction<any>;
  employerName?: FieldPolicy<any> | FieldReadFunction<any>;
  endMonth?: FieldPolicy<any> | FieldReadFunction<any>;
  endYear?: FieldPolicy<any> | FieldReadFunction<any>;
  jobTitle?: FieldPolicy<any> | FieldReadFunction<any>;
  ongoing?: FieldPolicy<any> | FieldReadFunction<any>;
  startMonth?: FieldPolicy<any> | FieldReadFunction<any>;
  startYear?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CandidateProfileLanguageSkillKeySpecifier = (
  | 'language'
  | 'proficiency'
  | CandidateProfileLanguageSkillKeySpecifier
)[];
export type CandidateProfileLanguageSkillFieldPolicy = {
  language?: FieldPolicy<any> | FieldReadFunction<any>;
  proficiency?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CandidateProfileLatestApplicationKeySpecifier = (
  | 'ID'
  | 'attachments'
  | 'cancelledAt'
  | 'candidateID'
  | 'candidateUUID'
  | 'createdAt'
  | 'cv'
  | 'cvFileID'
  | 'cvFileName'
  | 'emailAddress'
  | 'employerID'
  | 'employerStatus'
  | 'employerStatusChangedAt'
  | 'firstName'
  | 'hasBeenReadByEmployer'
  | 'isCancelled'
  | 'isOnlyApplication'
  | 'lastName'
  | 'message'
  | 'phoneNumber'
  | 'withProfile'
  | CandidateProfileLatestApplicationKeySpecifier
)[];
export type CandidateProfileLatestApplicationFieldPolicy = {
  ID?: FieldPolicy<any> | FieldReadFunction<any>;
  attachments?: FieldPolicy<any> | FieldReadFunction<any>;
  cancelledAt?: FieldPolicy<any> | FieldReadFunction<any>;
  candidateID?: FieldPolicy<any> | FieldReadFunction<any>;
  candidateUUID?: FieldPolicy<any> | FieldReadFunction<any>;
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  cv?: FieldPolicy<any> | FieldReadFunction<any>;
  cvFileID?: FieldPolicy<any> | FieldReadFunction<any>;
  cvFileName?: FieldPolicy<any> | FieldReadFunction<any>;
  emailAddress?: FieldPolicy<any> | FieldReadFunction<any>;
  employerID?: FieldPolicy<any> | FieldReadFunction<any>;
  employerStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  employerStatusChangedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  firstName?: FieldPolicy<any> | FieldReadFunction<any>;
  hasBeenReadByEmployer?: FieldPolicy<any> | FieldReadFunction<any>;
  isCancelled?: FieldPolicy<any> | FieldReadFunction<any>;
  isOnlyApplication?: FieldPolicy<any> | FieldReadFunction<any>;
  lastName?: FieldPolicy<any> | FieldReadFunction<any>;
  message?: FieldPolicy<any> | FieldReadFunction<any>;
  phoneNumber?: FieldPolicy<any> | FieldReadFunction<any>;
  withProfile?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CandidateProfileLocationKeySpecifier = (
  | 'cityId'
  | 'districtId'
  | 'name'
  | CandidateProfileLocationKeySpecifier
)[];
export type CandidateProfileLocationFieldPolicy = {
  cityId?: FieldPolicy<any> | FieldReadFunction<any>;
  districtId?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CandidateProfileMutationKeySpecifier = (
  | 'ApplyNew'
  | 'BasicInfo'
  | 'CV'
  | 'CVParsingSubmit'
  | 'CancelApplication'
  | 'CandidatesDatabaseConsentSetting'
  | 'CopyCV'
  | 'CopyCVV2'
  | 'DashboardEnabledSettings'
  | 'DeleteCV'
  | 'DeletePreferences'
  | 'DeleteProfile'
  | 'Dislike'
  | 'DrivingLicense'
  | 'Education'
  | 'Experience'
  | 'Hobby'
  | 'IncrementApplicationCounter'
  | 'Languages'
  | 'Like'
  | 'PreferredGeneric'
  | 'PreferredLocation'
  | 'PreferredRoles'
  | 'PreferredSalary'
  | 'SaveApplyQuestionsUserAnswers'
  | 'Skills'
  | 'Undislike'
  | 'Unlike'
  | 'UpdateApplication'
  | 'VisibilitySettings'
  | CandidateProfileMutationKeySpecifier
)[];
export type CandidateProfileMutationFieldPolicy = {
  ApplyNew?: FieldPolicy<any> | FieldReadFunction<any>;
  BasicInfo?: FieldPolicy<any> | FieldReadFunction<any>;
  CV?: FieldPolicy<any> | FieldReadFunction<any>;
  CVParsingSubmit?: FieldPolicy<any> | FieldReadFunction<any>;
  CancelApplication?: FieldPolicy<any> | FieldReadFunction<any>;
  CandidatesDatabaseConsentSetting?: FieldPolicy<any> | FieldReadFunction<any>;
  CopyCV?: FieldPolicy<any> | FieldReadFunction<any>;
  CopyCVV2?: FieldPolicy<any> | FieldReadFunction<any>;
  DashboardEnabledSettings?: FieldPolicy<any> | FieldReadFunction<any>;
  DeleteCV?: FieldPolicy<any> | FieldReadFunction<any>;
  DeletePreferences?: FieldPolicy<any> | FieldReadFunction<any>;
  DeleteProfile?: FieldPolicy<any> | FieldReadFunction<any>;
  Dislike?: FieldPolicy<any> | FieldReadFunction<any>;
  DrivingLicense?: FieldPolicy<any> | FieldReadFunction<any>;
  Education?: FieldPolicy<any> | FieldReadFunction<any>;
  Experience?: FieldPolicy<any> | FieldReadFunction<any>;
  Hobby?: FieldPolicy<any> | FieldReadFunction<any>;
  IncrementApplicationCounter?: FieldPolicy<any> | FieldReadFunction<any>;
  Languages?: FieldPolicy<any> | FieldReadFunction<any>;
  Like?: FieldPolicy<any> | FieldReadFunction<any>;
  PreferredGeneric?: FieldPolicy<any> | FieldReadFunction<any>;
  PreferredLocation?: FieldPolicy<any> | FieldReadFunction<any>;
  PreferredRoles?: FieldPolicy<any> | FieldReadFunction<any>;
  PreferredSalary?: FieldPolicy<any> | FieldReadFunction<any>;
  SaveApplyQuestionsUserAnswers?: FieldPolicy<any> | FieldReadFunction<any>;
  Skills?: FieldPolicy<any> | FieldReadFunction<any>;
  Undislike?: FieldPolicy<any> | FieldReadFunction<any>;
  Unlike?: FieldPolicy<any> | FieldReadFunction<any>;
  UpdateApplication?: FieldPolicy<any> | FieldReadFunction<any>;
  VisibilitySettings?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CandidateProfileNoAuthMutationKeySpecifier = (
  | 'IncrementCounter'
  | CandidateProfileNoAuthMutationKeySpecifier
)[];
export type CandidateProfileNoAuthMutationFieldPolicy = {
  IncrementCounter?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CandidateProfileNotificationsSettingsKeySpecifier = (
  | 'email'
  | 'push'
  | CandidateProfileNotificationsSettingsKeySpecifier
)[];
export type CandidateProfileNotificationsSettingsFieldPolicy = {
  email?: FieldPolicy<any> | FieldReadFunction<any>;
  push?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CandidateProfilePreferencesKeySpecifier = (
  | 'location'
  | 'locationRange'
  | 'preferredContracts'
  | 'preferredContractsV2'
  | 'preferredRoles'
  | 'preferredSalary'
  | 'preferredWorkingHours'
  | 'preferredWorkingHoursV2'
  | CandidateProfilePreferencesKeySpecifier
)[];
export type CandidateProfilePreferencesFieldPolicy = {
  location?: FieldPolicy<any> | FieldReadFunction<any>;
  locationRange?: FieldPolicy<any> | FieldReadFunction<any>;
  preferredContracts?: FieldPolicy<any> | FieldReadFunction<any>;
  preferredContractsV2?: FieldPolicy<any> | FieldReadFunction<any>;
  preferredRoles?: FieldPolicy<any> | FieldReadFunction<any>;
  preferredSalary?: FieldPolicy<any> | FieldReadFunction<any>;
  preferredWorkingHours?: FieldPolicy<any> | FieldReadFunction<any>;
  preferredWorkingHoursV2?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CandidateProfilePreferredSalaryKeySpecifier = (
  | 'amount'
  | 'currency'
  | 'period'
  | 'type'
  | CandidateProfilePreferredSalaryKeySpecifier
)[];
export type CandidateProfilePreferredSalaryFieldPolicy = {
  amount?: FieldPolicy<any> | FieldReadFunction<any>;
  currency?: FieldPolicy<any> | FieldReadFunction<any>;
  period?: FieldPolicy<any> | FieldReadFunction<any>;
  type?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CandidateProfileProfileKeySpecifier = (
  | 'basicInfo'
  | 'completeness'
  | 'drivingLicense'
  | 'education'
  | 'experience'
  | 'hobby'
  | 'languages'
  | 'skills'
  | CandidateProfileProfileKeySpecifier
)[];
export type CandidateProfileProfileFieldPolicy = {
  basicInfo?: FieldPolicy<any> | FieldReadFunction<any>;
  completeness?: FieldPolicy<any> | FieldReadFunction<any>;
  drivingLicense?: FieldPolicy<any> | FieldReadFunction<any>;
  education?: FieldPolicy<any> | FieldReadFunction<any>;
  experience?: FieldPolicy<any> | FieldReadFunction<any>;
  hobby?: FieldPolicy<any> | FieldReadFunction<any>;
  languages?: FieldPolicy<any> | FieldReadFunction<any>;
  skills?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CandidateProfileQueryKeySpecifier = (
  | 'Application'
  | 'ApplicationProfile'
  | 'ApplicationsCount'
  | 'ApplicationsList'
  | 'ApplyQuestions'
  | 'ApplyValidation'
  | 'AutoSuggest'
  | 'CV'
  | 'CVGeneratorTokenProvider'
  | 'CVParsingResult'
  | 'Experiment'
  | 'IsJobSeeker'
  | 'LatestApplication'
  | 'Preferences'
  | 'Profile'
  | 'ProfileCountryOptions'
  | 'ProposedSkills'
  | 'Recommendations'
  | 'RecommendationsV2'
  | 'Settings'
  | 'UploadData'
  | 'UploadToken'
  | CandidateProfileQueryKeySpecifier
)[];
export type CandidateProfileQueryFieldPolicy = {
  Application?: FieldPolicy<any> | FieldReadFunction<any>;
  ApplicationProfile?: FieldPolicy<any> | FieldReadFunction<any>;
  ApplicationsCount?: FieldPolicy<any> | FieldReadFunction<any>;
  ApplicationsList?: FieldPolicy<any> | FieldReadFunction<any>;
  ApplyQuestions?: FieldPolicy<any> | FieldReadFunction<any>;
  ApplyValidation?: FieldPolicy<any> | FieldReadFunction<any>;
  AutoSuggest?: FieldPolicy<any> | FieldReadFunction<any>;
  CV?: FieldPolicy<any> | FieldReadFunction<any>;
  CVGeneratorTokenProvider?: FieldPolicy<any> | FieldReadFunction<any>;
  CVParsingResult?: FieldPolicy<any> | FieldReadFunction<any>;
  Experiment?: FieldPolicy<any> | FieldReadFunction<any>;
  IsJobSeeker?: FieldPolicy<any> | FieldReadFunction<any>;
  LatestApplication?: FieldPolicy<any> | FieldReadFunction<any>;
  Preferences?: FieldPolicy<any> | FieldReadFunction<any>;
  Profile?: FieldPolicy<any> | FieldReadFunction<any>;
  ProfileCountryOptions?: FieldPolicy<any> | FieldReadFunction<any>;
  ProposedSkills?: FieldPolicy<any> | FieldReadFunction<any>;
  Recommendations?: FieldPolicy<any> | FieldReadFunction<any>;
  RecommendationsV2?: FieldPolicy<any> | FieldReadFunction<any>;
  Settings?: FieldPolicy<any> | FieldReadFunction<any>;
  UploadData?: FieldPolicy<any> | FieldReadFunction<any>;
  UploadToken?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CandidateProfileRecommendationKeySpecifier = (
  | 'adId'
  | 'addedAt'
  | 'categoryId'
  | 'cityName'
  | 'contractType'
  | 'districtName'
  | 'rawParams'
  | 'salaryCurrency'
  | 'salaryMax'
  | 'salaryMin'
  | 'salaryPeriod'
  | 'source'
  | 'title'
  | 'url'
  | 'workingHours'
  | CandidateProfileRecommendationKeySpecifier
)[];
export type CandidateProfileRecommendationFieldPolicy = {
  adId?: FieldPolicy<any> | FieldReadFunction<any>;
  addedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  categoryId?: FieldPolicy<any> | FieldReadFunction<any>;
  cityName?: FieldPolicy<any> | FieldReadFunction<any>;
  contractType?: FieldPolicy<any> | FieldReadFunction<any>;
  districtName?: FieldPolicy<any> | FieldReadFunction<any>;
  rawParams?: FieldPolicy<any> | FieldReadFunction<any>;
  salaryCurrency?: FieldPolicy<any> | FieldReadFunction<any>;
  salaryMax?: FieldPolicy<any> | FieldReadFunction<any>;
  salaryMin?: FieldPolicy<any> | FieldReadFunction<any>;
  salaryPeriod?: FieldPolicy<any> | FieldReadFunction<any>;
  source?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
  url?: FieldPolicy<any> | FieldReadFunction<any>;
  workingHours?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CandidateProfileRecommendationJobOfferKeySpecifier = (
  | 'ad'
  | 'adId'
  | 'source'
  | CandidateProfileRecommendationJobOfferKeySpecifier
)[];
export type CandidateProfileRecommendationJobOfferFieldPolicy = {
  ad?: FieldPolicy<any> | FieldReadFunction<any>;
  adId?: FieldPolicy<any> | FieldReadFunction<any>;
  source?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CandidateProfileRecommendationRawParamKeySpecifier = (
  | 'code'
  | 'value'
  | CandidateProfileRecommendationRawParamKeySpecifier
)[];
export type CandidateProfileRecommendationRawParamFieldPolicy = {
  code?: FieldPolicy<any> | FieldReadFunction<any>;
  value?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CandidateProfileSchoolKeySpecifier = (
  | 'endYear'
  | 'name'
  | 'ongoing'
  | 'specialty'
  | 'startYear'
  | CandidateProfileSchoolKeySpecifier
)[];
export type CandidateProfileSchoolFieldPolicy = {
  endYear?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  ongoing?: FieldPolicy<any> | FieldReadFunction<any>;
  specialty?: FieldPolicy<any> | FieldReadFunction<any>;
  startYear?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CandidateProfileSettingsKeySpecifier = (
  | 'candidatesDatabaseConsent'
  | 'dashboardEnabled'
  | 'notifications'
  | 'visibility'
  | CandidateProfileSettingsKeySpecifier
)[];
export type CandidateProfileSettingsFieldPolicy = {
  candidatesDatabaseConsent?: FieldPolicy<any> | FieldReadFunction<any>;
  dashboardEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  notifications?: FieldPolicy<any> | FieldReadFunction<any>;
  visibility?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CandidateProfileSuggestionKeySpecifier = (
  | 'name'
  | CandidateProfileSuggestionKeySpecifier
)[];
export type CandidateProfileSuggestionFieldPolicy = {
  name?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CandidateProfileUploadDataKeySpecifier = (
  | 'token'
  | 'url'
  | CandidateProfileUploadDataKeySpecifier
)[];
export type CandidateProfileUploadDataFieldPolicy = {
  token?: FieldPolicy<any> | FieldReadFunction<any>;
  url?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ChatAttachmentKeySpecifier = (
  | 'id'
  | 'name'
  | 'secureUrl'
  | 'url'
  | ChatAttachmentKeySpecifier
)[];
export type ChatAttachmentFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  secureUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  url?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ChatConversationKeySpecifier = (
  | 'archived'
  | 'blocked'
  | 'id'
  | 'messages'
  | ChatConversationKeySpecifier
)[];
export type ChatConversationFieldPolicy = {
  archived?: FieldPolicy<any> | FieldReadFunction<any>;
  blocked?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  messages?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ChatMessageKeySpecifier = (
  | 'attachments'
  | 'author'
  | 'conversationId'
  | 'createdAt'
  | 'id'
  | 'message'
  | 'seen'
  | ChatMessageKeySpecifier
)[];
export type ChatMessageFieldPolicy = {
  attachments?: FieldPolicy<any> | FieldReadFunction<any>;
  author?: FieldPolicy<any> | FieldReadFunction<any>;
  conversationId?: FieldPolicy<any> | FieldReadFunction<any>;
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  message?: FieldPolicy<any> | FieldReadFunction<any>;
  seen?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CompanyProfileAboutKeySpecifier = (
  | 'companyName'
  | 'description'
  | 'logoUrl'
  | 'tagline'
  | CompanyProfileAboutKeySpecifier
)[];
export type CompanyProfileAboutFieldPolicy = {
  companyName?: FieldPolicy<any> | FieldReadFunction<any>;
  description?: FieldPolicy<any> | FieldReadFunction<any>;
  logoUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  tagline?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CompanyProfileAdditionalInfoKeySpecifier = (
  | 'companySize'
  | 'companyUrl'
  | 'email'
  | 'facebookUrl'
  | 'headquarters'
  | 'industry'
  | 'instagramUrl'
  | 'linkedinUrl'
  | 'phone'
  | 'twitterUrl'
  | 'youtubeUrl'
  | CompanyProfileAdditionalInfoKeySpecifier
)[];
export type CompanyProfileAdditionalInfoFieldPolicy = {
  companySize?: FieldPolicy<any> | FieldReadFunction<any>;
  companyUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  email?: FieldPolicy<any> | FieldReadFunction<any>;
  facebookUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  headquarters?: FieldPolicy<any> | FieldReadFunction<any>;
  industry?: FieldPolicy<any> | FieldReadFunction<any>;
  instagramUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  linkedinUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  phone?: FieldPolicy<any> | FieldReadFunction<any>;
  twitterUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  youtubeUrl?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CompanyProfileAdsKeySpecifier = (
  | 'ads'
  | 'aggregations'
  | 'total'
  | CompanyProfileAdsKeySpecifier
)[];
export type CompanyProfileAdsFieldPolicy = {
  ads?: FieldPolicy<any> | FieldReadFunction<any>;
  aggregations?: FieldPolicy<any> | FieldReadFunction<any>;
  total?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CompanyProfileAdsAggregationKeySpecifier = (
  | 'type'
  | 'values'
  | CompanyProfileAdsAggregationKeySpecifier
)[];
export type CompanyProfileAdsAggregationFieldPolicy = {
  type?: FieldPolicy<any> | FieldReadFunction<any>;
  values?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CompanyProfileAdsAggregationValueKeySpecifier = (
  | 'count'
  | 'label'
  | 'value'
  | CompanyProfileAdsAggregationValueKeySpecifier
)[];
export type CompanyProfileAdsAggregationValueFieldPolicy = {
  count?: FieldPolicy<any> | FieldReadFunction<any>;
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  value?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CompanyProfileAdsAggregationsKeySpecifier = (
  | 'categories'
  | 'cities'
  | CompanyProfileAdsAggregationsKeySpecifier
)[];
export type CompanyProfileAdsAggregationsFieldPolicy = {
  categories?: FieldPolicy<any> | FieldReadFunction<any>;
  cities?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CompanyProfileBaseProfileKeySpecifier = (
  | 'about'
  | 'additionalInfo'
  | 'benefits'
  | 'contact'
  | 'header'
  | 'id'
  | 'lifeAt'
  | 'publishedAt'
  | 'recruitment'
  | 'slug'
  | 'userId'
  | 'userUuid'
  | CompanyProfileBaseProfileKeySpecifier
)[];
export type CompanyProfileBaseProfileFieldPolicy = {
  about?: FieldPolicy<any> | FieldReadFunction<any>;
  additionalInfo?: FieldPolicy<any> | FieldReadFunction<any>;
  benefits?: FieldPolicy<any> | FieldReadFunction<any>;
  contact?: FieldPolicy<any> | FieldReadFunction<any>;
  header?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lifeAt?: FieldPolicy<any> | FieldReadFunction<any>;
  publishedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  recruitment?: FieldPolicy<any> | FieldReadFunction<any>;
  slug?: FieldPolicy<any> | FieldReadFunction<any>;
  userId?: FieldPolicy<any> | FieldReadFunction<any>;
  userUuid?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CompanyProfileBenefitsKeySpecifier = ('items' | CompanyProfileBenefitsKeySpecifier)[];
export type CompanyProfileBenefitsFieldPolicy = {
  items?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CompanyProfileConfigKeySpecifier = (
  | 'id'
  | 'relations'
  | CompanyProfileConfigKeySpecifier
)[];
export type CompanyProfileConfigFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  relations?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CompanyProfileConfigFeatureBannerKeySpecifier = (
  | 'enabled'
  | CompanyProfileConfigFeatureBannerKeySpecifier
)[];
export type CompanyProfileConfigFeatureBannerFieldPolicy = {
  enabled?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CompanyProfileConfigFeatureBaseKeySpecifier = (
  | 'enabled'
  | CompanyProfileConfigFeatureBaseKeySpecifier
)[];
export type CompanyProfileConfigFeatureBaseFieldPolicy = {
  enabled?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CompanyProfileConfigFeatureBenefitsKeySpecifier = (
  | 'enabled'
  | CompanyProfileConfigFeatureBenefitsKeySpecifier
)[];
export type CompanyProfileConfigFeatureBenefitsFieldPolicy = {
  enabled?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CompanyProfileConfigFeatureCompanyUrlKeySpecifier = (
  | 'enabled'
  | CompanyProfileConfigFeatureCompanyUrlKeySpecifier
)[];
export type CompanyProfileConfigFeatureCompanyUrlFieldPolicy = {
  enabled?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CompanyProfileConfigFeatureFollowButtonKeySpecifier = (
  | 'enabled'
  | CompanyProfileConfigFeatureFollowButtonKeySpecifier
)[];
export type CompanyProfileConfigFeatureFollowButtonFieldPolicy = {
  enabled?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CompanyProfileConfigFeatureGalleryKeySpecifier = (
  | 'enabled'
  | 'maxPhotos'
  | CompanyProfileConfigFeatureGalleryKeySpecifier
)[];
export type CompanyProfileConfigFeatureGalleryFieldPolicy = {
  enabled?: FieldPolicy<any> | FieldReadFunction<any>;
  maxPhotos?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CompanyProfileConfigFeatureLogoKeySpecifier = (
  | 'enabled'
  | CompanyProfileConfigFeatureLogoKeySpecifier
)[];
export type CompanyProfileConfigFeatureLogoFieldPolicy = {
  enabled?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CompanyProfileConfigFeatureMultiprofileKeySpecifier = (
  | 'enabled'
  | CompanyProfileConfigFeatureMultiprofileKeySpecifier
)[];
export type CompanyProfileConfigFeatureMultiprofileFieldPolicy = {
  enabled?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CompanyProfileConfigFeaturePromotedOnListingKeySpecifier = (
  | 'enabled'
  | CompanyProfileConfigFeaturePromotedOnListingKeySpecifier
)[];
export type CompanyProfileConfigFeaturePromotedOnListingFieldPolicy = {
  enabled?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CompanyProfileConfigFeatureRecruitmentKeySpecifier = (
  | 'enabled'
  | CompanyProfileConfigFeatureRecruitmentKeySpecifier
)[];
export type CompanyProfileConfigFeatureRecruitmentFieldPolicy = {
  enabled?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CompanyProfileConfigFeatureSocialLinksKeySpecifier = (
  | 'enabled'
  | CompanyProfileConfigFeatureSocialLinksKeySpecifier
)[];
export type CompanyProfileConfigFeatureSocialLinksFieldPolicy = {
  enabled?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CompanyProfileConfigFeaturesKeySpecifier = (
  | 'banner'
  | 'benefits'
  | 'companyUrl'
  | 'followButton'
  | 'gallery'
  | 'logo'
  | 'multiprofile'
  | 'promotedOnListing'
  | 'recruitment'
  | 'socialLinks'
  | CompanyProfileConfigFeaturesKeySpecifier
)[];
export type CompanyProfileConfigFeaturesFieldPolicy = {
  banner?: FieldPolicy<any> | FieldReadFunction<any>;
  benefits?: FieldPolicy<any> | FieldReadFunction<any>;
  companyUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  followButton?: FieldPolicy<any> | FieldReadFunction<any>;
  gallery?: FieldPolicy<any> | FieldReadFunction<any>;
  logo?: FieldPolicy<any> | FieldReadFunction<any>;
  multiprofile?: FieldPolicy<any> | FieldReadFunction<any>;
  promotedOnListing?: FieldPolicy<any> | FieldReadFunction<any>;
  recruitment?: FieldPolicy<any> | FieldReadFunction<any>;
  socialLinks?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CompanyProfileConfigRelationsKeySpecifier = (
  | 'isMainProfile'
  | 'subProfiles'
  | CompanyProfileConfigRelationsKeySpecifier
)[];
export type CompanyProfileConfigRelationsFieldPolicy = {
  isMainProfile?: FieldPolicy<any> | FieldReadFunction<any>;
  subProfiles?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CompanyProfileConfigSubProfileKeySpecifier = (
  | 'id'
  | 'userId'
  | CompanyProfileConfigSubProfileKeySpecifier
)[];
export type CompanyProfileConfigSubProfileFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  userId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CompanyProfileContactKeySpecifier = (
  | 'companyName'
  | 'email'
  | 'headquarters'
  | 'phone'
  | CompanyProfileContactKeySpecifier
)[];
export type CompanyProfileContactFieldPolicy = {
  companyName?: FieldPolicy<any> | FieldReadFunction<any>;
  email?: FieldPolicy<any> | FieldReadFunction<any>;
  headquarters?: FieldPolicy<any> | FieldReadFunction<any>;
  phone?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CompanyProfileHeaderKeySpecifier = ('bannerUrl' | CompanyProfileHeaderKeySpecifier)[];
export type CompanyProfileHeaderFieldPolicy = {
  bannerUrl?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CompanyProfileLifeAtKeySpecifier = (
  | 'description'
  | 'items'
  | CompanyProfileLifeAtKeySpecifier
)[];
export type CompanyProfileLifeAtFieldPolicy = {
  description?: FieldPolicy<any> | FieldReadFunction<any>;
  items?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CompanyProfileLifeAtItemExternalVideoKeySpecifier = (
  | 'id'
  | 'type'
  | 'url'
  | CompanyProfileLifeAtItemExternalVideoKeySpecifier
)[];
export type CompanyProfileLifeAtItemExternalVideoFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  type?: FieldPolicy<any> | FieldReadFunction<any>;
  url?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CompanyProfileLifeAtItemImageKeySpecifier = (
  | 'fileId'
  | 'id'
  | 'type'
  | 'url'
  | CompanyProfileLifeAtItemImageKeySpecifier
)[];
export type CompanyProfileLifeAtItemImageFieldPolicy = {
  fileId?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  type?: FieldPolicy<any> | FieldReadFunction<any>;
  url?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CompanyProfileLocationKeySpecifier = (
  | 'city'
  | 'lat'
  | 'lng'
  | 'region'
  | 'streetName'
  | 'streetNumber'
  | 'zipCode'
  | CompanyProfileLocationKeySpecifier
)[];
export type CompanyProfileLocationFieldPolicy = {
  city?: FieldPolicy<any> | FieldReadFunction<any>;
  lat?: FieldPolicy<any> | FieldReadFunction<any>;
  lng?: FieldPolicy<any> | FieldReadFunction<any>;
  region?: FieldPolicy<any> | FieldReadFunction<any>;
  streetName?: FieldPolicy<any> | FieldReadFunction<any>;
  streetNumber?: FieldPolicy<any> | FieldReadFunction<any>;
  zipCode?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CompanyProfileMutationKeySpecifier = (
  | 'confirmAssets'
  | 'deleteAssets'
  | 'deleteData'
  | 'publishProfile'
  | 'saveAbout'
  | 'saveAdditionalInformation'
  | 'saveBenefits'
  | 'saveContact'
  | 'saveLifeAt'
  | 'saveMetadata'
  | 'saveRecruitment'
  | 'unpublishProfile'
  | CompanyProfileMutationKeySpecifier
)[];
export type CompanyProfileMutationFieldPolicy = {
  confirmAssets?: FieldPolicy<any> | FieldReadFunction<any>;
  deleteAssets?: FieldPolicy<any> | FieldReadFunction<any>;
  deleteData?: FieldPolicy<any> | FieldReadFunction<any>;
  publishProfile?: FieldPolicy<any> | FieldReadFunction<any>;
  saveAbout?: FieldPolicy<any> | FieldReadFunction<any>;
  saveAdditionalInformation?: FieldPolicy<any> | FieldReadFunction<any>;
  saveBenefits?: FieldPolicy<any> | FieldReadFunction<any>;
  saveContact?: FieldPolicy<any> | FieldReadFunction<any>;
  saveLifeAt?: FieldPolicy<any> | FieldReadFunction<any>;
  saveMetadata?: FieldPolicy<any> | FieldReadFunction<any>;
  saveRecruitment?: FieldPolicy<any> | FieldReadFunction<any>;
  unpublishProfile?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CompanyProfilePrivateConfigKeySpecifier = (
  | 'features'
  | 'id'
  | 'relations'
  | 'tier'
  | CompanyProfilePrivateConfigKeySpecifier
)[];
export type CompanyProfilePrivateConfigFieldPolicy = {
  features?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  relations?: FieldPolicy<any> | FieldReadFunction<any>;
  tier?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CompanyProfilePrivateConfigRelationsKeySpecifier = (
  | 'isMainProfile'
  | 'subProfiles'
  | CompanyProfilePrivateConfigRelationsKeySpecifier
)[];
export type CompanyProfilePrivateConfigRelationsFieldPolicy = {
  isMainProfile?: FieldPolicy<any> | FieldReadFunction<any>;
  subProfiles?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CompanyProfilePrivateConfigSubProfileKeySpecifier = (
  | 'id'
  | 'userId'
  | CompanyProfilePrivateConfigSubProfileKeySpecifier
)[];
export type CompanyProfilePrivateConfigSubProfileFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  userId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CompanyProfilePrivateConfigTierKeySpecifier = (
  | 'expireAt'
  | 'type'
  | CompanyProfilePrivateConfigTierKeySpecifier
)[];
export type CompanyProfilePrivateConfigTierFieldPolicy = {
  expireAt?: FieldPolicy<any> | FieldReadFunction<any>;
  type?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CompanyProfilePrivateProfileKeySpecifier = (
  | 'about'
  | 'additionalInfo'
  | 'benefits'
  | 'contact'
  | 'header'
  | 'id'
  | 'lifeAt'
  | 'publishedAt'
  | 'recruitment'
  | 'slug'
  | 'userId'
  | 'userUuid'
  | CompanyProfilePrivateProfileKeySpecifier
)[];
export type CompanyProfilePrivateProfileFieldPolicy = {
  about?: FieldPolicy<any> | FieldReadFunction<any>;
  additionalInfo?: FieldPolicy<any> | FieldReadFunction<any>;
  benefits?: FieldPolicy<any> | FieldReadFunction<any>;
  contact?: FieldPolicy<any> | FieldReadFunction<any>;
  header?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lifeAt?: FieldPolicy<any> | FieldReadFunction<any>;
  publishedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  recruitment?: FieldPolicy<any> | FieldReadFunction<any>;
  slug?: FieldPolicy<any> | FieldReadFunction<any>;
  userId?: FieldPolicy<any> | FieldReadFunction<any>;
  userUuid?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CompanyProfileProfileCountersKeySpecifier = (
  | 'ads'
  | 'cities'
  | CompanyProfileProfileCountersKeySpecifier
)[];
export type CompanyProfileProfileCountersFieldPolicy = {
  ads?: FieldPolicy<any> | FieldReadFunction<any>;
  cities?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CompanyProfileProfilesCarouselKeySpecifier = (
  | 'profiles'
  | CompanyProfileProfilesCarouselKeySpecifier
)[];
export type CompanyProfileProfilesCarouselFieldPolicy = {
  profiles?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CompanyProfileProfilesCarouselProfileKeySpecifier = (
  | 'bannerUrl'
  | 'companyName'
  | 'counters'
  | 'headquarters'
  | 'id'
  | 'industry'
  | 'logoUrl'
  | 'slug'
  | 'userId'
  | CompanyProfileProfilesCarouselProfileKeySpecifier
)[];
export type CompanyProfileProfilesCarouselProfileFieldPolicy = {
  bannerUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  companyName?: FieldPolicy<any> | FieldReadFunction<any>;
  counters?: FieldPolicy<any> | FieldReadFunction<any>;
  headquarters?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  industry?: FieldPolicy<any> | FieldReadFunction<any>;
  logoUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  slug?: FieldPolicy<any> | FieldReadFunction<any>;
  userId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CompanyProfileProfilesListingKeySpecifier = (
  | 'profiles'
  | 'total'
  | CompanyProfileProfilesListingKeySpecifier
)[];
export type CompanyProfileProfilesListingFieldPolicy = {
  profiles?: FieldPolicy<any> | FieldReadFunction<any>;
  total?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CompanyProfileProfilesListingProfileKeySpecifier = (
  | 'bannerUrl'
  | 'companyName'
  | 'counters'
  | 'headquarters'
  | 'id'
  | 'industry'
  | 'logoUrl'
  | 'slug'
  | 'userId'
  | CompanyProfileProfilesListingProfileKeySpecifier
)[];
export type CompanyProfileProfilesListingProfileFieldPolicy = {
  bannerUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  companyName?: FieldPolicy<any> | FieldReadFunction<any>;
  counters?: FieldPolicy<any> | FieldReadFunction<any>;
  headquarters?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  industry?: FieldPolicy<any> | FieldReadFunction<any>;
  logoUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  slug?: FieldPolicy<any> | FieldReadFunction<any>;
  userId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CompanyProfilePublicConfigKeySpecifier = (
  | 'features'
  | 'tier'
  | CompanyProfilePublicConfigKeySpecifier
)[];
export type CompanyProfilePublicConfigFieldPolicy = {
  features?: FieldPolicy<any> | FieldReadFunction<any>;
  tier?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CompanyProfilePublicProfileKeySpecifier = (
  | 'about'
  | 'additionalInfo'
  | 'benefits'
  | 'config'
  | 'contact'
  | 'header'
  | 'id'
  | 'lifeAt'
  | 'publishedAt'
  | 'recruitment'
  | 'slug'
  | 'userId'
  | 'userUuid'
  | CompanyProfilePublicProfileKeySpecifier
)[];
export type CompanyProfilePublicProfileFieldPolicy = {
  about?: FieldPolicy<any> | FieldReadFunction<any>;
  additionalInfo?: FieldPolicy<any> | FieldReadFunction<any>;
  benefits?: FieldPolicy<any> | FieldReadFunction<any>;
  config?: FieldPolicy<any> | FieldReadFunction<any>;
  contact?: FieldPolicy<any> | FieldReadFunction<any>;
  header?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lifeAt?: FieldPolicy<any> | FieldReadFunction<any>;
  publishedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  recruitment?: FieldPolicy<any> | FieldReadFunction<any>;
  slug?: FieldPolicy<any> | FieldReadFunction<any>;
  userId?: FieldPolicy<any> | FieldReadFunction<any>;
  userUuid?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CompanyProfileQueryKeySpecifier = (
  | 'ads'
  | 'employerSegment'
  | 'locationSuggestions'
  | 'metadata'
  | 'previewProfile'
  | 'privateConfig'
  | 'privateProfile'
  | 'profile'
  | 'profileConfig'
  | 'profileV2'
  | 'profiles'
  | 'profilesCarousel'
  | 'profilesListing'
  | 'publicProfileBySlug'
  | 'publicProfileByUuid'
  | 'publicProfiles'
  | 'uploadRequestData'
  | CompanyProfileQueryKeySpecifier
)[];
export type CompanyProfileQueryFieldPolicy = {
  ads?: FieldPolicy<any> | FieldReadFunction<any>;
  employerSegment?: FieldPolicy<any> | FieldReadFunction<any>;
  locationSuggestions?: FieldPolicy<any> | FieldReadFunction<any>;
  metadata?: FieldPolicy<any> | FieldReadFunction<any>;
  previewProfile?: FieldPolicy<any> | FieldReadFunction<any>;
  privateConfig?: FieldPolicy<any> | FieldReadFunction<any>;
  privateProfile?: FieldPolicy<any> | FieldReadFunction<any>;
  profile?: FieldPolicy<any> | FieldReadFunction<any>;
  profileConfig?: FieldPolicy<any> | FieldReadFunction<any>;
  profileV2?: FieldPolicy<any> | FieldReadFunction<any>;
  profiles?: FieldPolicy<any> | FieldReadFunction<any>;
  profilesCarousel?: FieldPolicy<any> | FieldReadFunction<any>;
  profilesListing?: FieldPolicy<any> | FieldReadFunction<any>;
  publicProfileBySlug?: FieldPolicy<any> | FieldReadFunction<any>;
  publicProfileByUuid?: FieldPolicy<any> | FieldReadFunction<any>;
  publicProfiles?: FieldPolicy<any> | FieldReadFunction<any>;
  uploadRequestData?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CompanyProfileRecruitmentKeySpecifier = (
  | 'items'
  | CompanyProfileRecruitmentKeySpecifier
)[];
export type CompanyProfileRecruitmentFieldPolicy = {
  items?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CompanyProfileRecruitmentProcessKeySpecifier = (
  | 'id'
  | 'name'
  | 'steps'
  | CompanyProfileRecruitmentProcessKeySpecifier
)[];
export type CompanyProfileRecruitmentProcessFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  steps?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CompanyProfileRecruitmentProcessStepKeySpecifier = (
  | 'description'
  | 'title'
  | CompanyProfileRecruitmentProcessStepKeySpecifier
)[];
export type CompanyProfileRecruitmentProcessStepFieldPolicy = {
  description?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type EmployerLeadKeySpecifier = ('closed' | 'exists' | 'id' | EmployerLeadKeySpecifier)[];
export type EmployerLeadFieldPolicy = {
  closed?: FieldPolicy<any> | FieldReadFunction<any>;
  exists?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type EmployerPanelMutationKeySpecifier = (
  | 'blockUser'
  | 'changeMultiAppStatus'
  | 'closeEmployerLead'
  | 'deleteMultiAppWithChat'
  | 'editMultiAppNote'
  | 'markMultiAppAsRead'
  | 'offerDelete'
  | 'removeApplyQuestionFromAd'
  | 'saveAdvancedQuestionsToAd'
  | 'saveApplyQuestionToAd'
  | 'saveMultiAppMeetingDate'
  | 'saveQuestionsToAd'
  | 'sendMessage'
  | 'setMultiAppRate'
  | 'unblockUser'
  | EmployerPanelMutationKeySpecifier
)[];
export type EmployerPanelMutationFieldPolicy = {
  blockUser?: FieldPolicy<any> | FieldReadFunction<any>;
  changeMultiAppStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  closeEmployerLead?: FieldPolicy<any> | FieldReadFunction<any>;
  deleteMultiAppWithChat?: FieldPolicy<any> | FieldReadFunction<any>;
  editMultiAppNote?: FieldPolicy<any> | FieldReadFunction<any>;
  markMultiAppAsRead?: FieldPolicy<any> | FieldReadFunction<any>;
  offerDelete?: FieldPolicy<any> | FieldReadFunction<any>;
  removeApplyQuestionFromAd?: FieldPolicy<any> | FieldReadFunction<any>;
  saveAdvancedQuestionsToAd?: FieldPolicy<any> | FieldReadFunction<any>;
  saveApplyQuestionToAd?: FieldPolicy<any> | FieldReadFunction<any>;
  saveMultiAppMeetingDate?: FieldPolicy<any> | FieldReadFunction<any>;
  saveQuestionsToAd?: FieldPolicy<any> | FieldReadFunction<any>;
  sendMessage?: FieldPolicy<any> | FieldReadFunction<any>;
  setMultiAppRate?: FieldPolicy<any> | FieldReadFunction<any>;
  unblockUser?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type EmployerPanelQueryKeySpecifier = (
  | 'applyQuestionsByAdId'
  | 'getAllPredefinedAQ'
  | 'getApolloToken'
  | 'getApplicationAttachments'
  | 'getCandidateProfile'
  | 'getChatConversation'
  | 'getCvGeneratorToken'
  | 'getEmployerLead'
  | 'getEmployerSegment'
  | 'getProfileData'
  | 'multiAppByAppIds'
  | 'multiAppIds'
  | 'offerById'
  | 'offerDelete'
  | 'offerIds'
  | 'offersByIds'
  | 'stafflyGetTestResult'
  | EmployerPanelQueryKeySpecifier
)[];
export type EmployerPanelQueryFieldPolicy = {
  applyQuestionsByAdId?: FieldPolicy<any> | FieldReadFunction<any>;
  getAllPredefinedAQ?: FieldPolicy<any> | FieldReadFunction<any>;
  getApolloToken?: FieldPolicy<any> | FieldReadFunction<any>;
  getApplicationAttachments?: FieldPolicy<any> | FieldReadFunction<any>;
  getCandidateProfile?: FieldPolicy<any> | FieldReadFunction<any>;
  getChatConversation?: FieldPolicy<any> | FieldReadFunction<any>;
  getCvGeneratorToken?: FieldPolicy<any> | FieldReadFunction<any>;
  getEmployerLead?: FieldPolicy<any> | FieldReadFunction<any>;
  getEmployerSegment?: FieldPolicy<any> | FieldReadFunction<any>;
  getProfileData?: FieldPolicy<any> | FieldReadFunction<any>;
  multiAppByAppIds?: FieldPolicy<any> | FieldReadFunction<any>;
  multiAppIds?: FieldPolicy<any> | FieldReadFunction<any>;
  offerById?: FieldPolicy<any> | FieldReadFunction<any>;
  offerDelete?: FieldPolicy<any> | FieldReadFunction<any>;
  offerIds?: FieldPolicy<any> | FieldReadFunction<any>;
  offersByIds?: FieldPolicy<any> | FieldReadFunction<any>;
  stafflyGetTestResult?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type EmployerProfileKeySpecifier = (
  | 'atlasUserId'
  | 'bannerUrl'
  | 'benefits'
  | 'companyName'
  | 'companySize'
  | 'companyUrl'
  | 'createdAt'
  | 'description'
  | 'email'
  | 'facebookUrl'
  | 'gdpr'
  | 'headquarters'
  | 'id'
  | 'industry'
  | 'instagramUrl'
  | 'lifeAt'
  | 'linkedinUrl'
  | 'logoUrl'
  | 'mobileBannerUrl'
  | 'phone'
  | 'publishedAt'
  | 'recruitment'
  | 'slug'
  | 'tagline'
  | 'twitterUrl'
  | 'updatedAt'
  | 'youtubeUrl'
  | EmployerProfileKeySpecifier
)[];
export type EmployerProfileFieldPolicy = {
  atlasUserId?: FieldPolicy<any> | FieldReadFunction<any>;
  bannerUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  benefits?: FieldPolicy<any> | FieldReadFunction<any>;
  companyName?: FieldPolicy<any> | FieldReadFunction<any>;
  companySize?: FieldPolicy<any> | FieldReadFunction<any>;
  companyUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  description?: FieldPolicy<any> | FieldReadFunction<any>;
  email?: FieldPolicy<any> | FieldReadFunction<any>;
  facebookUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  gdpr?: FieldPolicy<any> | FieldReadFunction<any>;
  headquarters?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  industry?: FieldPolicy<any> | FieldReadFunction<any>;
  instagramUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  lifeAt?: FieldPolicy<any> | FieldReadFunction<any>;
  linkedinUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  logoUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  mobileBannerUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  phone?: FieldPolicy<any> | FieldReadFunction<any>;
  publishedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  recruitment?: FieldPolicy<any> | FieldReadFunction<any>;
  slug?: FieldPolicy<any> | FieldReadFunction<any>;
  tagline?: FieldPolicy<any> | FieldReadFunction<any>;
  twitterUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  updatedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  youtubeUrl?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type EmployerSegmentResponseKeySpecifier = (
  | 'employerSegment'
  | 'id'
  | 'type'
  | EmployerSegmentResponseKeySpecifier
)[];
export type EmployerSegmentResponseFieldPolicy = {
  employerSegment?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  type?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type HomepageArticleKeySpecifier = (
  | 'URL'
  | 'description'
  | 'imageThumbnail'
  | 'imageURL'
  | 'title'
  | HomepageArticleKeySpecifier
)[];
export type HomepageArticleFieldPolicy = {
  URL?: FieldPolicy<any> | FieldReadFunction<any>;
  description?: FieldPolicy<any> | FieldReadFunction<any>;
  imageThumbnail?: FieldPolicy<any> | FieldReadFunction<any>;
  imageURL?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type HomepageFeaturedCategoryKeySpecifier = ('ID' | HomepageFeaturedCategoryKeySpecifier)[];
export type HomepageFeaturedCategoryFieldPolicy = {
  ID?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type HomepageFeaturedEmployerKeySpecifier = (
  | 'ID'
  | 'UUID'
  | 'bannerURL'
  | 'locationCounter'
  | 'logoURL'
  | 'name'
  | 'openPositionCounter'
  | HomepageFeaturedEmployerKeySpecifier
)[];
export type HomepageFeaturedEmployerFieldPolicy = {
  ID?: FieldPolicy<any> | FieldReadFunction<any>;
  UUID?: FieldPolicy<any> | FieldReadFunction<any>;
  bannerURL?: FieldPolicy<any> | FieldReadFunction<any>;
  locationCounter?: FieldPolicy<any> | FieldReadFunction<any>;
  logoURL?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  openPositionCounter?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type HomepageQueryKeySpecifier = (
  | 'FeaturedCategories'
  | 'FeaturedEmployers'
  | 'LatestArticles'
  | HomepageQueryKeySpecifier
)[];
export type HomepageQueryFieldPolicy = {
  FeaturedCategories?: FieldPolicy<any> | FieldReadFunction<any>;
  FeaturedEmployers?: FieldPolicy<any> | FieldReadFunction<any>;
  LatestArticles?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ImageThumbnailKeySpecifier = ('s' | 'xs' | ImageThumbnailKeySpecifier)[];
export type ImageThumbnailFieldPolicy = {
  s?: FieldPolicy<any> | FieldReadFunction<any>;
  xs?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type JobAdKeySpecifier = (
  | 'addedAt'
  | 'cdbCounter'
  | 'cityName'
  | 'counters'
  | 'description'
  | 'districtName'
  | 'id'
  | 'salaryValue'
  | 'status'
  | 'title'
  | 'trackingParameters'
  | 'url'
  | 'validTo'
  | JobAdKeySpecifier
)[];
export type JobAdFieldPolicy = {
  addedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  cdbCounter?: FieldPolicy<any> | FieldReadFunction<any>;
  cityName?: FieldPolicy<any> | FieldReadFunction<any>;
  counters?: FieldPolicy<any> | FieldReadFunction<any>;
  description?: FieldPolicy<any> | FieldReadFunction<any>;
  districtName?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  salaryValue?: FieldPolicy<any> | FieldReadFunction<any>;
  status?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
  trackingParameters?: FieldPolicy<any> | FieldReadFunction<any>;
  url?: FieldPolicy<any> | FieldReadFunction<any>;
  validTo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type JobAdCountersKeySpecifier = (
  | 'id'
  | 'newApplications'
  | 'rejected'
  | 'selectedForContact'
  | 'total'
  | 'unread'
  | JobAdCountersKeySpecifier
)[];
export type JobAdCountersFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  newApplications?: FieldPolicy<any> | FieldReadFunction<any>;
  rejected?: FieldPolicy<any> | FieldReadFunction<any>;
  selectedForContact?: FieldPolicy<any> | FieldReadFunction<any>;
  total?: FieldPolicy<any> | FieldReadFunction<any>;
  unread?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type JobAdTrackingParametersKeySpecifier = (
  | 'cat_l1_id'
  | 'cat_l1_name'
  | 'cat_l2_id'
  | 'cat_l2_name'
  | 'cat_l3_id'
  | 'cat_l3_name'
  | 'cat_l4_id'
  | 'cat_l4_name'
  | 'category_id'
  | 'city_id'
  | 'city_name'
  | 'province_id'
  | 'region_name'
  | JobAdTrackingParametersKeySpecifier
)[];
export type JobAdTrackingParametersFieldPolicy = {
  cat_l1_id?: FieldPolicy<any> | FieldReadFunction<any>;
  cat_l1_name?: FieldPolicy<any> | FieldReadFunction<any>;
  cat_l2_id?: FieldPolicy<any> | FieldReadFunction<any>;
  cat_l2_name?: FieldPolicy<any> | FieldReadFunction<any>;
  cat_l3_id?: FieldPolicy<any> | FieldReadFunction<any>;
  cat_l3_name?: FieldPolicy<any> | FieldReadFunction<any>;
  cat_l4_id?: FieldPolicy<any> | FieldReadFunction<any>;
  cat_l4_name?: FieldPolicy<any> | FieldReadFunction<any>;
  category_id?: FieldPolicy<any> | FieldReadFunction<any>;
  city_id?: FieldPolicy<any> | FieldReadFunction<any>;
  city_name?: FieldPolicy<any> | FieldReadFunction<any>;
  province_id?: FieldPolicy<any> | FieldReadFunction<any>;
  region_name?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type JobAdUnreadCountersKeySpecifier = (
  | 'newApplications'
  | 'rejected'
  | 'selectedForContact'
  | JobAdUnreadCountersKeySpecifier
)[];
export type JobAdUnreadCountersFieldPolicy = {
  newApplications?: FieldPolicy<any> | FieldReadFunction<any>;
  rejected?: FieldPolicy<any> | FieldReadFunction<any>;
  selectedForContact?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type JobOfferCityKeySpecifier = (
  | 'ID'
  | 'map'
  | 'name'
  | 'normalized'
  | 'regionID'
  | JobOfferCityKeySpecifier
)[];
export type JobOfferCityFieldPolicy = {
  ID?: FieldPolicy<any> | FieldReadFunction<any>;
  map?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  normalized?: FieldPolicy<any> | FieldReadFunction<any>;
  regionID?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type JobOfferDistrictKeySpecifier = (
  | 'ID'
  | 'cityID'
  | 'map'
  | 'name'
  | JobOfferDistrictKeySpecifier
)[];
export type JobOfferDistrictFieldPolicy = {
  ID?: FieldPolicy<any> | FieldReadFunction<any>;
  cityID?: FieldPolicy<any> | FieldReadFunction<any>;
  map?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type JobOfferEmployerKeySpecifier = (
  | 'bannerUrl'
  | 'companyName'
  | 'description'
  | 'hasProfile'
  | 'id'
  | 'isVerified'
  | 'logoThumbnails'
  | 'logoUrl'
  | 'mobileBannerUrl'
  | 'slug'
  | JobOfferEmployerKeySpecifier
)[];
export type JobOfferEmployerFieldPolicy = {
  bannerUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  companyName?: FieldPolicy<any> | FieldReadFunction<any>;
  description?: FieldPolicy<any> | FieldReadFunction<any>;
  hasProfile?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  isVerified?: FieldPolicy<any> | FieldReadFunction<any>;
  logoThumbnails?: FieldPolicy<any> | FieldReadFunction<any>;
  logoUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  mobileBannerUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  slug?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type JobOfferEmployerLogoThumbnailsKeySpecifier = (
  | 'M'
  | 'S'
  | JobOfferEmployerLogoThumbnailsKeySpecifier
)[];
export type JobOfferEmployerLogoThumbnailsFieldPolicy = {
  M?: FieldPolicy<any> | FieldReadFunction<any>;
  S?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type JobOfferFloatValueKeySpecifier = ('label' | 'value' | JobOfferFloatValueKeySpecifier)[];
export type JobOfferFloatValueFieldPolicy = {
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  value?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type JobOfferIntValueKeySpecifier = ('label' | 'value' | JobOfferIntValueKeySpecifier)[];
export type JobOfferIntValueFieldPolicy = {
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  value?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type JobOfferLocationKeySpecifier = (
  | 'city'
  | 'district'
  | 'map'
  | 'region'
  | JobOfferLocationKeySpecifier
)[];
export type JobOfferLocationFieldPolicy = {
  city?: FieldPolicy<any> | FieldReadFunction<any>;
  district?: FieldPolicy<any> | FieldReadFunction<any>;
  map?: FieldPolicy<any> | FieldReadFunction<any>;
  region?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type JobOfferMapKeySpecifier = (
  | 'lat'
  | 'lon'
  | 'radius'
  | 'zoom'
  | JobOfferMapKeySpecifier
)[];
export type JobOfferMapFieldPolicy = {
  lat?: FieldPolicy<any> | FieldReadFunction<any>;
  lon?: FieldPolicy<any> | FieldReadFunction<any>;
  radius?: FieldPolicy<any> | FieldReadFunction<any>;
  zoom?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type JobOfferOfferKeySpecifier = (
  | 'ID'
  | 'addedAt'
  | 'applyUrl'
  | 'categoryID'
  | 'description'
  | 'employer'
  | 'isBusiness'
  | 'isSeek'
  | 'location'
  | 'parameters'
  | 'postingComponent'
  | 'salary'
  | 'status'
  | 'title'
  | 'url'
  | 'userID'
  | 'userUUID'
  | 'validTo'
  | JobOfferOfferKeySpecifier
)[];
export type JobOfferOfferFieldPolicy = {
  ID?: FieldPolicy<any> | FieldReadFunction<any>;
  addedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  applyUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  categoryID?: FieldPolicy<any> | FieldReadFunction<any>;
  description?: FieldPolicy<any> | FieldReadFunction<any>;
  employer?: FieldPolicy<any> | FieldReadFunction<any>;
  isBusiness?: FieldPolicy<any> | FieldReadFunction<any>;
  isSeek?: FieldPolicy<any> | FieldReadFunction<any>;
  location?: FieldPolicy<any> | FieldReadFunction<any>;
  parameters?: FieldPolicy<any> | FieldReadFunction<any>;
  postingComponent?: FieldPolicy<any> | FieldReadFunction<any>;
  salary?: FieldPolicy<any> | FieldReadFunction<any>;
  status?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
  url?: FieldPolicy<any> | FieldReadFunction<any>;
  userID?: FieldPolicy<any> | FieldReadFunction<any>;
  userUUID?: FieldPolicy<any> | FieldReadFunction<any>;
  validTo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type JobOfferParameterKeySpecifier = (
  | 'code'
  | 'html'
  | 'label'
  | 'values'
  | JobOfferParameterKeySpecifier
)[];
export type JobOfferParameterFieldPolicy = {
  code?: FieldPolicy<any> | FieldReadFunction<any>;
  html?: FieldPolicy<any> | FieldReadFunction<any>;
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  values?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type JobOfferPostingComponentKeySpecifier = (
  | 'companyName'
  | 'gdprClause'
  | 'locationBuildingNumber'
  | 'locationPostalCode'
  | 'locationStreet'
  | JobOfferPostingComponentKeySpecifier
)[];
export type JobOfferPostingComponentFieldPolicy = {
  companyName?: FieldPolicy<any> | FieldReadFunction<any>;
  gdprClause?: FieldPolicy<any> | FieldReadFunction<any>;
  locationBuildingNumber?: FieldPolicy<any> | FieldReadFunction<any>;
  locationPostalCode?: FieldPolicy<any> | FieldReadFunction<any>;
  locationStreet?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type JobOfferQueryKeySpecifier = (
  | 'Employer'
  | 'Employers'
  | 'JobOffer'
  | 'JobOffers'
  | JobOfferQueryKeySpecifier
)[];
export type JobOfferQueryFieldPolicy = {
  Employer?: FieldPolicy<any> | FieldReadFunction<any>;
  Employers?: FieldPolicy<any> | FieldReadFunction<any>;
  JobOffer?: FieldPolicy<any> | FieldReadFunction<any>;
  JobOffers?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type JobOfferRegionKeySpecifier = (
  | 'ID'
  | 'name'
  | 'normalized'
  | JobOfferRegionKeySpecifier
)[];
export type JobOfferRegionFieldPolicy = {
  ID?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  normalized?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type JobOfferSalaryKeySpecifier = (
  | 'amount'
  | 'arranged'
  | 'currency'
  | 'currencySymbol'
  | 'from'
  | 'label'
  | 'to'
  | 'type'
  | JobOfferSalaryKeySpecifier
)[];
export type JobOfferSalaryFieldPolicy = {
  amount?: FieldPolicy<any> | FieldReadFunction<any>;
  arranged?: FieldPolicy<any> | FieldReadFunction<any>;
  currency?: FieldPolicy<any> | FieldReadFunction<any>;
  currencySymbol?: FieldPolicy<any> | FieldReadFunction<any>;
  from?: FieldPolicy<any> | FieldReadFunction<any>;
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  to?: FieldPolicy<any> | FieldReadFunction<any>;
  type?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type JobOfferSalaryTypeKeySpecifier = ('label' | 'value' | JobOfferSalaryTypeKeySpecifier)[];
export type JobOfferSalaryTypeFieldPolicy = {
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  value?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type JobOfferStringValueKeySpecifier = (
  | 'code'
  | 'label'
  | JobOfferStringValueKeySpecifier
)[];
export type JobOfferStringValueFieldPolicy = {
  code?: FieldPolicy<any> | FieldReadFunction<any>;
  label?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type LifeAtKeySpecifier = ('description' | 'items' | LifeAtKeySpecifier)[];
export type LifeAtFieldPolicy = {
  description?: FieldPolicy<any> | FieldReadFunction<any>;
  items?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type LifeAtItemExternalVideoKeySpecifier = (
  | 'id'
  | 'type'
  | 'url'
  | LifeAtItemExternalVideoKeySpecifier
)[];
export type LifeAtItemExternalVideoFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  type?: FieldPolicy<any> | FieldReadFunction<any>;
  url?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type LifeAtItemImageKeySpecifier = (
  | 'fileId'
  | 'id'
  | 'type'
  | 'url'
  | LifeAtItemImageKeySpecifier
)[];
export type LifeAtItemImageFieldPolicy = {
  fileId?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  type?: FieldPolicy<any> | FieldReadFunction<any>;
  url?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type LocationPayloadKeySpecifier = (
  | 'city'
  | 'lat'
  | 'lng'
  | 'region'
  | 'streetName'
  | 'streetNumber'
  | 'zipCode'
  | LocationPayloadKeySpecifier
)[];
export type LocationPayloadFieldPolicy = {
  city?: FieldPolicy<any> | FieldReadFunction<any>;
  lat?: FieldPolicy<any> | FieldReadFunction<any>;
  lng?: FieldPolicy<any> | FieldReadFunction<any>;
  region?: FieldPolicy<any> | FieldReadFunction<any>;
  streetName?: FieldPolicy<any> | FieldReadFunction<any>;
  streetNumber?: FieldPolicy<any> | FieldReadFunction<any>;
  zipCode?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type LocationSuggestionKeySpecifier = (
  | 'city'
  | 'id'
  | 'label'
  | 'lat'
  | 'lng'
  | 'region'
  | 'streetName'
  | 'streetNumber'
  | 'zipCode'
  | LocationSuggestionKeySpecifier
)[];
export type LocationSuggestionFieldPolicy = {
  city?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  lat?: FieldPolicy<any> | FieldReadFunction<any>;
  lng?: FieldPolicy<any> | FieldReadFunction<any>;
  region?: FieldPolicy<any> | FieldReadFunction<any>;
  streetName?: FieldPolicy<any> | FieldReadFunction<any>;
  streetNumber?: FieldPolicy<any> | FieldReadFunction<any>;
  zipCode?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type MetadataKeySpecifier = (
  | 'benefitsFeedback'
  | 'onboardingSteps'
  | 'startDate'
  | 'updatedAt'
  | MetadataKeySpecifier
)[];
export type MetadataFieldPolicy = {
  benefitsFeedback?: FieldPolicy<any> | FieldReadFunction<any>;
  onboardingSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  startDate?: FieldPolicy<any> | FieldReadFunction<any>;
  updatedAt?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type MultiApplicationKeySpecifier = (
  | 'adId'
  | 'allAttachments'
  | 'allCVs'
  | 'attachments'
  | 'candidate'
  | 'cv'
  | 'employerId'
  | 'fromInvitation'
  | 'hasAttachments'
  | 'id'
  | 'isApplyForm'
  | 'isCancelled'
  | 'isInitialMessageRead'
  | 'isReApplication'
  | 'jobAdId'
  | 'meetingDate'
  | 'note'
  | 'postedAt'
  | 'rankingScore'
  | 'rate'
  | 'read'
  | 'relatedAppsIds'
  | 'scoreExplanation'
  | 'sortDate'
  | 'status'
  | 'unreadMessagesCount'
  | 'userAnswers'
  | 'withProfile'
  | MultiApplicationKeySpecifier
)[];
export type MultiApplicationFieldPolicy = {
  adId?: FieldPolicy<any> | FieldReadFunction<any>;
  allAttachments?: FieldPolicy<any> | FieldReadFunction<any>;
  allCVs?: FieldPolicy<any> | FieldReadFunction<any>;
  attachments?: FieldPolicy<any> | FieldReadFunction<any>;
  candidate?: FieldPolicy<any> | FieldReadFunction<any>;
  cv?: FieldPolicy<any> | FieldReadFunction<any>;
  employerId?: FieldPolicy<any> | FieldReadFunction<any>;
  fromInvitation?: FieldPolicy<any> | FieldReadFunction<any>;
  hasAttachments?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  isApplyForm?: FieldPolicy<any> | FieldReadFunction<any>;
  isCancelled?: FieldPolicy<any> | FieldReadFunction<any>;
  isInitialMessageRead?: FieldPolicy<any> | FieldReadFunction<any>;
  isReApplication?: FieldPolicy<any> | FieldReadFunction<any>;
  jobAdId?: FieldPolicy<any> | FieldReadFunction<any>;
  meetingDate?: FieldPolicy<any> | FieldReadFunction<any>;
  note?: FieldPolicy<any> | FieldReadFunction<any>;
  postedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  rankingScore?: FieldPolicy<any> | FieldReadFunction<any>;
  rate?: FieldPolicy<any> | FieldReadFunction<any>;
  read?: FieldPolicy<any> | FieldReadFunction<any>;
  relatedAppsIds?: FieldPolicy<any> | FieldReadFunction<any>;
  scoreExplanation?: FieldPolicy<any> | FieldReadFunction<any>;
  sortDate?: FieldPolicy<any> | FieldReadFunction<any>;
  status?: FieldPolicy<any> | FieldReadFunction<any>;
  unreadMessagesCount?: FieldPolicy<any> | FieldReadFunction<any>;
  userAnswers?: FieldPolicy<any> | FieldReadFunction<any>;
  withProfile?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type MutationKeySpecifier = (
  | 'BusinessCard'
  | 'CandidateProfile'
  | 'CandidateProfileNoAuth'
  | 'CompanyProfile'
  | 'EmployerPanel'
  | MutationKeySpecifier
)[];
export type MutationFieldPolicy = {
  BusinessCard?: FieldPolicy<any> | FieldReadFunction<any>;
  CandidateProfile?: FieldPolicy<any> | FieldReadFunction<any>;
  CandidateProfileNoAuth?: FieldPolicy<any> | FieldReadFunction<any>;
  CompanyProfile?: FieldPolicy<any> | FieldReadFunction<any>;
  EmployerPanel?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type NoteKeySpecifier = ('content' | 'updatedAt' | NoteKeySpecifier)[];
export type NoteFieldPolicy = {
  content?: FieldPolicy<any> | FieldReadFunction<any>;
  updatedAt?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ProfileCountryOptionKeySpecifier = (
  | 'label'
  | 'normalizedValue'
  | 'value'
  | ProfileCountryOptionKeySpecifier
)[];
export type ProfileCountryOptionFieldPolicy = {
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  normalizedValue?: FieldPolicy<any> | FieldReadFunction<any>;
  value?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type QueryKeySpecifier = (
  | 'BusinessCard'
  | 'CandidateProfile'
  | 'CompanyProfile'
  | 'EmployerPanel'
  | 'Homepage'
  | 'JobOffer'
  | 'atlasUser'
  | QueryKeySpecifier
)[];
export type QueryFieldPolicy = {
  BusinessCard?: FieldPolicy<any> | FieldReadFunction<any>;
  CandidateProfile?: FieldPolicy<any> | FieldReadFunction<any>;
  CompanyProfile?: FieldPolicy<any> | FieldReadFunction<any>;
  EmployerPanel?: FieldPolicy<any> | FieldReadFunction<any>;
  Homepage?: FieldPolicy<any> | FieldReadFunction<any>;
  JobOffer?: FieldPolicy<any> | FieldReadFunction<any>;
  atlasUser?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RecruitmentProcessKeySpecifier = (
  | 'id'
  | 'name'
  | 'steps'
  | RecruitmentProcessKeySpecifier
)[];
export type RecruitmentProcessFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  steps?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RecruitmentProcessStepPayloadKeySpecifier = (
  | 'description'
  | 'title'
  | RecruitmentProcessStepPayloadKeySpecifier
)[];
export type RecruitmentProcessStepPayloadFieldPolicy = {
  description?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SecureUrlKeySpecifier = ('token' | 'url' | SecureUrlKeySpecifier)[];
export type SecureUrlFieldPolicy = {
  token?: FieldPolicy<any> | FieldReadFunction<any>;
  url?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type StafflyReportKeySpecifier = (
  | 'id'
  | 'name'
  | 'secureUrl'
  | 'url'
  | StafflyReportKeySpecifier
)[];
export type StafflyReportFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  secureUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  url?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type StafflyReportSecureUrlKeySpecifier = (
  | 'token'
  | 'url'
  | StafflyReportSecureUrlKeySpecifier
)[];
export type StafflyReportSecureUrlFieldPolicy = {
  token?: FieldPolicy<any> | FieldReadFunction<any>;
  url?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type StafflyTestResultKeySpecifier = (
  | 'adID'
  | 'candidateUUID'
  | 'report'
  | 'testID'
  | StafflyTestResultKeySpecifier
)[];
export type StafflyTestResultFieldPolicy = {
  adID?: FieldPolicy<any> | FieldReadFunction<any>;
  candidateUUID?: FieldPolicy<any> | FieldReadFunction<any>;
  report?: FieldPolicy<any> | FieldReadFunction<any>;
  testID?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UploadRequestDataPayloadKeySpecifier = (
  | 'token'
  | 'url'
  | UploadRequestDataPayloadKeySpecifier
)[];
export type UploadRequestDataPayloadFieldPolicy = {
  token?: FieldPolicy<any> | FieldReadFunction<any>;
  url?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UserAnswerKeySpecifier = (
  | 'questionId'
  | 'questionLabel'
  | 'values'
  | UserAnswerKeySpecifier
)[];
export type UserAnswerFieldPolicy = {
  questionId?: FieldPolicy<any> | FieldReadFunction<any>;
  questionLabel?: FieldPolicy<any> | FieldReadFunction<any>;
  values?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type StrictTypedTypePolicies = {
  ApolloToken?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | ApolloTokenKeySpecifier | (() => undefined | ApolloTokenKeySpecifier);
    fields?: ApolloTokenFieldPolicy;
  };
  ApplicationAttachments?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ApplicationAttachmentsKeySpecifier
      | (() => undefined | ApplicationAttachmentsKeySpecifier);
    fields?: ApplicationAttachmentsFieldPolicy;
  };
  ApplyQuestion?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | ApplyQuestionKeySpecifier | (() => undefined | ApplyQuestionKeySpecifier);
    fields?: ApplyQuestionFieldPolicy;
  };
  ApplyQuestionAnswer?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ApplyQuestionAnswerKeySpecifier
      | (() => undefined | ApplyQuestionAnswerKeySpecifier);
    fields?: ApplyQuestionAnswerFieldPolicy;
  };
  AtlasUser?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | AtlasUserKeySpecifier | (() => undefined | AtlasUserKeySpecifier);
    fields?: AtlasUserFieldPolicy;
  };
  Attachment?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | AttachmentKeySpecifier | (() => undefined | AttachmentKeySpecifier);
    fields?: AttachmentFieldPolicy;
  };
  BusinessCardAbout?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | BusinessCardAboutKeySpecifier
      | (() => undefined | BusinessCardAboutKeySpecifier);
    fields?: BusinessCardAboutFieldPolicy;
  };
  BusinessCardAdditionalInfo?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | BusinessCardAdditionalInfoKeySpecifier
      | (() => undefined | BusinessCardAdditionalInfoKeySpecifier);
    fields?: BusinessCardAdditionalInfoFieldPolicy;
  };
  BusinessCardBaseProfile?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | BusinessCardBaseProfileKeySpecifier
      | (() => undefined | BusinessCardBaseProfileKeySpecifier);
    fields?: BusinessCardBaseProfileFieldPolicy;
  };
  BusinessCardContact?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | BusinessCardContactKeySpecifier
      | (() => undefined | BusinessCardContactKeySpecifier);
    fields?: BusinessCardContactFieldPolicy;
  };
  BusinessCardHeader?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | BusinessCardHeaderKeySpecifier
      | (() => undefined | BusinessCardHeaderKeySpecifier);
    fields?: BusinessCardHeaderFieldPolicy;
  };
  BusinessCardLifeAt?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | BusinessCardLifeAtKeySpecifier
      | (() => undefined | BusinessCardLifeAtKeySpecifier);
    fields?: BusinessCardLifeAtFieldPolicy;
  };
  BusinessCardLifeAtItemExternalVideo?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | BusinessCardLifeAtItemExternalVideoKeySpecifier
      | (() => undefined | BusinessCardLifeAtItemExternalVideoKeySpecifier);
    fields?: BusinessCardLifeAtItemExternalVideoFieldPolicy;
  };
  BusinessCardLifeAtItemImage?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | BusinessCardLifeAtItemImageKeySpecifier
      | (() => undefined | BusinessCardLifeAtItemImageKeySpecifier);
    fields?: BusinessCardLifeAtItemImageFieldPolicy;
  };
  BusinessCardLocation?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | BusinessCardLocationKeySpecifier
      | (() => undefined | BusinessCardLocationKeySpecifier);
    fields?: BusinessCardLocationFieldPolicy;
  };
  BusinessCardLocationSuggestion?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | BusinessCardLocationSuggestionKeySpecifier
      | (() => undefined | BusinessCardLocationSuggestionKeySpecifier);
    fields?: BusinessCardLocationSuggestionFieldPolicy;
  };
  BusinessCardMutation?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | BusinessCardMutationKeySpecifier
      | (() => undefined | BusinessCardMutationKeySpecifier);
    fields?: BusinessCardMutationFieldPolicy;
  };
  BusinessCardPrivateProfile?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | BusinessCardPrivateProfileKeySpecifier
      | (() => undefined | BusinessCardPrivateProfileKeySpecifier);
    fields?: BusinessCardPrivateProfileFieldPolicy;
  };
  BusinessCardPublicProfile?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | BusinessCardPublicProfileKeySpecifier
      | (() => undefined | BusinessCardPublicProfileKeySpecifier);
    fields?: BusinessCardPublicProfileFieldPolicy;
  };
  BusinessCardQuery?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | BusinessCardQueryKeySpecifier
      | (() => undefined | BusinessCardQueryKeySpecifier);
    fields?: BusinessCardQueryFieldPolicy;
  };
  BusinessCardUploadRequestDataPayload?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | BusinessCardUploadRequestDataPayloadKeySpecifier
      | (() => undefined | BusinessCardUploadRequestDataPayloadKeySpecifier);
    fields?: BusinessCardUploadRequestDataPayloadFieldPolicy;
  };
  CVGeneratorOutput?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CVGeneratorOutputKeySpecifier
      | (() => undefined | CVGeneratorOutputKeySpecifier);
    fields?: CVGeneratorOutputFieldPolicy;
  };
  CVParsingResult?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CVParsingResultKeySpecifier
      | (() => undefined | CVParsingResultKeySpecifier);
    fields?: CVParsingResultFieldPolicy;
  };
  Candidate?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | CandidateKeySpecifier | (() => undefined | CandidateKeySpecifier);
    fields?: CandidateFieldPolicy;
  };
  CandidateProfile?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CandidateProfileKeySpecifier
      | (() => undefined | CandidateProfileKeySpecifier);
    fields?: CandidateProfileFieldPolicy;
  };
  CandidateProfileAd?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CandidateProfileAdKeySpecifier
      | (() => undefined | CandidateProfileAdKeySpecifier);
    fields?: CandidateProfileAdFieldPolicy;
  };
  CandidateProfileApplication?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CandidateProfileApplicationKeySpecifier
      | (() => undefined | CandidateProfileApplicationKeySpecifier);
    fields?: CandidateProfileApplicationFieldPolicy;
  };
  CandidateProfileApplicationAnswer?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CandidateProfileApplicationAnswerKeySpecifier
      | (() => undefined | CandidateProfileApplicationAnswerKeySpecifier);
    fields?: CandidateProfileApplicationAnswerFieldPolicy;
  };
  CandidateProfileApplicationsList?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CandidateProfileApplicationsListKeySpecifier
      | (() => undefined | CandidateProfileApplicationsListKeySpecifier);
    fields?: CandidateProfileApplicationsListFieldPolicy;
  };
  CandidateProfileApplyValidation?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CandidateProfileApplyValidationKeySpecifier
      | (() => undefined | CandidateProfileApplyValidationKeySpecifier);
    fields?: CandidateProfileApplyValidationFieldPolicy;
  };
  CandidateProfileBasicInfo?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CandidateProfileBasicInfoKeySpecifier
      | (() => undefined | CandidateProfileBasicInfoKeySpecifier);
    fields?: CandidateProfileBasicInfoFieldPolicy;
  };
  CandidateProfileCV?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CandidateProfileCVKeySpecifier
      | (() => undefined | CandidateProfileCVKeySpecifier);
    fields?: CandidateProfileCVFieldPolicy;
  };
  CandidateProfileCVCopy?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CandidateProfileCVCopyKeySpecifier
      | (() => undefined | CandidateProfileCVCopyKeySpecifier);
    fields?: CandidateProfileCVCopyFieldPolicy;
  };
  CandidateProfileCVCopyV2?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CandidateProfileCVCopyV2KeySpecifier
      | (() => undefined | CandidateProfileCVCopyV2KeySpecifier);
    fields?: CandidateProfileCVCopyV2FieldPolicy;
  };
  CandidateProfileCVGeneratorToken?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CandidateProfileCVGeneratorTokenKeySpecifier
      | (() => undefined | CandidateProfileCVGeneratorTokenKeySpecifier);
    fields?: CandidateProfileCVGeneratorTokenFieldPolicy;
  };
  CandidateProfileCountryOptions?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CandidateProfileCountryOptionsKeySpecifier
      | (() => undefined | CandidateProfileCountryOptionsKeySpecifier);
    fields?: CandidateProfileCountryOptionsFieldPolicy;
  };
  CandidateProfileCursorKey?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CandidateProfileCursorKeyKeySpecifier
      | (() => undefined | CandidateProfileCursorKeyKeySpecifier);
    fields?: CandidateProfileCursorKeyFieldPolicy;
  };
  CandidateProfileData?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CandidateProfileDataKeySpecifier
      | (() => undefined | CandidateProfileDataKeySpecifier);
    fields?: CandidateProfileDataFieldPolicy;
  };
  CandidateProfileExperience?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CandidateProfileExperienceKeySpecifier
      | (() => undefined | CandidateProfileExperienceKeySpecifier);
    fields?: CandidateProfileExperienceFieldPolicy;
  };
  CandidateProfileLanguageSkill?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CandidateProfileLanguageSkillKeySpecifier
      | (() => undefined | CandidateProfileLanguageSkillKeySpecifier);
    fields?: CandidateProfileLanguageSkillFieldPolicy;
  };
  CandidateProfileLatestApplication?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CandidateProfileLatestApplicationKeySpecifier
      | (() => undefined | CandidateProfileLatestApplicationKeySpecifier);
    fields?: CandidateProfileLatestApplicationFieldPolicy;
  };
  CandidateProfileLocation?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CandidateProfileLocationKeySpecifier
      | (() => undefined | CandidateProfileLocationKeySpecifier);
    fields?: CandidateProfileLocationFieldPolicy;
  };
  CandidateProfileMutation?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CandidateProfileMutationKeySpecifier
      | (() => undefined | CandidateProfileMutationKeySpecifier);
    fields?: CandidateProfileMutationFieldPolicy;
  };
  CandidateProfileNoAuthMutation?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CandidateProfileNoAuthMutationKeySpecifier
      | (() => undefined | CandidateProfileNoAuthMutationKeySpecifier);
    fields?: CandidateProfileNoAuthMutationFieldPolicy;
  };
  CandidateProfileNotificationsSettings?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CandidateProfileNotificationsSettingsKeySpecifier
      | (() => undefined | CandidateProfileNotificationsSettingsKeySpecifier);
    fields?: CandidateProfileNotificationsSettingsFieldPolicy;
  };
  CandidateProfilePreferences?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CandidateProfilePreferencesKeySpecifier
      | (() => undefined | CandidateProfilePreferencesKeySpecifier);
    fields?: CandidateProfilePreferencesFieldPolicy;
  };
  CandidateProfilePreferredSalary?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CandidateProfilePreferredSalaryKeySpecifier
      | (() => undefined | CandidateProfilePreferredSalaryKeySpecifier);
    fields?: CandidateProfilePreferredSalaryFieldPolicy;
  };
  CandidateProfileProfile?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CandidateProfileProfileKeySpecifier
      | (() => undefined | CandidateProfileProfileKeySpecifier);
    fields?: CandidateProfileProfileFieldPolicy;
  };
  CandidateProfileQuery?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CandidateProfileQueryKeySpecifier
      | (() => undefined | CandidateProfileQueryKeySpecifier);
    fields?: CandidateProfileQueryFieldPolicy;
  };
  CandidateProfileRecommendation?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CandidateProfileRecommendationKeySpecifier
      | (() => undefined | CandidateProfileRecommendationKeySpecifier);
    fields?: CandidateProfileRecommendationFieldPolicy;
  };
  CandidateProfileRecommendationJobOffer?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CandidateProfileRecommendationJobOfferKeySpecifier
      | (() => undefined | CandidateProfileRecommendationJobOfferKeySpecifier);
    fields?: CandidateProfileRecommendationJobOfferFieldPolicy;
  };
  CandidateProfileRecommendationRawParam?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CandidateProfileRecommendationRawParamKeySpecifier
      | (() => undefined | CandidateProfileRecommendationRawParamKeySpecifier);
    fields?: CandidateProfileRecommendationRawParamFieldPolicy;
  };
  CandidateProfileSchool?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CandidateProfileSchoolKeySpecifier
      | (() => undefined | CandidateProfileSchoolKeySpecifier);
    fields?: CandidateProfileSchoolFieldPolicy;
  };
  CandidateProfileSettings?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CandidateProfileSettingsKeySpecifier
      | (() => undefined | CandidateProfileSettingsKeySpecifier);
    fields?: CandidateProfileSettingsFieldPolicy;
  };
  CandidateProfileSuggestion?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CandidateProfileSuggestionKeySpecifier
      | (() => undefined | CandidateProfileSuggestionKeySpecifier);
    fields?: CandidateProfileSuggestionFieldPolicy;
  };
  CandidateProfileUploadData?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CandidateProfileUploadDataKeySpecifier
      | (() => undefined | CandidateProfileUploadDataKeySpecifier);
    fields?: CandidateProfileUploadDataFieldPolicy;
  };
  ChatAttachment?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | ChatAttachmentKeySpecifier | (() => undefined | ChatAttachmentKeySpecifier);
    fields?: ChatAttachmentFieldPolicy;
  };
  ChatConversation?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ChatConversationKeySpecifier
      | (() => undefined | ChatConversationKeySpecifier);
    fields?: ChatConversationFieldPolicy;
  };
  ChatMessage?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | ChatMessageKeySpecifier | (() => undefined | ChatMessageKeySpecifier);
    fields?: ChatMessageFieldPolicy;
  };
  CompanyProfileAbout?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CompanyProfileAboutKeySpecifier
      | (() => undefined | CompanyProfileAboutKeySpecifier);
    fields?: CompanyProfileAboutFieldPolicy;
  };
  CompanyProfileAdditionalInfo?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CompanyProfileAdditionalInfoKeySpecifier
      | (() => undefined | CompanyProfileAdditionalInfoKeySpecifier);
    fields?: CompanyProfileAdditionalInfoFieldPolicy;
  };
  CompanyProfileAds?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CompanyProfileAdsKeySpecifier
      | (() => undefined | CompanyProfileAdsKeySpecifier);
    fields?: CompanyProfileAdsFieldPolicy;
  };
  CompanyProfileAdsAggregation?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CompanyProfileAdsAggregationKeySpecifier
      | (() => undefined | CompanyProfileAdsAggregationKeySpecifier);
    fields?: CompanyProfileAdsAggregationFieldPolicy;
  };
  CompanyProfileAdsAggregationValue?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CompanyProfileAdsAggregationValueKeySpecifier
      | (() => undefined | CompanyProfileAdsAggregationValueKeySpecifier);
    fields?: CompanyProfileAdsAggregationValueFieldPolicy;
  };
  CompanyProfileAdsAggregations?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CompanyProfileAdsAggregationsKeySpecifier
      | (() => undefined | CompanyProfileAdsAggregationsKeySpecifier);
    fields?: CompanyProfileAdsAggregationsFieldPolicy;
  };
  CompanyProfileBaseProfile?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CompanyProfileBaseProfileKeySpecifier
      | (() => undefined | CompanyProfileBaseProfileKeySpecifier);
    fields?: CompanyProfileBaseProfileFieldPolicy;
  };
  CompanyProfileBenefits?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CompanyProfileBenefitsKeySpecifier
      | (() => undefined | CompanyProfileBenefitsKeySpecifier);
    fields?: CompanyProfileBenefitsFieldPolicy;
  };
  CompanyProfileConfig?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CompanyProfileConfigKeySpecifier
      | (() => undefined | CompanyProfileConfigKeySpecifier);
    fields?: CompanyProfileConfigFieldPolicy;
  };
  CompanyProfileConfigFeatureBanner?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CompanyProfileConfigFeatureBannerKeySpecifier
      | (() => undefined | CompanyProfileConfigFeatureBannerKeySpecifier);
    fields?: CompanyProfileConfigFeatureBannerFieldPolicy;
  };
  CompanyProfileConfigFeatureBase?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CompanyProfileConfigFeatureBaseKeySpecifier
      | (() => undefined | CompanyProfileConfigFeatureBaseKeySpecifier);
    fields?: CompanyProfileConfigFeatureBaseFieldPolicy;
  };
  CompanyProfileConfigFeatureBenefits?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CompanyProfileConfigFeatureBenefitsKeySpecifier
      | (() => undefined | CompanyProfileConfigFeatureBenefitsKeySpecifier);
    fields?: CompanyProfileConfigFeatureBenefitsFieldPolicy;
  };
  CompanyProfileConfigFeatureCompanyUrl?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CompanyProfileConfigFeatureCompanyUrlKeySpecifier
      | (() => undefined | CompanyProfileConfigFeatureCompanyUrlKeySpecifier);
    fields?: CompanyProfileConfigFeatureCompanyUrlFieldPolicy;
  };
  CompanyProfileConfigFeatureFollowButton?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CompanyProfileConfigFeatureFollowButtonKeySpecifier
      | (() => undefined | CompanyProfileConfigFeatureFollowButtonKeySpecifier);
    fields?: CompanyProfileConfigFeatureFollowButtonFieldPolicy;
  };
  CompanyProfileConfigFeatureGallery?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CompanyProfileConfigFeatureGalleryKeySpecifier
      | (() => undefined | CompanyProfileConfigFeatureGalleryKeySpecifier);
    fields?: CompanyProfileConfigFeatureGalleryFieldPolicy;
  };
  CompanyProfileConfigFeatureLogo?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CompanyProfileConfigFeatureLogoKeySpecifier
      | (() => undefined | CompanyProfileConfigFeatureLogoKeySpecifier);
    fields?: CompanyProfileConfigFeatureLogoFieldPolicy;
  };
  CompanyProfileConfigFeatureMultiprofile?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CompanyProfileConfigFeatureMultiprofileKeySpecifier
      | (() => undefined | CompanyProfileConfigFeatureMultiprofileKeySpecifier);
    fields?: CompanyProfileConfigFeatureMultiprofileFieldPolicy;
  };
  CompanyProfileConfigFeaturePromotedOnListing?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CompanyProfileConfigFeaturePromotedOnListingKeySpecifier
      | (() => undefined | CompanyProfileConfigFeaturePromotedOnListingKeySpecifier);
    fields?: CompanyProfileConfigFeaturePromotedOnListingFieldPolicy;
  };
  CompanyProfileConfigFeatureRecruitment?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CompanyProfileConfigFeatureRecruitmentKeySpecifier
      | (() => undefined | CompanyProfileConfigFeatureRecruitmentKeySpecifier);
    fields?: CompanyProfileConfigFeatureRecruitmentFieldPolicy;
  };
  CompanyProfileConfigFeatureSocialLinks?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CompanyProfileConfigFeatureSocialLinksKeySpecifier
      | (() => undefined | CompanyProfileConfigFeatureSocialLinksKeySpecifier);
    fields?: CompanyProfileConfigFeatureSocialLinksFieldPolicy;
  };
  CompanyProfileConfigFeatures?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CompanyProfileConfigFeaturesKeySpecifier
      | (() => undefined | CompanyProfileConfigFeaturesKeySpecifier);
    fields?: CompanyProfileConfigFeaturesFieldPolicy;
  };
  CompanyProfileConfigRelations?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CompanyProfileConfigRelationsKeySpecifier
      | (() => undefined | CompanyProfileConfigRelationsKeySpecifier);
    fields?: CompanyProfileConfigRelationsFieldPolicy;
  };
  CompanyProfileConfigSubProfile?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CompanyProfileConfigSubProfileKeySpecifier
      | (() => undefined | CompanyProfileConfigSubProfileKeySpecifier);
    fields?: CompanyProfileConfigSubProfileFieldPolicy;
  };
  CompanyProfileContact?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CompanyProfileContactKeySpecifier
      | (() => undefined | CompanyProfileContactKeySpecifier);
    fields?: CompanyProfileContactFieldPolicy;
  };
  CompanyProfileHeader?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CompanyProfileHeaderKeySpecifier
      | (() => undefined | CompanyProfileHeaderKeySpecifier);
    fields?: CompanyProfileHeaderFieldPolicy;
  };
  CompanyProfileLifeAt?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CompanyProfileLifeAtKeySpecifier
      | (() => undefined | CompanyProfileLifeAtKeySpecifier);
    fields?: CompanyProfileLifeAtFieldPolicy;
  };
  CompanyProfileLifeAtItemExternalVideo?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CompanyProfileLifeAtItemExternalVideoKeySpecifier
      | (() => undefined | CompanyProfileLifeAtItemExternalVideoKeySpecifier);
    fields?: CompanyProfileLifeAtItemExternalVideoFieldPolicy;
  };
  CompanyProfileLifeAtItemImage?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CompanyProfileLifeAtItemImageKeySpecifier
      | (() => undefined | CompanyProfileLifeAtItemImageKeySpecifier);
    fields?: CompanyProfileLifeAtItemImageFieldPolicy;
  };
  CompanyProfileLocation?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CompanyProfileLocationKeySpecifier
      | (() => undefined | CompanyProfileLocationKeySpecifier);
    fields?: CompanyProfileLocationFieldPolicy;
  };
  CompanyProfileMutation?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CompanyProfileMutationKeySpecifier
      | (() => undefined | CompanyProfileMutationKeySpecifier);
    fields?: CompanyProfileMutationFieldPolicy;
  };
  CompanyProfilePrivateConfig?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CompanyProfilePrivateConfigKeySpecifier
      | (() => undefined | CompanyProfilePrivateConfigKeySpecifier);
    fields?: CompanyProfilePrivateConfigFieldPolicy;
  };
  CompanyProfilePrivateConfigRelations?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CompanyProfilePrivateConfigRelationsKeySpecifier
      | (() => undefined | CompanyProfilePrivateConfigRelationsKeySpecifier);
    fields?: CompanyProfilePrivateConfigRelationsFieldPolicy;
  };
  CompanyProfilePrivateConfigSubProfile?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CompanyProfilePrivateConfigSubProfileKeySpecifier
      | (() => undefined | CompanyProfilePrivateConfigSubProfileKeySpecifier);
    fields?: CompanyProfilePrivateConfigSubProfileFieldPolicy;
  };
  CompanyProfilePrivateConfigTier?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CompanyProfilePrivateConfigTierKeySpecifier
      | (() => undefined | CompanyProfilePrivateConfigTierKeySpecifier);
    fields?: CompanyProfilePrivateConfigTierFieldPolicy;
  };
  CompanyProfilePrivateProfile?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CompanyProfilePrivateProfileKeySpecifier
      | (() => undefined | CompanyProfilePrivateProfileKeySpecifier);
    fields?: CompanyProfilePrivateProfileFieldPolicy;
  };
  CompanyProfileProfileCounters?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CompanyProfileProfileCountersKeySpecifier
      | (() => undefined | CompanyProfileProfileCountersKeySpecifier);
    fields?: CompanyProfileProfileCountersFieldPolicy;
  };
  CompanyProfileProfilesCarousel?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CompanyProfileProfilesCarouselKeySpecifier
      | (() => undefined | CompanyProfileProfilesCarouselKeySpecifier);
    fields?: CompanyProfileProfilesCarouselFieldPolicy;
  };
  CompanyProfileProfilesCarouselProfile?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CompanyProfileProfilesCarouselProfileKeySpecifier
      | (() => undefined | CompanyProfileProfilesCarouselProfileKeySpecifier);
    fields?: CompanyProfileProfilesCarouselProfileFieldPolicy;
  };
  CompanyProfileProfilesListing?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CompanyProfileProfilesListingKeySpecifier
      | (() => undefined | CompanyProfileProfilesListingKeySpecifier);
    fields?: CompanyProfileProfilesListingFieldPolicy;
  };
  CompanyProfileProfilesListingProfile?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CompanyProfileProfilesListingProfileKeySpecifier
      | (() => undefined | CompanyProfileProfilesListingProfileKeySpecifier);
    fields?: CompanyProfileProfilesListingProfileFieldPolicy;
  };
  CompanyProfilePublicConfig?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CompanyProfilePublicConfigKeySpecifier
      | (() => undefined | CompanyProfilePublicConfigKeySpecifier);
    fields?: CompanyProfilePublicConfigFieldPolicy;
  };
  CompanyProfilePublicProfile?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CompanyProfilePublicProfileKeySpecifier
      | (() => undefined | CompanyProfilePublicProfileKeySpecifier);
    fields?: CompanyProfilePublicProfileFieldPolicy;
  };
  CompanyProfileQuery?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CompanyProfileQueryKeySpecifier
      | (() => undefined | CompanyProfileQueryKeySpecifier);
    fields?: CompanyProfileQueryFieldPolicy;
  };
  CompanyProfileRecruitment?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CompanyProfileRecruitmentKeySpecifier
      | (() => undefined | CompanyProfileRecruitmentKeySpecifier);
    fields?: CompanyProfileRecruitmentFieldPolicy;
  };
  CompanyProfileRecruitmentProcess?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CompanyProfileRecruitmentProcessKeySpecifier
      | (() => undefined | CompanyProfileRecruitmentProcessKeySpecifier);
    fields?: CompanyProfileRecruitmentProcessFieldPolicy;
  };
  CompanyProfileRecruitmentProcessStep?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CompanyProfileRecruitmentProcessStepKeySpecifier
      | (() => undefined | CompanyProfileRecruitmentProcessStepKeySpecifier);
    fields?: CompanyProfileRecruitmentProcessStepFieldPolicy;
  };
  EmployerLead?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | EmployerLeadKeySpecifier | (() => undefined | EmployerLeadKeySpecifier);
    fields?: EmployerLeadFieldPolicy;
  };
  EmployerPanelMutation?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | EmployerPanelMutationKeySpecifier
      | (() => undefined | EmployerPanelMutationKeySpecifier);
    fields?: EmployerPanelMutationFieldPolicy;
  };
  EmployerPanelQuery?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | EmployerPanelQueryKeySpecifier
      | (() => undefined | EmployerPanelQueryKeySpecifier);
    fields?: EmployerPanelQueryFieldPolicy;
  };
  EmployerProfile?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | EmployerProfileKeySpecifier
      | (() => undefined | EmployerProfileKeySpecifier);
    fields?: EmployerProfileFieldPolicy;
  };
  EmployerSegmentResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | EmployerSegmentResponseKeySpecifier
      | (() => undefined | EmployerSegmentResponseKeySpecifier);
    fields?: EmployerSegmentResponseFieldPolicy;
  };
  HomepageArticle?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | HomepageArticleKeySpecifier
      | (() => undefined | HomepageArticleKeySpecifier);
    fields?: HomepageArticleFieldPolicy;
  };
  HomepageFeaturedCategory?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | HomepageFeaturedCategoryKeySpecifier
      | (() => undefined | HomepageFeaturedCategoryKeySpecifier);
    fields?: HomepageFeaturedCategoryFieldPolicy;
  };
  HomepageFeaturedEmployer?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | HomepageFeaturedEmployerKeySpecifier
      | (() => undefined | HomepageFeaturedEmployerKeySpecifier);
    fields?: HomepageFeaturedEmployerFieldPolicy;
  };
  HomepageQuery?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | HomepageQueryKeySpecifier | (() => undefined | HomepageQueryKeySpecifier);
    fields?: HomepageQueryFieldPolicy;
  };
  ImageThumbnail?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | ImageThumbnailKeySpecifier | (() => undefined | ImageThumbnailKeySpecifier);
    fields?: ImageThumbnailFieldPolicy;
  };
  JobAd?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | JobAdKeySpecifier | (() => undefined | JobAdKeySpecifier);
    fields?: JobAdFieldPolicy;
  };
  JobAdCounters?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | JobAdCountersKeySpecifier | (() => undefined | JobAdCountersKeySpecifier);
    fields?: JobAdCountersFieldPolicy;
  };
  JobAdTrackingParameters?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | JobAdTrackingParametersKeySpecifier
      | (() => undefined | JobAdTrackingParametersKeySpecifier);
    fields?: JobAdTrackingParametersFieldPolicy;
  };
  JobAdUnreadCounters?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | JobAdUnreadCountersKeySpecifier
      | (() => undefined | JobAdUnreadCountersKeySpecifier);
    fields?: JobAdUnreadCountersFieldPolicy;
  };
  JobOfferCity?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | JobOfferCityKeySpecifier | (() => undefined | JobOfferCityKeySpecifier);
    fields?: JobOfferCityFieldPolicy;
  };
  JobOfferDistrict?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | JobOfferDistrictKeySpecifier
      | (() => undefined | JobOfferDistrictKeySpecifier);
    fields?: JobOfferDistrictFieldPolicy;
  };
  JobOfferEmployer?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | JobOfferEmployerKeySpecifier
      | (() => undefined | JobOfferEmployerKeySpecifier);
    fields?: JobOfferEmployerFieldPolicy;
  };
  JobOfferEmployerLogoThumbnails?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | JobOfferEmployerLogoThumbnailsKeySpecifier
      | (() => undefined | JobOfferEmployerLogoThumbnailsKeySpecifier);
    fields?: JobOfferEmployerLogoThumbnailsFieldPolicy;
  };
  JobOfferFloatValue?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | JobOfferFloatValueKeySpecifier
      | (() => undefined | JobOfferFloatValueKeySpecifier);
    fields?: JobOfferFloatValueFieldPolicy;
  };
  JobOfferIntValue?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | JobOfferIntValueKeySpecifier
      | (() => undefined | JobOfferIntValueKeySpecifier);
    fields?: JobOfferIntValueFieldPolicy;
  };
  JobOfferLocation?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | JobOfferLocationKeySpecifier
      | (() => undefined | JobOfferLocationKeySpecifier);
    fields?: JobOfferLocationFieldPolicy;
  };
  JobOfferMap?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | JobOfferMapKeySpecifier | (() => undefined | JobOfferMapKeySpecifier);
    fields?: JobOfferMapFieldPolicy;
  };
  JobOfferOffer?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | JobOfferOfferKeySpecifier | (() => undefined | JobOfferOfferKeySpecifier);
    fields?: JobOfferOfferFieldPolicy;
  };
  JobOfferParameter?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | JobOfferParameterKeySpecifier
      | (() => undefined | JobOfferParameterKeySpecifier);
    fields?: JobOfferParameterFieldPolicy;
  };
  JobOfferPostingComponent?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | JobOfferPostingComponentKeySpecifier
      | (() => undefined | JobOfferPostingComponentKeySpecifier);
    fields?: JobOfferPostingComponentFieldPolicy;
  };
  JobOfferQuery?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | JobOfferQueryKeySpecifier | (() => undefined | JobOfferQueryKeySpecifier);
    fields?: JobOfferQueryFieldPolicy;
  };
  JobOfferRegion?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | JobOfferRegionKeySpecifier | (() => undefined | JobOfferRegionKeySpecifier);
    fields?: JobOfferRegionFieldPolicy;
  };
  JobOfferSalary?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | JobOfferSalaryKeySpecifier | (() => undefined | JobOfferSalaryKeySpecifier);
    fields?: JobOfferSalaryFieldPolicy;
  };
  JobOfferSalaryType?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | JobOfferSalaryTypeKeySpecifier
      | (() => undefined | JobOfferSalaryTypeKeySpecifier);
    fields?: JobOfferSalaryTypeFieldPolicy;
  };
  JobOfferStringValue?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | JobOfferStringValueKeySpecifier
      | (() => undefined | JobOfferStringValueKeySpecifier);
    fields?: JobOfferStringValueFieldPolicy;
  };
  LifeAt?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | LifeAtKeySpecifier | (() => undefined | LifeAtKeySpecifier);
    fields?: LifeAtFieldPolicy;
  };
  LifeAtItemExternalVideo?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | LifeAtItemExternalVideoKeySpecifier
      | (() => undefined | LifeAtItemExternalVideoKeySpecifier);
    fields?: LifeAtItemExternalVideoFieldPolicy;
  };
  LifeAtItemImage?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | LifeAtItemImageKeySpecifier
      | (() => undefined | LifeAtItemImageKeySpecifier);
    fields?: LifeAtItemImageFieldPolicy;
  };
  LocationPayload?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | LocationPayloadKeySpecifier
      | (() => undefined | LocationPayloadKeySpecifier);
    fields?: LocationPayloadFieldPolicy;
  };
  LocationSuggestion?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | LocationSuggestionKeySpecifier
      | (() => undefined | LocationSuggestionKeySpecifier);
    fields?: LocationSuggestionFieldPolicy;
  };
  Metadata?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | MetadataKeySpecifier | (() => undefined | MetadataKeySpecifier);
    fields?: MetadataFieldPolicy;
  };
  MultiApplication?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | MultiApplicationKeySpecifier
      | (() => undefined | MultiApplicationKeySpecifier);
    fields?: MultiApplicationFieldPolicy;
  };
  Mutation?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | MutationKeySpecifier | (() => undefined | MutationKeySpecifier);
    fields?: MutationFieldPolicy;
  };
  Note?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | NoteKeySpecifier | (() => undefined | NoteKeySpecifier);
    fields?: NoteFieldPolicy;
  };
  ProfileCountryOption?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ProfileCountryOptionKeySpecifier
      | (() => undefined | ProfileCountryOptionKeySpecifier);
    fields?: ProfileCountryOptionFieldPolicy;
  };
  Query?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | QueryKeySpecifier | (() => undefined | QueryKeySpecifier);
    fields?: QueryFieldPolicy;
  };
  RecruitmentProcess?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RecruitmentProcessKeySpecifier
      | (() => undefined | RecruitmentProcessKeySpecifier);
    fields?: RecruitmentProcessFieldPolicy;
  };
  RecruitmentProcessStepPayload?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RecruitmentProcessStepPayloadKeySpecifier
      | (() => undefined | RecruitmentProcessStepPayloadKeySpecifier);
    fields?: RecruitmentProcessStepPayloadFieldPolicy;
  };
  SecureUrl?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | SecureUrlKeySpecifier | (() => undefined | SecureUrlKeySpecifier);
    fields?: SecureUrlFieldPolicy;
  };
  StafflyReport?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | StafflyReportKeySpecifier | (() => undefined | StafflyReportKeySpecifier);
    fields?: StafflyReportFieldPolicy;
  };
  StafflyReportSecureUrl?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | StafflyReportSecureUrlKeySpecifier
      | (() => undefined | StafflyReportSecureUrlKeySpecifier);
    fields?: StafflyReportSecureUrlFieldPolicy;
  };
  StafflyTestResult?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | StafflyTestResultKeySpecifier
      | (() => undefined | StafflyTestResultKeySpecifier);
    fields?: StafflyTestResultFieldPolicy;
  };
  UploadRequestDataPayload?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UploadRequestDataPayloadKeySpecifier
      | (() => undefined | UploadRequestDataPayloadKeySpecifier);
    fields?: UploadRequestDataPayloadFieldPolicy;
  };
  UserAnswer?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | UserAnswerKeySpecifier | (() => undefined | UserAnswerKeySpecifier);
    fields?: UserAnswerFieldPolicy;
  };
};
export type TypedTypePolicies = StrictTypedTypePolicies & TypePolicies;
export const namedOperations = {
  Query: {
    CompanyProfilePrivate: 'CompanyProfilePrivate',
    CompanyProfilePublic: 'CompanyProfilePublic',
    CompanyProfilePreview: 'CompanyProfilePreview',
    CompanyProfilePublicSlug: 'CompanyProfilePublicSlug',
    LegacyCompanyProfileJobListingCarouselProfiles:
      'LegacyCompanyProfileJobListingCarouselProfiles',
    CompanyProfileCarousel: 'CompanyProfileCarousel',
    CompanyProfileListing: 'CompanyProfileListing',
    CompanyProfileTrial: 'CompanyProfileTrial',
    CompanyProfileJobAd: 'CompanyProfileJobAd',
    CompanyProfilePostingDetails: 'CompanyProfilePostingDetails',
    CompanyProfileMetadata: 'CompanyProfileMetadata',
    CompanyProfileUploadRequestData: 'CompanyProfileUploadRequestData',
    CompanyProfileLocationSuggestions: 'CompanyProfileLocationSuggestions',
    CompanyProfileEmployerSegment: 'CompanyProfileEmployerSegment',
    CompanyProfileJobOffers: 'CompanyProfileJobOffers',
    CompanyProfileExternalImageAdsCategories: 'CompanyProfileExternalImageAdsCategories',
    AtlasUser: 'AtlasUser',
    CompanyProfileMainFallbackProfile: 'CompanyProfileMainFallbackProfile',
    CompanyProfilePrivateConfig: 'CompanyProfilePrivateConfig',
  },
  Mutation: {
    CompanyProfileSaveAbout: 'CompanyProfileSaveAbout',
    CompanyProfileSaveAdditionalInfo: 'CompanyProfileSaveAdditionalInfo',
    CompanyProfileSaveContact: 'CompanyProfileSaveContact',
    CompanyProfileSaveBenefits: 'CompanyProfileSaveBenefits',
    CompanyProfileSaveRecruitment: 'CompanyProfileSaveRecruitment',
    CompanyProfileSaveLifeAt: 'CompanyProfileSaveLifeAt',
    CompanyProfileSaveMetadata: 'CompanyProfileSaveMetadata',
    CompanyProfileConfirmAssets: 'CompanyProfileConfirmAssets',
    CompanyProfileDeleteData: 'CompanyProfileDeleteData',
    CompanyProfileDeleteAssets: 'CompanyProfileDeleteAssets',
    CompanyProfilePublishProfile: 'CompanyProfilePublishProfile',
  },
  Fragment: {
    CompanyProfileHeader: 'CompanyProfileHeader',
    CompanyProfileAbout: 'CompanyProfileAbout',
    CompanyProfileAdditionalInfo: 'CompanyProfileAdditionalInfo',
    CompanyProfileContact: 'CompanyProfileContact',
    CompanyProfileBenefits: 'CompanyProfileBenefits',
    CompanyProfileRecruitment: 'CompanyProfileRecruitment',
    CompanyProfileLifeAt: 'CompanyProfileLifeAt',
    CompanyProfilePrivateProfile: 'CompanyProfilePrivateProfile',
    CompanyProfilePublicProfile: 'CompanyProfilePublicProfile',
    CompanyProfilePublicProfileWithConfig: 'CompanyProfilePublicProfileWithConfig',
    CompanyProfilePreviewProfile: 'CompanyProfilePreviewProfile',
    CompanyProfilePreviewProfileWithConfig: 'CompanyProfilePreviewProfileWithConfig',
    CompanyProfileJobAdProfile: 'CompanyProfileJobAdProfile',
    CompanyProfileTrialProfile: 'CompanyProfileTrialProfile',
    CompanyProfileMetadata: 'CompanyProfileMetadata',
    CompanyProfilePostingDetails: 'CompanyProfilePostingDetails',
    LegacyCompanyProfileCarouselProfile: 'LegacyCompanyProfileCarouselProfile',
    CompanyProfileCarouselProfile: 'CompanyProfileCarouselProfile',
    CompanyProfileJobOfferSalary: 'CompanyProfileJobOfferSalary',
    CompanyProfileJobOfferLocation: 'CompanyProfileJobOfferLocation',
    CompanyProfileJobOfferParameter: 'CompanyProfileJobOfferParameter',
    CompanyProfileJobOffer: 'CompanyProfileJobOffer',
    CompanyProfileJobOfferAggregation: 'CompanyProfileJobOfferAggregation',
    CompanyProfileListing: 'CompanyProfileListing',
    CompanyProfileListingProfile: 'CompanyProfileListingProfile',
    CompanyProfilePrivateConfig: 'CompanyProfilePrivateConfig',
    CompanyProfilePrivateConfigRelations: 'CompanyProfilePrivateConfigRelations',
    CompanyProfilePrivateConfigTier: 'CompanyProfilePrivateConfigTier',
    CompanyProfileConfigFeatures: 'CompanyProfileConfigFeatures',
    CompanyProfilePublicConfig: 'CompanyProfilePublicConfig',
  },
};
